(function () {
	'use strict';

	const parseProductForm = formData => {
	  const regEx = /properties\[(.+?)\]/;
	  const array = [];
	  let obj = {};
	  for (const [key, value] of formData) {
	    const propertyKey = key.match(regEx)?.['1'];
	    if (key === 'id') {
	      obj = {
	        properties: {}
	      };
	      array.push(obj);
	    }
	    propertyKey ? obj['properties'][propertyKey] = value : obj[key] = value;
	  }
	  return array;
	};
	const dispatchEvent = (target, name, data) => {
	  const event = new CustomEvent(name, {
	    detail: data
	  });
	  target.dispatchEvent(event);
	};
	const generateImageUrl = url => {
	  let imageUrl = '';
	  if (url) {
	    imageUrl = url.replace('123x321', '768x');
	  }
	  return imageUrl;
	};
	const setScrollbarWidth = () => {
	  // Creating invisible container
	  const outer = document.createElement('div');
	  outer.style.visibility = 'hidden';
	  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
	  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
	  document.body.appendChild(outer);

	  // Creating inner element and placing it in the container
	  const inner = document.createElement('div');
	  outer.appendChild(inner);

	  // Calculating difference between container's full width and the child width
	  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

	  // Removing temporary elements from the DOM
	  outer.parentNode.removeChild(outer);
	  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
	};

	const hydrateComponents = (components, ...additionalFunctions) => {
	  return {
	    components,
	    teardownFunctions: [],
	    async hydrate() {
	      additionalFunctions?.forEach(func => func());
	      const initializedComponents = await Promise.all(components.filter(Boolean).map(async component => {
	        const c = await component;
	        if (c.default) return c.default();else return () => {};
	      }));
	      this.teardownFunctions = initializedComponents.filter(c => typeof c === 'function');
	      window.teardown = () => this.teardownFunctions.forEach(teardown => teardown());
	    }
	  };
	};

	//  Should contain js used on all pages
	document.addEventListener('DOMContentLoaded', () => {
	  (async () => {
	    const components = [Promise.resolve().then(function () { return imageLoaded$1; }), Promise.resolve().then(function () { return dropdown$1; }), Promise.resolve().then(function () { return reveal$1; }), Promise.resolve().then(function () { return togglePreOrderBlock$1; }), Promise.resolve().then(function () { return parallax$1; }), Promise.resolve().then(function () { return fragmentOptionSelect$1; }), Promise.resolve().then(function () { return fragmentProductCard$1; }), Promise.resolve().then(function () { return fragmentCursor$1; }), Promise.resolve().then(function () { return fragmentSubMenu$1; }), Promise.resolve().then(function () { return bisModal$1; }), Promise.resolve().then(function () { return bisForm$1; }), Promise.resolve().then(function () { return fragmentSearchTrigger$1; }), Promise.resolve().then(function () { return fragmentVideo$1; }), Promise.resolve().then(function () { return fragmentCartNotification$1; }), Promise.resolve().then(function () { return fragmentRevealableItems$1; }), Promise.resolve().then(function () { return fragmentNewsletterSignup$1; }), Promise.resolve().then(function () { return sectionAnnouncementBar$1; }), Promise.resolve().then(function () { return sectionHeader$1; }), Promise.resolve().then(function () { return sectionWishlist$1; }), Promise.resolve().then(function () { return sectionArticleTeaser$1; }), Promise.resolve().then(function () { return fragmentLineItemsList$1; }), Promise.resolve().then(function () { return countrySelectorModal$1; }), Promise.resolve().then(function () { return main; }), Promise.resolve().then(function () { return componentCarousel$1; }), Promise.resolve().then(function () { return componentModal$1; }), Promise.resolve().then(function () { return eventForm$1; }), Promise.resolve().then(function () { return handleNewsletterEvent; })];
	    const componentsObj = hydrateComponents(components, setScrollbarWidth);
	    await componentsObj.hydrate?.();
	  })();
	});

	// https://gist.github.com/erikthalen/e23a088fa3fbc60fc51f9cc56dc93902
	const camelCase = s => s.replace(/-./g, x => x[1].toUpperCase());
	const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
	function groupByRef(element, result, onlyFirst = false) {
	  const ref = element.getAttribute('data-ref');
	  if (!ref) return;
	  // Split the ref string by spaces to handle multiple values
	  const refs = ref.split(' ').map(camelCase);
	  refs.forEach(capitalizedRef => {
	    if (onlyFirst) {
	      if (!result[capitalizedRef]) {
	        result[capitalizedRef] = element;
	      }
	    } else {
	      if (result[capitalizedRef]) {
	        if (Array.isArray(result[capitalizedRef])) {
	          result[capitalizedRef].push(element);
	        } else {
	          result[capitalizedRef] = [result[capitalizedRef], element];
	        }
	      } else {
	        result[capitalizedRef] = element;
	      }
	    }
	  });
	}
	const getElementByRef = (refs, target) => {
	  const root = target instanceof HTMLElement ? target : document.body;
	  const result = {};
	  // Create a selector that matches all data-ref attributes
	  const selector = Array.isArray(refs) ? refs.map(ref => `[data-ref="${ref}"]`).join(',') : `[data-ref="${refs}"]`;
	  // Query all matching elements at once
	  const elements = root.querySelectorAll(selector);
	  // Group elementss by their data-ref value
	  if (!elements) return {};
	  elements.forEach(element => groupByRef(element, result, true));
	  return result;
	};
	const getElementsByRef = (refs, target) => {
	  const root = target instanceof HTMLElement ? target : document.body;
	  const result = {};
	  // Create a selector that matches all data-ref attributes
	  const selector = Array.isArray(refs) ? refs.map(ref => `[data-ref*="${ref}"]`).join(',') : `[data-ref*="${refs}"]`;
	  // Query all matching elements at once
	  const elements = root.querySelectorAll(selector);
	  // Group elements by their data-ref value
	  elements.forEach(element => groupByRef(element, result));
	  return result;
	};
	const getRefs = (target = document.body, watch) => {
	  const root = typeof target === 'string' ? document.querySelector(`[data-namespace="${target}"]`) : target;
	  if (!root) {
	    return;
	  }
	  const name = root?.getAttribute('data-namespace');
	  return watch ? _watched(root, name, watch) : _refs(root, name, true);
	};
	function _refs(root, name, includeRoot) {
	  const attribute = name ? `data-ref-${name}` : 'data-ref';
	  return [...root.querySelectorAll(`[${attribute}]`)].reduce((refs, el) => {
	    const dataset = name ? `ref${capitalize(name)}` : 'ref';
	    return {
	      ...(includeRoot && {
	        root
	      }),
	      ...refs,
	      ...(camelCase(el.dataset[dataset]) || 'item').split(' ').reduce((acc, newRef) => ({
	        ...acc,
	        [newRef]: refs[newRef] ? [refs[newRef], el].flat() : el
	      }), {})
	    };
	  }, {});
	}
	function _watched(r, n, onChange) {
	  const observer = new MutationObserver(() => {
	    ref.current = _refs(r, n);
	    typeof onChange === 'function' && onChange();
	  });
	  observer.observe(r, {
	    childList: true,
	    subtree: true
	  });
	  const ref = {
	    root: r,
	    current: _refs(r, n),
	    unwatch: observer.disconnect.bind(observer)
	  };
	  return ref;
	}
	const ref = getRefs();

	var imageLoaded = () => {
	  const {
	    image,
	    video
	  } = getElementsByRef(['image', 'video']);
	  const images = image ? Array.isArray(image) ? image : [image] : [];
	  const videos = video ? Array.isArray(video) ? video : [video] : [];
	  const handleImageLoad = ({
	    target
	  }) => {
	    target.classList.add('loaded');
	  };
	  images.forEach(image => {
	    if (image.complete) {
	      handleImageLoad({
	        target: image
	      });
	    } else {
	      image.addEventListener('load', handleImageLoad, {
	        once: true
	      });
	    }
	  });
	  videos.forEach(video => {
	    video.addEventListener('canplaythrough', handleImageLoad);
	    setTimeout(() => {
	      // fuck it, just bail after a sec, xoxo erik
	      handleImageLoad({
	        target: video
	      });
	    }, 1000);
	  });
	};

	var imageLoaded$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: imageLoaded
	});

	// https://dev.to/emmabostian/creating-a-custom-accessible-drop-down-3gmo
	const initDropdown = dropdown => {
	  const ref = getRefs(dropdown);
	  const KEYS = {
	    SPACEBAR: [0, 32],
	    ENTER: 13,
	    DOWN_ARROW: 40,
	    UP_ARROW: 38,
	    ESCAPE: 27
	  };
	  if (!ref.items) return;
	  /**
	   * on init: set selected item to current store
	   */
	  if (dropdown.dataset.dropdown === 'store-selector') {
	    const currentStore = ref.items.find(item => {
	      const link = item.querySelector('a');
	      return link?.href?.includes(location.hostname);
	    });
	    if (currentStore) {
	      ref.selected.textContent = currentStore.textContent;
	    }
	  }
	  ref.selected.addEventListener('click', e => toggleVisibility(e));
	  ref.selected.addEventListener('keydown', e => toggleVisibility(e));
	  document.body.addEventListener('click', e => handleBodyClick(e));
	  const handleBodyClick = e => {
	    const clickOutsideDropdown = !e.target.closest('[data-ref="dropdown"]');
	    if (clickOutsideDropdown) close();
	  };
	  const handleClose = e => {
	    setSelected(e);
	    close();
	  };
	  const handleKeypress = e => {
	    switch (e.keyCode) {
	      case KEYS.ENTER:
	        handleClose(e);
	        return;
	      case KEYS.DOWN_ARROW:
	        focusNextItem(KEYS.DOWN_ARROW);
	        return;
	      case KEYS.UP_ARROW:
	        focusNextItem(KEYS.UP_ARROW);
	        return;
	      case KEYS.ESCAPE:
	        close();
	        return;
	      default:
	        return;
	    }
	  };
	  const itemTeardowns = ref.items.map(item => {
	    item.addEventListener('click', handleClose);
	    item.addEventListener('keydown', handleKeypress);
	    return () => {
	      item.removeEventListener('click', handleClose);
	      item.removeEventListener('keydown', handleKeypress);
	    };
	  });
	  function setSelected(e) {
	    ref.selected.textContent = e.target.innerText;
	  }
	  function close() {
	    ref.list.classList.remove('open');
	    ref.container.setAttribute('aria-expanded', false);
	    ref.container.hidden = true;
	    ref.root.focus();
	  }
	  function toggleVisibility(e) {
	    let openDropDown = KEYS.SPACEBAR.includes(e.keyCode) || e.keyCode === KEYS.ENTER;
	    if (e.keyCode === KEYS.ESCAPE) close();
	    if (e.type === 'click' || openDropDown) {
	      ref.list.classList.toggle('open');
	      ref.container.setAttribute('aria-expanded', ref.list.classList.contains('open'));
	      ref.container.hidden = false;
	    }
	    if (e.keyCode === KEYS.DOWN_ARROW) {
	      focusNextItem(KEYS.DOWN_ARROW);
	    }
	    if (e.keyCode === KEYS.UP_ARROW) {
	      focusNextItem(KEYS.UP_ARROW);
	    }
	  }
	  function focusNextItem(direction) {
	    if (!ref.list.classList.contains('open')) {
	      return;
	    }
	    const activeElement = document.activeElement;
	    const activeElementId = activeElement instanceof HTMLElement ? activeElement.dataset?.id : undefined;
	    if (activeElementId === 'selected') {
	      ref.items[0].focus();
	      return;
	    }
	    const activeItem = ref.items.findIndex(item => item.dataset.id === activeElementId);
	    if (direction === KEYS.DOWN_ARROW) {
	      const isLastItem = activeItem < ref.items.length - 1;
	      if (isLastItem) {
	        const nextListItemId = ref.items[activeItem + 1].dataset.id;
	        ref.items.find(item => item.dataset.id === nextListItemId).focus();
	      }
	    }
	    if (direction === KEYS.UP_ARROW) {
	      const isFirstItem = activeItem > 0;
	      if (isFirstItem) {
	        const nextListItemId = ref.items[activeItem - 1].dataset.id;
	        ref.items.find(item => item.dataset.id === nextListItemId).focus();
	      }
	    }
	  }
	  return () => {
	    itemTeardowns.forEach(teardown => teardown());
	  };
	};
	var dropdown = () => {
	  const {
	    dropdown
	  } = getElementsByRef(['dropdown']);
	  if (!dropdown) return;
	  const elements = Array.isArray(dropdown) ? dropdown : [dropdown];
	  const instances = elements.map(initDropdown);
	  return () => {
	    instances.forEach(teardown => teardown?.());
	  };
	};

	var dropdown$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: dropdown
	});

	var reveal = () => {
	  const {
	    revealElement
	  } = getElementsByRef('reveal-element');
	  if (!revealElement) return;
	  const items = Array.isArray(revealElement) ? Array.from(revealElement) : [revealElement];
	  const init = () => {
	    items.forEach(item => item.classList.add('is-revealed'));
	  };
	  init();
	};

	var reveal$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: reveal
	});

	var togglePreOrderBlock = window.addEventListener('PRODUCT_CARD_RENDERED', () => {
	  const variantInPreorder = document.querySelectorAll('.variant-selector__variant.is-preorder');
	  const disabledPreorder = document.querySelectorAll('.variant-selector__variant:not(.is-preorder)');
	  if (variantInPreorder.length > 0) {
	    variantInPreorder.forEach(variant => {
	      const variantInformations = variant.dataset;
	      const preorderInfoBlock = document.querySelector(`#preorder-${variantInformations.pid}`);
	      if (preorderInfoBlock) {
	        // Show pre-order information on hover
	        variant.addEventListener('mouseenter', function () {
	          if ('pod' in variantInformations && variantInformations.pod && variantInformations.pod !== '' && 'pofd' in variantInformations && variantInformations.pofd && variantInformations.pofd !== '') {
	            const preorderInput = variant.closest('.product-card')?.querySelector('input#pre-order');
	            const preorderTagInput = variant.closest('.product-card')?.querySelector('input#pre-order-tag');
	            const preorderDateInput = variant.closest('.product-card')?.querySelector('input#pre-order-date');
	            updatePreOrderInfoBlock({
	              pofd: variantInformations.pofd,
	              preorderInfoBlock: preorderInfoBlock
	            });
	            if (preorderInput && preorderTagInput && preorderDateInput) {
	              [{
	                preorderInput: preorderInput,
	                name: `properties[${window.translations?.preorder}]`,
	                value: variantInformations.pofd
	              }, {
	                preorderInput: preorderTagInput,
	                name: `properties[_is_preorder]`,
	                value: 'true'
	              }, {
	                preorderInput: preorderDateInput,
	                name: `properties[_preorder_date]`,
	                value: variantInformations.pod
	              }].forEach(e => updatePreOrderInput(e));
	            }
	          } else {
	            emptyPreorderInfoBlock({
	              preorderInfoBlock: preorderInfoBlock
	            });
	          }
	        });
	        // Hide pre-order information on mouse leave
	        variant.addEventListener('mouseleave', function () {
	          emptyPreorderInfoBlock({
	            preorderInfoBlock: preorderInfoBlock
	          });
	        });
	      }
	    });
	  }
	  // Hide pre-order information on product card hover when variant is not in pre-order
	  if (disabledPreorder.length > 0) {
	    disabledPreorder.forEach(variant => {
	      const variantInformations = variant.dataset;
	      const preorderInfoBlock = document.querySelector(`#preorder-${variantInformations.pid}`);
	      variant.addEventListener('mouseover', function () {
	        if (preorderInfoBlock) {
	          const preorderInput = variant.closest('.product-card')?.querySelector('input#pre-order');
	          const preorderTagInput = variant.closest('.product-card')?.querySelector('input#pre-order-tag');
	          const preorderDateInput = variant.closest('.product-card')?.querySelector('input#pre-order-date');
	          if (preorderInput && preorderTagInput && preorderDateInput) {
	            [{
	              preorderInput: preorderInput,
	              name: '',
	              value: ''
	            }, {
	              preorderInput: preorderTagInput,
	              name: '',
	              value: ''
	            }, {
	              preorderInput: preorderDateInput,
	              name: '',
	              value: ''
	            }].forEach(e => updatePreOrderInput(e));
	          }
	          emptyPreorderInfoBlock({
	            preorderInfoBlock: preorderInfoBlock
	          });
	        }
	      });
	    });
	  }
	  // Set pre-order input on mobile when variant is clicked
	  window.addEventListener('TRIGGER_NOTIFICATION_LAYOUT', event => {
	    const detail = event.detail;
	    if (detail) {
	      const preorderInput = detail.element.querySelector('input#pre-order');
	      const preorderTag = detail.element.querySelector('input#pre-order-tag');
	      const preorderDate = detail.element.querySelector('input#pre-order-date');
	      const product_variants = detail.element.querySelectorAll('.variant-selector__variant');
	      if (preorderInput && product_variants && preorderTag && preorderDate) {
	        product_variants.forEach(variant => {
	          variant.addEventListener('click', () => {
	            if ('pofd' in variant.dataset && variant.dataset.pofd && variant.dataset.pofd !== '' && variant.dataset.pod) {
	              [{
	                preorderInput: preorderInput,
	                value: variant.dataset.pofd,
	                name: `properties[${window.translations?.preorder}]`
	              }, {
	                preorderInput: preorderTag,
	                value: 'true',
	                name: `properties[_is_preorder]`
	              }, {
	                preorderInput: preorderDate,
	                value: variant.dataset.pod,
	                name: `properties[_preorder_date]`
	              }].forEach(e => updatePreOrderInput(e));
	            } else {
	              [{
	                preorderInput: preorderInput,
	                value: '',
	                name: ''
	              }, {
	                preorderInput: preorderTag,
	                value: '',
	                name: ''
	              }, {
	                preorderInput: preorderDate,
	                value: '',
	                name: ''
	              }].forEach(e => updatePreOrderInput(e));
	            }
	          });
	        });
	      }
	    }
	  });
	  /**
	   * Empties the pre-order information block.
	   *
	   * @param {EmptyPreorderInfoBlockI} params - The parameters for emptying the pre-order information block.
	   * @returns {void}
	   */
	  function emptyPreorderInfoBlock({
	    preorderInfoBlock
	  }) {
	    preorderInfoBlock.innerHTML = '';
	  }
	  /**
	   * Updates the pre-order information block.
	   *
	   * @param {UpdatePreOrderInfoBlockI} params - The parameters for updating the pre-order information block.
	   * @returns {string} The updated pre-order information block HTML.
	   */
	  function updatePreOrderInfoBlock({
	    pofd,
	    preorderInfoBlock
	  }) {
	    emptyPreorderInfoBlock({
	      preorderInfoBlock: preorderInfoBlock
	    });
	    preorderInfoBlock.innerHTML = `
			<span class="ts-label-s js-preorder-title">${window.translations?.preorder}</span>
			<span class="ts-label-s ts-grey js-preorder-info">${pofd}</span>
		`;
	  }
	  /**
	   * Updates the pre-order input element with the specified attributes.
	   * @param {UpdatePreOrderInputI} params - The parameters for updating the pre-order input.
	   * @returns {void}
	   */
	  function updatePreOrderInput({
	    preorderInput,
	    value,
	    name
	  }) {
	    preorderInput?.setAttribute('name', name);
	    preorderInput?.setAttribute('value', value);
	  }
	  return () => {};
	});

	var togglePreOrderBlock$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: togglePreOrderBlock
	});

	// single source of truth for breakpoints.
	// gets compiled to css by postcss
	// every breakpoint gets a min/max css query
	// used in css like @media (--sm) {}
	// used in css like @media (--until-sm) {}
	// used in js like breakpoints.sm
	const breakpoints$1 = {
	  'sm': 600,
	  'md': 1024,
	  'lg': 1200,
	  'xl': 1440,
	  'page-max': 1660
	};

	/**
	 * The progress module manages and animates elements based on scroll position.
	 * It provides functionality to add, start, pause, and destroy progress instances.
	 * Each instance represents an element that moves vertically based on its position in the viewport.
	 * The module uses requestAnimationFrame for smooth animations and performance optimization.
	 */
	const progress = (() => {
	  const multiplier = 0.1;
	  let instances = [];
	  window.ins = instances;
	  let ticking = false;
	  let raf = null;
	  const start = () => {
	    ticking = true;
	    animate();
	  };
	  const pause = () => {
	    ticking = false;
	    if (raf) cancelAnimationFrame(raf);
	  };
	  const destroy = () => {
	    pause();
	    instances = [];
	  };
	  const isAnimating = () => {
	    return ticking;
	  };
	  const add = ({
	    element,
	    value
	  }) => {
	    const valueAsFloat = value;
	    const bounds = element.getBoundingClientRect();
	    const startFromZero = bounds.y + bounds.height + scrollY >= 0 && bounds.y + scrollY < innerHeight ? true : false;
	    const initialProgressInScreen = Math.max((innerHeight - bounds.y - scrollY) / (innerHeight + bounds.height), 0);
	    let startValue = 0;
	    let endValue = 0;
	    if (startFromZero) {
	      startValue = 0;
	    } else {
	      startValue = valueAsFloat * -0.5;
	    }
	    endValue = valueAsFloat * 0.5;
	    const instance = {
	      element,
	      startValue,
	      endValue,
	      range: endValue - startValue,
	      currentValue: null,
	      initialProgressInScreen,
	      isInitialized: false
	    };
	    instances.push(instance);
	    if (!ticking) {
	      start();
	    }
	  };
	  const animate = () => {
	    const {
	      innerHeight
	    } = window;
	    let instancesLength = instances.length;
	    let i = instancesLength;
	    if (raf) {
	      cancelAnimationFrame(raf);
	    }
	    if (ticking) {
	      raf = requestAnimationFrame(animate);
	    }
	    while (i) {
	      i--;
	      const instance = instances[i];
	      const {
	        element,
	        startValue,
	        endValue,
	        initialProgressInScreen,
	        isInitialized
	      } = instance;
	      const bounds = element.getBoundingClientRect();
	      let progress = (innerHeight - bounds.y) / (innerHeight + bounds.height);
	      //Offset progress
	      let normalizedProgress = (progress - initialProgressInScreen) / (1 - initialProgressInScreen);
	      if (normalizedProgress > 1) normalizedProgress = 1;
	      if (normalizedProgress < 0) normalizedProgress = 0;
	      if (normalizedProgress === 0 && instance.currentValue === startValue) continue;
	      if (normalizedProgress >= 1 && instance.currentValue === endValue) continue;
	      // const easedProgress = easeInOutCubic(normalizedProgress);
	      const targetValue = (endValue - startValue) * normalizedProgress + startValue;
	      const delta = targetValue - (instance.currentValue ?? 0);
	      const velocity = Math.abs(delta) < 0.1 ? 0 : delta * multiplier;
	      instance.currentValue = (instance.currentValue ?? 0) + velocity;
	      instance.currentValue = parseFloat(instance.currentValue.toFixed(3));
	      // autoPause = false;
	      if (Math.abs(delta) < 0.1 || !isInitialized) {
	        instance.currentValue = parseFloat(targetValue.toFixed(3));
	        instance.isInitialized = true;
	        // autoPause = true;
	      }
	      const transformString = `translate3d(0, ${instance.currentValue}px,0)`;
	      setTransform(element, transformString);
	    }
	  };
	  const setTransform = (element, transform) => {
	    element.style.transform = transform;
	  };
	  return {
	    start,
	    pause,
	    destroy,
	    isAnimating,
	    add
	  };
	})();

	/**
	 * This module initializes and manages parallax effects for specified elements.
	 */
	var parallax = () => {
	  const ref = getElementsByRef(['parallax-el']);
	  if (!ref?.parallaxEl) return;
	  const parallaxItems = Array.isArray(ref.parallaxEl) ? ref.parallaxEl : [ref.parallaxEl];
	  let items = [];
	  let isMobile = window.innerWidth < breakpoints$1.md;
	  const init = () => {
	    window.addEventListener('load', isReady);
	  };
	  const isReady = () => {
	    items = isMobile ? parallaxItems.filter(item => !item.hasAttribute('data-disable-mobile-parallax')) : parallaxItems;
	    items.forEach(item => {
	      progress.add({
	        element: item,
	        value: item.dataset.parallax ? parseFloat(item.dataset.parallax) : 0
	      });
	    });
	  };
	  init();
	  return () => {
	    window.removeEventListener('load', isReady);
	    progress.destroy();
	  };
	};

	var parallax$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: parallax
	});

	const envelope = `<svg width="100%" height="100%" class="envelope" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.1964 0.75H14.25V8.25H0.75V0.75H0.803571L7.5 7L14.1964 0.75ZM13.0972 0.75H1.90277L7.5 5.97409L13.0972 0.75ZM0 0H15V9H0V0Z" fill="currentColor"/>
</svg>`;
	const close = `<svg width="100%" height="100%" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="23.5" cy="23.5" r="23.25" stroke="black" stroke-opacity="0.3" stroke-width="0.5" />
  <path d="M26.9128 26.9128L21 21" stroke="#767676" stroke-width="0.5" stroke-miterlimit="10" />
  <path d="M26.9128 21.0872L21 27" stroke="#767676" stroke-width="0.5" stroke-miterlimit="10" />
</svg>`;
	const cart = `<svg width="100%" height="100%" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M6.96786 0.625C6.15631 0.625 5.35897 0.924845 4.7656 1.54933C4.17834 2.16737 3.81877 3.07333 3.81021 4.24365H2.48465C2.13568 4.24365 1.84488 4.50175 1.77841 4.85449L0.424082 12.9158C0.324377 13.518 0.773049 14.0687 1.35466 14.0687H12.4635C13.0534 14.0687 13.502 13.518 13.394 12.9158L12.0314 4.85449C11.9737 4.50455 11.6789 4.24776 11.3335 4.2437L11.3252 4.24365H10.1255C10.1169 3.07333 9.75737 2.16737 9.17012 1.54933C8.57674 0.924845 7.77941 0.625 6.96786 0.625ZM9.37548 4.24365C9.36702 3.22935 9.05803 2.52019 8.62642 2.06594C8.18773 1.60426 7.59367 1.375 6.96786 1.375C6.34204 1.375 5.74798 1.60426 5.3093 2.06594C4.87768 2.52019 4.56869 3.22935 4.56024 4.24365H9.37548ZM1.35466 13.3187C1.26359 13.3187 1.13096 13.2143 1.15955 13.0396L2.51129 4.99365H11.2985L12.6589 13.0415L12.6602 13.0489C12.6892 13.2107 12.5689 13.3187 12.4635 13.3187H1.35466Z"/>
<path class="filled" d="M13.0243 12.9783L13.0243 12.9783L13.0249 12.982C13.0939 13.3667 12.8074 13.6937 12.4635 13.6937H1.35466C1.02213 13.6937 0.729448 13.3686 0.793985 12.9774C0.794005 12.9773 0.794025 12.9772 0.794046 12.9771L2.14752 4.92083C2.18461 4.73126 2.33256 4.61865 2.48465 4.61865H11.3252C11.4847 4.61865 11.6321 4.73799 11.6614 4.9155L11.6616 4.91699L13.0243 12.9783Z" fill="black" stroke="black" stroke-width="0.75" stroke-miterlimit="10"/>
</svg>
`;

	const loader = `<div class="loading">
      <span class="loading__dot"></span>
      <span class="loading__dot"></span>
      <span class="loading__dot"></span>
  </div>
`;
	const wrappedLoader = `<span class="btn-state is-loading" style="height: 10px;">
  <span class="state-label">
    ${loader}
  </span>
</span>
`;
	const favoriteButtonTemplate = id => `<div class="wishlist-btn fave-btn" data-product-id="${id}"></div>`;
	const addToCartBtnTemplate = (buttonStates, state) => `
  <button class="cta-primary--quick-add" data-ref="add-to-cart-btn" type="submit" data-state="${state}">
    <div class="cta-primary--quick-add__label ts-label-s">

      <div class="cta-primary--quick-add__text-container">
        <span class="btn-state is-default">
          <span class="state-label">
            <span class="state-label__icon">${cart}</span>
            <span class="state-label__text js-active-label">${buttonStates.default.label}</span>
            <div class="state-label__animation-text-container sm-only">
              <span class="state-label__animation-text">${buttonStates.animation.label}</span>
            </div>
          </span>
        </span>
        <span class="btn-state is-inactive">
          <span class="state-label">
          <span class="state-label__icon">${cart}</span>
          <span class="state-label__text">${buttonStates.inactive.label}</span>
          <div class="state-label__animation-text-container sm-only">
            <span class="state-label__animation-text">${buttonStates.animation.label}</span>
          </div>
          </span>
        </span>
        <span class="btn-state is-loading">
          <span class="state-label">
          ${loader}
          </span>
        </span>
        <span class="btn-state is-disabled">
          <span class="state-label">
          <span class="state-label__icon">${envelope}</span>
          <span class="state-label__text">${buttonStates.soldOut.label}</span>
          <div class="state-label__animation-text-container sm-only">
            <span class="state-label__animation-text">${buttonStates.animation.label}</span>
          </div>
          </span>
        </span>
        <span class="btn-state is-success">
          <span class="state-label">
            <span class="state-label__icon">${cart}</span>
            <span class="state-label__text">${buttonStates.success.label}</span>
            <div class="state-label__animation-text-container sm-only">
              <span class="state-label__animation-text">${buttonStates.animation.label}</span>
            </div>
          </span>
        </span>
      </div>
    </div>
  </button>`;
	const variantInputTemplate = (variant, productId) => {
	  const input_id = 'product-' + variant.id;
	  const statusClass = variant.available ? '' : 'is-disabled';
	  const icon = variant.available ? '' : envelope;
	  let isPreorder = '';
	  let preorderDate = '';
	  let formatted_date = '';
	  if ('pre_order' in variant) {
	    isPreorder = 'is-preorder';
	    preorderDate = variant.pre_order.date;
	    formatted_date = variant.pre_order.formatted_date;
	  }
	  return `<div id="pv-${variant.id}" class="variant-selector__variant ${statusClass + isPreorder}" data-pod="${preorderDate}" data-pofd="${formatted_date}" data-pid="${productId}">
      <input class="js-variant-input" id="${input_id}" type="radio" name="id" value="${variant.id}" data-availability="${variant.available}" />
      <label for="${input_id}"><span class="ts-label-s">${variant.option1} ${isPreorder ? '<p class="is-mobile">' + window.translations?.preorder + '</p>' : ''}</span>
        ${icon}
      </label>
      <input type="hidden" name="quantity" value="1">
    </div>`;
	};
	const variantSelectorTemplate = (variants, productId) => {
	  let colAmount = 2;
	  let dividedByThree = variants.length % 3;
	  if (dividedByThree == 0) {
	    colAmount = 3;
	  }
	  const options = variants.map(variant => variantInputTemplate(variant, productId)).join('');
	  return `<fieldset class="quick-buy-form__variant-selector variant-selector col-${colAmount} js-size-selector" data-ref="variant-selector">${options}</fieldset>`;
	};
	const productInputTemplate = variants => {
	  return `<input type="hidden" name="quantity" id="quantity" value="1">
  <input type="hidden" name="id" id="id" value="${variants[0].id}">`;
	};
	const preorderInputTemplate = (inputProperty, inputValue, preOrderDate) => {
	  return `<input id='pre-order' type='hidden' name='properties[${inputProperty}]' value='${inputValue}'>
  <input id='pre-order-tag' type='hidden' name='properties[_is_preorder]' value='true'>
  <input id='pre-order-date' type='hidden' name='properties[_preorder_date]' value='${preOrderDate}'>
  `;
	};
	const soldOutProductLabel = label => {
	  return `<span class="ts-label-s soldout-label ts-grey">${label}</span>`;
	};

	var events$2 = {
	  PRODUCT_DATA_LOADED: 'PRODUCT_DATA_LOADED',
	  CART_UPDATED: 'CART_UPDATED',
	  CART_DOM_UPDATED: 'CART_DOM_UPDATED',
	  AJAX_UPDATED: 'AJAX_UPDATED',
	  CHANGE_CURSOR: 'CHANGE_CURSOR',
	  FAVORITES_UPDATED: 'FAVORITES_UPDATED',
	  WISHLIST_READY: 'WISHLIST_READY',
	  FILTERS_UPDATED: 'FILTERS_UPDATED',
	  PRODUCT_CARD_RENDERED: 'PRODUCT_CARD_RENDERED',
	  FILTER_CONTENT_UPDATED: 'FILTER_CONTENT_UPDATED',
	  CLOSE_OPTIONS: 'CLOSE_OPTIONS',
	  TOGGLE_BIS: 'TOGGLE_BIS',
	  UPDATE_BIS: 'UPDATE_BIS',
	  ANNOUNCEMENT_BAR_RENDERED: 'ANNOUNCEMENT_BAR_RENDERED',
	  TRIGGER_NOTIFICATION_LAYOUT: 'TRIGGER_NOTIFICATION_LAYOUT',
	  TOGGLE_DELETE_ADDRESS: 'TOGGLE_DELETE_ADDRESS'
	};

	const classes$e = {
	  hidden: 'is-hidden',
	  open: 'is-open',
	  disabled: 'is-disabled',
	  preorder: 'is-preorder'
	};
	const selectors$b = {
	  option: '.js-option'
	};
	var fragmentOptionSelect = () => {
	  const ref = getElementByRef(['grid']);
	  const {
	    customSelect,
	    productDetails,
	    searchResults
	  } = getElementsByRef(['custom-select', 'product-details', 'search-results']);
	  if (!ref.grid && !customSelect) return;
	  let instances = [];
	  const refs = getRefs(ref.grid, true);
	  const initSelects = () => {
	    setTimeout(() => {
	      const select = Array.isArray(customSelect) ? [...customSelect] : [customSelect];
	      const selectElements = refs && refs.current && Array.isArray(refs.current.customSelect) ? [...refs.current.customSelect] : select;
	      selectElements.forEach(selectEl => {
	        const selectInstance = initSelect(selectEl);
	        if (selectInstance) instances.push(selectInstance);
	      });
	    });
	  };
	  const initSelect = selectEl => {
	    const {
	      select,
	      options,
	      arrowIcon
	    } = getRefs(selectEl);
	    if (!select) return;
	    let selected, container, item;
	    selected = document.createElement('div');
	    selected.setAttribute('class', `p-select__selected ts-label-s`);
	    selected.innerHTML = options[select.selectedIndex].innerHTML;
	    const buyBar = document.querySelector('.buy-bar__btn-label-text');
	    if (buyBar) buyBar.innerHTML = window.translations?.preorder || buyBar.innerHTML;
	    container = document.createElement('div');
	    container.setAttribute('class', 'p-select__item-list');
	    container.classList.add(classes$e.hidden);
	    const handleItemClick = e => {
	      const optionEl = e.target.closest(selectors$b.option);
	      const optionValue = optionEl.getElementsByClassName('option')[0].innerHTML;
	      let selectedIndex;
	      options.forEach((option, i) => {
	        if (option.innerHTML === optionValue) {
	          selectedIndex = i;
	        }
	      });
	      if (optionEl.classList.contains(classes$e.disabled)) {
	        e.preventDefault();
	        handleToggleList(e);
	        // if option is disabled open notify me overlay;
	        dispatchEvent(window, events$2.TOGGLE_BIS, {
	          variantId: options[selectedIndex].value
	        });
	        return;
	      }
	      select.selectedIndex = selectedIndex;
	      if (selectEl.nextElementSibling.querySelector('input#pre-order') !== null) {
	        selectEl.nextElementSibling.querySelector('input#pre-order').remove();
	        selectEl.nextElementSibling.querySelector('input#pre-order-tag').remove();
	        selectEl.nextElementSibling.querySelector('input#pre-order-date').remove();
	      }
	      if (selectEl.nextElementSibling.parentElement.querySelector('div.preorder-description') !== null) {
	        selectEl.nextElementSibling.parentElement.querySelector('div.preorder-description').remove();
	      }
	      // enable add to cart btn
	      if (optionEl.classList.contains(classes$e.preorder)) {
	        const preOrderInputProperty = select[selectedIndex].dataset.pol;
	        const preOrderInputValue = select[selectedIndex].dataset.pofd;
	        const preOrderDate = select[selectedIndex].dataset.pod;
	        selectEl.nextElementSibling.dataset.state = 'preorder';
	        let input = preorderInputTemplate(preOrderInputProperty, preOrderInputValue, preOrderDate);
	        selectEl.nextElementSibling.innerHTML += input;
	        selectEl.nextElementSibling.parentElement.insertAdjacentHTML('beforeend', `<div class="preorder-description"> ${preOrderInputValue} </div>`);
	      } else {
	        selectEl.nextElementSibling.dataset.state = 'default';
	      }
	      options.forEach((option, i) => {
	        if (option.innerHTML === e.target.innerHTML) {
	          select.selectedIndex = i;
	        }
	      });
	      selected.innerHTML = e.target.innerHTML;
	      handleToggleList(e);
	    };
	    const handleToggleList = e => {
	      if (e) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	      container.classList.toggle(classes$e.hidden);
	      selectEl.classList.toggle(classes$e.open);
	    };
	    options.forEach((option, i) => {
	      if (i === 0) return;
	      let optionInner = '';
	      let notifyLabel = option.dataset.notifyLabel;
	      let preorderLabel = option.dataset.pol;
	      item = document.createElement('div');
	      item.addEventListener('click', handleItemClick);
	      item.setAttribute('class', 'p-select__item js-option ts-label-s');
	      optionInner = `<span class="option">${option.innerHTML}</span>`;
	      if (option.dataset.availability === 'false') {
	        item.setAttribute('disabled', true);
	        item.classList.add('is-disabled');
	        optionInner = `<span class="option">${option.innerHTML}</span>
          <div class="option-message">
            <span>${notifyLabel}</span>
           ${envelope}
        </div>`;
	      }
	      if (option.dataset.availability === 'true' && 'pod' in option.dataset) {
	        item.setAttribute('preorder', true);
	        item.classList.add('is-preorder');
	        optionInner = `<span class="option">${option.innerHTML}</span>
          <div class="option-message">
            <span>${preorderLabel}</span>
        </div>`;
	      }
	      item.innerHTML = optionInner;
	      container.appendChild(item);
	    });
	    selectEl.insertBefore(selected, arrowIcon);
	    selectEl.appendChild(container);
	    selected.addEventListener('click', handleToggleList);
	    return () => {
	      selected.removeEventListener('click', handleToggleList);
	    };
	  };
	  if (productDetails || searchResults) {
	    initSelects();
	  }
	  window.addEventListener(events$2.PRODUCT_CARD_RENDERED, initSelects);
	  return () => {
	    instances.forEach(teardown => teardown());
	  };
	};

	var fragmentOptionSelect$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: fragmentOptionSelect
	});

	const root = window.Shopify?.routes.root;
	const selectors$a = {
	  cartCounter: '.js-cart-counter',
	  variantInput: '.js-variant-input'
	};
	const added_to_cart$2 = window.translations?.added_to_cart || 'Added to cart';
	const addToCart = lineItems => {
	  const promise = fetch(root + 'cart/add.js', {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify(lineItems)
	  }).catch(error => {});
	  promise.then(response => {
	    if (response instanceof Response && response.status >= 200 && response.status < 300) {
	      response.json().then(json => dispatchEvent(window, events$2.CART_UPDATED, json));
	    }
	  }).catch(error => {});
	  return promise;
	};
	const changeCart = async (id, quantity) => {
	  const promise = fetch(root + 'cart/change.js', {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({
	      quantity,
	      id,
	      sections: 'main-cart'
	    })
	  }).catch(error => {});
	  return promise.then(response => {
	    if (response instanceof Response) {
	      return response.json();
	    }
	  }).then(json => {
	    if (json && 'sections' in json) {
	      updateCartContent(json.sections['main-cart']);
	    }
	    return json;
	  }).catch(error => {
	    return {};
	  });
	};
	const updateCart = async updates => {
	  const promise = fetch(root + 'cart/update.js', {
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({
	      updates,
	      sections: 'main-cart,cart-notification-product'
	    })
	  }).catch(error => {});
	  promise.then(response => {
	    if (response instanceof Response) {
	      return response.json();
	    }
	  }).then(json => {
	    if (json && 'sections' in json) {
	      updateCartContent(json.sections['main-cart']);
	    }
	  });
	};
	const fetchCart = async () => {
	  try {
	    const response = await fetch(root + 'cart.js', {
	      method: 'GET'
	    });
	    const cart = await response.json();
	    fetchHandler(cart);
	  } catch (error) {}
	};
	const updateCartContent = section => {
	  let parser = new DOMParser();
	  let htmlDocument = parser.parseFromString(section, 'text/html');
	  const {
	    cart
	  } = getRefs();
	  const refs = getRefs(cart);
	  const listItems = htmlDocument.documentElement.querySelector(`[data-ref="cart-line-items"]`);
	  const total = htmlDocument.documentElement.querySelector(`[data-ref="cart-total"]`);
	  if (refs && listItems && total) {
	    refs.cartLineItems.innerHTML = listItems.innerHTML;
	    refs.cartTotal.innerHTML = total.innerHTML;
	    dispatchEvent(window, events$2.CART_UPDATED);
	    dispatchEvent(window, events$2.CART_DOM_UPDATED);
	  } else {
	    // empty cart
	    cart.innerHTML = section;
	    setCartCount(0);
	  }
	};
	const fetchHandler = cart => {
	  updateCartCount(cart);
	};
	const updateCartCount = cart => {
	  setTimeout(() => {
	    setCartCount(cart.item_count);
	  });
	};
	const setCartCount = amount => {
	  const counters = document.querySelectorAll(selectors$a.cartCounter);
	  counters.forEach(counter => {
	    const currentText = counter.innerHTML;
	    const newText = counter.classList.contains('visually-hidden') ? currentText.replace(/\d+/, amount.toString()) : amount.toString();
	    counter.innerHTML = newText;
	  });
	};
	const handleAddToCart = async productForm => {
	  const forms = productForm.getElementsByTagName('form');
	  const form = forms[0];
	  const formData = new FormData(form);
	  const items = parseProductForm(formData);
	  const btns = form.getElementsByTagName('button');
	  const inputs = form.getElementsByTagName('input');
	  const submitBtn = btns[0];
	  const defaultsubmitBtnState = submitBtn.dataset.state;
	  let preOrderBtn = false;
	  let preOrderLabel = '';
	  let eContainer;
	  const states = {
	    success: 'success',
	    loading: 'loading',
	    default: 'default',
	    disabled: 'disabled'
	  };
	  if (submitBtn.dataset.state == states.disabled) {
	    let variantId = null;
	    if (!items.length) {
	      variantId = form.querySelectorAll(selectors$a.variantInput)[0].value;
	    } else {
	      variantId = items[0].id;
	      const hasOptions = form.getElementsByTagName('option');
	      if (hasOptions && items[0].id === '0') {
	        variantId = form.getElementsByTagName('option')[1].value;
	      }
	    }
	    dispatchEvent(window, events$2.TOGGLE_BIS, {
	      variantId
	    });
	    return;
	  }
	  if (productForm.nextElementSibling) {
	    const {
	      errorContainer
	    } = getRefs(productForm.nextElementSibling);
	    eContainer = errorContainer;
	  }
	  if (!submitBtn.firstElementChild) {
	    preOrderBtn = true;
	    preOrderLabel = submitBtn.innerHTML;
	    submitBtn.innerHTML = wrappedLoader;
	  }
	  submitBtn.dataset.state = states.loading;
	  const add = addToCart({
	    items,
	    sections: 'main-cart,cart-notification-product'
	  });
	  add.then(response => {
	    if (response instanceof Response) {
	      if (response.status >= 200 && response.status < 300) {
	        submitBtn.dataset.state = states.success;
	        if (eContainer && eContainer.innerHTML) eContainer.innerHTML = '';
	        if (preOrderBtn) submitBtn.innerHTML = added_to_cart$2;
	        setTimeout(() => {
	          submitBtn.dataset.state = defaultsubmitBtnState;
	          [...inputs].forEach(input => {
	            input.checked = false;
	          });
	          if (preOrderBtn) {
	            submitBtn.innerHTML = preOrderLabel;
	          }
	        }, 3000);
	      } else {
	        response.json().then(json => {
	          submitBtn.dataset.state = defaultsubmitBtnState;
	          if (eContainer) {
	            eContainer.innerHTML = json.description;
	            setTimeout(() => {
	              eContainer.innerHTML = '';
	            }, 5000);
	          }
	        });
	      }
	    }
	  });
	};

	const selectors$9 = {
	  sizeSelector: '.js-size-selector',
	  productForm: '.js-product-form',
	  productAnchor: '.js-product-anchor',
	  addToCart: '.js-add-to-cart',
	  faveBtn: '.js-fave-btn'
	};
	const classes$d = {
	  preorderInput: 'preorder-note',
	  mobile: 'is-mobile',
	  preorderOverlay: 'is-preorder-overlay'
	};
	const isMobile$2 = () => window.innerWidth < breakpoints$1.md;
	var fragmentProductCard = () => {
	  const {
	    collectionSection,
	    wishlistGrid
	  } = getElementByRef(['collection-section', 'wishlist-grid']);
	  const {
	    carousel,
	    grid,
	    searchResults,
	    promoElement,
	    productRow,
	    productCard
	  } = getElementsByRef(['carousel', 'grid', 'search-results', 'promo-element', 'product-row', 'product-card']);
	  if (!carousel && !grid && !searchResults && !promoElement && !productRow && !productCard) return;
	  let refs = collectionSection ? getRefs(collectionSection, true) : grid ? getRefs(wishlistGrid, true) : null;
	  let items = [];
	  const init = () => {
	    window.addEventListener(events$2.PRODUCT_CARD_RENDERED, initCards);
	    initCards();
	  };
	  const initCards = () => {
	    setTimeout(() => {
	      if (refs) {
	        items = refs.current.productCard ? [].concat(refs.current.productCard) : [];
	        items = refs.current.promoElement ? items.concat(refs.current.promoElement) : items;
	      } else {
	        items = productCard ? Array.isArray(productCard) ? [...productCard] : [productCard] : [];
	        items = promoElement ? items.concat(promoElement) : items;
	      }
	      items.forEach(item => {
	        handleImgLoad(item);
	        const form = item.getElementsByTagName('form')[0];
	        if (form) {
	          form.addEventListener('input', handleFormChange);
	        }
	        if (!item.classList.contains('is-mini')) {
	          item.addEventListener('click', handleClick);
	        }
	      });
	    });
	  };
	  const handleImgLoad = item => {
	    const {
	      productCardImg
	    } = getRefs(item);
	    if (!productCardImg) return;
	    const {
	      imgSrc
	    } = productCardImg.dataset;
	    const pImg = new Image();
	    pImg.src = imgSrc;
	    pImg.addEventListener('load', () => {
	      productCardImg.parentNode.classList.add('is-visible');
	    });
	  };
	  const handleClick = e => {
	    const productForm = e.target.closest(selectors$9.productForm);
	    const sizeSelector = e.target.closest(selectors$9.sizeSelector);
	    const faveBtn = e.target.closest(selectors$9.faveBtn);
	    const productAnchor = e.currentTarget.querySelector(selectors$9.productAnchor);
	    if (faveBtn || sizeSelector) return;
	    if (productForm) {
	      e.preventDefault();
	      const btns = productForm.getElementsByTagName('button');
	      const submitBtn = btns[0];
	      const preOrderInput = productForm.getElementsByClassName(classes$d.preorderInput);
	      if (productForm.querySelector(selectors$9.sizeSelector)) {
	        updateCartNotification(productForm, classes$d.mobile, 'variantSelector');
	        return;
	      }
	      if (preOrderInput.length && isMobile$2()) {
	        updateCartNotification(productForm, classes$d.preorderOverlay, 'preorder');
	        return;
	      }
	      if (submitBtn.dataset.state === 'inactive') {
	        return;
	      }
	      handleAddToCart(productForm);
	      return;
	    }
	    if (productAnchor) {
	      const url = productAnchor.getAttribute('href');
	      window.location.href = url;
	    }
	  };
	  const updateCartNotification = (form, className, state) => {
	    const clone = form.cloneNode(true);
	    const obj = {
	      element: clone,
	      className,
	      state,
	      handle: form.dataset.handle
	    };
	    dispatchEvent(window, events$2.TRIGGER_NOTIFICATION_LAYOUT, obj);
	  };
	  const handleFormChange = e => {
	    e.preventDefault();
	    if (e.target.dataset.availability == 'false') {
	      dispatchEvent(window, events$2.TOGGLE_BIS, {
	        variantId: e.target.value
	      });
	      return;
	    } else {
	      const productForm = e.target.closest(selectors$9.productForm);
	      handleAddToCart(productForm);
	    }
	  };
	  init();
	  return () => {
	    window.removeEventListener(events$2.PRODUCT_CARD_RENDERED, initCards);
	    items.forEach(item => {
	      const {
	        productCardImg
	      } = getRefs(item);
	      if (!productCardImg) return;
	      const {
	        imgSrc
	      } = productCardImg.dataset;
	      const pImg = new Image();
	      pImg.src = imgSrc;
	      pImg.removeEventListener('load', () => {
	        productCardImg.parentNode.classList.add('is-visible');
	      });
	      const form = item.getElementsByTagName('form')[0];
	      if (form) form.removeEventListener('input', handleFormChange);
	    });
	    items.forEach(item => {
	      item.removeEventListener('click', handleClick);
	    });
	  };
	};

	var fragmentProductCard$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: fragmentProductCard
	});

	const classes$c = {
	  visible: 'is-visible',
	  constrast: 'has-contrast'
	};
	let type = null;
	let isTouchDevice = !document.getElementsByTagName('html')[0].classList.contains('no-touch');
	var fragmentCursor = () => {
	  const {
	    cursor
	  } = getElementByRef('cursor');
	  if (!cursor || isTouchDevice) return;
	  const init = () => {
	    setEventListeners();
	  };
	  const setEventListeners = () => {
	    window.addEventListener(events$2.CHANGE_CURSOR, handleChangeCursor);
	    window.addEventListener('mousemove', handleMouseMove);
	  };
	  const resetCursor = () => {
	    document.body.style.cursor = 'auto';
	    cursor.classList.remove(classes$c.visible);
	  };
	  const handleMouseMove = e => {
	    const bounds = cursor.getBoundingClientRect();
	    const cursorX = e.clientX - bounds.width / 2;
	    const cursorY = e.clientY - bounds.height / 2;
	    cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
	  };
	  const handleChangeCursor = e => {
	    document.body.style.cursor = 'none';
	    type = e.detail.type;
	    if (type === 'default') {
	      resetCursor();
	      return;
	    }
	    if (e.detail.contrast) {
	      cursor.classList.add(classes$c.constrast);
	    } else {
	      cursor.classList.remove(classes$c.constrast);
	    }
	    cursor.classList.add(classes$c.visible);
	    cursor.dataset.type = e.detail.type;
	  };
	  init();
	  return () => {
	    window.removeEventListener(events$2.CHANGE_CURSOR, handleChangeCursor);
	    window.removeEventListener('mousemove', handleMouseMove);
	    document.body.style.cursor = 'auto';
	  };
	};

	var fragmentCursor$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: fragmentCursor
	});

	var scrollLock = lock => {
	  document.body.style.overflowY = lock ? 'hidden' : 'auto';
	};

	const selectors$8 = {
	  navItem: '.js-nav-item'
	};
	const classes$b = {
	  hasChildList: 'has-active-child',
	  subMenuOpen: 'open-sub-menu',
	  open: 'is-open',
	  current: 'is-current'
	};
	var fragmentSubMenu = () => {
	  const {
	    subMenu,
	    subMenuClose
	  } = getElementByRef(['sub-menu', 'sub-menu-close']);
	  if (!subMenu || !subMenuClose) return;
	  const {
	    activeMenus
	  } = getRefs(subMenu);
	  const activeItems = activeMenus ? [...activeMenus] : [];
	  const init = () => {
	    subMenu.addEventListener('click', handleClick);
	    window.addEventListener('resize', closeMenu);
	    if (subMenuClose) {
	      subMenuClose.addEventListener('click', handleClose);
	    }
	  };
	  const handleClose = () => {
	    closeMenu();
	  };
	  const handleClick = e => {
	    e.preventDefault();
	    const subMenu = activeItems.length ? activeItems[activeItems.length - 1].parentNode : null;
	    const navItem = e.target.closest(selectors$8.navItem);
	    if (navItem && !navItem.classList.contains(classes$b.current) && !navItem.classList.contains(classes$b.hasChildList)) {
	      const links = navItem.getElementsByTagName('a');
	      const url = links[0].getAttribute('href');
	      window.location.href = url;
	      closeMenu();
	    }
	    if (!subMenu) return;
	    if (subMenu.classList.contains(classes$b.open)) {
	      subMenu.classList.remove(classes$b.open);
	      document.body.classList.remove(classes$b.subMenuOpen);
	      scrollLock(false);
	    } else {
	      subMenu.classList.add(classes$b.open);
	      document.body.classList.add(classes$b.subMenuOpen);
	      scrollLock(true);
	    }
	  };
	  const closeMenu = () => {
	    if (activeItems.length > 0) {
	      activeItems.forEach(item => {
	        item.parentNode.classList.remove(classes$b.open);
	      });
	    }
	    document.body.classList.remove(classes$b.subMenuOpen);
	    scrollLock(false);
	  };
	  init();
	  return () => {
	    subMenu.removeEventListener('click', handleClick);
	    window.removeEventListener('resize', closeMenu);
	    if (subMenuClose) {
	      subMenuClose.removeEventListener('click', handleClose);
	    }
	  };
	};

	var fragmentSubMenu$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: fragmentSubMenu
	});

	const KLAVIYO_BASE_PATH = 'https://a.klaviyo.com/client';
	const KLAVIYO_ID = window.P1?.klaviyo?.public_key;
	const KLAVIYO_LIST_ID = window.P1?.klaviyo?.list_id;
	const API_KLAVIYO = {
	  HEADERS: {
	    'revision': '2025-01-15',
	    'content-type': 'application/vnd.api+json'
	  },
	  BACK_IN_STOCK_SUB: KLAVIYO_BASE_PATH + `/back-in-stock-subscriptions/?company_id=${KLAVIYO_ID}`,
	  SUBSCRIPTION: KLAVIYO_BASE_PATH + `/subscriptions?company_id=${KLAVIYO_ID}`,
	  EVENT: KLAVIYO_BASE_PATH + `/profiles?company_id=${KLAVIYO_ID}`
	};
	const FOCUSABLE_SELECTORS = ['button', '[href]', 'input', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'].join(', ');

	const selectors$7 = {
	  image: '.js-zoom-image',
	  bg: '.js-bg',
	  close: '.js-close',
	  submitBtn: '.js-submit-btn',
	  zoomedImg: '.js-zoomed-img'
	};
	const classes$a = {
	  modalOpen: 'modal-open',
	  visible: 'is-visible'
	};
	const types = {
	  zoom: {
	    name: 'image-zoom',
	    config: {
	      modalClose: true
	    }
	  },
	  bis: {
	    name: 'bis',
	    config: {
	      modalClose: true
	    }
	  }
	};
	var bisModal = () => {
	  const {
	    modal,
	    bis
	  } = getElementByRef(['modal', 'bis']);
	  const {
	    modalTrigger
	  } = getElementsByRef(['modal-trigger']);
	  if (!modal) return;
	  let zoomImage;
	  let modalOpen = false;
	  let type;
	  let previousActiveElement = null;
	  let focusableElements = null;
	  const {
	    imageContainer
	  } = getRefs(modal);
	  const triggers = modalTrigger ? Array.isArray(modalTrigger) ? [...modalTrigger] : [modalTrigger] : [];
	  let variantId = undefined;
	  const init = () => {
	    setEventlisteners();
	  };
	  const initFocusableElements = () => {
	    if (!bis) return;
	    focusableElements = Array.from(bis.querySelectorAll(FOCUSABLE_SELECTORS));
	  };
	  const setEventlisteners = () => {
	    modal.addEventListener('click', handleClick);
	    window.addEventListener('keydown', handleKeyDown);
	    window.addEventListener(events$2.TOGGLE_BIS, handleToggleBis);
	    window.addEventListener(events$2.UPDATE_BIS, () => {
	      updateModalContent(true);
	    });
	    if (triggers.length) {
	      triggers.forEach(trigger => {
	        trigger.addEventListener('click', handleClick);
	        if (trigger.dataset.imagesrc) {
	          trigger.addEventListener('mouseenter', handleMouseOver);
	          trigger.addEventListener('mouseleave', handleMouseLeave);
	        }
	      });
	    }
	  };
	  const handleToggleBis = event => {
	    if (event.detail.variantId) variantId = event.detail.variantId;
	    type = types.bis;
	    toggleModal(true, type);
	  };
	  const handleClick = e => {
	    e.stopPropagation();
	    const image = e.target.closest(selectors$7.image);
	    const bg = e.target.closest(selectors$7.bg);
	    const close = e.target.closest(selectors$7.close);
	    const zoomed = e.target.closest(selectors$7.zoomedImg);
	    if (image) {
	      type = types.zoom;
	      toggleModal(true, type);
	      handleImageZoom(image.dataset.imagesrc);
	    }
	    if (bg) {
	      if (type && type.config.modalClose) {
	        toggleModal(false);
	      }
	    }
	    if (close || zoomed) {
	      toggleModal(false);
	    }
	  };
	  const handleKeyDown = e => {
	    if (e.key === 'Escape' && modalOpen) {
	      toggleModal(false);
	    } else if (e.key === 'Tab' && modalOpen) {
	      manageFocus(e);
	    }
	  };
	  const manageFocus = e => {
	    if (!focusableElements?.length) return;
	    const firstElement = focusableElements[0];
	    const lastElement = focusableElements[focusableElements.length - 1];
	    const isTabbing = !e.shiftKey;
	    const isReverseTabbing = e.shiftKey;
	    if (isReverseTabbing && document.activeElement === firstElement) {
	      lastElement.focus();
	      e.preventDefault();
	    } else if (isTabbing && document.activeElement === lastElement) {
	      firstElement.focus();
	      e.preventDefault();
	    }
	  };
	  const toggleModal = (state, type) => {
	    modalOpen = state;
	    scrollLock(modalOpen);
	    let hideForm = variantIsSubscribed(variantId) ? true : false;
	    updateModalContent(hideForm);
	    if (modalOpen) {
	      previousActiveElement = document.activeElement;
	      document.body.classList.add(classes$a.modalOpen);
	      document.body.dataset.modal = type.name;
	      requestAnimationFrame(() => {
	        if (bis) {
	          bis.setAttribute('aria-hidden', 'false');
	          initFocusableElements();
	          const closeButton = bis.querySelector('.js-close');
	          closeButton?.focus();
	        }
	      });
	    } else {
	      if (imageContainer) {
	        zoomImage = null;
	        imageContainer.innerHTML = '';
	        dispatchEvent(window, events$2.CHANGE_CURSOR, {
	          type: 'default',
	          contrast: false
	        });
	      }
	      document.body.classList.remove(classes$a.modalOpen);
	      if (bis) {
	        bis.setAttribute('aria-hidden', 'true');
	      }
	      previousActiveElement?.focus();
	      focusableElements = null;
	    }
	  };
	  const handleMouseOver = () => {
	    dispatchEvent(window, events$2.CHANGE_CURSOR, {
	      type: 'zoom',
	      contrast: true
	    });
	  };
	  const handleMouseLeave = () => {
	    if (!modalOpen) {
	      dispatchEvent(window, events$2.CHANGE_CURSOR, {
	        type: 'default',
	        contrast: false
	      });
	    }
	  };
	  const handleImageZoom = image => {
	    imageContainer.getBoundingClientRect();
	    dispatchEvent(window, events$2.CHANGE_CURSOR, {
	      type: 'close',
	      contrast: true
	    });
	    zoomImage = document.createElement('img');
	    zoomImage.setAttribute('class', 'modal__zoom-img js-zoomed-img');
	    zoomImage.setAttribute('src', image);
	    imageContainer.appendChild(zoomImage);
	  };
	  const updateModalContent = hide => {
	    const form = modal.querySelector('form.js-bis-form');
	    const formInput = modal.querySelector('div.form-input');
	    const formButton = modal.querySelector(selectors$7.submitBtn);
	    const formContainer = modal.querySelector('.js-bis-container');
	    const formNewsletter = modal.querySelector('.bis-form__newsletter');
	    if (formInput && formButton && formContainer && form && formNewsletter) {
	      formInput.classList.toggle('is-hidden', hide);
	      formButton.classList.toggle('is-hidden', hide);
	      form.classList.toggle('is-hidden', hide);
	      formNewsletter.classList.toggle('is-hidden', hide);
	      if (hide === true) {
	        formContainer.dataset.state = 'submitted';
	      } else {
	        formContainer.dataset.state = '';
	      }
	    }
	  };
	  const variantIsSubscribed = productId => {
	    return getBackInStockSubscriptions().includes(productId);
	  };
	  const getBackInStockSubscriptions = () => {
	    const storageKey = 'back-in-stock-subscriptions';
	    let backInStockSubscriptions = JSON.parse(localStorage.getItem(storageKey) || '[]');
	    return backInStockSubscriptions;
	  };
	  init();
	  return () => {
	    modal.removeEventListener('click', handleClick);
	    window.removeEventListener('keydown', handleKeyDown);
	    window.removeEventListener(events$2.TOGGLE_BIS, handleToggleBis);
	    window.removeEventListener(events$2.UPDATE_BIS, () => {
	      updateModalContent(true);
	    });
	    if (triggers.length) {
	      triggers.forEach(trigger => {
	        trigger.removeEventListener('click', handleClick);
	        if (trigger.dataset.imagesrc) {
	          trigger.removeEventListener('mouseenter', handleMouseOver);
	          trigger.removeEventListener('mouseleave', handleMouseLeave);
	        }
	      });
	    }
	  };
	};

	var bisModal$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: bisModal
	});

	const standardFields = ['email'];
	const validateEmail = email => {
	  if (/^[\w+.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
	    return true;
	  }
	  return false;
	};
	const klaviyoForm = (data, callback) => {
	  const defaults = {
	    g: window.P1.klaviyo.list_id,
	    $fields: '$source',
	    $source: 'Newsletter signup form'
	  };
	  const combinedData = Object.assign({}, defaults, data);
	  let dataURL = '';
	  if (combinedData.fields) {
	    for (let i = 0; i < combinedData.fields.length; i++) {
	      const field = combinedData.fields[i];

	      // if standard field or already present in $fields, don't append to $fields
	      if (!standardFields.includes(field.name) || combinedData['$fields'].includes(field.name)) {
	        // append custom fields so Klaviyo knows what to expect
	        if (combinedData['$fields'].indexOf(field.name) === -1) {
	          combinedData['$fields'] += `, ${field.name}`;
	        }
	      }

	      // append all relevant standard and custom data to cobined data object
	      if (combinedData[field.name]) {
	        combinedData[field.name] = [combinedData[field.name], field.value];
	      } else {
	        combinedData[field.name] = field.value;
	      }
	    }
	  }

	  // append all data from combined data object to URL (x-www-form-urlencoded)
	  for (const [key, value] of Object.entries(combinedData)) {
	    if (key !== 'fields') {
	      dataURL += '&' + key + '=' + encodeURIComponent(value);
	    }
	  }
	  fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
	    crossDomain: true,
	    method: 'POST',
	    headers: {
	      'content-type': 'application/x-www-form-urlencoded',
	      'cache-control': 'no-cache'
	    },
	    body: dataURL
	  }).then(res => res.json()).then(json => {
	    if (callback) {
	      callback(json);
	    }
	  });
	};

	const states$1 = {
	  submitted: 'submitted',
	  error: 'error',
	  noEmail: 'no-email'
	};
	const selectors$6 = {
	  bisForm: '.js-bis-form',
	  bisContainer: '.js-bis-container'
	};
	var bisForm = () => {
	  const {
	    bis
	  } = getElementsByRef('bis');
	  if (!bis || Array.isArray(bis) || !KLAVIYO_ID) return;
	  const bisContainers = bis ? Array.isArray(bis) ? bis : [bis] : [];
	  let newsletterConsent;
	  const init = () => {
	    newsletterConsent = bis.querySelector('input[id="newsletter-checkbox"]');
	    setEventListeners();
	  };
	  const setEventListeners = () => {
	    window.addEventListener(events$2.TOGGLE_BIS, handleBisData);
	    bisContainers.forEach(bis => {
	      const {
	        bisForm
	      } = getRefs(bis);
	      if (bisForm) {
	        bisForm.addEventListener('submit', handleSubmit);
	      }
	    });
	  };
	  const handleBisData = e => {
	    const {
	      variantId
	    } = e.detail;
	    bisContainers.forEach(bis => {
	      const {
	        bisForm
	      } = getRefs(bis);
	      if (bisForm) {
	        bisForm.dataset.variantId = variantId || '';
	      }
	    });
	  };
	  const requestSubscription = async email => {
	    return await fetch(API_KLAVIYO.SUBSCRIPTION, {
	      method: 'POST',
	      headers: API_KLAVIYO.HEADERS,
	      body: JSON.stringify({
	        data: {
	          type: 'subscription',
	          attributes: {
	            profile: {
	              data: {
	                type: 'profile',
	                attributes: {
	                  email: email,
	                  subscriptions: {
	                    email: {
	                      marketing: {
	                        consent: 'SUBSCRIBED'
	                      }
	                    }
	                  }
	                }
	              }
	            }
	          },
	          relationships: {
	            list: {
	              data: {
	                type: 'list',
	                id: KLAVIYO_LIST_ID
	              }
	            }
	          }
	        }
	      })
	    });
	  };
	  const handleSubmit = async e => {
	    e.preventDefault();
	    const bisForm = e.target.closest(selectors$6.bisForm);
	    const bisContainer = e.target.closest(selectors$6.bisContainer);
	    const {
	      variantId
	    } = e.target.dataset;
	    const {
	      bisEmail
	    } = getRefs(bisForm);
	    if (!KLAVIYO_ID) {
	      return;
	    }
	    if (!bisEmail.value || !validateEmail(bisEmail.value)) {
	      bis.dataset.state = states$1.noEmail;
	      return;
	    }
	    const bisData = {
	      data: {
	        type: 'back-in-stock-subscription',
	        attributes: {
	          profile: {
	            data: {
	              type: 'profile',
	              attributes: {
	                email: bisEmail.value
	              }
	            }
	          },
	          channels: ['EMAIL']
	        },
	        relationships: {
	          variant: {
	            data: {
	              type: 'catalog-variant',
	              id: `$shopify:::$default:::${variantId}`
	            }
	          }
	        }
	      }
	    };
	    try {
	      if (newsletterConsent?.checked) {
	        const subscription = await requestSubscription(bisEmail.value);
	        if (!subscription.ok) throw 'Subscription failed';
	      }
	      const response = await fetch(API_KLAVIYO.BACK_IN_STOCK_SUB, {
	        method: 'POST',
	        headers: API_KLAVIYO.HEADERS,
	        body: JSON.stringify(bisData)
	      });
	      if (response.status === 202) {
	        bisContainer.dataset.state = states$1.submitted;
	        updateBackInStockSubscriptions(variantId);
	      } else {
	        bisContainer.dataset.state = states$1.error;
	      }
	    } catch (error) {
	      bisContainer.dataset.state = states$1.error;
	    }
	  };
	  const updateBackInStockSubscriptions = variantId => {
	    const storageKey = 'back-in-stock-subscriptions';
	    let backInStockSubscriptions = JSON.parse(localStorage.getItem(storageKey) || '[]');
	    if (!backInStockSubscriptions.includes(variantId)) {
	      backInStockSubscriptions.push(variantId);
	      localStorage.setItem(storageKey, JSON.stringify(backInStockSubscriptions));
	    }
	    dispatchEvent(window, events$2.UPDATE_BIS, {
	      variantId
	    });
	  };
	  init();
	  return () => {
	    window.removeEventListener(events$2.TOGGLE_BIS, handleBisData);
	    bisContainers.forEach(bis => {
	      const {
	        bisForm
	      } = getRefs(bis);
	      if (bisForm) {
	        bisForm.removeEventListener('submit', handleSubmit);
	      }
	    });
	  };
	};

	var bisForm$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: bisForm
	});

	const classes$9 = {
	  open: 'is-open',
	  menuOpen: 'menu-open'
	};
	let isOpen$1 = false;
	const update$1 = ref => {
	  if (!ref.searchOverlay || !ref.searchInput || !ref.siteHeader || !ref.menu || !ref.searchTrigger) return;
	  const elements = Array.isArray(ref.searchTrigger) ? [...ref.searchTrigger] : [ref.searchTrigger];
	  if (Array.isArray(ref.searchOverlay)) return;
	  ref.searchOverlay.classList.toggle(classes$9.open, isOpen$1);
	  elements.forEach(element => {
	    element.classList.toggle('is-active', isOpen$1);
	  });
	  scrollLock(isOpen$1);
	  if (isOpen$1 && !Array.isArray(ref.searchInput) && !Array.isArray(ref.siteHeader) && !Array.isArray(ref.menu)) {
	    ref.searchInput.focus();
	    ref.searchInput.select();
	    ref.siteHeader.style.backgroundColor = 'hsl(var(--white))';
	    // close mobile menu when opening the overlay
	    ref.menu.classList.remove(classes$9.open);
	    ref.siteHeader.classList.remove(classes$9.menuOpen);
	  } else if (!Array.isArray(ref.siteHeader)) {
	    ref.siteHeader.style.removeProperty('background-color');
	  }
	};
	const setSearchOverlayOpenState = (ref, doOpen) => {
	  if (doOpen === undefined) {
	    isOpen$1 = !isOpen$1;
	  } else {
	    isOpen$1 = doOpen;
	  }
	  update$1(ref);
	};
	var fragmentSearchTrigger = () => {
	  const ref = getElementsByRef(['search-trigger', 'search-overlay', 'search-input', 'site-header', 'menu']);
	  if (!ref.searchTrigger) return;
	  const elements = Array.isArray(ref.searchTrigger) ? [...ref.searchTrigger] : [ref.searchTrigger];
	  const handleClick = () => setSearchOverlayOpenState(ref);
	  const handleKeypress = e => {
	    if (e.key !== 'Escape') return;
	    setSearchOverlayOpenState(ref, false);
	  };
	  // set init state
	  update$1(ref);
	  const teardowns = elements.map(element => {
	    element.addEventListener('click', handleClick);
	    return () => element.removeEventListener('click', handleClick);
	  });
	  window.addEventListener('keydown', handleKeypress);
	  return () => {
	    teardowns.forEach(teardown => teardown());
	    window.removeEventListener('keydown', handleKeypress);
	    setSearchOverlayOpenState(ref, false);
	  };
	};

	var fragmentSearchTrigger$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: fragmentSearchTrigger,
		setSearchOverlayOpenState: setSearchOverlayOpenState
	});

	const intersection = (el, callback, config = {
	  threshold: [0]
	}) => {
	  const observer = new IntersectionObserver(callback, config);
	  if (el) {
	    observer.observe(el);
	  }
	  return observer;
	};

	// import screenfull from 'screenfull'
	// 1 -> 01
	const zeroPad = x => x.toString().padStart(2, '0');
	const parseBool = str => str && str === 'true' ? true : false;
	const parseTime = time => {
	  const minutes = Math.floor(time / 60);
	  const seconds = Math.round(time - minutes * 60);
	  return `${zeroPad(minutes)}:${zeroPad(seconds)}`;
	};
	var fragmentVideo = () => {
	  const {
	    video,
	    videoNative
	  } = getElementsByRef(['video', 'video-native']);
	  if (!video) return;
	  const videos = Array.isArray(video) ? [...video] : [video];
	  const handleIntersection = entries => {
	    entries.forEach(entry => {
	      const {
	        isIntersecting,
	        target
	      } = entry;
	      if (isIntersecting) {
	        target.src = target.dataset.src;
	        observer.unobserve(target);
	      }
	    });
	  };
	  const observer = intersection(null, handleIntersection, {
	    rootMargin: `500px 0px 500px 0px`,
	    threshold: [0]
	  });
	  if (videoNative) {
	    const videos = videoNative ? Array.isArray(videoNative) ? [...videoNative] : [videoNative] : [];
	    videos.forEach(videoNative => {
	      observer.observe(videoNative);
	    });
	  }
	  videos.map(video => {
	    const refs = getRefs(video);
	    // vimeo video
	    if (refs.vimeoPlayer) {
	      const options = {
	        ...(refs.vimeoPlayer.dataset.vimeoUrl.includes('vimeo.com') ? {
	          url: refs.vimeoPlayer.dataset.vimeoUrl
	        } : {
	          id: refs.vimeoPlayer.dataset.vimeoUrl
	        }),
	        byline: false,
	        portrait: false,
	        title: false,
	        responsive: true
	      };
	      // Vimeo() comes from cdn by script in theme.liquid^
	      // @ts-expect-error external library
	      const player = new Vimeo.Player(refs.vimeoPlayer.id, options);
	      let duration = 0;
	      player.on('timeupdate', e => {
	        duration = e.duration;
	        if (refs.currentTime) refs.currentTime.textContent = parseTime(e.duration * e.percent);
	        if (refs.duration) refs.duration.textContent = parseTime(e.duration);
	        if (refs.timeline) {
	          refs.timeline.value = e.percent;
	          refs.timeline.style.setProperty('--progress', e.percent);
	        }
	      });
	      player.on('volumechange', e => {
	        if (refs.volume) refs.volume.value = e.volume;
	        // player.volume.value = e.volume
	        // @ts-expect-error Legacy code, i don't understand why it is here
	        if (volume) volume.style.setProperty('--progress', e.volume);
	      });
	      player.on('loaded', async () => {
	        const initVolume = await player.getVolume();
	        if (refs.play) refs.play.textContent = parseBool(refs.vimeoPlayer.dataset.vimeoAutoplay) ? 'Pause' : 'Play';
	        if (refs.volume) {
	          refs.volume.value = initVolume;
	          refs.volume.style.setProperty('--progress', initVolume);
	        }
	      });
	      const handlePlay = async ({
	        target
	      }) => {
	        if (target.closest('.controls') && !target.closest('[data-ref="play"]')) return;
	        if (await player.getPaused()) {
	          player.play();
	          if (refs.play) refs.play.textContent = 'Pause';
	        } else {
	          player.pause();
	          if (refs.play) refs.play.textContent = 'Play';
	        }
	      };
	      const handleSeek = e => {
	        player.setCurrentTime(parseFloat(e.target.value) * duration);
	        if (refs.timeline) refs.timeline.style.setProperty('--progress', parseFloat(e.target.value));
	      };
	      const handleVolume = e => {
	        player.setVolume(parseFloat(e.target.value));
	        if (refs.volume) {
	          refs.volume.style.setProperty('--progress', parseFloat(e.target.value));
	        }
	      };
	      const handleMute = async () => {
	        const volume = await player.getVolume();
	        if (refs.mute) {
	          if (volume > 0.5) {
	            player.setVolume(0);
	            refs.mute.dataset.state = 'unmute';
	          } else {
	            player.setVolume(1);
	            refs.mute.dataset.state = 'mute';
	          }
	        }
	      };
	      // @typescript-eslint/no-unused-vars LEGACY CODE
	      // const handleFullsKcreen = () => {
	      // screenfull.toggle(element)
	      // };
	      // ui
	      refs.play?.addEventListener('click', handlePlay);
	      refs.vimeoPlayer?.addEventListener('click', handlePlay);
	      refs.timeline?.addEventListener('input', handleSeek);
	      refs.volume?.addEventListener('input', handleVolume);
	      refs.mute?.addEventListener('input', handleMute);
	      // if (!screenfull.isEnabled) {
	      //   fullscreenButton.remove()
	      // } else {
	      //   fullscreenButton.addEventListener('click', handleFullscreen)
	      // }
	    }
	    // native video
	    if (refs.videoNative) {
	      let isPlaying = parseBool(refs.videoNative.getAttribute('muted')) && parseBool(refs.videoNative.getAttribute('autoplay'));
	      let progress = 0;
	      const updateUI = () => {
	        progress = refs.videoNative.currentTime / refs.videoNative.duration;
	        if (refs.timeline) {
	          refs.timeline.style.setProperty('--progress', parseFloat(progress.toString()));
	          refs.timeline.value = parseFloat(progress.toString());
	        }
	        if (refs.volume) {
	          refs.volume.value = refs.videoNative.muted ? 0 : refs.videoNative.volume;
	          refs.volume.style.setProperty('--progress', parseFloat(refs.volume.value));
	        }
	        if (refs.currentTime) {
	          refs.currentTime.textContent = parseTime(refs.videoNative.currentTime);
	        }
	        if (refs.duration) {
	          refs.duration.textContent = parseTime(refs.videoNative.duration);
	        }
	        if (refs.mute) {
	          if (refs.videoNative.muted) {
	            refs.mute.dataset.state = 'unmute';
	          } else {
	            refs.mute.dataset.state = 'mute';
	          }
	        }
	        if (refs.play) {
	          if (isPlaying) {
	            refs.play.textContent = 'Pause';
	          } else {
	            refs.play.textContent = 'Play';
	          }
	        }
	        if (isPlaying) requestAnimationFrame(updateUI);
	      };
	      updateUI();
	      const handlePlay = ({
	        target
	      }) => {
	        if (target.closest('.controls') && !target.closest('[data-ref="play"]')) return;
	        isPlaying = !isPlaying;
	        if (isPlaying) {
	          refs.videoNative.play();
	        } else {
	          refs.videoNative.pause();
	        }
	        updateUI();
	      };
	      const handleSeek = e => {
	        refs.videoNative.currentTime = e.target.value * refs.videoNative.duration;
	        updateUI();
	      };
	      const handleVolume = e => {
	        refs.videoNative.muted = false;
	        refs.videoNative.volume = e.target.value;
	        updateUI();
	      };
	      const handleMute = () => {
	        const muted = parseBool(refs.videoNative.getAttribute('muted'));
	        refs.videoNative.setAttribute('muted', !muted);
	        refs.videoNative.muted = !muted;
	        updateUI();
	      };
	      if (refs.play) {
	        video?.addEventListener('click', handlePlay);
	      }
	      // refs.play.addEventListener('click', handlePlay)
	      refs.volume?.addEventListener('input', handleVolume);
	      refs.mute?.addEventListener('click', handleMute);
	      refs.timeline?.addEventListener('input', handleSeek);
	    }
	  });
	};

	var fragmentVideo$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: fragmentVideo
	});

	const selectors$5 = {
	  closeBtn: '.js-close',
	  productForm: '.js-product-form',
	  sizeSelector: '.js-size-selector',
	  bg: '.js-notification-bg'
	};
	const classes$8 = {
	  active: 'is-active',
	  visible: 'is-visible',
	  hidden: 'is-hidden',
	  preorderInput: 'preorder-note'
	};
	const states = {
	  variantSelector: 'variant-selector',
	  productAdded: 'product-added',
	  preorder: 'preorder'
	};
	const {
	  select_size,
	  add_to_cart: add_to_cart$1,
	  added_to_cart: added_to_cart$1,
	  preorder_subtitle
	} = window.translations;
	let xDown = null;
	let yDown = null;
	let isOpen = false;
	const isMobile$1 = () => window.innerWidth < breakpoints$1.md;
	var fragmentCartNotification = () => {
	  const {
	    cartNotification
	  } = getElementByRef('cart-notification');
	  if (!cartNotification) return;
	  const {
	    notificationTitle,
	    notificationSubtitle,
	    notificationFormtitle,
	    notificationProduct,
	    notificationProductForm
	  } = getRefs(cartNotification);
	  const init = () => {
	    setEventListeners();
	  };
	  const setEventListeners = () => {
	    window.addEventListener(events$2.CART_UPDATED, handleCartUpdated);
	    window.addEventListener(events$2.TRIGGER_NOTIFICATION_LAYOUT, toggleLayout);
	    document.addEventListener('touchstart', handleTouchStart, false);
	    document.addEventListener('touchmove', handleTouchMove, false);
	    cartNotification.addEventListener('click', handleClick);
	  };
	  const handleCartUpdated = e => {
	    if (!e.detail?.sections['cart-notification-product']) return;
	    let parser = new DOMParser();
	    let markup = parser.parseFromString(e.detail.sections['cart-notification-product'], 'text/html');
	    const productCard = markup.documentElement.querySelector(`[id="cart-notification-product-${e.detail.items[0].key}"]`);
	    if (!productCard) return;
	    notificationProduct.innerHTML = productCard.innerHTML;
	    openPopUp(states.productAdded);
	    setTimeout(() => {
	      closePopUp();
	    }, 4000);
	  };
	  const toggleLayout = async e => {
	    let {
	      element,
	      handle,
	      className,
	      state
	    } = e.detail;
	    if (className) element.classList.add(className);
	    if (handle) {
	      const element = await createProductPreview(handle);
	      if (element) notificationProduct.innerHTML = element.innerHTML;
	    }
	    if (element) notificationProductForm.appendChild(element);
	    if (state === states.preorder) {
	      const preOrderInput = element.getElementsByClassName(classes$8.preorderInput);
	      const shippingInfo = preOrderInput[0].value;
	      const preorderSubtitle = preorder_subtitle.replace('{{ shippingInfo }}', shippingInfo);
	      notificationSubtitle.innerHTML = preorderSubtitle;
	    }
	    if (cartNotification.querySelector(selectors$5.productForm)) cartNotification.querySelector(selectors$5.productForm)?.addEventListener('input', handleFormChange);
	    openPopUp(states[state]);
	  };
	  const closePopUp = () => {
	    updateState(false);
	    const delay = isMobile$1() ? 150 : 600;
	    cartNotification.classList.add(classes$8.hidden);
	    notificationProduct.classList.remove(classes$8.visible);
	    // cartNotification.classList.remove(classes.active);
	    setTimeout(() => {
	      notificationProduct.innerHTML = '';
	      notificationTitle.innerHTML = '';
	      notificationSubtitle.innerHTML = '';
	      notificationFormtitle.innerHTML = '';
	      notificationProductForm.innerHTML = '';
	    }, delay);
	  };
	  const openPopUp = state => {
	    updateState(true);
	    cartNotification.dataset.state = state;
	    cartNotification.classList.remove(classes$8.hidden);
	    cartNotification.classList.add(classes$8.active);
	    const content = {
	      [states.variantSelector]: {
	        title: add_to_cart$1,
	        formtitle: select_size
	      },
	      [states.preorder]: {
	        title: add_to_cart$1
	      },
	      [states.productAdded]: {
	        title: added_to_cart$1
	      }
	    };
	    notificationTitle.innerHTML = content[state].title;
	    // Legacy code
	    // if (content[state].subtitle) {
	    // 	notificationSubtitle.innerHTML = content[state].subtitle;
	    // }
	    if (content[state].formtitle) {
	      notificationFormtitle.innerHTML = content[state].formtitle;
	    }
	    if (state == states.productAdded || state == states.preorder || state == states.variantSelector) {
	      setTimeout(() => {
	        notificationProduct.classList.add(classes$8.visible);
	      }, 500);
	    }
	  };
	  const updateState = state => {
	    isOpen = state;
	    if (isMobile$1()) {
	      scrollLock(state);
	    }
	  };
	  const createProductPreview = async productHandle => {
	    try {
	      const fetchUrl = `/products/${productHandle}?section_id=cart-notification-preview&product=${productHandle}`;
	      const res = await fetch(fetchUrl);
	      const text = await res.text();
	      const parser = new DOMParser();
	      const markup = parser.parseFromString(text, 'text/html');
	      const element = markup.documentElement.querySelector(`[id="notification-product-preview-${productHandle}"]`);
	      return element;
	    } catch (error) {}
	  };
	  const handleClick = e => {
	    const closeBtn = e.target.closest(selectors$5.closeBtn);
	    const productForm = e.target.closest(selectors$5.productForm);
	    const sizeSelector = e.target.closest(selectors$5.sizeSelector);
	    const bg = e.target.closest(selectors$5.bg);
	    if (sizeSelector) {
	      return;
	    }
	    if (closeBtn || bg) {
	      closePopUp();
	      return;
	    }
	    if (productForm) {
	      e.preventDefault();
	      handleAddToCart(productForm);
	    }
	  };
	  const handleFormChange = e => {
	    e.preventDefault();
	    if (e.target.dataset.availability == 'false') {
	      closePopUp();
	      // Open bis form
	      dispatchEvent(window, events$2.TOGGLE_BIS, {
	        variantId: e.target.value
	      });
	      return;
	    } else {
	      const productForm = e.target.closest(selectors$5.productForm);
	      handleAddToCart(productForm);
	    }
	  };
	  // Handle swipe down - close popup
	  const getTouches = e => {
	    return e.touches || e.originalEvent.touches;
	  };
	  const handleTouchStart = e => {
	    if (!isOpen) return;
	    const firstTouch = getTouches(e)[0];
	    xDown = firstTouch.clientX;
	    yDown = firstTouch.clientY;
	  };
	  const handleTouchMove = e => {
	    if (!xDown || !yDown || !isOpen) {
	      return;
	    }
	    var xUp = e.touches[0].clientX;
	    var yUp = e.touches[0].clientY;
	    var xDiff = xDown - xUp;
	    var yDiff = yDown - yUp;
	    if (Math.abs(xDiff) < Math.abs(yDiff)) {
	      if (yDiff > 0) {
	        return;
	      } else {
	        closePopUp();
	      }
	    }
	    xDown = null;
	    yDown = null;
	  };
	  init();
	  return () => {
	    window.removeEventListener(events$2.CART_UPDATED, handleCartUpdated);
	    window.removeEventListener(events$2.TRIGGER_NOTIFICATION_LAYOUT, toggleLayout);
	    document.removeEventListener('touchstart', handleTouchStart, false);
	    document.removeEventListener('touchmove', handleTouchMove, false);
	    cartNotification.removeEventListener('click', handleClick);
	    if (cartNotification.querySelector(selectors$5.productForm)) cartNotification.querySelector(selectors$5.productForm)?.removeEventListener('input', handleFormChange);
	  };
	};

	var fragmentCartNotification$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: fragmentCartNotification
	});

	const selectors$4 = {
	  item: '.js-item'
	};
	const classes$7 = {
	  active: 'is-active',
	  visible: 'is-visible'
	};
	var fragmentRevealableItems = () => {
	  const {
	    revealableItems
	  } = getElementByRef('revealable-items');
	  if (!revealableItems) return;
	  const {
	    contentContainer,
	    titles,
	    sliderTitles,
	    descriptions
	  } = getRefs(revealableItems);
	  const init = () => {
	    setContainerHeight(descriptions[0]);
	  };
	  const setContainerHeight = el => {
	    contentContainer.style.setProperty('--el-height', el.scrollHeight + 'px');
	  };
	  const handleClick = e => {
	    const isMobile = window.innerWidth < breakpoints$1.md;
	    const item = e.target.closest(selectors$4.item);
	    const currentIndex = item.dataset.index;
	    const currentDescription = descriptions.find(description => description.dataset.index === currentIndex);
	    let activeTopic;
	    if (isMobile) {
	      const {
	        sliderTitles: activeTitle
	      } = getRefs(item);
	      sliderTitles.forEach(title => {
	        title.classList.remove(classes$7.active);
	      });
	      activeTopic = activeTitle;
	    } else {
	      const {
	        titles: activeTitle
	      } = getRefs(item);
	      titles.forEach(title => {
	        title.classList.remove(classes$7.active);
	      });
	      activeTopic = activeTitle;
	    }
	    setContainerHeight(currentDescription);
	    activeTopic.classList.add(classes$7.active);
	    descriptions.forEach(description => {
	      if (description == currentDescription) {
	        description.classList.add(classes$7.visible);
	      } else {
	        description.classList.remove(classes$7.visible);
	      }
	    });
	  };
	  init();
	  revealableItems.addEventListener('click', handleClick);
	  return () => {
	    revealableItems.removeEventListener('click', handleClick);
	  };
	};

	var fragmentRevealableItems$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: fragmentRevealableItems
	});

	var fragmentNewsletterSignup = () => {
	  const {
	    newsletterSignup
	  } = getElementByRef('newsletter-signup');
	  if (!newsletterSignup) return;
	  const {
	    signupForm,
	    formInput,
	    messageContainer
	  } = getRefs(newsletterSignup);
	  const {
	    messageSuccess,
	    messageError,
	    messageAlreadySubscribed
	  } = signupForm.dataset;
	  const inputs = formInput ? Array.isArray(formInput) ? [...formInput] : [formInput] : [];
	  const init = () => {
	    setEventListeners();
	  };
	  const setEventListeners = () => {
	    signupForm.addEventListener('submit', handleSubmit);
	  };
	  const handleSubmit = e => {
	    e.preventDefault();
	    const data = {
	      fields: inputs
	    };
	    klaviyoForm(data, handleResponse);
	  };
	  const handleResponse = res => {
	    if (res.success) {
	      messageContainer.innerHTML = '<p>' + messageSuccess + '</p>';
	      if (res.data.is_subscribed) {
	        messageContainer.innerHTML = '<p>' + messageAlreadySubscribed + '</p>';
	      }
	    } else {
	      messageContainer.innerHTML = '<p>' + messageError + '</p>';
	    }
	    inputs.forEach(input => {
	      input.value = '';
	    });
	  };
	  init();
	  return () => {
	    signupForm.removeEventListener('submit', handleSubmit);
	  };
	};

	var fragmentNewsletterSignup$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: fragmentNewsletterSignup
	});

	const classes$6 = {
	  announcementBarActive: 'announcement-bar-active',
	  appear: 'appear'
	};
	var sectionAnnouncementBar = () => {
	  const {
	    announcementBar,
	    siteHeader
	  } = getElementByRef(['announcement-bar', 'site-header']);
	  if (!announcementBar || !siteHeader) return;
	  const init = () => {
	    document.body.style.setProperty('--header-top-pos', '30px');
	    siteHeader.classList.add(classes$6.announcementBarActive);
	    announcementBar.classList.add(classes$6.appear);
	    dispatchEvent(window, events$2.ANNOUNCEMENT_BAR_RENDERED);
	  };
	  init();
	};

	var sectionAnnouncementBar$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: sectionAnnouncementBar
	});

	const selectors$3 = {
	  item: '.js-item',
	  menuToggle: '.js-menu-toggle',
	  faveCounter: '.js-fave-counter',
	  subNavTitle: '.js-sub-nav-title'
	};
	const classes$5 = {
	  item: 'js-item',
	  menuOpen: 'menu-open',
	  scrolled: 'is-scrolled',
	  open: 'is-open',
	  announcementBarActive: 'announcement-bar-active',
	  reveal: 'reveal',
	  active: 'is-active'
	};
	const isMobile = () => window.innerWidth < breakpoints$1.md;
	const isSmall = () => window.innerWidth < breakpoints$1.sm;
	const isScrolled = () => window.scrollY > (isMobile() ? 0 : 80);
	var sectionHeader = () => {
	  const {
	    siteHeader,
	    closeMenu
	  } = getElementByRef(['site-header', 'close-menu']);
	  if (!siteHeader || !closeMenu) return;
	  const {
	    menu,
	    menuItem,
	    imageLink,
	    hoverImg,
	    subNavTitle
	  } = getRefs(siteHeader);
	  const imageLinks = imageLink ? [].concat(imageLink) : [];
	  const hoverImages = hoverImg ? [].concat(hoverImg) : [];
	  const menuItems = menuItem ? [].concat(menuItem) : [];
	  const subNavTitles = subNavTitle ? [].concat(subNavTitle) : [];
	  let timer = null;
	  let activeDropdown = null;
	  let activeContainer = null;
	  let containerFocusable = null;
	  let triggerElem = null;
	  const init = () => {
	    setEventListeners();
	    handleScroll();
	  };
	  const handleResize = () => {
	    handleScroll();
	  };
	  const setEventListeners = () => {
	    window.addEventListener('scroll', handleScroll, {
	      passive: true
	    });
	    window.addEventListener('resize', handleResize, {
	      passive: true
	    });
	    window.addEventListener('keydown', handleKeyDown);
	    window.addEventListener(events$2.CART_UPDATED, updateCartCount);
	    window.addEventListener(events$2.ANNOUNCEMENT_BAR_RENDERED, setCSSVariables);
	    menuItems.forEach(item => {
	      if (item.classList.contains(classes$5.active) && isMobile()) {
	        if (item.dataset.level == '3') {
	          const firstLevel = item.closest('[data-level="1"]');
	          const subNav = item.closest('ul');
	          const secondLevel = subNav?.previousElementSibling;
	          firstLevel?.setAttribute('aria-expanded', 'true');
	          secondLevel && subNav && toggleSubNav(secondLevel, subNav);
	        } else {
	          item.setAttribute('aria-expanded', 'true');
	        }
	      }
	      if (item.dataset.level === '1' && item.dataset.children && +item.dataset.children > 0) {
	        item.addEventListener('mouseenter', handleOpenDropdown);
	        item.addEventListener('mouseleave', handleCloseDropdown);
	        item.addEventListener('click', handleToggleNextLevel);
	      }
	      if (item.dataset.level === '2') {
	        item.addEventListener('click', handleOpenSubNav);
	      }
	    });
	    subNavTitles.forEach(title => {
	      title.addEventListener('click', handleCloseSubNav);
	    });
	    imageLinks.forEach(link => {
	      link.addEventListener('mouseenter', e => handleRevealImage(e, true));
	      link.addEventListener('mouseleave', e => handleRevealImage(e, false));
	    });
	    if (closeMenu) {
	      closeMenu.addEventListener('click', handleClose);
	    }
	    siteHeader?.addEventListener('click', handleClick);
	  };
	  const handleToggleNextLevel = e => {
	    const target = e.target;
	    const item = target?.closest(selectors$3.item);
	    const subNavTitle = target?.closest(selectors$3.subNavTitle);
	    if (subNavTitle) return;
	    item?.setAttribute('aria-expanded', 'true');
	  };
	  const handleOpenSubNav = e => {
	    const item = e.currentTarget;
	    const subNav = item?.nextElementSibling;
	    item && subNav && toggleSubNav(item, subNav);
	  };
	  const toggleSubNav = (item, subNav) => {
	    const expanded = subNav.getAttribute('aria-expanded');
	    if (expanded === 'false') {
	      subNav.style.maxHeight = subNav.scrollHeight + 'px';
	      subNav.style.opacity = '1';
	      subNav.setAttribute('aria-expanded', 'true');
	      item.classList.add(classes$5.open);
	    } else {
	      subNav.style.maxHeight = '0px';
	      subNav.style.opacity = '0';
	      subNav.setAttribute('aria-expanded', 'false');
	      item.classList.remove(classes$5.open);
	    }
	  };
	  const handleCloseSubNav = () => {
	    menuItems.forEach(item => {
	      item.setAttribute('aria-expanded', 'false');
	    });
	  };
	  const handleOpenDropdown = e => {
	    if (!isMobile()) {
	      timer && clearTimeout(timer);
	      if (activeDropdown && activeDropdown !== e.target) {
	        menuItems.forEach(item => {
	          item.setAttribute('aria-expanded', 'false');
	        });
	      }
	      activeDropdown = e.target;
	      activeDropdown?.setAttribute('aria-expanded', 'true');
	      siteHeader?.classList.add(classes$5.menuOpen);
	      document.body.classList.add(classes$5.menuOpen);
	      activeContainer = activeDropdown?.querySelector('div[data-ref="nav-containers"]');
	      if (!activeContainer) return;
	      containerFocusable = Array.from(activeContainer?.querySelectorAll('a.ts-tertiary-item'));
	    }
	  };
	  const handleCloseDropdown = e => {
	    if (!isMobile()) {
	      timer && clearTimeout(timer);
	      timer = window.setTimeout(() => {
	        e.target?.setAttribute('aria-expanded', 'false');
	        siteHeader?.classList.remove(classes$5.menuOpen);
	        document.body.classList.remove(classes$5.menuOpen);
	        activeDropdown = null;
	      }, 500);
	      activeContainer = null;
	      containerFocusable = [];
	      if (triggerElem) {
	        triggerElem.focus();
	        triggerElem = null;
	      }
	    }
	  };
	  const handleRevealImage = (e, reveal) => {
	    hoverImages.forEach(img => {
	      if (img.dataset.media === e.target?.dataset.handle) {
	        if (reveal) {
	          img.classList.add(classes$5.reveal);
	        } else {
	          img.classList.remove(classes$5.reveal);
	        }
	      }
	    });
	  };
	  const handleClose = () => {
	    menu?.classList.remove(classes$5.open);
	    document.body.classList.remove(classes$5.open);
	    siteHeader?.classList.remove(classes$5.menuOpen);
	    document.body.classList.remove(classes$5.menuOpen);
	    scrollLock(false);
	  };
	  const handleClick = e => {
	    const toggle = e.target?.closest(selectors$3.menuToggle);
	    const isMenuOpen = siteHeader?.classList.contains(classes$5.menuOpen);
	    if (toggle) {
	      const header = siteHeader;
	      menu?.classList.toggle(classes$5.open);
	      header?.classList.toggle(classes$5.menuOpen);
	      document.body.classList.toggle(classes$5.open);
	      document.body.classList.toggle(classes$5.menuOpen);
	      setSearchOverlayOpenState(ref, false);
	      handleColorTheme(!isMenuOpen);
	      scrollLock(!isMenuOpen);
	    }
	  };
	  const handleColorTheme = menuOpen => {
	    const pageColor = document.body.classList.contains('theme-beige') ? '#EDEAE7' : 'transparent';
	    const metaThemeColor = document.querySelector("meta[name='theme-color']");
	    if (!metaThemeColor) return;
	    if (menuOpen) {
	      metaThemeColor.content = '#fff';
	    } else {
	      metaThemeColor.content = pageColor;
	    }
	  };
	  const handleScroll = () => {
	    siteHeader?.classList.toggle(classes$5.scrolled, isScrolled());
	    document.body.classList.toggle(classes$5.scrolled, isScrolled());
	    setCSSVariables();
	    setProductDetailsMarginTopCssVariable();
	  };
	  const handleKeyDown = event => {
	    if (event.key === 'Enter') {
	      const target = event.target;
	      if (target.hasAttribute('aria-haspopup')) {
	        triggerElem = target;
	        handleOpenDropdown(event);
	      }
	    }
	    if (event.key === 'Escape') {
	      handleCloseDropdown(event);
	      handleCloseSubNav();
	    }
	    if (event.key === 'Tab') {
	      handleTab(event);
	    }
	  };
	  const handleTab = event => {
	    if (!containerFocusable) return;
	    const isReverseTabbing = event.shiftKey;
	    const firstElement = containerFocusable[0];
	    const lastElement = containerFocusable[containerFocusable.length - 1];
	    if (event.target == firstElement && isReverseTabbing) {
	      event.preventDefault();
	      lastElement.focus();
	    }
	    if (event.target == lastElement && !isReverseTabbing) {
	      event.preventDefault();
	      firstElement.focus();
	    }
	  };
	  // Calculate the total height of an element
	  const calculateTotalHeight = element => {
	    if (!element) return 0;
	    const rect = element.getBoundingClientRect();
	    return Math.floor(rect.height);
	  };
	  const setCSSVariables = () => {
	    const hasAnnouncementBar = siteHeader?.classList.contains(classes$5.announcementBarActive);
	    const {
	      height
	    } = siteHeader.getBoundingClientRect();
	    const translate = !isScrolled() || isSmall() ? 0 : 20;
	    const headerHeight = `${height - translate}px`;
	    const fullHeight = hasAnnouncementBar ? `${height - translate + 30}px` : `${height - translate}px`;
	    const initHeaderHeight = hasAnnouncementBar ? `${height + 30}px` : `${height}px`;
	    document.body.style.setProperty('--init-header-height', initHeaderHeight);
	    document.body.style.setProperty('--header-height', headerHeight);
	    document.body.style.setProperty('--full-header-height', fullHeight);
	    document.body.style.setProperty('--full-height', `${window.innerHeight}px`);
	  };
	  const setProductDetailsMarginTopCssVariable = () => {
	    const hasAnnouncementBar = siteHeader?.classList.contains(classes$5.announcementBarActive);
	    const {
	      height
	    } = siteHeader.getBoundingClientRect();
	    const translate = !isScrolled() || isSmall() ? 0 : 20;
	    const productInfoHeader = document.querySelector('.product-hero-info__header');
	    const productInfoMain = document.querySelector('.product-hero-info__main');
	    const productInfoBottom = document.querySelector('.product-hero-info__bottom');
	    const totalHeight = calculateTotalHeight(productInfoHeader) + calculateTotalHeight(productInfoMain) + calculateTotalHeight(productInfoBottom);
	    document.body.style.setProperty('--product-details-margin-top', `${Math.max(0, totalHeight + 55 + (hasAnnouncementBar ? height - translate + 30 : height - translate) - window.innerHeight)}px`);
	  };
	  const updateCartCount = () => {
	    fetchCart();
	  };
	  init();
	  return () => {
	    window.removeEventListener(events$2.CART_UPDATED, updateCartCount);
	    window.removeEventListener('scroll', handleScroll);
	    window.removeEventListener('resize', handleResize);
	    siteHeader?.removeEventListener('click', handleClick);
	    menuItems.forEach(item => {
	      if (item.dataset.level === '1' && item.dataset.children && +item.dataset.children > 0) {
	        item.removeEventListener('mouseenter', handleOpenDropdown);
	        item.removeEventListener('mouseleave', handleCloseDropdown);
	        item.removeEventListener('click', handleToggleNextLevel);
	      }
	      if (item.dataset.level === '2') {
	        item.removeEventListener('click', handleOpenSubNav);
	      }
	    });
	    subNavTitles.forEach(title => {
	      title.removeEventListener('click', handleCloseSubNav);
	    });
	    imageLinks.forEach(link => {
	      const handleMouseEnter = e => handleRevealImage(e, true);
	      const handleMouseLeave = e => handleRevealImage(e, false);
	      link.removeEventListener('mouseenter', handleMouseEnter);
	      link.removeEventListener('mouseleave', handleMouseLeave);
	    });
	    if (closeMenu) {
	      closeMenu.removeEventListener('click', handleClose);
	    }
	  };
	};

	var sectionHeader$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: sectionHeader
	});

	const {
	  title_edition,
	  add_to_cart,
	  added_to_cart,
	  notify_me,
	  preorder,
	  preorder_cta,
	  preorder_shipping_on,
	  sold_out,
	  animation
	} = window.translations;
	const compileQuickShop = (product, collection) => {
	  let variantSelector = '';
	  let productInput = '';
	  let preorderInput = '';
	  let addToCartBtn = '';
	  let btnState;
	  const preOrderSettings = getPreOrderInfo(product);
	  const isPreOrder = preOrderSettings;
	  const firstProductVariant = product.variants[0];
	  const productTags = product.tags;
	  const id = 'add-to-cart-' + product.handle + '-' + collection + '-' + 'col-grid';
	  const buttonStates = {
	    default: {
	      label: isPreOrder ? preorder_cta : add_to_cart
	    },
	    inactive: {
	      label: add_to_cart
	    },
	    soldOut: {
	      label: `${sold_out} - ${notify_me}`
	    },
	    success: {
	      label: added_to_cart
	    },
	    preorder: {
	      label: preorder_cta
	    },
	    animation: {
	      label: animation
	    }
	  };
	  if (product.variants.length > 1) {
	    variantSelector = variantSelectorTemplate(product.variants, product.id);
	  } else {
	    productInput = productInputTemplate(product.variants);
	  }
	  let inputProperty = '';
	  let inputValue = '';
	  if (isPreOrder) {
	    if (firstProductVariant && 'pre_order' in firstProductVariant) {
	      inputProperty = preorder;
	      inputValue = firstProductVariant.pre_order.formatted_date;
	    }
	  }
	  preorderInput = preorderInputTemplate(inputProperty, inputValue);
	  btnState = product.available ? 'default' : 'disabled';
	  addToCartBtn = addToCartBtnTemplate(buttonStates, btnState);
	  const template = `
    <div class="quick-buy-form js-product-form" data-tags="${productTags}" data-handle="${product.handle}">
      <form id=${id} data-ref="product-form">
      ${variantSelector}
      ${productInput}
      ${preorderInput}
      ${addToCartBtn}
    </form>
  </div>
`;
	  return template;
	};
	const getPreOrderInfo = product => {
	  let preOrderInProduct = 0;
	  if (product.variants.length === 1 && 'pre_order' in product.variants[0]) {
	    return true;
	  }
	  product.variants.forEach(variant => {
	    if (product.variants.length > 1 && variant.available && 'pre_order' in variant || !variant.available) {
	      preOrderInProduct += 1;
	    }
	  });
	  return preOrderInProduct === product.variants.length ? true : false;
	};
	const compileProductCard = (product, idx, collection) => {
	  let isMobile = window.innerWidth < breakpoints$1.md;
	  let layoutClass = '';
	  let delay = 0.02;
	  let animationDelay = idx * delay;
	  let quickShopOptions = '';
	  let hoverImg = '';
	  let compareAtPrice = '';
	  let upcyclingTagName = 'plèi';
	  let upcyclingTag = '';
	  let hoverImgUrl;
	  let soldOutLabel = '';
	  let preorderTitle = '';
	  let preorderInfo = '';
	  const firstProductVariant = product.variants[0];
	  const preOrderSettings = getPreOrderInfo(product);
	  const isPreOrder = preOrderSettings;
	  const titleArray = product.title.split('-');
	  const edition = titleArray[titleArray.length - 1];
	  const editionLabel = title_edition.replace('{{ edition }}', edition);
	  const url = product.url;
	  const title = titleArray[0];
	  const price = product.variants[0].price; // todo: fix price
	  const productImg = product.featured_image_url ? product.featured_image_url : product.images ? product.images[0]?.src : '';
	  quickShopOptions = compileQuickShop(product, collection);
	  if (product.tags.includes(upcyclingTagName)) {
	    upcyclingTag = '<div class="product-card__tag"></div>';
	  }
	  if (product.variants[0].compare_at_price) {
	    compareAtPrice = `<span class="ts-discount">${product.variants[0].compare_at_price}</span>`;
	  }
	  if (product.hover_image && !isMobile) {
	    hoverImgUrl = generateImageUrl(product.hover_image);
	    hoverImg = `<div class="product-card__image is-hover" style="background-image: url(${generateImageUrl(hoverImgUrl)});"></div>`;
	  }
	  if (!product.available) {
	    soldOutLabel = soldOutProductLabel(sold_out);
	  }
	  if (isPreOrder) {
	    if (firstProductVariant && 'pre_order' in firstProductVariant) {
	      preorderTitle = preorder;
	      preorderInfo = firstProductVariant.pre_order.formatted_date;
	    }
	  }
	  const imgSrc = generateImageUrl(productImg);
	  const productCardTemplate = `
  <article class="product-card js-card is-animation-card ${layoutClass} item-${idx}" data-ref="product-card" style="transition-delay: ${animationDelay}s;" data-flip="grid">
    <a class="product-card__inner js-product-anchor" href="${url}">
      <div class="product-card__image-container">
        <div class="product-card__image is-default" data-ref="product-card-img" data-img-src="${imgSrc}" style="background-image: url(${imgSrc});"></div>
        ${hoverImg}
        ${upcyclingTag}
        <div id="preorder-${product.id}" class="product-card__preorder-info">
		${isPreOrder && 'pre_order' in firstProductVariant ? `
			<span class="ts-label-s js-preorder-title">${preorderTitle}</span>
			<span class="ts-label-s ts-grey js-preorder-info">${preorderInfo}</span>
		` : ''}
		</div>
      </div>
      <div class="product-card__details">
        <div class="product-card__form">
          ${quickShopOptions}
          <span class="product-card__error ts-error ts-label-s" data-ref="error-container"></span>
        </div>
        <div class="product-card__details-text">
          <div class="product-card__fave-btn">
            ${favoriteButtonTemplate(product.id)}
          </div>
          <h3 class="ts-label-s">${title}</h3>
          <p class="ts-label-s edition-label ts-grey">${editionLabel}</p>
          <span class="ts-label-s preorder-label ts-grey js-preorder-label"></span>
          ${soldOutLabel}
          <span class="ts-label-s price-label">${compareAtPrice} ${price}</span>
        </div>
      </div>
    </a>
  </article>
`;
	  return productCardTemplate;
	};

	const classes$4 = {
	  visible: 'is-visible'
	};
	let wishlist;
	var sectionWishlist = () => {
	  const refWishlist = getElementsByRef('wishlist').wishlist;
	  if (!refWishlist) return;
	  const {
	    grid
	  } = getRefs(refWishlist);
	  const init = () => {
	    // @ts-expect-error unknown props
	    wishlist = window.WishlistKing;
	    setWishListState();
	  };
	  const setWishListState = async () => {
	    const collection = await wishlist.toolkit.collection.get();
	    if (collection.products.length) {
	      refWishlist.dataset.state = 'filled';
	      createGrid(collection.products);
	    } else {
	      refWishlist.dataset.state = 'empty';
	    }
	  };
	  const getPrice = price => {
	    return wishlist.toolkit.filters.money(price).replace(',00', '');
	  };
	  const revealItems = items => {
	    items.forEach(item => {
	      item.classList.add(classes$4.visible);
	    });
	  };
	  const createGrid = products => {
	    grid.innerHTML = '';
	    const formatted = products.map(product => ({
	      ...product,
	      variants: product.variants.map(variant => ({
	        ...variant,
	        price: getPrice(variant.price)
	      }))
	    }));
	    formatted.forEach((product, idx) => {
	      grid.innerHTML += compileProductCard(product, idx, 'wishlist');
	    });
	    const {
	      productCard: item
	    } = getRefs(grid);
	    const items = item ? [].concat(item) : [];
	    if (items) {
	      setTimeout(revealItems(items));
	    }
	    dispatchEvent(window, events$2.PRODUCT_CARD_RENDERED);
	  };
	  // @ts-expect-error unknown props
	  if (window.WishlistKing) {
	    init();
	  } else {
	    window.addEventListener(events$2.WISHLIST_READY, init);
	  }
	  return () => {
	    window.removeEventListener(events$2.WISHLIST_READY, init);
	  };
	};

	var sectionWishlist$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: sectionWishlist
	});

	const selectors$2 = {
	  item: '.js-teaser-item'
	};
	const classes$3 = {
	  reveal: 'reveal',
	  active: 'is-active'
	};
	var sectionArticleTeaser = () => {
	  const {
	    articleTeaser
	  } = getElementsByRef(['article-teaser']);
	  if (!articleTeaser) return;
	  const articleTeasers = Array.isArray(articleTeaser) ? articleTeaser : [articleTeaser];
	  articleTeasers.forEach(teaser => {
	    let interval;
	    let currentIdx = 0;
	    let lastIdx = 0;
	    let mobileIndex = 0;
	    let mobileInterval;
	    const {
	      previewImages,
	      items,
	      articleTeaserItem
	    } = getRefs(teaser);
	    const init = () => {
	      setEventlisteners();
	    };
	    const setEventlisteners = () => {
	      teaser.addEventListener('mouseover', handleMouseOver);
	    };
	    const handleMouseOver = e => {
	      const item = e.target instanceof Element ? e.target.closest(selectors$2.item) : null;
	      if (item) {
	        const activeIdx = item.dataset.index ? item.dataset.index : 0;
	        const links = items ? Array.from(items) : [];
	        links.forEach(link => {
	          if (link == item) {
	            link.classList.add(classes$3.active);
	          } else {
	            link.classList.remove(classes$3.active);
	          }
	        });
	        if (lastIdx === activeIdx) return;
	        lastIdx = activeIdx;
	        stopCounter();
	        revealImage(previewImages, activeIdx);
	        if (item.dataset.imageAmount) {
	          const imageAmount = item.dataset.imageAmount;
	          const preview = previewImages.find(p => p?.dataset?.index === activeIdx);
	          const {
	            revealImages
	          } = getRefs(preview);
	          if (revealImages.length) {
	            revealImage(revealImages, 0);
	            interval = setInterval(() => {
	              if (currentIdx == imageAmount - 1) {
	                currentIdx = 0;
	              } else {
	                currentIdx = currentIdx + 1;
	              }
	              revealImage(revealImages, currentIdx);
	            }, 1800);
	          }
	        }
	      }
	    };
	    const stopCounter = () => {
	      clearInterval(interval ?? undefined);
	    };
	    if (window.innerWidth <= breakpoints$1.md) {
	      const updateClasses = () => {
	        previewImages.forEach((item, idx) => {
	          const reveal = idx === mobileIndex;
	          item.classList.toggle('reveal', reveal);
	          item.firstElementChild?.classList.add('reveal');
	          articleTeaserItem[idx].classList.toggle('reveal', reveal);
	        });
	      };
	      updateClasses();
	      mobileInterval = setInterval(() => {
	        mobileIndex = (mobileIndex + 1) % previewImages.length;
	        updateClasses();
	      }, 3200);
	    }
	    const revealImage = (images, idx) => {
	      images.forEach(img => {
	        if (img.dataset.index == idx) {
	          img.classList.add(classes$3.reveal);
	        } else {
	          img.classList.remove(classes$3.reveal);
	        }
	      });
	    };
	    init();
	    return () => {
	      teaser.removeEventListener('mouseover', handleMouseOver);
	      if (mobileInterval) clearInterval(mobileInterval);
	    };
	  });
	};

	var sectionArticleTeaser$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: sectionArticleTeaser
	});

	const selectors$1 = {
	  lineItem: '.js-line-item',
	  removeBtn: '.js-remove-btn',
	  decrementBtn: '.js-decrement-btn',
	  incrementBtn: '.js-increment-btn',
	  lineItemCounter: '.js-line-item-counter'
	};
	const classes$2 = {
	  hidden: 'is-hidden',
	  open: 'is-open',
	  loaded: 'loaded'
	};
	var fragmentLineItemsList = () => {
	  const {
	    cart
	  } = getElementByRef(['cart']);
	  if (!cart) return;
	  const cartRefs = getRefs(cart, true);
	  const init = () => {
	    if (cartRefs.current.lineItems) {
	      const lineItems = Array.isArray(cartRefs.current.lineItems) ? cartRefs.current.lineItems : [cartRefs.current.lineItems];
	      lineItems.forEach(lineItem => {
	        const image = lineItem.getElementsByTagName('img')[0];
	        image.classList.add(classes$2.loaded);
	        lineItem.addEventListener('click', handleItemClick);
	      });
	    }
	    if (cartRefs.current.sizeSelect) {
	      const selectElements = Array.isArray(cartRefs.current.sizeSelect) ? cartRefs.current.sizeSelect : [cartRefs.current.sizeSelect];
	      selectElements.forEach(selectEl => {
	        initSizeSelect(selectEl, selectElements);
	      });
	    }
	  };
	  const initSizeSelect = (selectEl, selectElements) => {
	    const {
	      select,
	      options
	    } = getRefs(selectEl);
	    let selected, container, item;
	    selected = document.createElement('div');
	    selected.setAttribute('class', `p-select__selected ts-label-m`);
	    selected.innerHTML = options[select.selectedIndex].innerHTML;
	    container = document.createElement('div');
	    container.setAttribute('class', 'p-select__item-list');
	    container.classList.add(classes$2.hidden);
	    const handleLineItemClick = e => {
	      e.preventDefault();
	      const {
	        selectedVariantId,
	        currentVariantId,
	        currentQuantity
	      } = e.target.dataset;
	      const updates = {
	        [currentVariantId]: 0,
	        [selectedVariantId]: currentQuantity
	      };
	      updateCart(updates);
	    };
	    const handleToggleList = () => {
	      // close the other dropdowns
	      selectElements.forEach(select => {
	        if (select === selectEl) return;
	        select.querySelector('.p-select__item-list').classList.add(classes$2.hidden);
	        select.classList.remove(classes$2.open);
	      });
	      container.classList.toggle(classes$2.hidden);
	      selectEl.classList.toggle(classes$2.open);
	    };
	    options.forEach((option, i) => {
	      if (i === 0) return;
	      let quantity = 0;
	      const lineItem = selectEl.closest(selectors$1.lineItem);
	      if (lineItem) {
	        quantity = lineItem.dataset.quantity;
	      }
	      const currentVariantId = option.dataset.variantId;
	      const selectedVariantId = option.value;
	      const {
	        available
	      } = option.dataset;
	      item = document.createElement(available === 'true' ? 'a' : 'button');
	      item.dataset.currentVariantId = currentVariantId;
	      item.dataset.selectedVariantId = selectedVariantId;
	      item.dataset.currentQuantity = quantity.toString();
	      item.dataset.productId = currentVariantId;
	      item.setAttribute('class', 'p-select__item ts-label-s');
	      item.innerHTML = option.innerHTML;
	      if (available === 'true') {
	        item.setAttribute('href', `/cart/update?updates[${currentVariantId}]=0&updates[${selectedVariantId}]=${quantity}`);
	        item.addEventListener('click', handleLineItemClick);
	      } else {
	        // make it a BIS-button
	        item.textContent += ' - ' + window.translations?.notify_me;
	        item.classList.add('is-disabled');
	        item.setAttribute('type', 'button');
	      }
	      container.appendChild(item);
	    });
	    selectEl.appendChild(selected);
	    selectEl.appendChild(container);
	    selected.addEventListener('click', handleToggleList);
	  };
	  const handleItemClick = e => {
	    const selectOption = e.target.closest('.p-select__item');
	    const lineItem = e.target.closest(selectors$1.lineItem);
	    const removeBtn = e.target.closest(selectors$1.removeBtn);
	    const decrementBtn = e.target.closest(selectors$1.decrementBtn);
	    const incrementBtn = e.target.closest(selectors$1.incrementBtn);
	    const {
	      id,
	      quantity
	    } = lineItem.dataset;
	    // show BIS-modal
	    if (selectOption && selectOption.tagName === 'BUTTON') {
	      const {
	        selectedVariantId
	      } = selectOption.dataset;
	      dispatchEvent(window, events$2.TOGGLE_BIS, {
	        variantId: selectedVariantId
	      });
	      if (selectOption.parentNode) {
	        selectOption.parentNode.classList.toggle(classes$2.hidden);
	      }
	    }
	    if (removeBtn) {
	      e.preventDefault();
	      lineItem.remove();
	      handleUpdateCart(id, 0);
	    }
	    if (decrementBtn || incrementBtn) {
	      const newQuantity = parseInt(quantity) + (decrementBtn ? -1 : 1);
	      handleUpdateCart(id, newQuantity);
	    }
	  };
	  const maybeDisableIncrementButtons = async (id, quantity) => {
	    const lineItem = document.body.querySelector(`${selectors$1.lineItem}[data-id="${id}"]`);
	    if (!lineItem) return;
	    const incrementButton = lineItem.querySelector(selectors$1.incrementBtn);
	    const lineItemCounter = lineItem.querySelector(selectors$1.lineItemCounter);
	    const lineItemInventory = Number(lineItemCounter?.getAttribute('max'));
	    const isDisabled = !!(lineItemInventory && lineItemInventory <= quantity);
	    incrementButton?.toggleAttribute('disabled', isDisabled);
	  };
	  const handleUpdateCart = async (id, quantity) => {
	    await changeCart(id, quantity);
	    maybeDisableIncrementButtons(id, quantity);
	  };
	  const reInit = () => {
	    setTimeout(init);
	  };
	  init();
	  window.addEventListener(events$2.CART_DOM_UPDATED, reInit);
	  return () => {
	    window.removeEventListener(events$2.CART_DOM_UPDATED, reInit);
	    if (cartRefs.current.lineItems) {
	      const lineItems = Array.isArray(cartRefs.current.lineItems) ? cartRefs.current.lineItems : [cartRefs.current.lineItems];
	      lineItems.forEach(lineItem => {
	        lineItem.removeEventListener('click', handleItemClick);
	      });
	    }
	  };
	};

	var fragmentLineItemsList$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: fragmentLineItemsList
	});

	/**
	 * defines a focus group
	 */
	var FOCUS_GROUP = 'data-focus-lock';
	/**
	 * disables element discovery inside a group marked by key
	 */
	var FOCUS_DISABLED = 'data-focus-lock-disabled';
	/**
	 * allows uncontrolled focus within the marked area, effectively disabling focus lock for it's content
	 */
	var FOCUS_ALLOW = 'data-no-focus-lock';
	/**
	 * instructs autofocus engine to pick default autofocus inside a given node
	 * can be set on the element or container
	 */
	var FOCUS_AUTO = 'data-autofocus-inside';
	/**
	 * instructs autofocus to ignore elements within a given node
	 * can be set on the element or container
	 */
	var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

	/*
	IE11 support
	 */
	var toArray = function (a) {
	  var ret = Array(a.length);
	  for (var i = 0; i < a.length; ++i) {
	    ret[i] = a[i];
	  }
	  return ret;
	};
	var asArray = function (a) {
	  return Array.isArray(a) ? a : [a];
	};
	var getFirst = function (a) {
	  return Array.isArray(a) ? a[0] : a;
	};

	var isElementHidden = function (node) {
	  // we can measure only "elements"
	  // consider others as "visible"
	  if (node.nodeType !== Node.ELEMENT_NODE) {
	    return false;
	  }
	  var computedStyle = window.getComputedStyle(node, null);
	  if (!computedStyle || !computedStyle.getPropertyValue) {
	    return false;
	  }
	  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
	};
	var getParentNode = function (node) {
	  // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
	  return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ?
	  // eslint-disable-next-line @typescript-eslint/no-explicit-any
	  node.parentNode.host : node.parentNode;
	};
	var isTopNode = function (node) {
	  // @ts-ignore
	  return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
	};
	var isVisibleUncached = function (node, checkParent) {
	  return !node || isTopNode(node) || !isElementHidden(node) && checkParent(getParentNode(node));
	};
	var isVisibleCached = function (visibilityCache, node) {
	  var cached = visibilityCache.get(node);
	  if (cached !== undefined) {
	    return cached;
	  }
	  var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
	  visibilityCache.set(node, result);
	  return result;
	};
	var isAutoFocusAllowedUncached = function (node, checkParent) {
	  return node && !isTopNode(node) ? isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false : true;
	};
	var isAutoFocusAllowedCached = function (cache, node) {
	  var cached = cache.get(node);
	  if (cached !== undefined) {
	    return cached;
	  }
	  var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
	  cache.set(node, result);
	  return result;
	};
	var getDataset = function (node) {
	  // @ts-ignore
	  return node.dataset;
	};
	var isHTMLButtonElement = function (node) {
	  return node.tagName === 'BUTTON';
	};
	var isHTMLInputElement = function (node) {
	  return node.tagName === 'INPUT';
	};
	var isRadioElement = function (node) {
	  return isHTMLInputElement(node) && node.type === 'radio';
	};
	var notHiddenInput = function (node) {
	  return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
	};
	var isAutoFocusAllowed = function (node) {
	  var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
	  return ![true, 'true', ''].includes(attribute);
	};
	var isGuard = function (node) {
	  var _a;
	  return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
	};
	var isNotAGuard = function (node) {
	  return !isGuard(node);
	};
	var isDefined = function (x) {
	  return Boolean(x);
	};

	var tabSort = function (a, b) {
	  var tabDiff = a.tabIndex - b.tabIndex;
	  var indexDiff = a.index - b.index;
	  if (tabDiff) {
	    if (!a.tabIndex) {
	      return 1;
	    }
	    if (!b.tabIndex) {
	      return -1;
	    }
	  }
	  return tabDiff || indexDiff;
	};
	var orderByTabIndex = function (nodes, filterNegative, keepGuards) {
	  return toArray(nodes).map(function (node, index) {
	    return {
	      node: node,
	      index: index,
	      tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
	    };
	  }).filter(function (data) {
	    return !filterNegative || data.tabIndex >= 0;
	  }).sort(tabSort);
	};

	/**
	 * list of the object to be considered as focusable
	 */
	var tabbables = ['button:enabled', 'select:enabled', 'textarea:enabled', 'input:enabled',
	// elements with explicit roles will also use explicit tabindex
	// '[role="button"]',
	'a[href]', 'area[href]', 'summary', 'iframe', 'object', 'embed', 'audio[controls]', 'video[controls]', '[tabindex]', '[contenteditable]', '[autofocus]'];

	var queryTabbables = tabbables.join(',');
	var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
	var getFocusablesWithShadowDom = function (parent, withGuards) {
	  return toArray((parent.shadowRoot || parent).children).reduce(function (acc, child) {
	    return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
	  }, []);
	};
	var getFocusablesWithIFrame = function (parent, withGuards) {
	  var _a;
	  // contentDocument of iframe will be null if current origin cannot access it
	  if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
	    return getFocusables([parent.contentDocument.body], withGuards);
	  }
	  return [parent];
	};
	var getFocusables = function (parents, withGuards) {
	  return parents.reduce(function (acc, parent) {
	    var _a;
	    var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
	    var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function (node) {
	      return getFocusablesWithIFrame(node, withGuards);
	    }));
	    return acc.concat(
	    // add all tabbables inside and within shadow DOMs in DOM order
	    focusableWithIframes,
	    // add if node is tabbable itself
	    parent.parentNode ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) {
	      return node === parent;
	    }) : []);
	  }, []);
	};
	/**
	 * return a list of focusable nodes within an area marked as "auto-focusable"
	 * @param parent
	 */
	var getParentAutofocusables = function (parent) {
	  var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
	  return toArray(parentFocus).map(function (node) {
	    return getFocusables([node]);
	  }).reduce(function (acc, nodes) {
	    return acc.concat(nodes);
	  }, []);
	};

	/**
	 * given list of focusable elements keeps the ones user can interact with
	 * @param nodes
	 * @param visibilityCache
	 */
	var filterFocusable = function (nodes, visibilityCache) {
	  return toArray(nodes).filter(function (node) {
	    return isVisibleCached(visibilityCache, node);
	  }).filter(function (node) {
	    return notHiddenInput(node);
	  });
	};
	var filterAutoFocusable = function (nodes, cache) {
	  if (cache === void 0) {
	    cache = new Map();
	  }
	  return toArray(nodes).filter(function (node) {
	    return isAutoFocusAllowedCached(cache, node);
	  });
	};
	/**
	 * only tabbable ones
	 * (but with guards which would be ignored)
	 */
	var getTabbableNodes = function (topNodes, visibilityCache, withGuards) {
	  return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
	};
	/**
	 * actually anything "focusable", not only tabbable
	 * (without guards, as long as they are not expected to be focused)
	 */
	var getAllTabbableNodes = function (topNodes, visibilityCache) {
	  return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
	};
	/**
	 * return list of nodes which are expected to be auto-focused
	 * @param topNode
	 * @param visibilityCache
	 */
	var parentAutofocusables = function (topNode, visibilityCache) {
	  return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
	};
	/*
	 * Determines if element is contained in scope, including nested shadow DOMs
	 */
	var contains = function (scope, element) {
	  if (scope.shadowRoot) {
	    return contains(scope.shadowRoot, element);
	  } else {
	    if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) {
	      return true;
	    }
	    return toArray(scope.children).some(function (child) {
	      var _a;
	      if (child instanceof HTMLIFrameElement) {
	        var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
	        if (iframeBody) {
	          return contains(iframeBody, element);
	        }
	        return false;
	      }
	      return contains(child, element);
	    });
	  }
	};

	/**
	 * in case of multiple nodes nested inside each other
	 * keeps only top ones
	 * this is O(nlogn)
	 * @param nodes
	 * @returns {*}
	 */
	var filterNested = function (nodes) {
	  var contained = new Set();
	  var l = nodes.length;
	  for (var i = 0; i < l; i += 1) {
	    for (var j = i + 1; j < l; j += 1) {
	      var position = nodes[i].compareDocumentPosition(nodes[j]);
	      /* eslint-disable no-bitwise */
	      if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
	        contained.add(j);
	      }
	      if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
	        contained.add(i);
	      }
	      /* eslint-enable */
	    }
	  }
	  return nodes.filter(function (_, index) {
	    return !contained.has(index);
	  });
	};
	/**
	 * finds top most parent for a node
	 * @param node
	 * @returns {*}
	 */
	var getTopParent = function (node) {
	  return node.parentNode ? getTopParent(node.parentNode) : node;
	};
	/**
	 * returns all "focus containers" inside a given node
	 * @param node
	 * @returns {T}
	 */
	var getAllAffectedNodes = function (node) {
	  var nodes = asArray(node);
	  return nodes.filter(Boolean).reduce(function (acc, currentNode) {
	    var group = currentNode.getAttribute(FOCUS_GROUP);
	    acc.push.apply(acc, group ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])")))) : [currentNode]);
	    return acc;
	  }, []);
	};

	var safeProbe = function (cb) {
	  try {
	    return cb();
	  } catch (e) {
	    return undefined;
	  }
	};

	/**
	 * returns active element from document or from nested shadowdoms
	 */
	var getActiveElement = function (inDocument) {
	  if (inDocument === void 0) {
	    inDocument = document;
	  }
	  if (!inDocument || !inDocument.activeElement) {
	    return undefined;
	  }
	  var activeElement = inDocument.activeElement;
	  return activeElement.shadowRoot ? getActiveElement(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && safeProbe(function () {
	    return activeElement.contentWindow.document;
	  }) ? getActiveElement(activeElement.contentWindow.document) : activeElement;
	};

	var focusInFrame = function (frame, activeElement) {
	  return frame === activeElement;
	};
	var focusInsideIframe = function (topNode, activeElement) {
	  return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) {
	    return focusInFrame(node, activeElement);
	  }));
	};
	/**
	 * @returns {Boolean} true, if the current focus is inside given node or nodes
	 */
	var focusInside = function (topNode, activeElement) {
	  // const activeElement = document && getActiveElement();
	  if (activeElement === void 0) {
	    activeElement = getActiveElement(getFirst(topNode).ownerDocument);
	  }
	  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
	    return false;
	  }
	  return getAllAffectedNodes(topNode).some(function (node) {
	    return contains(node, activeElement) || focusInsideIframe(node, activeElement);
	  });
	};

	/**
	 * focus is hidden FROM the focus-lock
	 * ie contained inside a node focus-lock shall ignore
	 * @returns {boolean} focus is currently is in "allow" area
	 */
	var focusIsHidden = function (inDocument) {
	  if (inDocument === void 0) {
	    inDocument = document;
	  }
	  var activeElement = getActiveElement(inDocument);
	  if (!activeElement) {
	    return false;
	  }
	  // this does not support setting FOCUS_ALLOW within shadow dom
	  return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) {
	    return contains(node, activeElement);
	  });
	};

	var findSelectedRadio = function (node, nodes) {
	  return nodes.filter(isRadioElement).filter(function (el) {
	    return el.name === node.name;
	  }).filter(function (el) {
	    return el.checked;
	  })[0] || node;
	};
	var correctNode = function (node, nodes) {
	  if (isRadioElement(node) && node.name) {
	    return findSelectedRadio(node, nodes);
	  }
	  return node;
	};
	/**
	 * giving a set of radio inputs keeps only selected (tabbable) ones
	 * @param nodes
	 */
	var correctNodes = function (nodes) {
	  // IE11 has no Set(array) constructor
	  var resultSet = new Set();
	  nodes.forEach(function (node) {
	    return resultSet.add(correctNode(node, nodes));
	  });
	  // using filter to support IE11
	  return nodes.filter(function (node) {
	    return resultSet.has(node);
	  });
	};

	var pickFirstFocus = function (nodes) {
	  if (nodes[0] && nodes.length > 1) {
	    return correctNode(nodes[0], nodes);
	  }
	  return nodes[0];
	};
	var pickFocusable = function (nodes, index) {
	  if (nodes.length > 1) {
	    return nodes.indexOf(correctNode(nodes[index], nodes));
	  }
	  return index;
	};

	var NEW_FOCUS = 'NEW_FOCUS';
	/**
	 * Main solver for the "find next focus" question
	 * @param innerNodes
	 * @param outerNodes
	 * @param activeElement
	 * @param lastNode
	 * @returns {number|string|undefined|*}
	 */
	var newFocus = function (innerNodes, outerNodes, activeElement, lastNode) {
	  var cnt = innerNodes.length;
	  var firstFocus = innerNodes[0];
	  var lastFocus = innerNodes[cnt - 1];
	  var isOnGuard = isGuard(activeElement);
	  // focus is inside
	  if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
	    return undefined;
	  }
	  var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
	  var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
	  var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
	  var indexDiff = activeIndex - lastIndex;
	  var firstNodeIndex = outerNodes.indexOf(firstFocus);
	  var lastNodeIndex = outerNodes.indexOf(lastFocus);
	  var correctedNodes = correctNodes(outerNodes);
	  var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
	  var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
	  var returnFirstNode = pickFocusable(innerNodes, 0);
	  var returnLastNode = pickFocusable(innerNodes, cnt - 1);
	  // new focus
	  if (activeIndex === -1 || lastNodeInside === -1) {
	    return NEW_FOCUS;
	  }
	  // old focus
	  if (!indexDiff && lastNodeInside >= 0) {
	    return lastNodeInside;
	  }
	  // first element
	  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
	    return returnLastNode;
	  }
	  // last element
	  if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
	    return returnFirstNode;
	  }
	  // jump out, but not on the guard
	  if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
	    return lastNodeInside;
	  }
	  // focus above lock
	  if (activeIndex <= firstNodeIndex) {
	    return returnLastNode;
	  }
	  // focus below lock
	  if (activeIndex > lastNodeIndex) {
	    return returnFirstNode;
	  }
	  // index is inside tab order, but outside Lock
	  if (indexDiff) {
	    if (Math.abs(indexDiff) > 1) {
	      return lastNodeInside;
	    }
	    return (cnt + lastNodeInside + indexDiff) % cnt;
	  }
	  // do nothing
	  return undefined;
	};

	var findAutoFocused = function (autoFocusables) {
	  return function (node) {
	    var _a;
	    var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
	    return (
	      // @ts-expect-error
	      node.autofocus ||
	      //
	      autofocus !== undefined && autofocus !== 'false' ||
	      //
	      autoFocusables.indexOf(node) >= 0
	    );
	  };
	};
	var pickAutofocus = function (nodesIndexes, orderedNodes, groups) {
	  var nodes = nodesIndexes.map(function (_a) {
	    var node = _a.node;
	    return node;
	  });
	  var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
	  if (autoFocusable && autoFocusable.length) {
	    return pickFirstFocus(autoFocusable);
	  }
	  return pickFirstFocus(filterAutoFocusable(orderedNodes));
	};

	var getParents = function (node, parents) {
	  if (parents === void 0) {
	    parents = [];
	  }
	  parents.push(node);
	  if (node.parentNode) {
	    getParents(node.parentNode.host || node.parentNode, parents);
	  }
	  return parents;
	};
	/**
	 * finds a parent for both nodeA and nodeB
	 * @param nodeA
	 * @param nodeB
	 * @returns {boolean|*}
	 */
	var getCommonParent = function (nodeA, nodeB) {
	  var parentsA = getParents(nodeA);
	  var parentsB = getParents(nodeB);
	  // tslint:disable-next-line:prefer-for-of
	  for (var i = 0; i < parentsA.length; i += 1) {
	    var currentParent = parentsA[i];
	    if (parentsB.indexOf(currentParent) >= 0) {
	      return currentParent;
	    }
	  }
	  return false;
	};
	var getTopCommonParent = function (baseActiveElement, leftEntry, rightEntries) {
	  var activeElements = asArray(baseActiveElement);
	  var leftEntries = asArray(leftEntry);
	  var activeElement = activeElements[0];
	  var topCommon = false;
	  leftEntries.filter(Boolean).forEach(function (entry) {
	    topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
	    rightEntries.filter(Boolean).forEach(function (subEntry) {
	      var common = getCommonParent(activeElement, subEntry);
	      if (common) {
	        if (!topCommon || contains(common, topCommon)) {
	          topCommon = common;
	        } else {
	          topCommon = getCommonParent(common, topCommon);
	        }
	      }
	    });
	  });
	  // TODO: add assert here?
	  return topCommon;
	};
	/**
	 * return list of nodes which are expected to be autofocused inside a given top nodes
	 * @param entries
	 * @param visibilityCache
	 */
	var allParentAutofocusables = function (entries, visibilityCache) {
	  return entries.reduce(function (acc, node) {
	    return acc.concat(parentAutofocusables(node, visibilityCache));
	  }, []);
	};

	var reorderNodes = function (srcNodes, dstNodes) {
	  var remap = new Map();
	  // no Set(dstNodes) for IE11 :(
	  dstNodes.forEach(function (entity) {
	    return remap.set(entity.node, entity);
	  });
	  // remap to dstNodes
	  return srcNodes.map(function (node) {
	    return remap.get(node);
	  }).filter(isDefined);
	};
	/**
	 * given top node(s) and the last active element return the element to be focused next
	 * @param topNode
	 * @param lastNode
	 */
	var getFocusMerge = function (topNode, lastNode) {
	  var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
	  var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
	  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
	  var visibilityCache = new Map();
	  var anyFocusable = getAllTabbableNodes(entries, visibilityCache);
	  var innerElements = getTabbableNodes(entries, visibilityCache).filter(function (_a) {
	    var node = _a.node;
	    return isNotAGuard(node);
	  });
	  if (!innerElements[0]) {
	    innerElements = anyFocusable;
	    if (!innerElements[0]) {
	      return undefined;
	    }
	  }
	  var outerNodes = getAllTabbableNodes([commonParent], visibilityCache).map(function (_a) {
	    var node = _a.node;
	    return node;
	  });
	  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
	  var innerNodes = orderedInnerElements.map(function (_a) {
	    var node = _a.node;
	    return node;
	  });
	  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode);
	  if (newId === NEW_FOCUS) {
	    var focusNode = pickAutofocus(anyFocusable, innerNodes, allParentAutofocusables(entries, visibilityCache));
	    if (focusNode) {
	      return {
	        node: focusNode
	      };
	    } else {
	      return undefined;
	    }
	  }
	  if (newId === undefined) {
	    return newId;
	  }
	  return orderedInnerElements[newId];
	};

	var focusOn = function (target, focusOptions) {
	  if ('focus' in target) {
	    target.focus(focusOptions);
	  }
	  if ('contentWindow' in target && target.contentWindow) {
	    target.contentWindow.focus();
	  }
	};
	var guardCount = 0;
	var lockDisabled = false;
	/**
	 * Sets focus at a given node. The last focused element will help to determine which element(first or last) should be focused.
	 * HTML markers (see {@link import('./constants').FOCUS_AUTO} constants) can control autofocus
	 * @param topNode
	 * @param lastNode
	 * @param options
	 */
	var setFocus = function (topNode, lastNode, options) {
	  if (options === void 0) {
	    options = {};
	  }
	  var focusable = getFocusMerge(topNode, lastNode);
	  if (lockDisabled) {
	    return;
	  }
	  if (focusable) {
	    if (guardCount > 2) {
	      // tslint:disable-next-line:no-console

	      lockDisabled = true;
	      setTimeout(function () {
	        lockDisabled = false;
	      }, 1);
	      return;
	    }
	    guardCount++;
	    focusOn(focusable.node, options.focusOptions);
	    guardCount--;
	  }
	};

	var moveFocusInside = setFocus;
	//

	var lastActiveTrap = 0;
	var lastActiveFocus = null;
	var focusOnBody = function focusOnBody() {
	  return document && document.activeElement === document.body;
	};
	var isFreeFocus = function isFreeFocus() {
	  return focusOnBody() || focusIsHidden();
	};
	var activateTrap = function activateTrap() {
	  var result = false;
	  if (lastActiveTrap) {
	    var observed = lastActiveTrap;
	    if (!isFreeFocus()) {
	      if (observed && !focusInside(observed)) {
	        result = moveFocusInside(observed, lastActiveFocus);
	      }
	      lastActiveFocus = document.activeElement;
	    }
	  }
	  return result;
	};
	var reducePropsToState = function reducePropsToState(propsList) {
	  return propsList.filter(function (node) {
	    return node;
	  }).slice(-1)[0];
	};
	var handleStateChangeOnClient = function handleStateChangeOnClient(trap) {
	  lastActiveTrap = trap;
	  if (trap) {
	    activateTrap();
	  }
	};
	var instances = [];
	var emitChange = function emitChange(event) {
	  if (handleStateChangeOnClient(reducePropsToState(instances))) {
	    event && event.preventDefault();
	    return true;
	  }
	  return false;
	};
	var attachHandler = function attachHandler() {
	  document.addEventListener('focusin', emitChange);
	};
	var detachHandler = function detachHandler() {
	  document.removeEventListener('focusin', emitChange);
	};
	var focusLock = {
	  on: function on(domNode) {
	    if (instances.length === 0) {
	      attachHandler();
	    }
	    if (instances.indexOf(domNode) < 0) {
	      instances.push(domNode);
	      emitChange();
	    }
	  },
	  off: function off(domNode) {
	    instances = instances.filter(function (node) {
	      return node !== domNode;
	    });
	    emitChange();
	    if (instances.length === 0) {
	      detachHandler();
	    }
	  }
	};

	const SEARCH_PARAM = 'openCountrySelector';
	const CLOSE_BUTTON_SELECTOR = '.country-selector__popup__header__close';
	class CountrySelectorModal {
	  constructor() {
	    this.selectorModals = document.querySelectorAll('.selector_popup');
	    this.selectorButtons = document.querySelectorAll('.selector-button');
	    this.boundHandleEscapeKeydown = this.handleEscapeKeydown.bind(this);
	    this.boundHandleButtonClick = this.handleButtonClick.bind(this);
	    this.boundCloseModal = this.closeModal.bind(this);
	  }
	  handleButtonClick(event) {
	    const button = event.currentTarget;
	    const countrySelectorModal = document.querySelector(`#${button.dataset.puid}`);
	    if (countrySelectorModal) {
	      this.showModal(countrySelectorModal);
	    }
	  }
	  showModal(countrySelectorModal) {
	    if (!countrySelectorModal) return;
	    const closeModalButton = countrySelectorModal.querySelector(CLOSE_BUTTON_SELECTOR);
	    if (closeModalButton) {
	      closeModalButton.addEventListener('click', this.boundCloseModal);
	    }
	    document.addEventListener('keydown', this.boundHandleEscapeKeydown);
	    countrySelectorModal.classList.add('is-open');
	    document.querySelector('body')?.classList.add('country-selector-modal-is-open');
	    countrySelectorModal.setAttribute('tabindex', '0');
	    focusLock.on(countrySelectorModal);
	  }
	  closeModal() {
	    const countrySelectorModal = document.querySelector('.selector_popup.is-open');
	    if (countrySelectorModal) {
	      countrySelectorModal.classList.remove('is-open');
	      document.querySelector('body')?.classList.remove('country-selector-modal-is-open');
	      focusLock.off(countrySelectorModal);
	      this.clearEvents(countrySelectorModal);
	      // Remove the openCountrySelector parameter from the URL
	      const url = new URL(window.location.href);
	      const urlParams = new URLSearchParams(url.search);
	      urlParams.delete(SEARCH_PARAM);
	      url.search = urlParams.toString();
	      window.history.replaceState({}, document.title, url.toString());
	    }
	  }
	  clearEvents(countrySelectorModal) {
	    const modalCloseButton = countrySelectorModal.querySelector(CLOSE_BUTTON_SELECTOR);
	    document.removeEventListener('keydown', this.boundHandleEscapeKeydown);
	    if (modalCloseButton) {
	      modalCloseButton.removeEventListener('click', this.boundCloseModal);
	    }
	  }
	  handleEscapeKeydown(event) {
	    if (event.key === 'Escape') {
	      this.closeModal();
	    }
	  }
	  getSearchParam() {
	    const url = new URL(window.location.href);
	    const urlParams = new URLSearchParams(url.search);
	    urlParams.delete('country');
	    // Update the URL with the new search params
	    url.search = urlParams.toString();
	    // Update the URL without reloading the page
	    window.history.replaceState({}, document.title, url.toString());
	    return urlParams.has(SEARCH_PARAM);
	  }
	  setupEventListeners() {
	    if (!this.selectorModals || this.selectorButtons.length === 0) return;
	    this.selectorButtons.forEach(button => {
	      button.addEventListener('click', this.boundHandleButtonClick);
	    });
	  }
	  cleanup() {
	    if (this.selectorButtons) {
	      this.selectorButtons.forEach(button => {
	        button.removeEventListener('click', this.boundHandleButtonClick);
	      });
	    }
	    document.removeEventListener('keydown', this.boundHandleEscapeKeydown);
	    if (this.selectorModals) {
	      this.selectorModals.forEach(modal => {
	        if (modal.classList.contains('is-open')) {
	          this.clearEvents(modal);
	          focusLock.off(modal);
	          modal.classList.remove('is-open');
	        }
	      });
	    }
	    document.querySelector('body')?.classList.remove('country-selector-modal-is-open');
	  }
	  init() {
	    if (document.readyState === 'loading') {
	      document.addEventListener('DOMContentLoaded', () => {
	        this.setupEventListeners();
	      });
	    } else {
	      this.setupEventListeners();
	    }
	    if (this.getSearchParam()) {
	      const defaultModal = this.selectorModals[0];
	      if (defaultModal) {
	        this.showModal(defaultModal);
	      }
	    }
	    return this.cleanup.bind(this);
	  }
	}
	var countrySelectorModal = () => {
	  const modal = new CountrySelectorModal();
	  return modal.init();
	};

	var countrySelectorModal$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		CountrySelectorModal: CountrySelectorModal,
		default: countrySelectorModal
	});

	class Accordion {
	  static currentOpen = null; // manage the current opened accordion

	  constructor(domNode, autoClose) {
	    this.autoClose = autoClose;
	    this.rootEl = domNode;
	    this.buttonEl = this.rootEl?.querySelector('button[aria-expanded]') ?? undefined;
	    const controlsId = this.buttonEl?.getAttribute('aria-controls') ?? undefined;
	    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
	    this.contentEl = controlsId ? document.getElementById(controlsId) : undefined;
	    this.closeIconEl = this.buttonEl ? this.buttonEl?.querySelector('.icon-close') : undefined;
	    this.openIconEl = this.buttonEl ? this.buttonEl?.querySelector('.icon-open') : undefined;
	    this.open = this.buttonEl?.getAttribute('aria-expanded') === 'true';
	    // add event listeners
	    this.buttonEl?.addEventListener('click', this.onButtonClick.bind(this));
	    // If the accordion is open by default, set the currentOpen static variable
	    if (this.open) {
	      Accordion.currentOpen = this;
	    }
	  }
	  onButtonClick() {
	    if (!this.open && Accordion.currentOpen && this.autoClose) {
	      // close the currently opened accordion before opening a new one
	      Accordion.closeCurrentOpen();
	    }
	    this.toggle(!this.open);
	  }
	  toggle(open) {
	    // don't do anything if the open state doesn't change
	    if (open === this.open) {
	      return;
	    }
	    // update the internal state
	    this.open = open;
	    // update the currently opened Accordion
	    Accordion.currentOpen = open ? this : null;
	    // handle DOM updates
	    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
	    this.buttonEl?.setAttribute('aria-expanded', `${open}`);
	    const grandParentNode = this.buttonEl?.parentNode?.parentNode;
	    this.buttonEl?.setAttribute('aria-expanded', `${open}`);
	    grandParentNode?.classList.toggle('active', open);
	    if (open) {
	      this.contentEl?.removeAttribute('hidden');
	      this.closeIconEl?.classList.remove('hidden');
	      this.openIconEl?.classList.add('hidden');
	    } else {
	      this.contentEl?.setAttribute('hidden', '');
	      this.closeIconEl?.classList.add('hidden');
	      this.openIconEl?.classList.remove('hidden');
	    }
	  }
	  // Method to close the current opened accordion
	  static closeCurrentOpen() {
	    if (Accordion.currentOpen) {
	      Accordion.currentOpen.setClose();
	    }
	  }
	  // Add public open and close methods for convenience
	  setOpen() {
	    this.toggle(true);
	  }
	  setClose() {
	    this.toggle(false);
	  }
	}

	const AccordionModule = () => {
	  window.addEventListener('DOMContentLoaded', () => {
	    const accordionGroup = document.querySelectorAll('.accordion-group');
	    // init accordions
	    accordionGroup.forEach(accordionGroupEl => {
	      const autoClose = accordionGroupEl?.dataset.closeOthers === 'true';
	      const accordions = accordionGroupEl.querySelectorAll('.accordion');
	      accordions.forEach(accordionEl => {
	        new Accordion(accordionEl, autoClose);
	      });
	    });
	  });
	};

	var main = /*#__PURE__*/Object.freeze({
		__proto__: null,
		AccordionModule: AccordionModule,
		default: AccordionModule
	});

	/*!
	  * PhotoSwipe Lightbox 5.4.4 - https://photoswipe.com
	  * (c) 2024 Dmytro Semenov
	  */
	/** @typedef {import('../photoswipe.js').Point} Point */

	/**
	 * @template {keyof HTMLElementTagNameMap} T
	 * @param {string} className
	 * @param {T} tagName
	 * @param {Node} [appendToEl]
	 * @returns {HTMLElementTagNameMap[T]}
	 */
	function createElement$1(className, tagName, appendToEl) {
	  const el = document.createElement(tagName);
	  if (className) {
	    el.className = className;
	  }
	  if (appendToEl) {
	    appendToEl.appendChild(el);
	  }
	  return el;
	}
	/**
	 * Get transform string
	 *
	 * @param {number} x
	 * @param {number} [y]
	 * @param {number} [scale]
	 * @returns {string}
	 */

	function toTransformString$1(x, y, scale) {
	  let propValue = `translate3d(${x}px,${y || 0}px,0)`;
	  if (scale !== undefined) {
	    propValue += ` scale3d(${scale},${scale},1)`;
	  }
	  return propValue;
	}
	/**
	 * Apply width and height CSS properties to element
	 *
	 * @param {HTMLElement} el
	 * @param {string | number} w
	 * @param {string | number} h
	 */

	function setWidthHeight$1(el, w, h) {
	  el.style.width = typeof w === 'number' ? `${w}px` : w;
	  el.style.height = typeof h === 'number' ? `${h}px` : h;
	}
	/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */

	/** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */

	const LOAD_STATE$1 = {
	  IDLE: 'idle',
	  LOADING: 'loading',
	  LOADED: 'loaded',
	  ERROR: 'error'
	};
	/**
	 * Check if click or keydown event was dispatched
	 * with a special key or via mouse wheel.
	 *
	 * @param {MouseEvent | KeyboardEvent} e
	 * @returns {boolean}
	 */

	function specialKeyUsed$1(e) {
	  return 'button' in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
	}
	/**
	 * Parse `gallery` or `children` options.
	 *
	 * @param {import('../photoswipe.js').ElementProvider} [option]
	 * @param {string} [legacySelector]
	 * @param {HTMLElement | Document} [parent]
	 * @returns HTMLElement[]
	 */

	function getElementsFromOption$1(option, legacySelector, parent = document) {
	  /** @type {HTMLElement[]} */
	  let elements = [];
	  if (option instanceof Element) {
	    elements = [option];
	  } else if (option instanceof NodeList || Array.isArray(option)) {
	    elements = Array.from(option);
	  } else {
	    const selector = typeof option === 'string' ? option : legacySelector;
	    if (selector) {
	      elements = Array.from(parent.querySelectorAll(selector));
	    }
	  }
	  return elements;
	}
	/**
	 * Check if variable is PhotoSwipe class
	 *
	 * @param {any} fn
	 * @returns {boolean}
	 */

	function isPswpClass(fn) {
	  return typeof fn === 'function' && fn.prototype && fn.prototype.goTo;
	}
	/**
	 * Check if browser is Safari
	 *
	 * @returns {boolean}
	 */

	function isSafari$1() {
	  return !!(navigator.vendor && navigator.vendor.match(/apple/i));
	}

	/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */

	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

	/** @typedef {import('../photoswipe.js').DataSource} DataSource */

	/** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */

	/** @typedef {import('../slide/content.js').default} ContentDefault */

	/** @typedef {import('../slide/slide.js').default} Slide */

	/** @typedef {import('../slide/slide.js').SlideData} SlideData */

	/** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */

	/** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */

	/**
	 * Allow adding an arbitrary props to the Content
	 * https://photoswipe.com/custom-content/#using-webp-image-format
	 * @typedef {ContentDefault & Record<string, any>} Content
	 */

	/** @typedef {{ x?: number; y?: number }} Point */

	/**
	 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
	 *
	 *
	 * https://photoswipe.com/adding-ui-elements/
	 *
	 * @prop {undefined} uiRegister
	 * @prop {{ data: UIElementData }} uiElementCreate
	 *
	 *
	 * https://photoswipe.com/events/#initialization-events
	 *
	 * @prop {undefined} beforeOpen
	 * @prop {undefined} firstUpdate
	 * @prop {undefined} initialLayout
	 * @prop {undefined} change
	 * @prop {undefined} afterInit
	 * @prop {undefined} bindEvents
	 *
	 *
	 * https://photoswipe.com/events/#opening-or-closing-transition-events
	 *
	 * @prop {undefined} openingAnimationStart
	 * @prop {undefined} openingAnimationEnd
	 * @prop {undefined} closingAnimationStart
	 * @prop {undefined} closingAnimationEnd
	 *
	 *
	 * https://photoswipe.com/events/#closing-events
	 *
	 * @prop {undefined} close
	 * @prop {undefined} destroy
	 *
	 *
	 * https://photoswipe.com/events/#pointer-and-gesture-events
	 *
	 * @prop {{ originalEvent: PointerEvent }} pointerDown
	 * @prop {{ originalEvent: PointerEvent }} pointerMove
	 * @prop {{ originalEvent: PointerEvent }} pointerUp
	 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
	 * @prop {{ panY: number }} verticalDrag can be default prevented
	 *
	 *
	 * https://photoswipe.com/events/#slide-content-events
	 *
	 * @prop {{ content: Content }} contentInit
	 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
	 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
	 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
	 * @prop {{ content: Content; slide: Slide }} loadError
	 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
	 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
	 * @prop {{ content: Content }} contentLazyLoad can be default prevented
	 * @prop {{ content: Content }} contentAppend can be default prevented
	 * @prop {{ content: Content }} contentActivate can be default prevented
	 * @prop {{ content: Content }} contentDeactivate can be default prevented
	 * @prop {{ content: Content }} contentRemove can be default prevented
	 * @prop {{ content: Content }} contentDestroy can be default prevented
	 *
	 *
	 * undocumented
	 *
	 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
	 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
	 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
	 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
	 *
	 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
	 * @prop {{ x: number; dragging: boolean }} moveMainScroll
	 * @prop {{ slide: Slide }} firstZoomPan
	 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
	 * @prop {undefined} beforeResize
	 * @prop {undefined} resize
	 * @prop {undefined} viewportSize
	 * @prop {undefined} updateScrollOffset
	 * @prop {{ slide: Slide }} slideInit
	 * @prop {{ slide: Slide }} afterSetContent
	 * @prop {{ slide: Slide }} slideLoad
	 * @prop {{ slide: Slide }} appendHeavy can be default prevented
	 * @prop {{ slide: Slide }} appendHeavyContent
	 * @prop {{ slide: Slide }} slideActivate
	 * @prop {{ slide: Slide }} slideDeactivate
	 * @prop {{ slide: Slide }} slideDestroy
	 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
	 * @prop {{ slide: Slide }} zoomPanUpdate
	 * @prop {{ slide: Slide }} initialZoomPan
	 * @prop {{ slide: Slide }} calcSlideSize
	 * @prop {undefined} resolutionChanged
	 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
	 * @prop {{ content: Content }} contentAppendImage can be default prevented
	 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
	 * @prop {undefined} lazyLoad
	 * @prop {{ slide: Slide }} calcBounds
	 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
	 *
	 *
	 * legacy
	 *
	 * @prop {undefined} init
	 * @prop {undefined} initialZoomIn
	 * @prop {undefined} initialZoomOut
	 * @prop {undefined} initialZoomInEnd
	 * @prop {undefined} initialZoomOutEnd
	 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
	 * @prop {{ itemData: SlideData; index: number }} itemData
	 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
	 */

	/**
	 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
	 *
	 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
	 * Modify the total amount of slides. Example on Data sources page.
	 * https://photoswipe.com/filters/#numitems
	 *
	 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
	 * Modify slide item data. Example on Data sources page.
	 * https://photoswipe.com/filters/#itemdata
	 *
	 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
	 * Modify item data when it's parsed from DOM element. Example on Data sources page.
	 * https://photoswipe.com/filters/#domitemdata
	 *
	 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
	 * Modify clicked gallery item index.
	 * https://photoswipe.com/filters/#clickedindex
	 *
	 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
	 * Modify placeholder image source.
	 * https://photoswipe.com/filters/#placeholdersrc
	 *
	 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
	 * Modify if the content is currently loading.
	 * https://photoswipe.com/filters/#iscontentloading
	 *
	 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
	 * Modify if the content can be zoomed.
	 * https://photoswipe.com/filters/#iscontentzoomable
	 *
	 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
	 * Modify if the placeholder should be used for the content.
	 * https://photoswipe.com/filters/#usecontentplaceholder
	 *
	 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
	 * Modify if the placeholder should be kept after the content is loaded.
	 * https://photoswipe.com/filters/#iskeepingplaceholder
	 *
	 *
	 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
	 * Modify an element when the content has error state (for example, if image cannot be loaded).
	 * https://photoswipe.com/filters/#contenterrorelement
	 *
	 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
	 * Modify a UI element that's being created.
	 * https://photoswipe.com/filters/#uielement
	 *
	 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
	 * Modify the thumbnail element from which opening zoom animation starts or ends.
	 * https://photoswipe.com/filters/#thumbel
	 *
	 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
	 * Modify the thumbnail bounds from which opening zoom animation starts or ends.
	 * https://photoswipe.com/filters/#thumbbounds
	 *
	 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
	 *
	 * @prop {(preventPointerEvent: boolean, event: PointerEvent, pointerType: string) => boolean} preventPointerEvent
	 *
	 */

	/**
	 * @template {keyof PhotoSwipeFiltersMap} T
	 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
	 */

	/**
	 * @template {keyof PhotoSwipeEventsMap} T
	 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
	 */

	/**
	 * @template {keyof PhotoSwipeEventsMap} T
	 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
	 */

	/**
	 * Base PhotoSwipe event object
	 *
	 * @template {keyof PhotoSwipeEventsMap} T
	 */
	let PhotoSwipeEvent$1 = class PhotoSwipeEvent {
	  /**
	   * @param {T} type
	   * @param {PhotoSwipeEventsMap[T]} [details]
	   */
	  constructor(type, details) {
	    this.type = type;
	    this.defaultPrevented = false;
	    if (details) {
	      Object.assign(this, details);
	    }
	  }
	  preventDefault() {
	    this.defaultPrevented = true;
	  }
	};
	/**
	 * PhotoSwipe base class that can listen and dispatch for events.
	 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
	 */

	let Eventable$1 = class Eventable {
	  constructor() {
	    /**
	     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
	     */
	    this._listeners = {};
	    /**
	     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
	     */

	    this._filters = {};
	    /** @type {PhotoSwipe | undefined} */

	    this.pswp = undefined;
	    /** @type {PhotoSwipeOptions | undefined} */

	    this.options = undefined;
	  }
	  /**
	   * @template {keyof PhotoSwipeFiltersMap} T
	   * @param {T} name
	   * @param {PhotoSwipeFiltersMap[T]} fn
	   * @param {number} priority
	   */

	  addFilter(name, fn, priority = 100) {
	    var _this$_filters$name, _this$_filters$name2, _this$pswp;
	    if (!this._filters[name]) {
	      this._filters[name] = [];
	    }
	    (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
	      fn,
	      priority
	    });
	    (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort((f1, f2) => f1.priority - f2.priority);
	    (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
	  }
	  /**
	   * @template {keyof PhotoSwipeFiltersMap} T
	   * @param {T} name
	   * @param {PhotoSwipeFiltersMap[T]} fn
	   */

	  removeFilter(name, fn) {
	    if (this._filters[name]) {
	      // @ts-expect-error
	      this._filters[name] = this._filters[name].filter(filter => filter.fn !== fn);
	    }
	    if (this.pswp) {
	      this.pswp.removeFilter(name, fn);
	    }
	  }
	  /**
	   * @template {keyof PhotoSwipeFiltersMap} T
	   * @param {T} name
	   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
	   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
	   */

	  applyFilters(name, ...args) {
	    var _this$_filters$name3;
	    (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach(filter => {
	      // @ts-expect-error
	      args[0] = filter.fn.apply(this, args);
	    });
	    return args[0];
	  }
	  /**
	   * @template {keyof PhotoSwipeEventsMap} T
	   * @param {T} name
	   * @param {EventCallback<T>} fn
	   */

	  on(name, fn) {
	    var _this$_listeners$name, _this$pswp2;
	    if (!this._listeners[name]) {
	      this._listeners[name] = [];
	    }
	    (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn); // When binding events to lightbox,
	    // also bind events to PhotoSwipe Core,
	    // if it's open.

	    (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
	  }
	  /**
	   * @template {keyof PhotoSwipeEventsMap} T
	   * @param {T} name
	   * @param {EventCallback<T>} fn
	   */

	  off(name, fn) {
	    var _this$pswp3;
	    if (this._listeners[name]) {
	      // @ts-expect-error
	      this._listeners[name] = this._listeners[name].filter(listener => fn !== listener);
	    }
	    (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
	  }
	  /**
	   * @template {keyof PhotoSwipeEventsMap} T
	   * @param {T} name
	   * @param {PhotoSwipeEventsMap[T]} [details]
	   * @returns {AugmentedEvent<T>}
	   */

	  dispatch(name, details) {
	    var _this$_listeners$name2;
	    if (this.pswp) {
	      return this.pswp.dispatch(name, details);
	    }
	    const event = /** @type {AugmentedEvent<T>} */
	    new PhotoSwipeEvent$1(name, details);
	    (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach(listener => {
	      listener.call(this, event);
	    });
	    return event;
	  }
	};
	let Placeholder$1 = class Placeholder {
	  /**
	   * @param {string | false} imageSrc
	   * @param {HTMLElement} container
	   */
	  constructor(imageSrc, container) {
	    // Create placeholder
	    // (stretched thumbnail or simple div behind the main image)

	    /** @type {HTMLImageElement | HTMLDivElement | null} */
	    this.element = createElement$1('pswp__img pswp__img--placeholder', imageSrc ? 'img' : 'div', container);
	    if (imageSrc) {
	      const imgEl = /** @type {HTMLImageElement} */
	      this.element;
	      imgEl.decoding = 'async';
	      imgEl.alt = '';
	      imgEl.src = imageSrc;
	      imgEl.setAttribute('role', 'presentation');
	    }
	    this.element.setAttribute('aria-hidden', 'true');
	  }
	  /**
	   * @param {number} width
	   * @param {number} height
	   */

	  setDisplayedSize(width, height) {
	    if (!this.element) {
	      return;
	    }
	    if (this.element.tagName === 'IMG') {
	      // Use transform scale() to modify img placeholder size
	      // (instead of changing width/height directly).
	      // This helps with performance, specifically in iOS15 Safari.
	      setWidthHeight$1(this.element, 250, 'auto');
	      this.element.style.transformOrigin = '0 0';
	      this.element.style.transform = toTransformString$1(0, 0, width / 250);
	    } else {
	      setWidthHeight$1(this.element, width, height);
	    }
	  }
	  destroy() {
	    var _this$element;
	    if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) {
	      this.element.remove();
	    }
	    this.element = null;
	  }
	};

	/** @typedef {import('./slide.js').default} Slide */

	/** @typedef {import('./slide.js').SlideData} SlideData */

	/** @typedef {import('../core/base.js').default} PhotoSwipeBase */

	/** @typedef {import('../util/util.js').LoadState} LoadState */

	let Content$1 = class Content {
	  /**
	   * @param {SlideData} itemData Slide data
	   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
	   * @param {number} index
	   */
	  constructor(itemData, instance, index) {
	    this.instance = instance;
	    this.data = itemData;
	    this.index = index;
	    /** @type {HTMLImageElement | HTMLDivElement | undefined} */

	    this.element = undefined;
	    /** @type {Placeholder | undefined} */

	    this.placeholder = undefined;
	    /** @type {Slide | undefined} */

	    this.slide = undefined;
	    this.displayedImageWidth = 0;
	    this.displayedImageHeight = 0;
	    this.width = Number(this.data.w) || Number(this.data.width) || 0;
	    this.height = Number(this.data.h) || Number(this.data.height) || 0;
	    this.isAttached = false;
	    this.hasSlide = false;
	    this.isDecoding = false;
	    /** @type {LoadState} */

	    this.state = LOAD_STATE$1.IDLE;
	    if (this.data.type) {
	      this.type = this.data.type;
	    } else if (this.data.src) {
	      this.type = 'image';
	    } else {
	      this.type = 'html';
	    }
	    this.instance.dispatch('contentInit', {
	      content: this
	    });
	  }
	  removePlaceholder() {
	    if (this.placeholder && !this.keepPlaceholder()) {
	      // With delay, as image might be loaded, but not rendered
	      setTimeout(() => {
	        if (this.placeholder) {
	          this.placeholder.destroy();
	          this.placeholder = undefined;
	        }
	      }, 1000);
	    }
	  }
	  /**
	   * Preload content
	   *
	   * @param {boolean} isLazy
	   * @param {boolean} [reload]
	   */

	  load(isLazy, reload) {
	    if (this.slide && this.usePlaceholder()) {
	      if (!this.placeholder) {
	        const placeholderSrc = this.instance.applyFilters('placeholderSrc',
	        // use  image-based placeholder only for the first slide,
	        // as rendering (even small stretched thumbnail) is an expensive operation
	        this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
	        this.placeholder = new Placeholder$1(placeholderSrc, this.slide.container);
	      } else {
	        const placeholderEl = this.placeholder.element; // Add placeholder to DOM if it was already created

	        if (placeholderEl && !placeholderEl.parentElement) {
	          this.slide.container.prepend(placeholderEl);
	        }
	      }
	    }
	    if (this.element && !reload) {
	      return;
	    }
	    if (this.instance.dispatch('contentLoad', {
	      content: this,
	      isLazy
	    }).defaultPrevented) {
	      return;
	    }
	    if (this.isImageContent()) {
	      this.element = createElement$1('pswp__img', 'img'); // Start loading only after width is defined, as sizes might depend on it.
	      // Due to Safari feature, we must define sizes before srcset.

	      if (this.displayedImageWidth) {
	        this.loadImage(isLazy);
	      }
	    } else {
	      this.element = createElement$1('pswp__content', 'div');
	      this.element.innerHTML = this.data.html || '';
	    }
	    if (reload && this.slide) {
	      this.slide.updateContentSize(true);
	    }
	  }
	  /**
	   * Preload image
	   *
	   * @param {boolean} isLazy
	   */

	  loadImage(isLazy) {
	    var _this$data$src, _this$data$alt;
	    if (!this.isImageContent() || !this.element || this.instance.dispatch('contentLoadImage', {
	      content: this,
	      isLazy
	    }).defaultPrevented) {
	      return;
	    }
	    const imageElement = /** @type HTMLImageElement */
	    this.element;
	    this.updateSrcsetSizes();
	    if (this.data.srcset) {
	      imageElement.srcset = this.data.srcset;
	    }
	    imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : '';
	    imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : '';
	    this.state = LOAD_STATE$1.LOADING;
	    if (imageElement.complete) {
	      this.onLoaded();
	    } else {
	      imageElement.onload = () => {
	        this.onLoaded();
	      };
	      imageElement.onerror = () => {
	        this.onError();
	      };
	    }
	  }
	  /**
	   * Assign slide to content
	   *
	   * @param {Slide} slide
	   */

	  setSlide(slide) {
	    this.slide = slide;
	    this.hasSlide = true;
	    this.instance = slide.pswp; // todo: do we need to unset slide?
	  }
	  /**
	   * Content load success handler
	   */

	  onLoaded() {
	    this.state = LOAD_STATE$1.LOADED;
	    if (this.slide && this.element) {
	      this.instance.dispatch('loadComplete', {
	        slide: this.slide,
	        content: this
	      }); // if content is reloaded

	      if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
	        this.append();
	        this.slide.updateContentSize(true);
	      }
	      if (this.state === LOAD_STATE$1.LOADED || this.state === LOAD_STATE$1.ERROR) {
	        this.removePlaceholder();
	      }
	    }
	  }
	  /**
	   * Content load error handler
	   */

	  onError() {
	    this.state = LOAD_STATE$1.ERROR;
	    if (this.slide) {
	      this.displayError();
	      this.instance.dispatch('loadComplete', {
	        slide: this.slide,
	        isError: true,
	        content: this
	      });
	      this.instance.dispatch('loadError', {
	        slide: this.slide,
	        content: this
	      });
	    }
	  }
	  /**
	   * @returns {Boolean} If the content is currently loading
	   */

	  isLoading() {
	    return this.instance.applyFilters('isContentLoading', this.state === LOAD_STATE$1.LOADING, this);
	  }
	  /**
	   * @returns {Boolean} If the content is in error state
	   */

	  isError() {
	    return this.state === LOAD_STATE$1.ERROR;
	  }
	  /**
	   * @returns {boolean} If the content is image
	   */

	  isImageContent() {
	    return this.type === 'image';
	  }
	  /**
	   * Update content size
	   *
	   * @param {Number} width
	   * @param {Number} height
	   */

	  setDisplayedSize(width, height) {
	    if (!this.element) {
	      return;
	    }
	    if (this.placeholder) {
	      this.placeholder.setDisplayedSize(width, height);
	    }
	    if (this.instance.dispatch('contentResize', {
	      content: this,
	      width,
	      height
	    }).defaultPrevented) {
	      return;
	    }
	    setWidthHeight$1(this.element, width, height);
	    if (this.isImageContent() && !this.isError()) {
	      const isInitialSizeUpdate = !this.displayedImageWidth && width;
	      this.displayedImageWidth = width;
	      this.displayedImageHeight = height;
	      if (isInitialSizeUpdate) {
	        this.loadImage(false);
	      } else {
	        this.updateSrcsetSizes();
	      }
	      if (this.slide) {
	        this.instance.dispatch('imageSizeChange', {
	          slide: this.slide,
	          width,
	          height,
	          content: this
	        });
	      }
	    }
	  }
	  /**
	   * @returns {boolean} If the content can be zoomed
	   */

	  isZoomable() {
	    return this.instance.applyFilters('isContentZoomable', this.isImageContent() && this.state !== LOAD_STATE$1.ERROR, this);
	  }
	  /**
	   * Update image srcset sizes attribute based on width and height
	   */

	  updateSrcsetSizes() {
	    // Handle srcset sizes attribute.
	    //
	    // Never lower quality, if it was increased previously.
	    // Chrome does this automatically, Firefox and Safari do not,
	    // so we store largest used size in dataset.
	    if (!this.isImageContent() || !this.element || !this.data.srcset) {
	      return;
	    }
	    const image = /** @type HTMLImageElement */
	    this.element;
	    const sizesWidth = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
	    if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
	      image.sizes = sizesWidth + 'px';
	      image.dataset.largestUsedSize = String(sizesWidth);
	    }
	  }
	  /**
	   * @returns {boolean} If content should use a placeholder (from msrc by default)
	   */

	  usePlaceholder() {
	    return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
	  }
	  /**
	   * Preload content with lazy-loading param
	   */

	  lazyLoad() {
	    if (this.instance.dispatch('contentLazyLoad', {
	      content: this
	    }).defaultPrevented) {
	      return;
	    }
	    this.load(true);
	  }
	  /**
	   * @returns {boolean} If placeholder should be kept after content is loaded
	   */

	  keepPlaceholder() {
	    return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
	  }
	  /**
	   * Destroy the content
	   */

	  destroy() {
	    this.hasSlide = false;
	    this.slide = undefined;
	    if (this.instance.dispatch('contentDestroy', {
	      content: this
	    }).defaultPrevented) {
	      return;
	    }
	    this.remove();
	    if (this.placeholder) {
	      this.placeholder.destroy();
	      this.placeholder = undefined;
	    }
	    if (this.isImageContent() && this.element) {
	      this.element.onload = null;
	      this.element.onerror = null;
	      this.element = undefined;
	    }
	  }
	  /**
	   * Display error message
	   */

	  displayError() {
	    if (this.slide) {
	      var _this$instance$option, _this$instance$option2;
	      let errorMsgEl = createElement$1('pswp__error-msg', 'div');
	      errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : '';
	      errorMsgEl = /** @type {HTMLDivElement} */
	      this.instance.applyFilters('contentErrorElement', errorMsgEl, this);
	      this.element = createElement$1('pswp__content pswp__error-msg-container', 'div');
	      this.element.appendChild(errorMsgEl);
	      this.slide.container.innerText = '';
	      this.slide.container.appendChild(this.element);
	      this.slide.updateContentSize(true);
	      this.removePlaceholder();
	    }
	  }
	  /**
	   * Append the content
	   */

	  append() {
	    if (this.isAttached || !this.element) {
	      return;
	    }
	    this.isAttached = true;
	    if (this.state === LOAD_STATE$1.ERROR) {
	      this.displayError();
	      return;
	    }
	    if (this.instance.dispatch('contentAppend', {
	      content: this
	    }).defaultPrevented) {
	      return;
	    }
	    const supportsDecode = 'decode' in this.element;
	    if (this.isImageContent()) {
	      // Use decode() on nearby slides
	      //
	      // Nearby slide images are in DOM and not hidden via display:none.
	      // However, they are placed offscreen (to the left and right side).
	      //
	      // Some browsers do not composite the image until it's actually visible,
	      // using decode() helps.
	      //
	      // You might ask "why dont you just decode() and then append all images",
	      // that's because I want to show image before it's fully loaded,
	      // as browser can render parts of image while it is loading.
	      // We do not do this in Safari due to partial loading bug.
	      if (supportsDecode && this.slide && (!this.slide.isActive || isSafari$1())) {
	        this.isDecoding = true; // purposefully using finally instead of then,
	        // as if srcset sizes changes dynamically - it may cause decode error

	        /** @type {HTMLImageElement} */

	        this.element.decode().catch(() => {}).finally(() => {
	          this.isDecoding = false;
	          this.appendImage();
	        });
	      } else {
	        this.appendImage();
	      }
	    } else if (this.slide && !this.element.parentNode) {
	      this.slide.container.appendChild(this.element);
	    }
	  }
	  /**
	   * Activate the slide,
	   * active slide is generally the current one,
	   * meaning the user can see it.
	   */

	  activate() {
	    if (this.instance.dispatch('contentActivate', {
	      content: this
	    }).defaultPrevented || !this.slide) {
	      return;
	    }
	    if (this.isImageContent() && this.isDecoding && !isSafari$1()) {
	      // add image to slide when it becomes active,
	      // even if it's not finished decoding
	      this.appendImage();
	    } else if (this.isError()) {
	      this.load(false, true); // try to reload
	    }
	    if (this.slide.holderElement) {
	      this.slide.holderElement.setAttribute('aria-hidden', 'false');
	    }
	  }
	  /**
	   * Deactivate the content
	   */

	  deactivate() {
	    this.instance.dispatch('contentDeactivate', {
	      content: this
	    });
	    if (this.slide && this.slide.holderElement) {
	      this.slide.holderElement.setAttribute('aria-hidden', 'true');
	    }
	  }
	  /**
	   * Remove the content from DOM
	   */

	  remove() {
	    this.isAttached = false;
	    if (this.instance.dispatch('contentRemove', {
	      content: this
	    }).defaultPrevented) {
	      return;
	    }
	    if (this.element && this.element.parentNode) {
	      this.element.remove();
	    }
	    if (this.placeholder && this.placeholder.element) {
	      this.placeholder.element.remove();
	    }
	  }
	  /**
	   * Append the image content to slide container
	   */

	  appendImage() {
	    if (!this.isAttached) {
	      return;
	    }
	    if (this.instance.dispatch('contentAppendImage', {
	      content: this
	    }).defaultPrevented) {
	      return;
	    } // ensure that element exists and is not already appended

	    if (this.slide && this.element && !this.element.parentNode) {
	      this.slide.container.appendChild(this.element);
	    }
	    if (this.state === LOAD_STATE$1.LOADED || this.state === LOAD_STATE$1.ERROR) {
	      this.removePlaceholder();
	    }
	  }
	};

	/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

	/** @typedef {import('../core/base.js').default} PhotoSwipeBase */

	/** @typedef {import('../photoswipe.js').Point} Point */

	/** @typedef {import('../slide/slide.js').SlideData} SlideData */

	/**
	 * @param {PhotoSwipeOptions} options
	 * @param {PhotoSwipeBase} pswp
	 * @returns {Point}
	 */
	function getViewportSize$1(options, pswp) {
	  if (options.getViewportSizeFn) {
	    const newViewportSize = options.getViewportSizeFn(options, pswp);
	    if (newViewportSize) {
	      return newViewportSize;
	    }
	  }
	  return {
	    x: document.documentElement.clientWidth,
	    // TODO: height on mobile is very incosistent due to toolbar
	    // find a way to improve this
	    //
	    // document.documentElement.clientHeight - doesn't seem to work well
	    y: window.innerHeight
	  };
	}
	/**
	 * Parses padding option.
	 * Supported formats:
	 *
	 * // Object
	 * padding: {
	 *  top: 0,
	 *  bottom: 0,
	 *  left: 0,
	 *  right: 0
	 * }
	 *
	 * // A function that returns the object
	 * paddingFn: (viewportSize, itemData, index) => {
	 *  return {
	 *    top: 0,
	 *    bottom: 0,
	 *    left: 0,
	 *    right: 0
	 *  };
	 * }
	 *
	 * // Legacy variant
	 * paddingLeft: 0,
	 * paddingRight: 0,
	 * paddingTop: 0,
	 * paddingBottom: 0,
	 *
	 * @param {'left' | 'top' | 'bottom' | 'right'} prop
	 * @param {PhotoSwipeOptions} options PhotoSwipe options
	 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
	 * @param {SlideData} itemData Data about the slide
	 * @param {number} index Slide index
	 * @returns {number}
	 */

	function parsePaddingOption$1(prop, options, viewportSize, itemData, index) {
	  let paddingValue = 0;
	  if (options.paddingFn) {
	    paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
	  } else if (options.padding) {
	    paddingValue = options.padding[prop];
	  } else {
	    const legacyPropName = 'padding' + prop[0].toUpperCase() + prop.slice(1); // @ts-expect-error

	    if (options[legacyPropName]) {
	      // @ts-expect-error
	      paddingValue = options[legacyPropName];
	    }
	  }
	  return Number(paddingValue) || 0;
	}
	/**
	 * @param {PhotoSwipeOptions} options
	 * @param {Point} viewportSize
	 * @param {SlideData} itemData
	 * @param {number} index
	 * @returns {Point}
	 */

	function getPanAreaSize$1(options, viewportSize, itemData, index) {
	  return {
	    x: viewportSize.x - parsePaddingOption$1('left', options, viewportSize, itemData, index) - parsePaddingOption$1('right', options, viewportSize, itemData, index),
	    y: viewportSize.y - parsePaddingOption$1('top', options, viewportSize, itemData, index) - parsePaddingOption$1('bottom', options, viewportSize, itemData, index)
	  };
	}
	const MAX_IMAGE_WIDTH$1 = 4000;
	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

	/** @typedef {import('../photoswipe.js').Point} Point */

	/** @typedef {import('../slide/slide.js').SlideData} SlideData */

	/** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */

	/**
	 * Calculates zoom levels for specific slide.
	 * Depends on viewport size and image size.
	 */

	let ZoomLevel$1 = class ZoomLevel {
	  /**
	   * @param {PhotoSwipeOptions} options PhotoSwipe options
	   * @param {SlideData} itemData Slide data
	   * @param {number} index Slide index
	   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
	   */
	  constructor(options, itemData, index, pswp) {
	    this.pswp = pswp;
	    this.options = options;
	    this.itemData = itemData;
	    this.index = index;
	    /** @type { Point | null } */

	    this.panAreaSize = null;
	    /** @type { Point | null } */

	    this.elementSize = null;
	    this.fit = 1;
	    this.fill = 1;
	    this.vFill = 1;
	    this.initial = 1;
	    this.secondary = 1;
	    this.max = 1;
	    this.min = 1;
	  }
	  /**
	   * Calculate initial, secondary and maximum zoom level for the specified slide.
	   *
	   * It should be called when either image or viewport size changes.
	   *
	   * @param {number} maxWidth
	   * @param {number} maxHeight
	   * @param {Point} panAreaSize
	   */

	  update(maxWidth, maxHeight, panAreaSize) {
	    /** @type {Point} */
	    const elementSize = {
	      x: maxWidth,
	      y: maxHeight
	    };
	    this.elementSize = elementSize;
	    this.panAreaSize = panAreaSize;
	    const hRatio = panAreaSize.x / elementSize.x;
	    const vRatio = panAreaSize.y / elementSize.y;
	    this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
	    this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio); // zoom.vFill defines zoom level of the image
	    // when it has 100% of viewport vertical space (height)

	    this.vFill = Math.min(1, vRatio);
	    this.initial = this._getInitial();
	    this.secondary = this._getSecondary();
	    this.max = Math.max(this.initial, this.secondary, this._getMax());
	    this.min = Math.min(this.fit, this.initial, this.secondary);
	    if (this.pswp) {
	      this.pswp.dispatch('zoomLevelsUpdate', {
	        zoomLevels: this,
	        slideData: this.itemData
	      });
	    }
	  }
	  /**
	   * Parses user-defined zoom option.
	   *
	   * @private
	   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
	   * @returns { number | undefined }
	   */

	  _parseZoomLevelOption(optionPrefix) {
	    const optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */
	    optionPrefix + 'ZoomLevel';
	    const optionValue = this.options[optionName];
	    if (!optionValue) {
	      return;
	    }
	    if (typeof optionValue === 'function') {
	      return optionValue(this);
	    }
	    if (optionValue === 'fill') {
	      return this.fill;
	    }
	    if (optionValue === 'fit') {
	      return this.fit;
	    }
	    return Number(optionValue);
	  }
	  /**
	   * Get zoom level to which image will be zoomed after double-tap gesture,
	   * or when user clicks on zoom icon,
	   * or mouse-click on image itself.
	   * If you return 1 image will be zoomed to its original size.
	   *
	   * @private
	   * @return {number}
	   */

	  _getSecondary() {
	    let currZoomLevel = this._parseZoomLevelOption('secondary');
	    if (currZoomLevel) {
	      return currZoomLevel;
	    } // 3x of "fit" state, but not larger than original

	    currZoomLevel = Math.min(1, this.fit * 3);
	    if (this.elementSize && currZoomLevel * this.elementSize.x > MAX_IMAGE_WIDTH$1) {
	      currZoomLevel = MAX_IMAGE_WIDTH$1 / this.elementSize.x;
	    }
	    return currZoomLevel;
	  }
	  /**
	   * Get initial image zoom level.
	   *
	   * @private
	   * @return {number}
	   */

	  _getInitial() {
	    return this._parseZoomLevelOption('initial') || this.fit;
	  }
	  /**
	   * Maximum zoom level when user zooms
	   * via zoom/pinch gesture,
	   * via cmd/ctrl-wheel or via trackpad.
	   *
	   * @private
	   * @return {number}
	   */

	  _getMax() {
	    // max zoom level is x4 from "fit state",
	    // used for zoom gesture and ctrl/trackpad zoom
	    return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
	  }
	};

	/**
	 * Lazy-load an image
	 * This function is used both by Lightbox and PhotoSwipe core,
	 * thus it can be called before dialog is opened.
	 *
	 * @param {SlideData} itemData Data about the slide
	 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
	 * @param {number} index
	 * @returns {Content} Image that is being decoded or false.
	 */

	function lazyLoadData$1(itemData, instance, index) {
	  const content = instance.createContentFromData(itemData, index);
	  /** @type {ZoomLevel | undefined} */

	  let zoomLevel;
	  const {
	    options
	  } = instance; // We need to know dimensions of the image to preload it,
	  // as it might use srcset, and we need to define sizes

	  if (options) {
	    zoomLevel = new ZoomLevel$1(options, itemData, -1);
	    let viewportSize;
	    if (instance.pswp) {
	      viewportSize = instance.pswp.viewportSize;
	    } else {
	      viewportSize = getViewportSize$1(options, instance);
	    }
	    const panAreaSize = getPanAreaSize$1(options, viewportSize, itemData, index);
	    zoomLevel.update(content.width, content.height, panAreaSize);
	  }
	  content.lazyLoad();
	  if (zoomLevel) {
	    content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
	  }
	  return content;
	}
	/**
	 * Lazy-loads specific slide.
	 * This function is used both by Lightbox and PhotoSwipe core,
	 * thus it can be called before dialog is opened.
	 *
	 * By default, it loads image based on viewport size and initial zoom level.
	 *
	 * @param {number} index Slide index
	 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
	 * @returns {Content | undefined}
	 */

	function lazyLoadSlide$1(index, instance) {
	  const itemData = instance.getItemData(index);
	  if (instance.dispatch('lazyLoadSlide', {
	    index,
	    itemData
	  }).defaultPrevented) {
	    return;
	  }
	  return lazyLoadData$1(itemData, instance, index);
	}

	/** @typedef {import("../photoswipe.js").default} PhotoSwipe */

	/** @typedef {import("../slide/slide.js").SlideData} SlideData */

	/**
	 * PhotoSwipe base class that can retrieve data about every slide.
	 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
	 */

	let PhotoSwipeBase$1 = class PhotoSwipeBase extends Eventable$1 {
	  /**
	   * Get total number of slides
	   *
	   * @returns {number}
	   */
	  getNumItems() {
	    var _this$options;
	    let numItems = 0;
	    const dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
	    if (dataSource && 'length' in dataSource) {
	      // may be an array or just object with length property
	      numItems = dataSource.length;
	    } else if (dataSource && 'gallery' in dataSource) {
	      // query DOM elements
	      if (!dataSource.items) {
	        dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
	      }
	      if (dataSource.items) {
	        numItems = dataSource.items.length;
	      }
	    } // legacy event, before filters were introduced

	    const event = this.dispatch('numItems', {
	      dataSource,
	      numItems
	    });
	    return this.applyFilters('numItems', event.numItems, dataSource);
	  }
	  /**
	   * @param {SlideData} slideData
	   * @param {number} index
	   * @returns {Content}
	   */

	  createContentFromData(slideData, index) {
	    return new Content$1(slideData, this, index);
	  }
	  /**
	   * Get item data by index.
	   *
	   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
	   * For example, it may contain properties like
	   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
	   *
	   * @param {number} index
	   * @returns {SlideData}
	   */

	  getItemData(index) {
	    var _this$options2;
	    const dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
	    /** @type {SlideData | HTMLElement} */

	    let dataSourceItem = {};
	    if (Array.isArray(dataSource)) {
	      // Datasource is an array of elements
	      dataSourceItem = dataSource[index];
	    } else if (dataSource && 'gallery' in dataSource) {
	      // dataSource has gallery property,
	      // thus it was created by Lightbox, based on
	      // gallery and children options
	      // query DOM elements
	      if (!dataSource.items) {
	        dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
	      }
	      dataSourceItem = dataSource.items[index];
	    }
	    let itemData = dataSourceItem;
	    if (itemData instanceof Element) {
	      itemData = this._domElementToItemData(itemData);
	    } // Dispatching the itemData event,
	    // it's a legacy verion before filters were introduced

	    const event = this.dispatch('itemData', {
	      itemData: itemData || {},
	      index
	    });
	    return this.applyFilters('itemData', event.itemData, index);
	  }
	  /**
	   * Get array of gallery DOM elements,
	   * based on childSelector and gallery element.
	   *
	   * @param {HTMLElement} galleryElement
	   * @returns {HTMLElement[]}
	   */

	  _getGalleryDOMElements(galleryElement) {
	    var _this$options3, _this$options4;
	    if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) {
	      return getElementsFromOption$1(this.options.children, this.options.childSelector, galleryElement) || [];
	    }
	    return [galleryElement];
	  }
	  /**
	   * Converts DOM element to item data object.
	   *
	   * @param {HTMLElement} element DOM element
	   * @returns {SlideData}
	   */

	  _domElementToItemData(element) {
	    /** @type {SlideData} */
	    const itemData = {
	      element
	    };
	    const linkEl = /** @type {HTMLAnchorElement} */
	    element.tagName === 'A' ? element : element.querySelector('a');
	    if (linkEl) {
	      // src comes from data-pswp-src attribute,
	      // if it's empty link href is used
	      itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
	      if (linkEl.dataset.pswpSrcset) {
	        itemData.srcset = linkEl.dataset.pswpSrcset;
	      }
	      itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
	      itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0; // support legacy w & h properties

	      itemData.w = itemData.width;
	      itemData.h = itemData.height;
	      if (linkEl.dataset.pswpType) {
	        itemData.type = linkEl.dataset.pswpType;
	      }
	      const thumbnailEl = element.querySelector('img');
	      if (thumbnailEl) {
	        var _thumbnailEl$getAttri;

	        // msrc is URL to placeholder image that's displayed before large image is loaded
	        // by default it's displayed only for the first slide
	        itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
	        itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute('alt')) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : '';
	      }
	      if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) {
	        itemData.thumbCropped = true;
	      }
	    }
	    return this.applyFilters('domItemData', itemData, element, linkEl);
	  }
	  /**
	   * Lazy-load by slide data
	   *
	   * @param {SlideData} itemData Data about the slide
	   * @param {number} index
	   * @returns {Content} Image that is being decoded or false.
	   */

	  lazyLoadData(itemData, index) {
	    return lazyLoadData$1(itemData, this, index);
	  }
	};

	/**
	 * @template T
	 * @typedef {import('../types.js').Type<T>} Type<T>
	 */

	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

	/** @typedef {import('../photoswipe.js').DataSource} DataSource */

	/** @typedef {import('../photoswipe.js').Point} Point */

	/** @typedef {import('../slide/content.js').default} Content */

	/** @typedef {import('../core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */

	/** @typedef {import('../core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */

	/**
	 * @template {keyof PhotoSwipeEventsMap} T
	 * @typedef {import('../core/eventable.js').EventCallback<T>} EventCallback<T>
	 */

	/**
	 * PhotoSwipe Lightbox
	 *
	 * - If user has unsupported browser it falls back to default browser action (just opens URL)
	 * - Binds click event to links that should open PhotoSwipe
	 * - parses DOM strcture for PhotoSwipe (retrieves large image URLs and sizes)
	 * - Initializes PhotoSwipe
	 *
	 *
	 * Loader options use the same object as PhotoSwipe, and supports such options:
	 *
	 * gallery - Element | Element[] | NodeList | string selector for the gallery element
	 * children - Element | Element[] | NodeList | string selector for the gallery children
	 *
	 */

	class PhotoSwipeLightbox extends PhotoSwipeBase$1 {
	  /**
	   * @param {PhotoSwipeOptions} [options]
	   */
	  constructor(options) {
	    super();
	    /** @type {PhotoSwipeOptions} */

	    this.options = options || {};
	    this._uid = 0;
	    this.shouldOpen = false;
	    /**
	     * @private
	     * @type {Content | undefined}
	     */

	    this._preloadedContent = undefined;
	    this.onThumbnailsClick = this.onThumbnailsClick.bind(this);
	  }
	  /**
	   * Initialize lightbox, should be called only once.
	   * It's not included in the main constructor, so you may bind events before it.
	   */

	  init() {
	    // Bind click events to each gallery
	    getElementsFromOption$1(this.options.gallery, this.options.gallerySelector).forEach(galleryElement => {
	      galleryElement.addEventListener('click', this.onThumbnailsClick, false);
	    });
	  }
	  /**
	   * @param {MouseEvent} e
	   */

	  onThumbnailsClick(e) {
	    // Exit and allow default browser action if:
	    if (specialKeyUsed$1(e) // ... if clicked with a special key (ctrl/cmd...)
	    || window.pswp) {
	      // ... if PhotoSwipe is already open
	      return;
	    } // If both clientX and clientY are 0 or not defined,
	    // the event is likely triggered by keyboard,
	    // so we do not pass the initialPoint
	    //
	    // Note that some screen readers emulate the mouse position,
	    // so it's not the ideal way to detect them.
	    //

	    /** @type {Point | null} */

	    let initialPoint = {
	      x: e.clientX,
	      y: e.clientY
	    };
	    if (!initialPoint.x && !initialPoint.y) {
	      initialPoint = null;
	    }
	    let clickedIndex = this.getClickedIndex(e);
	    clickedIndex = this.applyFilters('clickedIndex', clickedIndex, e, this);
	    /** @type {DataSource} */

	    const dataSource = {
	      gallery: /** @type {HTMLElement} */
	      e.currentTarget
	    };
	    if (clickedIndex >= 0) {
	      e.preventDefault();
	      this.loadAndOpen(clickedIndex, dataSource, initialPoint);
	    }
	  }
	  /**
	   * Get index of gallery item that was clicked.
	   *
	   * @param {MouseEvent} e click event
	   * @returns {number}
	   */

	  getClickedIndex(e) {
	    // legacy option
	    if (this.options.getClickedIndexFn) {
	      return this.options.getClickedIndexFn.call(this, e);
	    }
	    const clickedTarget = /** @type {HTMLElement} */
	    e.target;
	    const childElements = getElementsFromOption$1(this.options.children, this.options.childSelector, /** @type {HTMLElement} */
	    e.currentTarget);
	    const clickedChildIndex = childElements.findIndex(child => child === clickedTarget || child.contains(clickedTarget));
	    if (clickedChildIndex !== -1) {
	      return clickedChildIndex;
	    } else if (this.options.children || this.options.childSelector) {
	      // click wasn't on a child element
	      return -1;
	    } // There is only one item (which is the gallery)

	    return 0;
	  }
	  /**
	   * Load and open PhotoSwipe
	   *
	   * @param {number} index
	   * @param {DataSource} [dataSource]
	   * @param {Point | null} [initialPoint]
	   * @returns {boolean}
	   */

	  loadAndOpen(index, dataSource, initialPoint) {
	    // Check if the gallery is already open
	    if (window.pswp || !this.options) {
	      return false;
	    } // Use the first gallery element if dataSource is not provided

	    if (!dataSource && this.options.gallery && this.options.children) {
	      const galleryElements = getElementsFromOption$1(this.options.gallery);
	      if (galleryElements[0]) {
	        dataSource = {
	          gallery: galleryElements[0]
	        };
	      }
	    } // set initial index

	    this.options.index = index; // define options for PhotoSwipe constructor

	    this.options.initialPointerPos = initialPoint;
	    this.shouldOpen = true;
	    this.preload(index, dataSource);
	    return true;
	  }
	  /**
	   * Load the main module and the slide content by index
	   *
	   * @param {number} index
	   * @param {DataSource} [dataSource]
	   */

	  preload(index, dataSource) {
	    const {
	      options
	    } = this;
	    if (dataSource) {
	      options.dataSource = dataSource;
	    } // Add the main module

	    /** @type {Promise<Type<PhotoSwipe>>[]} */

	    const promiseArray = [];
	    const pswpModuleType = typeof options.pswpModule;
	    if (isPswpClass(options.pswpModule)) {
	      promiseArray.push(Promise.resolve(/** @type {Type<PhotoSwipe>} */
	      options.pswpModule));
	    } else if (pswpModuleType === 'string') {
	      throw new Error('pswpModule as string is no longer supported');
	    } else if (pswpModuleType === 'function') {
	      promiseArray.push(/** @type {() => Promise<Type<PhotoSwipe>>} */
	      options.pswpModule());
	    } else {
	      throw new Error('pswpModule is not valid');
	    } // Add custom-defined promise, if any

	    if (typeof options.openPromise === 'function') {
	      // allow developers to perform some task before opening
	      promiseArray.push(options.openPromise());
	    }
	    if (options.preloadFirstSlide !== false && index >= 0) {
	      this._preloadedContent = lazyLoadSlide$1(index, this);
	    } // Wait till all promises resolve and open PhotoSwipe

	    const uid = ++this._uid;
	    Promise.all(promiseArray).then(iterableModules => {
	      if (this.shouldOpen) {
	        const mainModule = iterableModules[0];
	        this._openPhotoswipe(mainModule, uid);
	      }
	    });
	  }
	  /**
	   * @private
	   * @param {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} module
	   * @param {number} uid
	   */

	  _openPhotoswipe(module, uid) {
	    // Cancel opening if UID doesn't match the current one
	    // (if user clicked on another gallery item before current was loaded).
	    //
	    // Or if shouldOpen flag is set to false
	    // (developer may modify it via public API)
	    if (uid !== this._uid && this.shouldOpen) {
	      return;
	    }
	    this.shouldOpen = false; // PhotoSwipe is already open

	    if (window.pswp) {
	      return;
	    }
	    /**
	     * Pass data to PhotoSwipe and open init
	     *
	     * @type {PhotoSwipe}
	     */

	    const pswp = typeof module === 'object' ? new module.default(this.options) // eslint-disable-line
	    : new module(this.options); // eslint-disable-line

	    this.pswp = pswp;
	    window.pswp = pswp; // map listeners from Lightbox to PhotoSwipe Core

	    /** @type {(keyof PhotoSwipeEventsMap)[]} */

	    Object.keys(this._listeners).forEach(name => {
	      var _this$_listeners$name;
	      (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.forEach(fn => {
	        pswp.on(name, /** @type {EventCallback<typeof name>} */
	        fn);
	      });
	    }); // same with filters

	    /** @type {(keyof PhotoSwipeFiltersMap)[]} */

	    Object.keys(this._filters).forEach(name => {
	      var _this$_filters$name;
	      (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.forEach(filter => {
	        pswp.addFilter(name, filter.fn, filter.priority);
	      });
	    });
	    if (this._preloadedContent) {
	      pswp.contentLoader.addToCache(this._preloadedContent);
	      this._preloadedContent = undefined;
	    }
	    pswp.on('destroy', () => {
	      // clean up public variables
	      this.pswp = undefined;
	      delete window.pswp;
	    });
	    pswp.init();
	  }
	  /**
	   * Unbinds all events, closes PhotoSwipe if it's open.
	   */

	  destroy() {
	    var _this$pswp;
	    (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.destroy();
	    this.shouldOpen = false;
	    this._listeners = {};
	    getElementsFromOption$1(this.options.gallery, this.options.gallerySelector).forEach(galleryElement => {
	      galleryElement.removeEventListener('click', this.onThumbnailsClick, false);
	    });
	  }
	}

	/**
	 * SSR Window 4.0.2
	 * Better handling for window object in SSR environment
	 * https://github.com/nolimits4web/ssr-window
	 *
	 * Copyright 2021, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: December 13, 2021
	 */
	/* eslint-disable no-param-reassign */
	function isObject$1(obj) {
	  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
	}
	function extend$1(target = {}, src = {}) {
	  Object.keys(src).forEach(key => {
	    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$1(src[key]) && isObject$1(target[key]) && Object.keys(src[key]).length > 0) {
	      extend$1(target[key], src[key]);
	    }
	  });
	}
	const ssrDocument = {
	  body: {},
	  addEventListener() {},
	  removeEventListener() {},
	  activeElement: {
	    blur() {},
	    nodeName: ''
	  },
	  querySelector() {
	    return null;
	  },
	  querySelectorAll() {
	    return [];
	  },
	  getElementById() {
	    return null;
	  },
	  createEvent() {
	    return {
	      initEvent() {}
	    };
	  },
	  createElement() {
	    return {
	      children: [],
	      childNodes: [],
	      style: {},
	      setAttribute() {},
	      getElementsByTagName() {
	        return [];
	      }
	    };
	  },
	  createElementNS() {
	    return {};
	  },
	  importNode() {
	    return null;
	  },
	  location: {
	    hash: '',
	    host: '',
	    hostname: '',
	    href: '',
	    origin: '',
	    pathname: '',
	    protocol: '',
	    search: ''
	  }
	};
	function getDocument() {
	  const doc = typeof document !== 'undefined' ? document : {};
	  extend$1(doc, ssrDocument);
	  return doc;
	}
	const ssrWindow = {
	  document: ssrDocument,
	  navigator: {
	    userAgent: ''
	  },
	  location: {
	    hash: '',
	    host: '',
	    hostname: '',
	    href: '',
	    origin: '',
	    pathname: '',
	    protocol: '',
	    search: ''
	  },
	  history: {
	    replaceState() {},
	    pushState() {},
	    go() {},
	    back() {}
	  },
	  CustomEvent: function CustomEvent() {
	    return this;
	  },
	  addEventListener() {},
	  removeEventListener() {},
	  getComputedStyle() {
	    return {
	      getPropertyValue() {
	        return '';
	      }
	    };
	  },
	  Image() {},
	  Date() {},
	  screen: {},
	  setTimeout() {},
	  clearTimeout() {},
	  matchMedia() {
	    return {};
	  },
	  requestAnimationFrame(callback) {
	    if (typeof setTimeout === 'undefined') {
	      callback();
	      return null;
	    }
	    return setTimeout(callback, 0);
	  },
	  cancelAnimationFrame(id) {
	    if (typeof setTimeout === 'undefined') {
	      return;
	    }
	    clearTimeout(id);
	  }
	};
	function getWindow() {
	  const win = typeof window !== 'undefined' ? window : {};
	  extend$1(win, ssrWindow);
	  return win;
	}

	/**
	 * Dom7 4.0.6
	 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
	 * https://framework7.io/docs/dom7.html
	 *
	 * Copyright 2023, Vladimir Kharlampidi
	 *
	 * Licensed under MIT
	 *
	 * Released on: February 2, 2023
	 */

	/* eslint-disable no-proto */
	function makeReactive(obj) {
	  const proto = obj.__proto__;
	  Object.defineProperty(obj, '__proto__', {
	    get() {
	      return proto;
	    },
	    set(value) {
	      proto.__proto__ = value;
	    }
	  });
	}
	class Dom7 extends Array {
	  constructor(items) {
	    if (typeof items === 'number') {
	      super(items);
	    } else {
	      super(...(items || []));
	      makeReactive(this);
	    }
	  }
	}
	function arrayFlat(arr = []) {
	  const res = [];
	  arr.forEach(el => {
	    if (Array.isArray(el)) {
	      res.push(...arrayFlat(el));
	    } else {
	      res.push(el);
	    }
	  });
	  return res;
	}
	function arrayFilter(arr, callback) {
	  return Array.prototype.filter.call(arr, callback);
	}
	function arrayUnique(arr) {
	  const uniqueArray = [];
	  for (let i = 0; i < arr.length; i += 1) {
	    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
	  }
	  return uniqueArray;
	}

	// eslint-disable-next-line

	function qsa(selector, context) {
	  if (typeof selector !== 'string') {
	    return [selector];
	  }
	  const a = [];
	  const res = context.querySelectorAll(selector);
	  for (let i = 0; i < res.length; i += 1) {
	    a.push(res[i]);
	  }
	  return a;
	}
	function $(selector, context) {
	  const window = getWindow();
	  const document = getDocument();
	  let arr = [];
	  if (!context && selector instanceof Dom7) {
	    return selector;
	  }
	  if (!selector) {
	    return new Dom7(arr);
	  }
	  if (typeof selector === 'string') {
	    const html = selector.trim();
	    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	      let toCreate = 'div';
	      if (html.indexOf('<li') === 0) toCreate = 'ul';
	      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
	      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
	      if (html.indexOf('<tbody') === 0) toCreate = 'table';
	      if (html.indexOf('<option') === 0) toCreate = 'select';
	      const tempParent = document.createElement(toCreate);
	      tempParent.innerHTML = html;
	      for (let i = 0; i < tempParent.childNodes.length; i += 1) {
	        arr.push(tempParent.childNodes[i]);
	      }
	    } else {
	      arr = qsa(selector.trim(), context || document);
	    } // arr = qsa(selector, document);
	  } else if (selector.nodeType || selector === window || selector === document) {
	    arr.push(selector);
	  } else if (Array.isArray(selector)) {
	    if (selector instanceof Dom7) return selector;
	    arr = selector;
	  }
	  return new Dom7(arrayUnique(arr));
	}
	$.fn = Dom7.prototype;

	// eslint-disable-next-line

	function addClass(...classes) {
	  const classNames = arrayFlat(classes.map(c => c.split(' ')));
	  this.forEach(el => {
	    el.classList.add(...classNames);
	  });
	  return this;
	}
	function removeClass(...classes) {
	  const classNames = arrayFlat(classes.map(c => c.split(' ')));
	  this.forEach(el => {
	    el.classList.remove(...classNames);
	  });
	  return this;
	}
	function toggleClass(...classes) {
	  const classNames = arrayFlat(classes.map(c => c.split(' ')));
	  this.forEach(el => {
	    classNames.forEach(className => {
	      el.classList.toggle(className);
	    });
	  });
	}
	function hasClass(...classes) {
	  const classNames = arrayFlat(classes.map(c => c.split(' ')));
	  return arrayFilter(this, el => {
	    return classNames.filter(className => el.classList.contains(className)).length > 0;
	  }).length > 0;
	}
	function attr(attrs, value) {
	  if (arguments.length === 1 && typeof attrs === 'string') {
	    // Get attr
	    if (this[0]) return this[0].getAttribute(attrs);
	    return undefined;
	  } // Set attrs

	  for (let i = 0; i < this.length; i += 1) {
	    if (arguments.length === 2) {
	      // String
	      this[i].setAttribute(attrs, value);
	    } else {
	      // Object
	      for (const attrName in attrs) {
	        this[i][attrName] = attrs[attrName];
	        this[i].setAttribute(attrName, attrs[attrName]);
	      }
	    }
	  }
	  return this;
	}
	function removeAttr(attr) {
	  for (let i = 0; i < this.length; i += 1) {
	    this[i].removeAttribute(attr);
	  }
	  return this;
	}
	function transform(transform) {
	  for (let i = 0; i < this.length; i += 1) {
	    this[i].style.transform = transform;
	  }
	  return this;
	}
	function transition$1(duration) {
	  for (let i = 0; i < this.length; i += 1) {
	    this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
	  }
	  return this;
	}
	function on(...args) {
	  let [eventType, targetSelector, listener, capture] = args;
	  if (typeof args[1] === 'function') {
	    [eventType, listener, capture] = args;
	    targetSelector = undefined;
	  }
	  if (!capture) capture = false;
	  function handleLiveEvent(e) {
	    const target = e.target;
	    if (!target) return;
	    const eventData = e.target.dom7EventData || [];
	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }
	    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
	      const parents = $(target).parents(); // eslint-disable-line

	      for (let k = 0; k < parents.length; k += 1) {
	        if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
	      }
	    }
	  }
	  function handleEvent(e) {
	    const eventData = e && e.target ? e.target.dom7EventData || [] : [];
	    if (eventData.indexOf(e) < 0) {
	      eventData.unshift(e);
	    }
	    listener.apply(this, eventData);
	  }
	  const events = eventType.split(' ');
	  let j;
	  for (let i = 0; i < this.length; i += 1) {
	    const el = this[i];
	    if (!targetSelector) {
	      for (j = 0; j < events.length; j += 1) {
	        const event = events[j];
	        if (!el.dom7Listeners) el.dom7Listeners = {};
	        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
	        el.dom7Listeners[event].push({
	          listener,
	          proxyListener: handleEvent
	        });
	        el.addEventListener(event, handleEvent, capture);
	      }
	    } else {
	      // Live events
	      for (j = 0; j < events.length; j += 1) {
	        const event = events[j];
	        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
	        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
	        el.dom7LiveListeners[event].push({
	          listener,
	          proxyListener: handleLiveEvent
	        });
	        el.addEventListener(event, handleLiveEvent, capture);
	      }
	    }
	  }
	  return this;
	}
	function off(...args) {
	  let [eventType, targetSelector, listener, capture] = args;
	  if (typeof args[1] === 'function') {
	    [eventType, listener, capture] = args;
	    targetSelector = undefined;
	  }
	  if (!capture) capture = false;
	  const events = eventType.split(' ');
	  for (let i = 0; i < events.length; i += 1) {
	    const event = events[i];
	    for (let j = 0; j < this.length; j += 1) {
	      const el = this[j];
	      let handlers;
	      if (!targetSelector && el.dom7Listeners) {
	        handlers = el.dom7Listeners[event];
	      } else if (targetSelector && el.dom7LiveListeners) {
	        handlers = el.dom7LiveListeners[event];
	      }
	      if (handlers && handlers.length) {
	        for (let k = handlers.length - 1; k >= 0; k -= 1) {
	          const handler = handlers[k];
	          if (listener && handler.listener === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          } else if (!listener) {
	            el.removeEventListener(event, handler.proxyListener, capture);
	            handlers.splice(k, 1);
	          }
	        }
	      }
	    }
	  }
	  return this;
	}
	function trigger(...args) {
	  const window = getWindow();
	  const events = args[0].split(' ');
	  const eventData = args[1];
	  for (let i = 0; i < events.length; i += 1) {
	    const event = events[i];
	    for (let j = 0; j < this.length; j += 1) {
	      const el = this[j];
	      if (window.CustomEvent) {
	        const evt = new window.CustomEvent(event, {
	          detail: eventData,
	          bubbles: true,
	          cancelable: true
	        });
	        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
	        el.dispatchEvent(evt);
	        el.dom7EventData = [];
	        delete el.dom7EventData;
	      }
	    }
	  }
	  return this;
	}
	function transitionEnd$1(callback) {
	  const dom = this;
	  function fireCallBack(e) {
	    if (e.target !== this) return;
	    callback.call(this, e);
	    dom.off('transitionend', fireCallBack);
	  }
	  if (callback) {
	    dom.on('transitionend', fireCallBack);
	  }
	  return this;
	}
	function outerWidth(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      const styles = this.styles();
	      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
	    }
	    return this[0].offsetWidth;
	  }
	  return null;
	}
	function outerHeight(includeMargins) {
	  if (this.length > 0) {
	    if (includeMargins) {
	      const styles = this.styles();
	      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
	    }
	    return this[0].offsetHeight;
	  }
	  return null;
	}
	function offset() {
	  if (this.length > 0) {
	    const window = getWindow();
	    const document = getDocument();
	    const el = this[0];
	    const box = el.getBoundingClientRect();
	    const body = document.body;
	    const clientTop = el.clientTop || body.clientTop || 0;
	    const clientLeft = el.clientLeft || body.clientLeft || 0;
	    const scrollTop = el === window ? window.scrollY : el.scrollTop;
	    const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
	    return {
	      top: box.top + scrollTop - clientTop,
	      left: box.left + scrollLeft - clientLeft
	    };
	  }
	  return null;
	}
	function styles() {
	  const window = getWindow();
	  if (this[0]) return window.getComputedStyle(this[0], null);
	  return {};
	}
	function css(props, value) {
	  const window = getWindow();
	  let i;
	  if (arguments.length === 1) {
	    if (typeof props === 'string') {
	      // .css('width')
	      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
	    } else {
	      // .css({ width: '100px' })
	      for (i = 0; i < this.length; i += 1) {
	        for (const prop in props) {
	          this[i].style[prop] = props[prop];
	        }
	      }
	      return this;
	    }
	  }
	  if (arguments.length === 2 && typeof props === 'string') {
	    // .css('width', '100px')
	    for (i = 0; i < this.length; i += 1) {
	      this[i].style[props] = value;
	    }
	    return this;
	  }
	  return this;
	}
	function each(callback) {
	  if (!callback) return this;
	  this.forEach((el, index) => {
	    callback.apply(el, [el, index]);
	  });
	  return this;
	}
	function filter(callback) {
	  const result = arrayFilter(this, callback);
	  return $(result);
	}
	function html(html) {
	  if (typeof html === 'undefined') {
	    return this[0] ? this[0].innerHTML : null;
	  }
	  for (let i = 0; i < this.length; i += 1) {
	    this[i].innerHTML = html;
	  }
	  return this;
	}
	function text(text) {
	  if (typeof text === 'undefined') {
	    return this[0] ? this[0].textContent.trim() : null;
	  }
	  for (let i = 0; i < this.length; i += 1) {
	    this[i].textContent = text;
	  }
	  return this;
	}
	function is(selector) {
	  const window = getWindow();
	  const document = getDocument();
	  const el = this[0];
	  let compareWith;
	  let i;
	  if (!el || typeof selector === 'undefined') return false;
	  if (typeof selector === 'string') {
	    if (el.matches) return el.matches(selector);
	    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
	    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
	    compareWith = $(selector);
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }
	    return false;
	  }
	  if (selector === document) {
	    return el === document;
	  }
	  if (selector === window) {
	    return el === window;
	  }
	  if (selector.nodeType || selector instanceof Dom7) {
	    compareWith = selector.nodeType ? [selector] : selector;
	    for (i = 0; i < compareWith.length; i += 1) {
	      if (compareWith[i] === el) return true;
	    }
	    return false;
	  }
	  return false;
	}
	function index() {
	  let child = this[0];
	  let i;
	  if (child) {
	    i = 0; // eslint-disable-next-line

	    while ((child = child.previousSibling) !== null) {
	      if (child.nodeType === 1) i += 1;
	    }
	    return i;
	  }
	  return undefined;
	}
	function eq(index) {
	  if (typeof index === 'undefined') return this;
	  const length = this.length;
	  if (index > length - 1) {
	    return $([]);
	  }
	  if (index < 0) {
	    const returnIndex = length + index;
	    if (returnIndex < 0) return $([]);
	    return $([this[returnIndex]]);
	  }
	  return $([this[index]]);
	}
	function append(...els) {
	  let newChild;
	  const document = getDocument();
	  for (let k = 0; k < els.length; k += 1) {
	    newChild = els[k];
	    for (let i = 0; i < this.length; i += 1) {
	      if (typeof newChild === 'string') {
	        const tempDiv = document.createElement('div');
	        tempDiv.innerHTML = newChild;
	        while (tempDiv.firstChild) {
	          this[i].appendChild(tempDiv.firstChild);
	        }
	      } else if (newChild instanceof Dom7) {
	        for (let j = 0; j < newChild.length; j += 1) {
	          this[i].appendChild(newChild[j]);
	        }
	      } else {
	        this[i].appendChild(newChild);
	      }
	    }
	  }
	  return this;
	}
	function prepend(newChild) {
	  const document = getDocument();
	  let i;
	  let j;
	  for (i = 0; i < this.length; i += 1) {
	    if (typeof newChild === 'string') {
	      const tempDiv = document.createElement('div');
	      tempDiv.innerHTML = newChild;
	      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	      }
	    } else if (newChild instanceof Dom7) {
	      for (j = 0; j < newChild.length; j += 1) {
	        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	      }
	    } else {
	      this[i].insertBefore(newChild, this[i].childNodes[0]);
	    }
	  }
	  return this;
	}
	function next(selector) {
	  if (this.length > 0) {
	    if (selector) {
	      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
	        return $([this[0].nextElementSibling]);
	      }
	      return $([]);
	    }
	    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
	    return $([]);
	  }
	  return $([]);
	}
	function nextAll(selector) {
	  const nextEls = [];
	  let el = this[0];
	  if (!el) return $([]);
	  while (el.nextElementSibling) {
	    const next = el.nextElementSibling; // eslint-disable-line

	    if (selector) {
	      if ($(next).is(selector)) nextEls.push(next);
	    } else nextEls.push(next);
	    el = next;
	  }
	  return $(nextEls);
	}
	function prev(selector) {
	  if (this.length > 0) {
	    const el = this[0];
	    if (selector) {
	      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
	        return $([el.previousElementSibling]);
	      }
	      return $([]);
	    }
	    if (el.previousElementSibling) return $([el.previousElementSibling]);
	    return $([]);
	  }
	  return $([]);
	}
	function prevAll(selector) {
	  const prevEls = [];
	  let el = this[0];
	  if (!el) return $([]);
	  while (el.previousElementSibling) {
	    const prev = el.previousElementSibling; // eslint-disable-line

	    if (selector) {
	      if ($(prev).is(selector)) prevEls.push(prev);
	    } else prevEls.push(prev);
	    el = prev;
	  }
	  return $(prevEls);
	}
	function parent(selector) {
	  const parents = []; // eslint-disable-line

	  for (let i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode !== null) {
	      if (selector) {
	        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
	      } else {
	        parents.push(this[i].parentNode);
	      }
	    }
	  }
	  return $(parents);
	}
	function parents(selector) {
	  const parents = []; // eslint-disable-line

	  for (let i = 0; i < this.length; i += 1) {
	    let parent = this[i].parentNode; // eslint-disable-line

	    while (parent) {
	      if (selector) {
	        if ($(parent).is(selector)) parents.push(parent);
	      } else {
	        parents.push(parent);
	      }
	      parent = parent.parentNode;
	    }
	  }
	  return $(parents);
	}
	function closest(selector) {
	  let closest = this; // eslint-disable-line

	  if (typeof selector === 'undefined') {
	    return $([]);
	  }
	  if (!closest.is(selector)) {
	    closest = closest.parents(selector).eq(0);
	  }
	  return closest;
	}
	function find(selector) {
	  const foundElements = [];
	  for (let i = 0; i < this.length; i += 1) {
	    const found = this[i].querySelectorAll(selector);
	    for (let j = 0; j < found.length; j += 1) {
	      foundElements.push(found[j]);
	    }
	  }
	  return $(foundElements);
	}
	function children(selector) {
	  const children = []; // eslint-disable-line

	  for (let i = 0; i < this.length; i += 1) {
	    const childNodes = this[i].children;
	    for (let j = 0; j < childNodes.length; j += 1) {
	      if (!selector || $(childNodes[j]).is(selector)) {
	        children.push(childNodes[j]);
	      }
	    }
	  }
	  return $(children);
	}
	function remove() {
	  for (let i = 0; i < this.length; i += 1) {
	    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	  }
	  return this;
	}

	const Methods = {
	  addClass,
	  removeClass,
	  hasClass,
	  toggleClass,
	  attr,
	  removeAttr,
	  transform,
	  transition: transition$1,
	  on,
	  off,
	  trigger,
	  transitionEnd: transitionEnd$1,
	  outerWidth,
	  outerHeight,
	  styles,
	  offset,
	  css,
	  each,
	  html,
	  text,
	  is,
	  index,
	  eq,
	  append,
	  prepend,
	  next,
	  nextAll,
	  prev,
	  prevAll,
	  parent,
	  parents,
	  closest,
	  find,
	  children,
	  filter,
	  remove
	};
	Object.keys(Methods).forEach(methodName => {
	  Object.defineProperty($.fn, methodName, {
	    value: Methods[methodName],
	    writable: true
	  });
	});

	function deleteProps(obj) {
	  const object = obj;
	  Object.keys(object).forEach(key => {
	    try {
	      object[key] = null;
	    } catch (e) {// no getter for object
	    }
	    try {
	      delete object[key];
	    } catch (e) {// something got wrong
	    }
	  });
	}
	function nextTick(callback, delay = 0) {
	  return setTimeout(callback, delay);
	}
	function now() {
	  return Date.now();
	}
	function getComputedStyle$1(el) {
	  const window = getWindow();
	  let style;
	  if (window.getComputedStyle) {
	    style = window.getComputedStyle(el, null);
	  }
	  if (!style && el.currentStyle) {
	    style = el.currentStyle;
	  }
	  if (!style) {
	    style = el.style;
	  }
	  return style;
	}
	function getTranslate(el, axis = 'x') {
	  const window = getWindow();
	  let matrix;
	  let curTransform;
	  let transformMatrix;
	  const curStyle = getComputedStyle$1(el);
	  if (window.WebKitCSSMatrix) {
	    curTransform = curStyle.transform || curStyle.webkitTransform;
	    if (curTransform.split(',').length > 6) {
	      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
	    } // Some old versions of Webkit choke when 'none' is passed; pass
	    // empty string instead in this case

	    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	  } else {
	    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	    matrix = transformMatrix.toString().split(',');
	  }
	  if (axis === 'x') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
	    else curTransform = parseFloat(matrix[4]);
	  }
	  if (axis === 'y') {
	    // Latest Chrome and webkits Fix
	    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
	    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
	    else curTransform = parseFloat(matrix[5]);
	  }
	  return curTransform || 0;
	}
	function isObject(o) {
	  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
	}
	function isNode(node) {
	  // eslint-disable-next-line
	  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
	    return node instanceof HTMLElement;
	  }
	  return node && (node.nodeType === 1 || node.nodeType === 11);
	}
	function extend(...args) {
	  const to = Object(args[0]);
	  const noExtend = ['__proto__', 'constructor', 'prototype'];
	  for (let i = 1; i < args.length; i += 1) {
	    const nextSource = args[i];
	    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
	      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);
	      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	        const nextKey = keysArray[nextIndex];
	        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	        if (desc !== undefined && desc.enumerable) {
	          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
	            if (nextSource[nextKey].__swiper__) {
	              to[nextKey] = nextSource[nextKey];
	            } else {
	              extend(to[nextKey], nextSource[nextKey]);
	            }
	          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
	            to[nextKey] = {};
	            if (nextSource[nextKey].__swiper__) {
	              to[nextKey] = nextSource[nextKey];
	            } else {
	              extend(to[nextKey], nextSource[nextKey]);
	            }
	          } else {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	    }
	  }
	  return to;
	}
	function setCSSProperty(el, varName, varValue) {
	  el.style.setProperty(varName, varValue);
	}
	function animateCSSModeScroll({
	  swiper,
	  targetPosition,
	  side
	}) {
	  const window = getWindow();
	  const startPosition = -swiper.translate;
	  let startTime = null;
	  let time;
	  const duration = swiper.params.speed;
	  swiper.wrapperEl.style.scrollSnapType = 'none';
	  window.cancelAnimationFrame(swiper.cssModeFrameID);
	  const dir = targetPosition > startPosition ? 'next' : 'prev';
	  const isOutOfBound = (current, target) => {
	    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
	  };
	  const animate = () => {
	    time = new Date().getTime();
	    if (startTime === null) {
	      startTime = time;
	    }
	    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
	    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
	    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
	    if (isOutOfBound(currentPosition, targetPosition)) {
	      currentPosition = targetPosition;
	    }
	    swiper.wrapperEl.scrollTo({
	      [side]: currentPosition
	    });
	    if (isOutOfBound(currentPosition, targetPosition)) {
	      swiper.wrapperEl.style.overflow = 'hidden';
	      swiper.wrapperEl.style.scrollSnapType = '';
	      setTimeout(() => {
	        swiper.wrapperEl.style.overflow = '';
	        swiper.wrapperEl.scrollTo({
	          [side]: currentPosition
	        });
	      });
	      window.cancelAnimationFrame(swiper.cssModeFrameID);
	      return;
	    }
	    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
	  };
	  animate();
	}

	let support;
	function calcSupport() {
	  const window = getWindow();
	  const document = getDocument();
	  return {
	    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
	    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
	    passiveListener: function checkPassiveListener() {
	      let supportsPassive = false;
	      try {
	        const opts = Object.defineProperty({}, 'passive', {
	          // eslint-disable-next-line
	          get() {
	            supportsPassive = true;
	          }
	        });
	        window.addEventListener('testPassiveListener', null, opts);
	      } catch (e) {// No support
	      }
	      return supportsPassive;
	    }(),
	    gestures: function checkGestures() {
	      return 'ongesturestart' in window;
	    }()
	  };
	}
	function getSupport() {
	  if (!support) {
	    support = calcSupport();
	  }
	  return support;
	}

	let deviceCached;
	function calcDevice({
	  userAgent
	} = {}) {
	  const support = getSupport();
	  const window = getWindow();
	  const platform = window.navigator.platform;
	  const ua = userAgent || window.navigator.userAgent;
	  const device = {
	    ios: false,
	    android: false
	  };
	  const screenWidth = window.screen.width;
	  const screenHeight = window.screen.height;
	  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

	  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	  const windows = platform === 'Win32';
	  let macos = platform === 'MacIntel'; // iPadOs 13 fix

	  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
	  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
	    ipad = ua.match(/(Version)\/([\d.]+)/);
	    if (!ipad) ipad = [0, 1, '13_0_0'];
	    macos = false;
	  } // Android

	  if (android && !windows) {
	    device.os = 'android';
	    device.android = true;
	  }
	  if (ipad || iphone || ipod) {
	    device.os = 'ios';
	    device.ios = true;
	  } // Export object

	  return device;
	}
	function getDevice(overrides = {}) {
	  if (!deviceCached) {
	    deviceCached = calcDevice(overrides);
	  }
	  return deviceCached;
	}

	let browser;
	function calcBrowser() {
	  const window = getWindow();
	  function isSafari() {
	    const ua = window.navigator.userAgent.toLowerCase();
	    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
	  }
	  return {
	    isSafari: isSafari(),
	    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
	  };
	}
	function getBrowser() {
	  if (!browser) {
	    browser = calcBrowser();
	  }
	  return browser;
	}

	function Resize({
	  swiper,
	  on,
	  emit
	}) {
	  const window = getWindow();
	  let observer = null;
	  let animationFrame = null;
	  const resizeHandler = () => {
	    if (!swiper || swiper.destroyed || !swiper.initialized) return;
	    emit('beforeResize');
	    emit('resize');
	  };
	  const createObserver = () => {
	    if (!swiper || swiper.destroyed || !swiper.initialized) return;
	    observer = new ResizeObserver(entries => {
	      animationFrame = window.requestAnimationFrame(() => {
	        const {
	          width,
	          height
	        } = swiper;
	        let newWidth = width;
	        let newHeight = height;
	        entries.forEach(({
	          contentBoxSize,
	          contentRect,
	          target
	        }) => {
	          if (target && target !== swiper.el) return;
	          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
	          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
	        });
	        if (newWidth !== width || newHeight !== height) {
	          resizeHandler();
	        }
	      });
	    });
	    observer.observe(swiper.el);
	  };
	  const removeObserver = () => {
	    if (animationFrame) {
	      window.cancelAnimationFrame(animationFrame);
	    }
	    if (observer && observer.unobserve && swiper.el) {
	      observer.unobserve(swiper.el);
	      observer = null;
	    }
	  };
	  const orientationChangeHandler = () => {
	    if (!swiper || swiper.destroyed || !swiper.initialized) return;
	    emit('orientationchange');
	  };
	  on('init', () => {
	    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
	      createObserver();
	      return;
	    }
	    window.addEventListener('resize', resizeHandler);
	    window.addEventListener('orientationchange', orientationChangeHandler);
	  });
	  on('destroy', () => {
	    removeObserver();
	    window.removeEventListener('resize', resizeHandler);
	    window.removeEventListener('orientationchange', orientationChangeHandler);
	  });
	}

	function Observer({
	  swiper,
	  extendParams,
	  on,
	  emit
	}) {
	  const observers = [];
	  const window = getWindow();
	  const attach = (target, options = {}) => {
	    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
	    const observer = new ObserverFunc(mutations => {
	      // The observerUpdate event should only be triggered
	      // once despite the number of mutations.  Additional
	      // triggers are redundant and are very costly
	      if (mutations.length === 1) {
	        emit('observerUpdate', mutations[0]);
	        return;
	      }
	      const observerUpdate = function observerUpdate() {
	        emit('observerUpdate', mutations[0]);
	      };
	      if (window.requestAnimationFrame) {
	        window.requestAnimationFrame(observerUpdate);
	      } else {
	        window.setTimeout(observerUpdate, 0);
	      }
	    });
	    observer.observe(target, {
	      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	      childList: typeof options.childList === 'undefined' ? true : options.childList,
	      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
	    });
	    observers.push(observer);
	  };
	  const init = () => {
	    if (!swiper.params.observer) return;
	    if (swiper.params.observeParents) {
	      const containerParents = swiper.$el.parents();
	      for (let i = 0; i < containerParents.length; i += 1) {
	        attach(containerParents[i]);
	      }
	    } // Observe container

	    attach(swiper.$el[0], {
	      childList: swiper.params.observeSlideChildren
	    }); // Observe wrapper

	    attach(swiper.$wrapperEl[0], {
	      attributes: false
	    });
	  };
	  const destroy = () => {
	    observers.forEach(observer => {
	      observer.disconnect();
	    });
	    observers.splice(0, observers.length);
	  };
	  extendParams({
	    observer: false,
	    observeParents: false,
	    observeSlideChildren: false
	  });
	  on('init', init);
	  on('destroy', destroy);
	}

	/* eslint-disable no-underscore-dangle */
	var eventsEmitter = {
	  on(events, handler, priority) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (typeof handler !== 'function') return self;
	    const method = priority ? 'unshift' : 'push';
	    events.split(' ').forEach(event => {
	      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
	      self.eventsListeners[event][method](handler);
	    });
	    return self;
	  },
	  once(events, handler, priority) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (typeof handler !== 'function') return self;
	    function onceHandler(...args) {
	      self.off(events, onceHandler);
	      if (onceHandler.__emitterProxy) {
	        delete onceHandler.__emitterProxy;
	      }
	      handler.apply(self, args);
	    }
	    onceHandler.__emitterProxy = handler;
	    return self.on(events, onceHandler, priority);
	  },
	  onAny(handler, priority) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (typeof handler !== 'function') return self;
	    const method = priority ? 'unshift' : 'push';
	    if (self.eventsAnyListeners.indexOf(handler) < 0) {
	      self.eventsAnyListeners[method](handler);
	    }
	    return self;
	  },
	  offAny(handler) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (!self.eventsAnyListeners) return self;
	    const index = self.eventsAnyListeners.indexOf(handler);
	    if (index >= 0) {
	      self.eventsAnyListeners.splice(index, 1);
	    }
	    return self;
	  },
	  off(events, handler) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (!self.eventsListeners) return self;
	    events.split(' ').forEach(event => {
	      if (typeof handler === 'undefined') {
	        self.eventsListeners[event] = [];
	      } else if (self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach((eventHandler, index) => {
	          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
	            self.eventsListeners[event].splice(index, 1);
	          }
	        });
	      }
	    });
	    return self;
	  },
	  emit(...args) {
	    const self = this;
	    if (!self.eventsListeners || self.destroyed) return self;
	    if (!self.eventsListeners) return self;
	    let events;
	    let data;
	    let context;
	    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
	      events = args[0];
	      data = args.slice(1, args.length);
	      context = self;
	    } else {
	      events = args[0].events;
	      data = args[0].data;
	      context = args[0].context || self;
	    }
	    data.unshift(context);
	    const eventsArray = Array.isArray(events) ? events : events.split(' ');
	    eventsArray.forEach(event => {
	      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
	        self.eventsAnyListeners.forEach(eventHandler => {
	          eventHandler.apply(context, [event, ...data]);
	        });
	      }
	      if (self.eventsListeners && self.eventsListeners[event]) {
	        self.eventsListeners[event].forEach(eventHandler => {
	          eventHandler.apply(context, data);
	        });
	      }
	    });
	    return self;
	  }
	};

	function updateSize() {
	  const swiper = this;
	  let width;
	  let height;
	  const $el = swiper.$el;
	  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
	    width = swiper.params.width;
	  } else {
	    width = $el[0].clientWidth;
	  }
	  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
	    height = swiper.params.height;
	  } else {
	    height = $el[0].clientHeight;
	  }
	  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
	    return;
	  } // Subtract paddings

	  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
	  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
	  if (Number.isNaN(width)) width = 0;
	  if (Number.isNaN(height)) height = 0;
	  Object.assign(swiper, {
	    width,
	    height,
	    size: swiper.isHorizontal() ? width : height
	  });
	}

	function updateSlides() {
	  const swiper = this;
	  function getDirectionLabel(property) {
	    if (swiper.isHorizontal()) {
	      return property;
	    } // prettier-ignore

	    return {
	      'width': 'height',
	      'margin-top': 'margin-left',
	      'margin-bottom ': 'margin-right',
	      'margin-left': 'margin-top',
	      'margin-right': 'margin-bottom',
	      'padding-left': 'padding-top',
	      'padding-right': 'padding-bottom',
	      'marginRight': 'marginBottom'
	    }[property];
	  }
	  function getDirectionPropertyValue(node, label) {
	    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
	  }
	  const params = swiper.params;
	  const {
	    $wrapperEl,
	    size: swiperSize,
	    rtlTranslate: rtl,
	    wrongRTL
	  } = swiper;
	  const isVirtual = swiper.virtual && params.virtual.enabled;
	  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
	  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
	  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
	  let snapGrid = [];
	  const slidesGrid = [];
	  const slidesSizesGrid = [];
	  let offsetBefore = params.slidesOffsetBefore;
	  if (typeof offsetBefore === 'function') {
	    offsetBefore = params.slidesOffsetBefore.call(swiper);
	  }
	  let offsetAfter = params.slidesOffsetAfter;
	  if (typeof offsetAfter === 'function') {
	    offsetAfter = params.slidesOffsetAfter.call(swiper);
	  }
	  const previousSnapGridLength = swiper.snapGrid.length;
	  const previousSlidesGridLength = swiper.slidesGrid.length;
	  let spaceBetween = params.spaceBetween;
	  let slidePosition = -offsetBefore;
	  let prevSlideSize = 0;
	  let index = 0;
	  if (typeof swiperSize === 'undefined') {
	    return;
	  }
	  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
	  }
	  swiper.virtualSize = -spaceBetween; // reset margins

	  if (rtl) slides.css({
	    marginLeft: '',
	    marginBottom: '',
	    marginTop: ''
	  });else slides.css({
	    marginRight: '',
	    marginBottom: '',
	    marginTop: ''
	  }); // reset cssMode offsets

	  if (params.centeredSlides && params.cssMode) {
	    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
	    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
	  }
	  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
	  if (gridEnabled) {
	    swiper.grid.initSlides(slidesLength);
	  } // Calc slides

	  let slideSize;
	  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
	    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
	  }).length > 0;
	  for (let i = 0; i < slidesLength; i += 1) {
	    slideSize = 0;
	    const slide = slides.eq(i);
	    if (gridEnabled) {
	      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
	    }
	    if (slide.css('display') === 'none') continue; // eslint-disable-line

	    if (params.slidesPerView === 'auto') {
	      if (shouldResetSlideSize) {
	        slides[i].style[getDirectionLabel('width')] = ``;
	      }
	      const slideStyles = getComputedStyle(slide[0]);
	      const currentTransform = slide[0].style.transform;
	      const currentWebKitTransform = slide[0].style.webkitTransform;
	      if (currentTransform) {
	        slide[0].style.transform = 'none';
	      }
	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = 'none';
	      }
	      if (params.roundLengths) {
	        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
	      } else {
	        // eslint-disable-next-line
	        const width = getDirectionPropertyValue(slideStyles, 'width');
	        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
	        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
	        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
	        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
	        const boxSizing = slideStyles.getPropertyValue('box-sizing');
	        if (boxSizing && boxSizing === 'border-box') {
	          slideSize = width + marginLeft + marginRight;
	        } else {
	          const {
	            clientWidth,
	            offsetWidth
	          } = slide[0];
	          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
	        }
	      }
	      if (currentTransform) {
	        slide[0].style.transform = currentTransform;
	      }
	      if (currentWebKitTransform) {
	        slide[0].style.webkitTransform = currentWebKitTransform;
	      }
	      if (params.roundLengths) slideSize = Math.floor(slideSize);
	    } else {
	      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
	      if (params.roundLengths) slideSize = Math.floor(slideSize);
	      if (slides[i]) {
	        slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
	      }
	    }
	    if (slides[i]) {
	      slides[i].swiperSlideSize = slideSize;
	    }
	    slidesSizesGrid.push(slideSize);
	    if (params.centeredSlides) {
	      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
	      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
	      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	    } else {
	      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
	      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
	      slidesGrid.push(slidePosition);
	      slidePosition = slidePosition + slideSize + spaceBetween;
	    }
	    swiper.virtualSize += slideSize + spaceBetween;
	    prevSlideSize = slideSize;
	    index += 1;
	  }
	  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
	  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
	    $wrapperEl.css({
	      width: `${swiper.virtualSize + params.spaceBetween}px`
	    });
	  }
	  if (params.setWrapperSize) {
	    $wrapperEl.css({
	      [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
	    });
	  }
	  if (gridEnabled) {
	    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
	  } // Remove last grid elements depending on width

	  if (!params.centeredSlides) {
	    const newSlidesGrid = [];
	    for (let i = 0; i < snapGrid.length; i += 1) {
	      let slidesGridItem = snapGrid[i];
	      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
	      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
	        newSlidesGrid.push(slidesGridItem);
	      }
	    }
	    snapGrid = newSlidesGrid;
	    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
	      snapGrid.push(swiper.virtualSize - swiperSize);
	    }
	  }
	  if (snapGrid.length === 0) snapGrid = [0];
	  if (params.spaceBetween !== 0) {
	    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
	    slides.filter((_, slideIndex) => {
	      if (!params.cssMode) return true;
	      if (slideIndex === slides.length - 1) {
	        return false;
	      }
	      return true;
	    }).css({
	      [key]: `${spaceBetween}px`
	    });
	  }
	  if (params.centeredSlides && params.centeredSlidesBounds) {
	    let allSlidesSize = 0;
	    slidesSizesGrid.forEach(slideSizeValue => {
	      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	    });
	    allSlidesSize -= params.spaceBetween;
	    const maxSnap = allSlidesSize - swiperSize;
	    snapGrid = snapGrid.map(snap => {
	      if (snap < 0) return -offsetBefore;
	      if (snap > maxSnap) return maxSnap + offsetAfter;
	      return snap;
	    });
	  }
	  if (params.centerInsufficientSlides) {
	    let allSlidesSize = 0;
	    slidesSizesGrid.forEach(slideSizeValue => {
	      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
	    });
	    allSlidesSize -= params.spaceBetween;
	    if (allSlidesSize < swiperSize) {
	      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
	      snapGrid.forEach((snap, snapIndex) => {
	        snapGrid[snapIndex] = snap - allSlidesOffset;
	      });
	      slidesGrid.forEach((snap, snapIndex) => {
	        slidesGrid[snapIndex] = snap + allSlidesOffset;
	      });
	    }
	  }
	  Object.assign(swiper, {
	    slides,
	    snapGrid,
	    slidesGrid,
	    slidesSizesGrid
	  });
	  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
	    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
	    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
	    const addToSnapGrid = -swiper.snapGrid[0];
	    const addToSlidesGrid = -swiper.slidesGrid[0];
	    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
	    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
	  }
	  if (slidesLength !== previousSlidesLength) {
	    swiper.emit('slidesLengthChange');
	  }
	  if (snapGrid.length !== previousSnapGridLength) {
	    if (swiper.params.watchOverflow) swiper.checkOverflow();
	    swiper.emit('snapGridLengthChange');
	  }
	  if (slidesGrid.length !== previousSlidesGridLength) {
	    swiper.emit('slidesGridLengthChange');
	  }
	  if (params.watchSlidesProgress) {
	    swiper.updateSlidesOffset();
	  }
	  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
	    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
	    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
	    if (slidesLength <= params.maxBackfaceHiddenSlides) {
	      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
	    } else if (hasClassBackfaceClassAdded) {
	      swiper.$el.removeClass(backFaceHiddenClass);
	    }
	  }
	}

	function updateAutoHeight(speed) {
	  const swiper = this;
	  const activeSlides = [];
	  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	  let newHeight = 0;
	  let i;
	  if (typeof speed === 'number') {
	    swiper.setTransition(speed);
	  } else if (speed === true) {
	    swiper.setTransition(swiper.params.speed);
	  }
	  const getSlideByIndex = index => {
	    if (isVirtual) {
	      return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
	    }
	    return swiper.slides.eq(index)[0];
	  }; // Find slides currently in view

	  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
	    if (swiper.params.centeredSlides) {
	      (swiper.visibleSlides || $([])).each(slide => {
	        activeSlides.push(slide);
	      });
	    } else {
	      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
	        const index = swiper.activeIndex + i;
	        if (index > swiper.slides.length && !isVirtual) break;
	        activeSlides.push(getSlideByIndex(index));
	      }
	    }
	  } else {
	    activeSlides.push(getSlideByIndex(swiper.activeIndex));
	  } // Find new height from highest slide in view

	  for (i = 0; i < activeSlides.length; i += 1) {
	    if (typeof activeSlides[i] !== 'undefined') {
	      const height = activeSlides[i].offsetHeight;
	      newHeight = height > newHeight ? height : newHeight;
	    }
	  } // Update Height

	  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
	}

	function updateSlidesOffset() {
	  const swiper = this;
	  const slides = swiper.slides;
	  for (let i = 0; i < slides.length; i += 1) {
	    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
	  }
	}

	function updateSlidesProgress(translate = this && this.translate || 0) {
	  const swiper = this;
	  const params = swiper.params;
	  const {
	    slides,
	    rtlTranslate: rtl,
	    snapGrid
	  } = swiper;
	  if (slides.length === 0) return;
	  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
	  let offsetCenter = -translate;
	  if (rtl) offsetCenter = translate; // Visible Slides

	  slides.removeClass(params.slideVisibleClass);
	  swiper.visibleSlidesIndexes = [];
	  swiper.visibleSlides = [];
	  for (let i = 0; i < slides.length; i += 1) {
	    const slide = slides[i];
	    let slideOffset = slide.swiperSlideOffset;
	    if (params.cssMode && params.centeredSlides) {
	      slideOffset -= slides[0].swiperSlideOffset;
	    }
	    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
	    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
	    const slideBefore = -(offsetCenter - slideOffset);
	    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
	    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
	    if (isVisible) {
	      swiper.visibleSlides.push(slide);
	      swiper.visibleSlidesIndexes.push(i);
	      slides.eq(i).addClass(params.slideVisibleClass);
	    }
	    slide.progress = rtl ? -slideProgress : slideProgress;
	    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
	  }
	  swiper.visibleSlides = $(swiper.visibleSlides);
	}

	function updateProgress(translate) {
	  const swiper = this;
	  if (typeof translate === 'undefined') {
	    const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

	    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
	  }
	  const params = swiper.params;
	  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  let {
	    progress,
	    isBeginning,
	    isEnd
	  } = swiper;
	  const wasBeginning = isBeginning;
	  const wasEnd = isEnd;
	  if (translatesDiff === 0) {
	    progress = 0;
	    isBeginning = true;
	    isEnd = true;
	  } else {
	    progress = (translate - swiper.minTranslate()) / translatesDiff;
	    isBeginning = progress <= 0;
	    isEnd = progress >= 1;
	  }
	  Object.assign(swiper, {
	    progress,
	    isBeginning,
	    isEnd
	  });
	  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
	  if (isBeginning && !wasBeginning) {
	    swiper.emit('reachBeginning toEdge');
	  }
	  if (isEnd && !wasEnd) {
	    swiper.emit('reachEnd toEdge');
	  }
	  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
	    swiper.emit('fromEdge');
	  }
	  swiper.emit('progress', progress);
	}

	function updateSlidesClasses() {
	  const swiper = this;
	  const {
	    slides,
	    params,
	    $wrapperEl,
	    activeIndex,
	    realIndex
	  } = swiper;
	  const isVirtual = swiper.virtual && params.virtual.enabled;
	  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
	  let activeSlide;
	  if (isVirtual) {
	    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
	  } else {
	    activeSlide = slides.eq(activeIndex);
	  } // Active classes

	  activeSlide.addClass(params.slideActiveClass);
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (activeSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
	    } else {
	      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
	    }
	  } // Next Slide

	  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
	  if (params.loop && nextSlide.length === 0) {
	    nextSlide = slides.eq(0);
	    nextSlide.addClass(params.slideNextClass);
	  } // Prev Slide

	  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
	  if (params.loop && prevSlide.length === 0) {
	    prevSlide = slides.eq(-1);
	    prevSlide.addClass(params.slidePrevClass);
	  }
	  if (params.loop) {
	    // Duplicate to all looped slides
	    if (nextSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
	    } else {
	      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
	    }
	    if (prevSlide.hasClass(params.slideDuplicateClass)) {
	      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
	    } else {
	      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
	    }
	  }
	  swiper.emitSlidesClasses();
	}

	function updateActiveIndex(newActiveIndex) {
	  const swiper = this;
	  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  const {
	    slidesGrid,
	    snapGrid,
	    params,
	    activeIndex: previousIndex,
	    realIndex: previousRealIndex,
	    snapIndex: previousSnapIndex
	  } = swiper;
	  let activeIndex = newActiveIndex;
	  let snapIndex;
	  if (typeof activeIndex === 'undefined') {
	    for (let i = 0; i < slidesGrid.length; i += 1) {
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
	          activeIndex = i;
	        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
	          activeIndex = i + 1;
	        }
	      } else if (translate >= slidesGrid[i]) {
	        activeIndex = i;
	      }
	    } // Normalize slideIndex

	    if (params.normalizeSlideIndex) {
	      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
	    }
	  }
	  if (snapGrid.indexOf(translate) >= 0) {
	    snapIndex = snapGrid.indexOf(translate);
	  } else {
	    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
	    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
	  }
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
	  if (activeIndex === previousIndex) {
	    if (snapIndex !== previousSnapIndex) {
	      swiper.snapIndex = snapIndex;
	      swiper.emit('snapIndexChange');
	    }
	    return;
	  } // Get real index

	  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
	  Object.assign(swiper, {
	    snapIndex,
	    realIndex,
	    previousIndex,
	    activeIndex
	  });
	  swiper.emit('activeIndexChange');
	  swiper.emit('snapIndexChange');
	  if (previousRealIndex !== realIndex) {
	    swiper.emit('realIndexChange');
	  }
	  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
	    swiper.emit('slideChange');
	  }
	}

	function updateClickedSlide(e) {
	  const swiper = this;
	  const params = swiper.params;
	  const slide = $(e).closest(`.${params.slideClass}`)[0];
	  let slideFound = false;
	  let slideIndex;
	  if (slide) {
	    for (let i = 0; i < swiper.slides.length; i += 1) {
	      if (swiper.slides[i] === slide) {
	        slideFound = true;
	        slideIndex = i;
	        break;
	      }
	    }
	  }
	  if (slide && slideFound) {
	    swiper.clickedSlide = slide;
	    if (swiper.virtual && swiper.params.virtual.enabled) {
	      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
	    } else {
	      swiper.clickedIndex = slideIndex;
	    }
	  } else {
	    swiper.clickedSlide = undefined;
	    swiper.clickedIndex = undefined;
	    return;
	  }
	  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
	    swiper.slideToClickedSlide();
	  }
	}

	var update = {
	  updateSize,
	  updateSlides,
	  updateAutoHeight,
	  updateSlidesOffset,
	  updateSlidesProgress,
	  updateProgress,
	  updateSlidesClasses,
	  updateActiveIndex,
	  updateClickedSlide
	};

	function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
	  const swiper = this;
	  const {
	    params,
	    rtlTranslate: rtl,
	    translate,
	    $wrapperEl
	  } = swiper;
	  if (params.virtualTranslate) {
	    return rtl ? -translate : translate;
	  }
	  if (params.cssMode) {
	    return translate;
	  }
	  let currentTranslate = getTranslate($wrapperEl[0], axis);
	  if (rtl) currentTranslate = -currentTranslate;
	  return currentTranslate || 0;
	}

	function setTranslate(translate, byController) {
	  const swiper = this;
	  const {
	    rtlTranslate: rtl,
	    params,
	    $wrapperEl,
	    wrapperEl,
	    progress
	  } = swiper;
	  let x = 0;
	  let y = 0;
	  const z = 0;
	  if (swiper.isHorizontal()) {
	    x = rtl ? -translate : translate;
	  } else {
	    y = translate;
	  }
	  if (params.roundLengths) {
	    x = Math.floor(x);
	    y = Math.floor(y);
	  }
	  if (params.cssMode) {
	    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
	  } else if (!params.virtualTranslate) {
	    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
	  }
	  swiper.previousTranslate = swiper.translate;
	  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

	  let newProgress;
	  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
	  }
	  if (newProgress !== progress) {
	    swiper.updateProgress(translate);
	  }
	  swiper.emit('setTranslate', swiper.translate, byController);
	}

	function minTranslate() {
	  return -this.snapGrid[0];
	}

	function maxTranslate() {
	  return -this.snapGrid[this.snapGrid.length - 1];
	}

	function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
	  const swiper = this;
	  const {
	    params,
	    wrapperEl
	  } = swiper;
	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return false;
	  }
	  const minTranslate = swiper.minTranslate();
	  const maxTranslate = swiper.maxTranslate();
	  let newTranslate;
	  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

	  swiper.updateProgress(newTranslate);
	  if (params.cssMode) {
	    const isH = swiper.isHorizontal();
	    if (speed === 0) {
	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
	    } else {
	      if (!swiper.support.smoothScroll) {
	        animateCSSModeScroll({
	          swiper,
	          targetPosition: -newTranslate,
	          side: isH ? 'left' : 'top'
	        });
	        return true;
	      }
	      wrapperEl.scrollTo({
	        [isH ? 'left' : 'top']: -newTranslate,
	        behavior: 'smooth'
	      });
	    }
	    return true;
	  }
	  if (speed === 0) {
	    swiper.setTransition(0);
	    swiper.setTranslate(newTranslate);
	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionEnd');
	    }
	  } else {
	    swiper.setTransition(speed);
	    swiper.setTranslate(newTranslate);
	    if (runCallbacks) {
	      swiper.emit('beforeTransitionStart', speed, internal);
	      swiper.emit('transitionStart');
	    }
	    if (!swiper.animating) {
	      swiper.animating = true;
	      if (!swiper.onTranslateToWrapperTransitionEnd) {
	        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
	          if (!swiper || swiper.destroyed) return;
	          if (e.target !== this) return;
	          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	          swiper.onTranslateToWrapperTransitionEnd = null;
	          delete swiper.onTranslateToWrapperTransitionEnd;
	          if (runCallbacks) {
	            swiper.emit('transitionEnd');
	          }
	        };
	      }
	      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
	      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
	    }
	  }
	  return true;
	}

	var translate = {
	  getTranslate: getSwiperTranslate,
	  setTranslate,
	  minTranslate,
	  maxTranslate,
	  translateTo
	};

	function setTransition(duration, byController) {
	  const swiper = this;
	  if (!swiper.params.cssMode) {
	    swiper.$wrapperEl.transition(duration);
	  }
	  swiper.emit('setTransition', duration, byController);
	}

	function transitionEmit({
	  swiper,
	  runCallbacks,
	  direction,
	  step
	}) {
	  const {
	    activeIndex,
	    previousIndex
	  } = swiper;
	  let dir = direction;
	  if (!dir) {
	    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
	  }
	  swiper.emit(`transition${step}`);
	  if (runCallbacks && activeIndex !== previousIndex) {
	    if (dir === 'reset') {
	      swiper.emit(`slideResetTransition${step}`);
	      return;
	    }
	    swiper.emit(`slideChangeTransition${step}`);
	    if (dir === 'next') {
	      swiper.emit(`slideNextTransition${step}`);
	    } else {
	      swiper.emit(`slidePrevTransition${step}`);
	    }
	  }
	}

	function transitionStart(runCallbacks = true, direction) {
	  const swiper = this;
	  const {
	    params
	  } = swiper;
	  if (params.cssMode) return;
	  if (params.autoHeight) {
	    swiper.updateAutoHeight();
	  }
	  transitionEmit({
	    swiper,
	    runCallbacks,
	    direction,
	    step: 'Start'
	  });
	}

	function transitionEnd(runCallbacks = true, direction) {
	  const swiper = this;
	  const {
	    params
	  } = swiper;
	  swiper.animating = false;
	  if (params.cssMode) return;
	  swiper.setTransition(0);
	  transitionEmit({
	    swiper,
	    runCallbacks,
	    direction,
	    step: 'End'
	  });
	}

	var transition = {
	  setTransition,
	  transitionStart,
	  transitionEnd
	};

	function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
	  if (typeof index !== 'number' && typeof index !== 'string') {
	    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
	  }
	  if (typeof index === 'string') {
	    /**
	     * The `index` argument converted from `string` to `number`.
	     * @type {number}
	     */
	    const indexAsNumber = parseInt(index, 10);
	    /**
	     * Determines whether the `index` argument is a valid `number`
	     * after being converted from the `string` type.
	     * @type {boolean}
	     */

	    const isValidNumber = isFinite(indexAsNumber);
	    if (!isValidNumber) {
	      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
	    } // Knowing that the converted `index` is a valid number,
	    // we can update the original argument's value.

	    index = indexAsNumber;
	  }
	  const swiper = this;
	  let slideIndex = index;
	  if (slideIndex < 0) slideIndex = 0;
	  const {
	    params,
	    snapGrid,
	    slidesGrid,
	    previousIndex,
	    activeIndex,
	    rtlTranslate: rtl,
	    wrapperEl,
	    enabled
	  } = swiper;
	  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
	    return false;
	  }
	  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
	  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
	  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
	  const translate = -snapGrid[snapIndex]; // Normalize slideIndex

	  if (params.normalizeSlideIndex) {
	    for (let i = 0; i < slidesGrid.length; i += 1) {
	      const normalizedTranslate = -Math.floor(translate * 100);
	      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
	      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
	      if (typeof slidesGrid[i + 1] !== 'undefined') {
	        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
	          slideIndex = i;
	        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
	          slideIndex = i + 1;
	        }
	      } else if (normalizedTranslate >= normalizedGrid) {
	        slideIndex = i;
	      }
	    }
	  } // Directions locks

	  if (swiper.initialized && slideIndex !== activeIndex) {
	    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
	      return false;
	    }
	    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
	      if ((activeIndex || 0) !== slideIndex) return false;
	    }
	  }
	  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
	    swiper.emit('beforeSlideChangeStart');
	  } // Update progress

	  swiper.updateProgress(translate);
	  let direction;
	  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

	  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
	    swiper.updateActiveIndex(slideIndex); // Update Height

	    if (params.autoHeight) {
	      swiper.updateAutoHeight();
	    }
	    swiper.updateSlidesClasses();
	    if (params.effect !== 'slide') {
	      swiper.setTranslate(translate);
	    }
	    if (direction !== 'reset') {
	      swiper.transitionStart(runCallbacks, direction);
	      swiper.transitionEnd(runCallbacks, direction);
	    }
	    return false;
	  }
	  if (params.cssMode) {
	    const isH = swiper.isHorizontal();
	    const t = rtl ? translate : -translate;
	    if (speed === 0) {
	      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
	      if (isVirtual) {
	        swiper.wrapperEl.style.scrollSnapType = 'none';
	        swiper._immediateVirtual = true;
	      }
	      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
	      if (isVirtual) {
	        requestAnimationFrame(() => {
	          swiper.wrapperEl.style.scrollSnapType = '';
	          swiper._swiperImmediateVirtual = false;
	        });
	      }
	    } else {
	      if (!swiper.support.smoothScroll) {
	        animateCSSModeScroll({
	          swiper,
	          targetPosition: t,
	          side: isH ? 'left' : 'top'
	        });
	        return true;
	      }
	      wrapperEl.scrollTo({
	        [isH ? 'left' : 'top']: t,
	        behavior: 'smooth'
	      });
	    }
	    return true;
	  }
	  swiper.setTransition(speed);
	  swiper.setTranslate(translate);
	  swiper.updateActiveIndex(slideIndex);
	  swiper.updateSlidesClasses();
	  swiper.emit('beforeTransitionStart', speed, internal);
	  swiper.transitionStart(runCallbacks, direction);
	  if (speed === 0) {
	    swiper.transitionEnd(runCallbacks, direction);
	  } else if (!swiper.animating) {
	    swiper.animating = true;
	    if (!swiper.onSlideToWrapperTransitionEnd) {
	      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
	        if (!swiper || swiper.destroyed) return;
	        if (e.target !== this) return;
	        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	        swiper.onSlideToWrapperTransitionEnd = null;
	        delete swiper.onSlideToWrapperTransitionEnd;
	        swiper.transitionEnd(runCallbacks, direction);
	      };
	    }
	    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
	    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
	  }
	  return true;
	}

	function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
	  if (typeof index === 'string') {
	    /**
	     * The `index` argument converted from `string` to `number`.
	     * @type {number}
	     */
	    const indexAsNumber = parseInt(index, 10);
	    /**
	     * Determines whether the `index` argument is a valid `number`
	     * after being converted from the `string` type.
	     * @type {boolean}
	     */

	    const isValidNumber = isFinite(indexAsNumber);
	    if (!isValidNumber) {
	      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
	    } // Knowing that the converted `index` is a valid number,
	    // we can update the original argument's value.

	    index = indexAsNumber;
	  }
	  const swiper = this;
	  let newIndex = index;
	  if (swiper.params.loop) {
	    newIndex += swiper.loopedSlides;
	  }
	  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
	  const swiper = this;
	  const {
	    animating,
	    enabled,
	    params
	  } = swiper;
	  if (!enabled) return swiper;
	  let perGroup = params.slidesPerGroup;
	  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
	    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
	  }
	  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
	  if (params.loop) {
	    if (animating && params.loopPreventsSlide) return false;
	    swiper.loopFix(); // eslint-disable-next-line

	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }
	  if (params.rewind && swiper.isEnd) {
	    return swiper.slideTo(0, speed, runCallbacks, internal);
	  }
	  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
	  const swiper = this;
	  const {
	    params,
	    animating,
	    snapGrid,
	    slidesGrid,
	    rtlTranslate,
	    enabled
	  } = swiper;
	  if (!enabled) return swiper;
	  if (params.loop) {
	    if (animating && params.loopPreventsSlide) return false;
	    swiper.loopFix(); // eslint-disable-next-line

	    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
	  }
	  const translate = rtlTranslate ? swiper.translate : -swiper.translate;
	  function normalize(val) {
	    if (val < 0) return -Math.floor(Math.abs(val));
	    return Math.floor(val);
	  }
	  const normalizedTranslate = normalize(translate);
	  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
	  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
	  if (typeof prevSnap === 'undefined' && params.cssMode) {
	    let prevSnapIndex;
	    snapGrid.forEach((snap, snapIndex) => {
	      if (normalizedTranslate >= snap) {
	        // prevSnap = snap;
	        prevSnapIndex = snapIndex;
	      }
	    });
	    if (typeof prevSnapIndex !== 'undefined') {
	      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
	    }
	  }
	  let prevIndex = 0;
	  if (typeof prevSnap !== 'undefined') {
	    prevIndex = slidesGrid.indexOf(prevSnap);
	    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
	    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
	      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
	      prevIndex = Math.max(prevIndex, 0);
	    }
	  }
	  if (params.rewind && swiper.isBeginning) {
	    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
	    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
	  }
	  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
	  const swiper = this;
	  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
	}

	/* eslint no-unused-vars: "off" */
	function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
	  const swiper = this;
	  let index = swiper.activeIndex;
	  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
	  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
	  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
	  if (translate >= swiper.snapGrid[snapIndex]) {
	    // The current translate is on or after the current snap index, so the choice
	    // is between the current index and the one after it.
	    const currentSnap = swiper.snapGrid[snapIndex];
	    const nextSnap = swiper.snapGrid[snapIndex + 1];
	    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
	      index += swiper.params.slidesPerGroup;
	    }
	  } else {
	    // The current translate is before the current snap index, so the choice
	    // is between the current index and the one before it.
	    const prevSnap = swiper.snapGrid[snapIndex - 1];
	    const currentSnap = swiper.snapGrid[snapIndex];
	    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
	      index -= swiper.params.slidesPerGroup;
	    }
	  }
	  index = Math.max(index, 0);
	  index = Math.min(index, swiper.slidesGrid.length - 1);
	  return swiper.slideTo(index, speed, runCallbacks, internal);
	}

	function slideToClickedSlide() {
	  const swiper = this;
	  const {
	    params,
	    $wrapperEl
	  } = swiper;
	  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
	  let slideToIndex = swiper.clickedIndex;
	  let realIndex;
	  if (params.loop) {
	    if (swiper.animating) return;
	    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
	    if (params.centeredSlides) {
	      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
	        swiper.loopFix();
	        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
	        nextTick(() => {
	          swiper.slideTo(slideToIndex);
	        });
	      } else {
	        swiper.slideTo(slideToIndex);
	      }
	    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
	      swiper.loopFix();
	      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
	      nextTick(() => {
	        swiper.slideTo(slideToIndex);
	      });
	    } else {
	      swiper.slideTo(slideToIndex);
	    }
	  } else {
	    swiper.slideTo(slideToIndex);
	  }
	}

	var slide = {
	  slideTo,
	  slideToLoop,
	  slideNext,
	  slidePrev,
	  slideReset,
	  slideToClosest,
	  slideToClickedSlide
	};

	function loopCreate() {
	  const swiper = this;
	  const document = getDocument();
	  const {
	    params,
	    $wrapperEl
	  } = swiper; // Remove duplicated slides

	  const $selector = $wrapperEl.children().length > 0 ? $($wrapperEl.children()[0].parentNode) : $wrapperEl;
	  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
	  let slides = $selector.children(`.${params.slideClass}`);
	  if (params.loopFillGroupWithBlank) {
	    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
	    if (blankSlidesNum !== params.slidesPerGroup) {
	      for (let i = 0; i < blankSlidesNum; i += 1) {
	        const blankNode = $(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
	        $selector.append(blankNode);
	      }
	      slides = $selector.children(`.${params.slideClass}`);
	    }
	  }
	  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
	  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
	  swiper.loopedSlides += params.loopAdditionalSlides;
	  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
	    swiper.loopedSlides = slides.length;
	  }
	  const prependSlides = [];
	  const appendSlides = [];
	  slides.each((el, index) => {
	    const slide = $(el);
	    slide.attr('data-swiper-slide-index', index);
	  });
	  for (let i = 0; i < swiper.loopedSlides; i += 1) {
	    const index = i - Math.floor(i / slides.length) * slides.length;
	    appendSlides.push(slides.eq(index)[0]);
	    prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
	  }
	  for (let i = 0; i < appendSlides.length; i += 1) {
	    $selector.append($(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
	    $selector.prepend($(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
	  }
	}

	function loopFix() {
	  const swiper = this;
	  swiper.emit('beforeLoopFix');
	  const {
	    activeIndex,
	    slides,
	    loopedSlides,
	    allowSlidePrev,
	    allowSlideNext,
	    snapGrid,
	    rtlTranslate: rtl
	  } = swiper;
	  let newIndex;
	  swiper.allowSlidePrev = true;
	  swiper.allowSlideNext = true;
	  const snapTranslate = -snapGrid[activeIndex];
	  const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

	  if (activeIndex < loopedSlides) {
	    newIndex = slides.length - loopedSlides * 3 + activeIndex;
	    newIndex += loopedSlides;
	    const slideChanged = swiper.slideTo(newIndex, 0, false, true);
	    if (slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  } else if (activeIndex >= slides.length - loopedSlides) {
	    // Fix For Positive Oversliding
	    newIndex = -slides.length + activeIndex + loopedSlides;
	    newIndex += loopedSlides;
	    const slideChanged = swiper.slideTo(newIndex, 0, false, true);
	    if (slideChanged && diff !== 0) {
	      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
	    }
	  }
	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	  swiper.emit('loopFix');
	}

	function loopDestroy() {
	  const swiper = this;
	  const {
	    $wrapperEl,
	    params,
	    slides
	  } = swiper;
	  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
	  slides.removeAttr('data-swiper-slide-index');
	}

	var loop = {
	  loopCreate,
	  loopFix,
	  loopDestroy
	};

	function setGrabCursor(moving) {
	  const swiper = this;
	  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
	  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
	  el.style.cursor = 'move';
	  el.style.cursor = moving ? 'grabbing' : 'grab';
	}

	function unsetGrabCursor() {
	  const swiper = this;
	  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
	    return;
	  }
	  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
	}

	var grabCursor = {
	  setGrabCursor,
	  unsetGrabCursor
	};

	function closestElement(selector, base = this) {
	  function __closestFrom(el) {
	    if (!el || el === getDocument() || el === getWindow()) return null;
	    if (el.assignedSlot) el = el.assignedSlot;
	    const found = el.closest(selector);
	    if (!found && !el.getRootNode) {
	      return null;
	    }
	    return found || __closestFrom(el.getRootNode().host);
	  }
	  return __closestFrom(base);
	}
	function onTouchStart(event) {
	  const swiper = this;
	  const document = getDocument();
	  const window = getWindow();
	  const data = swiper.touchEventsData;
	  const {
	    params,
	    touches,
	    enabled
	  } = swiper;
	  if (!enabled) return;
	  if (swiper.animating && params.preventInteractionOnTransition) {
	    return;
	  }
	  if (!swiper.animating && params.cssMode && params.loop) {
	    swiper.loopFix();
	  }
	  let e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  let $targetEl = $(e.target);
	  if (params.touchEventsTarget === 'wrapper') {
	    if (!$targetEl.closest(swiper.wrapperEl).length) return;
	  }
	  data.isTouchEvent = e.type === 'touchstart';
	  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
	  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
	  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

	  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line

	  const eventPath = event.composedPath ? event.composedPath() : event.path;
	  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
	    $targetEl = $(eventPath[0]);
	  }
	  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
	  const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

	  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
	    swiper.allowClick = true;
	    return;
	  }
	  if (params.swipeHandler) {
	    if (!$targetEl.closest(params.swipeHandler)[0]) return;
	  }
	  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	  const startX = touches.currentX;
	  const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

	  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
	  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
	  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
	    if (edgeSwipeDetection === 'prevent') {
	      event.preventDefault();
	    } else {
	      return;
	    }
	  }
	  Object.assign(data, {
	    isTouched: true,
	    isMoved: false,
	    allowTouchCallbacks: true,
	    isScrolling: undefined,
	    startMoving: undefined
	  });
	  touches.startX = startX;
	  touches.startY = startY;
	  data.touchStartTime = now();
	  swiper.allowClick = true;
	  swiper.updateSize();
	  swiper.swipeDirection = undefined;
	  if (params.threshold > 0) data.allowThresholdMove = false;
	  if (e.type !== 'touchstart') {
	    let preventDefault = true;
	    if ($targetEl.is(data.focusableElements)) {
	      preventDefault = false;
	      if ($targetEl[0].nodeName === 'SELECT') {
	        data.isTouched = false;
	      }
	    }
	    if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
	      document.activeElement.blur();
	    }
	    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
	    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
	      e.preventDefault();
	    }
	  }
	  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
	    swiper.freeMode.onTouchStart();
	  }
	  swiper.emit('touchStart', e);
	}

	function onTouchMove(event) {
	  const document = getDocument();
	  const swiper = this;
	  const data = swiper.touchEventsData;
	  const {
	    params,
	    touches,
	    rtlTranslate: rtl,
	    enabled
	  } = swiper;
	  if (!enabled) return;
	  let e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  if (!data.isTouched) {
	    if (data.startMoving && data.isScrolling) {
	      swiper.emit('touchMoveOpposite', e);
	    }
	    return;
	  }
	  if (data.isTouchEvent && e.type !== 'touchmove') return;
	  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
	  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
	  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
	  if (e.preventedByNestedSwiper) {
	    touches.startX = pageX;
	    touches.startY = pageY;
	    return;
	  }
	  if (!swiper.allowTouchMove) {
	    if (!$(e.target).is(data.focusableElements)) {
	      swiper.allowClick = false;
	    }
	    if (data.isTouched) {
	      Object.assign(touches, {
	        startX: pageX,
	        startY: pageY,
	        currentX: pageX,
	        currentY: pageY
	      });
	      data.touchStartTime = now();
	    }
	    return;
	  }
	  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
	    if (swiper.isVertical()) {
	      // Vertical
	      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
	        data.isTouched = false;
	        data.isMoved = false;
	        return;
	      }
	    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
	      return;
	    }
	  }
	  if (data.isTouchEvent && document.activeElement) {
	    if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
	      data.isMoved = true;
	      swiper.allowClick = false;
	      return;
	    }
	  }
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchMove', e);
	  }
	  if (e.targetTouches && e.targetTouches.length > 1) return;
	  touches.currentX = pageX;
	  touches.currentY = pageY;
	  const diffX = touches.currentX - touches.startX;
	  const diffY = touches.currentY - touches.startY;
	  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
	  if (typeof data.isScrolling === 'undefined') {
	    let touchAngle;
	    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
	      data.isScrolling = false;
	    } else {
	      // eslint-disable-next-line
	      if (diffX * diffX + diffY * diffY >= 25) {
	        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
	        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
	      }
	    }
	  }
	  if (data.isScrolling) {
	    swiper.emit('touchMoveOpposite', e);
	  }
	  if (typeof data.startMoving === 'undefined') {
	    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
	      data.startMoving = true;
	    }
	  }
	  if (data.isScrolling) {
	    data.isTouched = false;
	    return;
	  }
	  if (!data.startMoving) {
	    return;
	  }
	  swiper.allowClick = false;
	  if (!params.cssMode && e.cancelable) {
	    e.preventDefault();
	  }
	  if (params.touchMoveStopPropagation && !params.nested) {
	    e.stopPropagation();
	  }
	  if (!data.isMoved) {
	    if (params.loop && !params.cssMode) {
	      swiper.loopFix();
	    }
	    data.startTranslate = swiper.getTranslate();
	    swiper.setTransition(0);
	    if (swiper.animating) {
	      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
	    }
	    data.allowMomentumBounce = false; // Grab Cursor

	    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	      swiper.setGrabCursor(true);
	    }
	    swiper.emit('sliderFirstMove', e);
	  }
	  swiper.emit('sliderMove', e);
	  data.isMoved = true;
	  let diff = swiper.isHorizontal() ? diffX : diffY;
	  touches.diff = diff;
	  diff *= params.touchRatio;
	  if (rtl) diff = -diff;
	  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
	  data.currentTranslate = diff + data.startTranslate;
	  let disableParentSwiper = true;
	  let resistanceRatio = params.resistanceRatio;
	  if (params.touchReleaseOnEdges) {
	    resistanceRatio = 0;
	  }
	  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
	  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
	    disableParentSwiper = false;
	    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
	  }
	  if (disableParentSwiper) {
	    e.preventedByNestedSwiper = true;
	  } // Directions locks

	  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
	    data.currentTranslate = data.startTranslate;
	  }
	  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
	    data.currentTranslate = data.startTranslate;
	  } // Threshold

	  if (params.threshold > 0) {
	    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
	      if (!data.allowThresholdMove) {
	        data.allowThresholdMove = true;
	        touches.startX = touches.currentX;
	        touches.startY = touches.currentY;
	        data.currentTranslate = data.startTranslate;
	        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
	        return;
	      }
	    } else {
	      data.currentTranslate = data.startTranslate;
	      return;
	    }
	  }
	  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

	  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }
	  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
	    swiper.freeMode.onTouchMove();
	  } // Update progress

	  swiper.updateProgress(data.currentTranslate); // Update translate

	  swiper.setTranslate(data.currentTranslate);
	}

	function onTouchEnd(event) {
	  const swiper = this;
	  const data = swiper.touchEventsData;
	  const {
	    params,
	    touches,
	    rtlTranslate: rtl,
	    slidesGrid,
	    enabled
	  } = swiper;
	  if (!enabled) return;
	  let e = event;
	  if (e.originalEvent) e = e.originalEvent;
	  if (data.allowTouchCallbacks) {
	    swiper.emit('touchEnd', e);
	  }
	  data.allowTouchCallbacks = false;
	  if (!data.isTouched) {
	    if (data.isMoved && params.grabCursor) {
	      swiper.setGrabCursor(false);
	    }
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  } // Return Grab Cursor

	  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
	    swiper.setGrabCursor(false);
	  } // Time diff

	  const touchEndTime = now();
	  const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

	  if (swiper.allowClick) {
	    const pathTree = e.path || e.composedPath && e.composedPath();
	    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
	    swiper.emit('tap click', e);
	    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
	      swiper.emit('doubleTap doubleClick', e);
	    }
	  }
	  data.lastClickTime = now();
	  nextTick(() => {
	    if (!swiper.destroyed) swiper.allowClick = true;
	  });
	  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
	    data.isTouched = false;
	    data.isMoved = false;
	    data.startMoving = false;
	    return;
	  }
	  data.isTouched = false;
	  data.isMoved = false;
	  data.startMoving = false;
	  let currentPos;
	  if (params.followFinger) {
	    currentPos = rtl ? swiper.translate : -swiper.translate;
	  } else {
	    currentPos = -data.currentTranslate;
	  }
	  if (params.cssMode) {
	    return;
	  }
	  if (swiper.params.freeMode && params.freeMode.enabled) {
	    swiper.freeMode.onTouchEnd({
	      currentPos
	    });
	    return;
	  } // Find current slide

	  let stopIndex = 0;
	  let groupSize = swiper.slidesSizesGrid[0];
	  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
	    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
	    if (typeof slidesGrid[i + increment] !== 'undefined') {
	      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
	        stopIndex = i;
	        groupSize = slidesGrid[i + increment] - slidesGrid[i];
	      }
	    } else if (currentPos >= slidesGrid[i]) {
	      stopIndex = i;
	      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
	    }
	  }
	  let rewindFirstIndex = null;
	  let rewindLastIndex = null;
	  if (params.rewind) {
	    if (swiper.isBeginning) {
	      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
	    } else if (swiper.isEnd) {
	      rewindFirstIndex = 0;
	    }
	  } // Find current slide size

	  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
	  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
	  if (timeDiff > params.longSwipesMs) {
	    // Long touches
	    if (!params.longSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    if (swiper.swipeDirection === 'next') {
	      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
	    }
	    if (swiper.swipeDirection === 'prev') {
	      if (ratio > 1 - params.longSwipesRatio) {
	        swiper.slideTo(stopIndex + increment);
	      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
	        swiper.slideTo(rewindLastIndex);
	      } else {
	        swiper.slideTo(stopIndex);
	      }
	    }
	  } else {
	    // Short swipes
	    if (!params.shortSwipes) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
	    if (!isNavButtonTarget) {
	      if (swiper.swipeDirection === 'next') {
	        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
	      }
	      if (swiper.swipeDirection === 'prev') {
	        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
	      }
	    } else if (e.target === swiper.navigation.nextEl) {
	      swiper.slideTo(stopIndex + increment);
	    } else {
	      swiper.slideTo(stopIndex);
	    }
	  }
	}

	function onResize() {
	  const swiper = this;
	  const {
	    params,
	    el
	  } = swiper;
	  if (el && el.offsetWidth === 0) return; // Breakpoints

	  if (params.breakpoints) {
	    swiper.setBreakpoint();
	  } // Save locks

	  const {
	    allowSlideNext,
	    allowSlidePrev,
	    snapGrid
	  } = swiper; // Disable locks on resize

	  swiper.allowSlideNext = true;
	  swiper.allowSlidePrev = true;
	  swiper.updateSize();
	  swiper.updateSlides();
	  swiper.updateSlidesClasses();
	  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
	    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	  } else {
	    swiper.slideTo(swiper.activeIndex, 0, false, true);
	  }
	  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
	    swiper.autoplay.run();
	  } // Return locks after resize

	  swiper.allowSlidePrev = allowSlidePrev;
	  swiper.allowSlideNext = allowSlideNext;
	  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
	    swiper.checkOverflow();
	  }
	}

	function onClick(e) {
	  const swiper = this;
	  if (!swiper.enabled) return;
	  if (!swiper.allowClick) {
	    if (swiper.params.preventClicks) e.preventDefault();
	    if (swiper.params.preventClicksPropagation && swiper.animating) {
	      e.stopPropagation();
	      e.stopImmediatePropagation();
	    }
	  }
	}

	function onScroll() {
	  const swiper = this;
	  const {
	    wrapperEl,
	    rtlTranslate,
	    enabled
	  } = swiper;
	  if (!enabled) return;
	  swiper.previousTranslate = swiper.translate;
	  if (swiper.isHorizontal()) {
	    swiper.translate = -wrapperEl.scrollLeft;
	  } else {
	    swiper.translate = -wrapperEl.scrollTop;
	  } // eslint-disable-next-line

	  if (swiper.translate === 0) swiper.translate = 0;
	  swiper.updateActiveIndex();
	  swiper.updateSlidesClasses();
	  let newProgress;
	  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
	  if (translatesDiff === 0) {
	    newProgress = 0;
	  } else {
	    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
	  }
	  if (newProgress !== swiper.progress) {
	    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
	  }
	  swiper.emit('setTranslate', swiper.translate, false);
	}

	let dummyEventAttached = false;
	function dummyEventListener() {}
	const events = (swiper, method) => {
	  const document = getDocument();
	  const {
	    params,
	    touchEvents,
	    el,
	    wrapperEl,
	    device,
	    support
	  } = swiper;
	  const capture = !!params.nested;
	  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
	  const swiperMethod = method; // Touch Events

	  if (!support.touch) {
	    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
	    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
	    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
	  } else {
	    const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
	      passive: true,
	      capture: false
	    } : false;
	    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
	    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
	      passive: false,
	      capture
	    } : capture);
	    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
	    if (touchEvents.cancel) {
	      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
	    }
	  } // Prevent Links Clicks

	  if (params.preventClicks || params.preventClicksPropagation) {
	    el[domMethod]('click', swiper.onClick, true);
	  }
	  if (params.cssMode) {
	    wrapperEl[domMethod]('scroll', swiper.onScroll);
	  } // Resize handler

	  if (params.updateOnWindowResize) {
	    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
	  } else {
	    swiper[swiperMethod]('observerUpdate', onResize, true);
	  }
	};
	function attachEvents() {
	  const swiper = this;
	  const document = getDocument();
	  const {
	    params,
	    support
	  } = swiper;
	  swiper.onTouchStart = onTouchStart.bind(swiper);
	  swiper.onTouchMove = onTouchMove.bind(swiper);
	  swiper.onTouchEnd = onTouchEnd.bind(swiper);
	  if (params.cssMode) {
	    swiper.onScroll = onScroll.bind(swiper);
	  }
	  swiper.onClick = onClick.bind(swiper);
	  if (support.touch && !dummyEventAttached) {
	    document.addEventListener('touchstart', dummyEventListener);
	    dummyEventAttached = true;
	  }
	  events(swiper, 'on');
	}
	function detachEvents() {
	  const swiper = this;
	  events(swiper, 'off');
	}
	var events$1 = {
	  attachEvents,
	  detachEvents
	};

	const isGridEnabled = (swiper, params) => {
	  return swiper.grid && params.grid && params.grid.rows > 1;
	};
	function setBreakpoint() {
	  const swiper = this;
	  const {
	    activeIndex,
	    initialized,
	    loopedSlides = 0,
	    params,
	    $el
	  } = swiper;
	  const breakpoints = params.breakpoints;
	  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

	  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
	  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
	  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
	  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
	  const wasMultiRow = isGridEnabled(swiper, params);
	  const isMultiRow = isGridEnabled(swiper, breakpointParams);
	  const wasEnabled = params.enabled;
	  if (wasMultiRow && !isMultiRow) {
	    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
	    swiper.emitContainerClasses();
	  } else if (!wasMultiRow && isMultiRow) {
	    $el.addClass(`${params.containerModifierClass}grid`);
	    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
	      $el.addClass(`${params.containerModifierClass}grid-column`);
	    }
	    swiper.emitContainerClasses();
	  } // Toggle navigation, pagination, scrollbar

	  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
	    const wasModuleEnabled = params[prop] && params[prop].enabled;
	    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
	    if (wasModuleEnabled && !isModuleEnabled) {
	      swiper[prop].disable();
	    }
	    if (!wasModuleEnabled && isModuleEnabled) {
	      swiper[prop].enable();
	    }
	  });
	  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
	  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
	  if (directionChanged && initialized) {
	    swiper.changeDirection();
	  }
	  extend(swiper.params, breakpointParams);
	  const isEnabled = swiper.params.enabled;
	  Object.assign(swiper, {
	    allowTouchMove: swiper.params.allowTouchMove,
	    allowSlideNext: swiper.params.allowSlideNext,
	    allowSlidePrev: swiper.params.allowSlidePrev
	  });
	  if (wasEnabled && !isEnabled) {
	    swiper.disable();
	  } else if (!wasEnabled && isEnabled) {
	    swiper.enable();
	  }
	  swiper.currentBreakpoint = breakpoint;
	  swiper.emit('_beforeBreakpoint', breakpointParams);
	  if (needsReLoop && initialized) {
	    swiper.loopDestroy();
	    swiper.loopCreate();
	    swiper.updateSlides();
	    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
	  }
	  swiper.emit('breakpoint', breakpointParams);
	}

	function getBreakpoint(breakpoints, base = 'window', containerEl) {
	  if (!breakpoints || base === 'container' && !containerEl) return undefined;
	  let breakpoint = false;
	  const window = getWindow();
	  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
	  const points = Object.keys(breakpoints).map(point => {
	    if (typeof point === 'string' && point.indexOf('@') === 0) {
	      const minRatio = parseFloat(point.substr(1));
	      const value = currentHeight * minRatio;
	      return {
	        value,
	        point
	      };
	    }
	    return {
	      value: point,
	      point
	    };
	  });
	  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
	  for (let i = 0; i < points.length; i += 1) {
	    const {
	      point,
	      value
	    } = points[i];
	    if (base === 'window') {
	      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
	        breakpoint = point;
	      }
	    } else if (value <= containerEl.clientWidth) {
	      breakpoint = point;
	    }
	  }
	  return breakpoint || 'max';
	}

	var breakpoints = {
	  setBreakpoint,
	  getBreakpoint
	};

	function prepareClasses(entries, prefix) {
	  const resultClasses = [];
	  entries.forEach(item => {
	    if (typeof item === 'object') {
	      Object.keys(item).forEach(classNames => {
	        if (item[classNames]) {
	          resultClasses.push(prefix + classNames);
	        }
	      });
	    } else if (typeof item === 'string') {
	      resultClasses.push(prefix + item);
	    }
	  });
	  return resultClasses;
	}
	function addClasses() {
	  const swiper = this;
	  const {
	    classNames,
	    params,
	    rtl,
	    $el,
	    device,
	    support
	  } = swiper; // prettier-ignore

	  const suffixes = prepareClasses(['initialized', params.direction, {
	    'pointer-events': !support.touch
	  }, {
	    'free-mode': swiper.params.freeMode && params.freeMode.enabled
	  }, {
	    'autoheight': params.autoHeight
	  }, {
	    'rtl': rtl
	  }, {
	    'grid': params.grid && params.grid.rows > 1
	  }, {
	    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
	  }, {
	    'android': device.android
	  }, {
	    'ios': device.ios
	  }, {
	    'css-mode': params.cssMode
	  }, {
	    'centered': params.cssMode && params.centeredSlides
	  }, {
	    'watch-progress': params.watchSlidesProgress
	  }], params.containerModifierClass);
	  classNames.push(...suffixes);
	  $el.addClass([...classNames].join(' '));
	  swiper.emitContainerClasses();
	}

	function removeClasses() {
	  const swiper = this;
	  const {
	    $el,
	    classNames
	  } = swiper;
	  $el.removeClass(classNames.join(' '));
	  swiper.emitContainerClasses();
	}

	var classes$1 = {
	  addClasses,
	  removeClasses
	};

	function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
	  const window = getWindow();
	  let image;
	  function onReady() {
	    if (callback) callback();
	  }
	  const isPicture = $(imageEl).parent('picture')[0];
	  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
	    if (src) {
	      image = new window.Image();
	      image.onload = onReady;
	      image.onerror = onReady;
	      if (sizes) {
	        image.sizes = sizes;
	      }
	      if (srcset) {
	        image.srcset = srcset;
	      }
	      if (src) {
	        image.src = src;
	      }
	    } else {
	      onReady();
	    }
	  } else {
	    // image already loaded...
	    onReady();
	  }
	}

	function preloadImages() {
	  const swiper = this;
	  swiper.imagesToLoad = swiper.$el.find('img');
	  function onReady() {
	    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
	    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
	    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
	      if (swiper.params.updateOnImagesReady) swiper.update();
	      swiper.emit('imagesReady');
	    }
	  }
	  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
	    const imageEl = swiper.imagesToLoad[i];
	    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
	  }
	}

	var images = {
	  loadImage,
	  preloadImages
	};

	function checkOverflow() {
	  const swiper = this;
	  const {
	    isLocked: wasLocked,
	    params
	  } = swiper;
	  const {
	    slidesOffsetBefore
	  } = params;
	  if (slidesOffsetBefore) {
	    const lastSlideIndex = swiper.slides.length - 1;
	    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
	    swiper.isLocked = swiper.size > lastSlideRightEdge;
	  } else {
	    swiper.isLocked = swiper.snapGrid.length === 1;
	  }
	  if (params.allowSlideNext === true) {
	    swiper.allowSlideNext = !swiper.isLocked;
	  }
	  if (params.allowSlidePrev === true) {
	    swiper.allowSlidePrev = !swiper.isLocked;
	  }
	  if (wasLocked && wasLocked !== swiper.isLocked) {
	    swiper.isEnd = false;
	  }
	  if (wasLocked !== swiper.isLocked) {
	    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
	  }
	}
	var checkOverflow$1 = {
	  checkOverflow
	};

	var defaults = {
	  init: true,
	  direction: 'horizontal',
	  touchEventsTarget: 'wrapper',
	  initialSlide: 0,
	  speed: 300,
	  cssMode: false,
	  updateOnWindowResize: true,
	  resizeObserver: true,
	  nested: false,
	  createElements: false,
	  enabled: true,
	  focusableElements: 'input, select, option, textarea, button, video, label',
	  // Overrides
	  width: null,
	  height: null,
	  //
	  preventInteractionOnTransition: false,
	  // ssr
	  userAgent: null,
	  url: null,
	  // To support iOS's swipe-to-go-back gesture (when being used in-app).
	  edgeSwipeDetection: false,
	  edgeSwipeThreshold: 20,
	  // Autoheight
	  autoHeight: false,
	  // Set wrapper width
	  setWrapperSize: false,
	  // Virtual Translate
	  virtualTranslate: false,
	  // Effects
	  effect: 'slide',
	  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	  // Breakpoints
	  breakpoints: undefined,
	  breakpointsBase: 'window',
	  // Slides grid
	  spaceBetween: 0,
	  slidesPerView: 1,
	  slidesPerGroup: 1,
	  slidesPerGroupSkip: 0,
	  slidesPerGroupAuto: false,
	  centeredSlides: false,
	  centeredSlidesBounds: false,
	  slidesOffsetBefore: 0,
	  // in px
	  slidesOffsetAfter: 0,
	  // in px
	  normalizeSlideIndex: true,
	  centerInsufficientSlides: false,
	  // Disable swiper and hide navigation when container not overflow
	  watchOverflow: true,
	  // Round length
	  roundLengths: false,
	  // Touches
	  touchRatio: 1,
	  touchAngle: 45,
	  simulateTouch: true,
	  shortSwipes: true,
	  longSwipes: true,
	  longSwipesRatio: 0.5,
	  longSwipesMs: 300,
	  followFinger: true,
	  allowTouchMove: true,
	  threshold: 0,
	  touchMoveStopPropagation: false,
	  touchStartPreventDefault: true,
	  touchStartForcePreventDefault: false,
	  touchReleaseOnEdges: false,
	  // Unique Navigation Elements
	  uniqueNavElements: true,
	  // Resistance
	  resistance: true,
	  resistanceRatio: 0.85,
	  // Progress
	  watchSlidesProgress: false,
	  // Cursor
	  grabCursor: false,
	  // Clicks
	  preventClicks: true,
	  preventClicksPropagation: true,
	  slideToClickedSlide: false,
	  // Images
	  preloadImages: true,
	  updateOnImagesReady: true,
	  // loop
	  loop: false,
	  loopAdditionalSlides: 0,
	  loopedSlides: null,
	  loopedSlidesLimit: true,
	  loopFillGroupWithBlank: false,
	  loopPreventsSlide: true,
	  // rewind
	  rewind: false,
	  // Swiping/no swiping
	  allowSlidePrev: true,
	  allowSlideNext: true,
	  swipeHandler: null,
	  // '.swipe-handler',
	  noSwiping: true,
	  noSwipingClass: 'swiper-no-swiping',
	  noSwipingSelector: null,
	  // Passive Listeners
	  passiveListeners: true,
	  maxBackfaceHiddenSlides: 10,
	  // NS
	  containerModifierClass: 'swiper-',
	  // NEW
	  slideClass: 'swiper-slide',
	  slideBlankClass: 'swiper-slide-invisible-blank',
	  slideActiveClass: 'swiper-slide-active',
	  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	  slideVisibleClass: 'swiper-slide-visible',
	  slideDuplicateClass: 'swiper-slide-duplicate',
	  slideNextClass: 'swiper-slide-next',
	  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	  slidePrevClass: 'swiper-slide-prev',
	  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	  wrapperClass: 'swiper-wrapper',
	  // Callbacks
	  runCallbacksOnInit: true,
	  // Internals
	  _emitClasses: false
	};

	function moduleExtendParams(params, allModulesParams) {
	  return function extendParams(obj = {}) {
	    const moduleParamName = Object.keys(obj)[0];
	    const moduleParams = obj[moduleParamName];
	    if (typeof moduleParams !== 'object' || moduleParams === null) {
	      extend(allModulesParams, obj);
	      return;
	    }
	    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
	      params[moduleParamName] = {
	        auto: true
	      };
	    }
	    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
	      extend(allModulesParams, obj);
	      return;
	    }
	    if (params[moduleParamName] === true) {
	      params[moduleParamName] = {
	        enabled: true
	      };
	    }
	    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
	      params[moduleParamName].enabled = true;
	    }
	    if (!params[moduleParamName]) params[moduleParamName] = {
	      enabled: false
	    };
	    extend(allModulesParams, obj);
	  };
	}

	/* eslint no-param-reassign: "off" */
	const prototypes = {
	  eventsEmitter,
	  update,
	  translate,
	  transition,
	  slide,
	  loop,
	  grabCursor,
	  events: events$1,
	  breakpoints,
	  checkOverflow: checkOverflow$1,
	  classes: classes$1,
	  images
	};
	const extendedDefaults = {};
	class Swiper {
	  constructor(...args) {
	    let el;
	    let params;
	    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
	      params = args[0];
	    } else {
	      [el, params] = args;
	    }
	    if (!params) params = {};
	    params = extend({}, params);
	    if (el && !params.el) params.el = el;
	    if (params.el && $(params.el).length > 1) {
	      const swipers = [];
	      $(params.el).each(containerEl => {
	        const newParams = extend({}, params, {
	          el: containerEl
	        });
	        swipers.push(new Swiper(newParams));
	      }); // eslint-disable-next-line no-constructor-return

	      return swipers;
	    } // Swiper Instance

	    const swiper = this;
	    swiper.__swiper__ = true;
	    swiper.support = getSupport();
	    swiper.device = getDevice({
	      userAgent: params.userAgent
	    });
	    swiper.browser = getBrowser();
	    swiper.eventsListeners = {};
	    swiper.eventsAnyListeners = [];
	    swiper.modules = [...swiper.__modules__];
	    if (params.modules && Array.isArray(params.modules)) {
	      swiper.modules.push(...params.modules);
	    }
	    const allModulesParams = {};
	    swiper.modules.forEach(mod => {
	      mod({
	        swiper,
	        extendParams: moduleExtendParams(params, allModulesParams),
	        on: swiper.on.bind(swiper),
	        once: swiper.once.bind(swiper),
	        off: swiper.off.bind(swiper),
	        emit: swiper.emit.bind(swiper)
	      });
	    }); // Extend defaults with modules params

	    const swiperParams = extend({}, defaults, allModulesParams); // Extend defaults with passed params

	    swiper.params = extend({}, swiperParams, extendedDefaults, params);
	    swiper.originalParams = extend({}, swiper.params);
	    swiper.passedParams = extend({}, params); // add event listeners

	    if (swiper.params && swiper.params.on) {
	      Object.keys(swiper.params.on).forEach(eventName => {
	        swiper.on(eventName, swiper.params.on[eventName]);
	      });
	    }
	    if (swiper.params && swiper.params.onAny) {
	      swiper.onAny(swiper.params.onAny);
	    } // Save Dom lib

	    swiper.$ = $; // Extend Swiper

	    Object.assign(swiper, {
	      enabled: swiper.params.enabled,
	      el,
	      // Classes
	      classNames: [],
	      // Slides
	      slides: $(),
	      slidesGrid: [],
	      snapGrid: [],
	      slidesSizesGrid: [],
	      // isDirection
	      isHorizontal() {
	        return swiper.params.direction === 'horizontal';
	      },
	      isVertical() {
	        return swiper.params.direction === 'vertical';
	      },
	      // Indexes
	      activeIndex: 0,
	      realIndex: 0,
	      //
	      isBeginning: true,
	      isEnd: false,
	      // Props
	      translate: 0,
	      previousTranslate: 0,
	      progress: 0,
	      velocity: 0,
	      animating: false,
	      // Locks
	      allowSlideNext: swiper.params.allowSlideNext,
	      allowSlidePrev: swiper.params.allowSlidePrev,
	      // Touch Events
	      touchEvents: function touchEvents() {
	        const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
	        const desktop = ['pointerdown', 'pointermove', 'pointerup'];
	        swiper.touchEventsTouch = {
	          start: touch[0],
	          move: touch[1],
	          end: touch[2],
	          cancel: touch[3]
	        };
	        swiper.touchEventsDesktop = {
	          start: desktop[0],
	          move: desktop[1],
	          end: desktop[2]
	        };
	        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
	      }(),
	      touchEventsData: {
	        isTouched: undefined,
	        isMoved: undefined,
	        allowTouchCallbacks: undefined,
	        touchStartTime: undefined,
	        isScrolling: undefined,
	        currentTranslate: undefined,
	        startTranslate: undefined,
	        allowThresholdMove: undefined,
	        // Form elements to match
	        focusableElements: swiper.params.focusableElements,
	        // Last click time
	        lastClickTime: now(),
	        clickTimeout: undefined,
	        // Velocities
	        velocities: [],
	        allowMomentumBounce: undefined,
	        isTouchEvent: undefined,
	        startMoving: undefined
	      },
	      // Clicks
	      allowClick: true,
	      // Touches
	      allowTouchMove: swiper.params.allowTouchMove,
	      touches: {
	        startX: 0,
	        startY: 0,
	        currentX: 0,
	        currentY: 0,
	        diff: 0
	      },
	      // Images
	      imagesToLoad: [],
	      imagesLoaded: 0
	    });
	    swiper.emit('_swiper'); // Init

	    if (swiper.params.init) {
	      swiper.init();
	    } // Return app instance
	    // eslint-disable-next-line no-constructor-return

	    return swiper;
	  }
	  enable() {
	    const swiper = this;
	    if (swiper.enabled) return;
	    swiper.enabled = true;
	    if (swiper.params.grabCursor) {
	      swiper.setGrabCursor();
	    }
	    swiper.emit('enable');
	  }
	  disable() {
	    const swiper = this;
	    if (!swiper.enabled) return;
	    swiper.enabled = false;
	    if (swiper.params.grabCursor) {
	      swiper.unsetGrabCursor();
	    }
	    swiper.emit('disable');
	  }
	  setProgress(progress, speed) {
	    const swiper = this;
	    progress = Math.min(Math.max(progress, 0), 1);
	    const min = swiper.minTranslate();
	    const max = swiper.maxTranslate();
	    const current = (max - min) * progress + min;
	    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	  }
	  emitContainerClasses() {
	    const swiper = this;
	    if (!swiper.params._emitClasses || !swiper.el) return;
	    const cls = swiper.el.className.split(' ').filter(className => {
	      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
	    });
	    swiper.emit('_containerClasses', cls.join(' '));
	  }
	  getSlideClasses(slideEl) {
	    const swiper = this;
	    if (swiper.destroyed) return '';
	    return slideEl.className.split(' ').filter(className => {
	      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
	    }).join(' ');
	  }
	  emitSlidesClasses() {
	    const swiper = this;
	    if (!swiper.params._emitClasses || !swiper.el) return;
	    const updates = [];
	    swiper.slides.each(slideEl => {
	      const classNames = swiper.getSlideClasses(slideEl);
	      updates.push({
	        slideEl,
	        classNames
	      });
	      swiper.emit('_slideClass', slideEl, classNames);
	    });
	    swiper.emit('_slideClasses', updates);
	  }
	  slidesPerViewDynamic(view = 'current', exact = false) {
	    const swiper = this;
	    const {
	      params,
	      slides,
	      slidesGrid,
	      slidesSizesGrid,
	      size: swiperSize,
	      activeIndex
	    } = swiper;
	    let spv = 1;
	    if (params.centeredSlides) {
	      let slideSize = slides[activeIndex].swiperSlideSize;
	      let breakLoop;
	      for (let i = activeIndex + 1; i < slides.length; i += 1) {
	        if (slides[i] && !breakLoop) {
	          slideSize += slides[i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) breakLoop = true;
	        }
	      }
	      for (let i = activeIndex - 1; i >= 0; i -= 1) {
	        if (slides[i] && !breakLoop) {
	          slideSize += slides[i].swiperSlideSize;
	          spv += 1;
	          if (slideSize > swiperSize) breakLoop = true;
	        }
	      }
	    } else {
	      // eslint-disable-next-line
	      if (view === 'current') {
	        for (let i = activeIndex + 1; i < slides.length; i += 1) {
	          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
	          if (slideInView) {
	            spv += 1;
	          }
	        }
	      } else {
	        // previous
	        for (let i = activeIndex - 1; i >= 0; i -= 1) {
	          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
	          if (slideInView) {
	            spv += 1;
	          }
	        }
	      }
	    }
	    return spv;
	  }
	  update() {
	    const swiper = this;
	    if (!swiper || swiper.destroyed) return;
	    const {
	      snapGrid,
	      params
	    } = swiper; // Breakpoints

	    if (params.breakpoints) {
	      swiper.setBreakpoint();
	    }
	    swiper.updateSize();
	    swiper.updateSlides();
	    swiper.updateProgress();
	    swiper.updateSlidesClasses();
	    function setTranslate() {
	      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
	      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
	      swiper.setTranslate(newTranslate);
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	    let translated;
	    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
	      setTranslate();
	      if (swiper.params.autoHeight) {
	        swiper.updateAutoHeight();
	      }
	    } else {
	      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
	        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
	      } else {
	        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
	      }
	      if (!translated) {
	        setTranslate();
	      }
	    }
	    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
	      swiper.checkOverflow();
	    }
	    swiper.emit('update');
	  }
	  changeDirection(newDirection, needUpdate = true) {
	    const swiper = this;
	    const currentDirection = swiper.params.direction;
	    if (!newDirection) {
	      // eslint-disable-next-line
	      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
	    }
	    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
	      return swiper;
	    }
	    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
	    swiper.emitContainerClasses();
	    swiper.params.direction = newDirection;
	    swiper.slides.each(slideEl => {
	      if (newDirection === 'vertical') {
	        slideEl.style.width = '';
	      } else {
	        slideEl.style.height = '';
	      }
	    });
	    swiper.emit('changeDirection');
	    if (needUpdate) swiper.update();
	    return swiper;
	  }
	  changeLanguageDirection(direction) {
	    const swiper = this;
	    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
	    swiper.rtl = direction === 'rtl';
	    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
	    if (swiper.rtl) {
	      swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
	      swiper.el.dir = 'rtl';
	    } else {
	      swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
	      swiper.el.dir = 'ltr';
	    }
	    swiper.update();
	  }
	  mount(el) {
	    const swiper = this;
	    if (swiper.mounted) return true; // Find el

	    const $el = $(el || swiper.params.el);
	    el = $el[0];
	    if (!el) {
	      return false;
	    }
	    el.swiper = swiper;
	    const getWrapperSelector = () => {
	      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
	    };
	    const getWrapper = () => {
	      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
	        const res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

	        res.children = options => $el.children(options);
	        return res;
	      }
	      if (!$el.children) {
	        return $($el).children(getWrapperSelector());
	      }
	      return $el.children(getWrapperSelector());
	    }; // Find Wrapper

	    let $wrapperEl = getWrapper();
	    if ($wrapperEl.length === 0 && swiper.params.createElements) {
	      const document = getDocument();
	      const wrapper = document.createElement('div');
	      $wrapperEl = $(wrapper);
	      wrapper.className = swiper.params.wrapperClass;
	      $el.append(wrapper);
	      $el.children(`.${swiper.params.slideClass}`).each(slideEl => {
	        $wrapperEl.append(slideEl);
	      });
	    }
	    Object.assign(swiper, {
	      $el,
	      el,
	      $wrapperEl,
	      wrapperEl: $wrapperEl[0],
	      mounted: true,
	      // RTL
	      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
	      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
	      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
	    });
	    return true;
	  }
	  init(el) {
	    const swiper = this;
	    if (swiper.initialized) return swiper;
	    const mounted = swiper.mount(el);
	    if (mounted === false) return swiper;
	    swiper.emit('beforeInit'); // Set breakpoint

	    if (swiper.params.breakpoints) {
	      swiper.setBreakpoint();
	    } // Add Classes

	    swiper.addClasses(); // Create loop

	    if (swiper.params.loop) {
	      swiper.loopCreate();
	    } // Update size

	    swiper.updateSize(); // Update slides

	    swiper.updateSlides();
	    if (swiper.params.watchOverflow) {
	      swiper.checkOverflow();
	    } // Set Grab Cursor

	    if (swiper.params.grabCursor && swiper.enabled) {
	      swiper.setGrabCursor();
	    }
	    if (swiper.params.preloadImages) {
	      swiper.preloadImages();
	    } // Slide To Initial Slide

	    if (swiper.params.loop) {
	      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
	    } else {
	      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
	    } // Attach events

	    swiper.attachEvents(); // Init Flag

	    swiper.initialized = true; // Emit

	    swiper.emit('init');
	    swiper.emit('afterInit');
	    return swiper;
	  }
	  destroy(deleteInstance = true, cleanStyles = true) {
	    const swiper = this;
	    const {
	      params,
	      $el,
	      $wrapperEl,
	      slides
	    } = swiper;
	    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
	      return null;
	    }
	    swiper.emit('beforeDestroy'); // Init Flag

	    swiper.initialized = false; // Detach events

	    swiper.detachEvents(); // Destroy loop

	    if (params.loop) {
	      swiper.loopDestroy();
	    } // Cleanup styles

	    if (cleanStyles) {
	      swiper.removeClasses();
	      $el.removeAttr('style');
	      $wrapperEl.removeAttr('style');
	      if (slides && slides.length) {
	        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
	      }
	    }
	    swiper.emit('destroy'); // Detach emitter events

	    Object.keys(swiper.eventsListeners).forEach(eventName => {
	      swiper.off(eventName);
	    });
	    if (deleteInstance !== false) {
	      swiper.$el[0].swiper = null;
	      deleteProps(swiper);
	    }
	    swiper.destroyed = true;
	    return null;
	  }
	  static extendDefaults(newDefaults) {
	    extend(extendedDefaults, newDefaults);
	  }
	  static get extendedDefaults() {
	    return extendedDefaults;
	  }
	  static get defaults() {
	    return defaults;
	  }
	  static installModule(mod) {
	    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
	    const modules = Swiper.prototype.__modules__;
	    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
	      modules.push(mod);
	    }
	  }
	  static use(module) {
	    if (Array.isArray(module)) {
	      module.forEach(m => Swiper.installModule(m));
	      return Swiper;
	    }
	    Swiper.installModule(module);
	    return Swiper;
	  }
	}
	Object.keys(prototypes).forEach(prototypeGroup => {
	  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
	    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
	  });
	});
	Swiper.use([Resize, Observer]);
	var Swiper$1 = Swiper;

	/* eslint-disable consistent-return */
	function Mousewheel({
	  swiper,
	  extendParams,
	  on,
	  emit
	}) {
	  const window = getWindow();
	  extendParams({
	    mousewheel: {
	      enabled: false,
	      releaseOnEdges: false,
	      invert: false,
	      forceToAxis: false,
	      sensitivity: 1,
	      eventsTarget: 'container',
	      thresholdDelta: null,
	      thresholdTime: null
	    }
	  });
	  swiper.mousewheel = {
	    enabled: false
	  };
	  let timeout;
	  let lastScrollTime = now();
	  let lastEventBeforeSnap;
	  const recentWheelEvents = [];
	  function normalize(e) {
	    // Reasonable defaults
	    const PIXEL_STEP = 10;
	    const LINE_HEIGHT = 40;
	    const PAGE_HEIGHT = 800;
	    let sX = 0;
	    let sY = 0; // spinX, spinY

	    let pX = 0;
	    let pY = 0; // pixelX, pixelY
	    // Legacy

	    if ('detail' in e) {
	      sY = e.detail;
	    }
	    if ('wheelDelta' in e) {
	      sY = -e.wheelDelta / 120;
	    }
	    if ('wheelDeltaY' in e) {
	      sY = -e.wheelDeltaY / 120;
	    }
	    if ('wheelDeltaX' in e) {
	      sX = -e.wheelDeltaX / 120;
	    } // side scrolling on FF with DOMMouseScroll

	    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
	      sX = sY;
	      sY = 0;
	    }
	    pX = sX * PIXEL_STEP;
	    pY = sY * PIXEL_STEP;
	    if ('deltaY' in e) {
	      pY = e.deltaY;
	    }
	    if ('deltaX' in e) {
	      pX = e.deltaX;
	    }
	    if (e.shiftKey && !pX) {
	      // if user scrolls with shift he wants horizontal scroll
	      pX = pY;
	      pY = 0;
	    }
	    if ((pX || pY) && e.deltaMode) {
	      if (e.deltaMode === 1) {
	        // delta in LINE units
	        pX *= LINE_HEIGHT;
	        pY *= LINE_HEIGHT;
	      } else {
	        // delta in PAGE units
	        pX *= PAGE_HEIGHT;
	        pY *= PAGE_HEIGHT;
	      }
	    } // Fall-back if spin cannot be determined

	    if (pX && !sX) {
	      sX = pX < 1 ? -1 : 1;
	    }
	    if (pY && !sY) {
	      sY = pY < 1 ? -1 : 1;
	    }
	    return {
	      spinX: sX,
	      spinY: sY,
	      pixelX: pX,
	      pixelY: pY
	    };
	  }
	  function handleMouseEnter() {
	    if (!swiper.enabled) return;
	    swiper.mouseEntered = true;
	  }
	  function handleMouseLeave() {
	    if (!swiper.enabled) return;
	    swiper.mouseEntered = false;
	  }
	  function animateSlider(newEvent) {
	    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
	      // Prevent if delta of wheel scroll delta is below configured threshold
	      return false;
	    }
	    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
	      // Prevent if time between scrolls is below configured threshold
	      return false;
	    } // If the movement is NOT big enough and
	    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
	    //   Don't go any further (avoid insignificant scroll movement).

	    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
	      // Return false as a default
	      return true;
	    } // If user is scrolling towards the end:
	    //   If the slider hasn't hit the latest slide or
	    //   if the slider is a loop and
	    //   if the slider isn't moving right now:
	    //     Go to next slide and
	    //     emit a scroll event.
	    // Else (the user is scrolling towards the beginning) and
	    // if the slider hasn't hit the first slide or
	    // if the slider is a loop and
	    // if the slider isn't moving right now:
	    //   Go to prev slide and
	    //   emit a scroll event.

	    if (newEvent.direction < 0) {
	      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
	        swiper.slideNext();
	        emit('scroll', newEvent.raw);
	      }
	    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
	      swiper.slidePrev();
	      emit('scroll', newEvent.raw);
	    } // If you got here is because an animation has been triggered so store the current time

	    lastScrollTime = new window.Date().getTime(); // Return false as a default

	    return false;
	  }
	  function releaseScroll(newEvent) {
	    const params = swiper.params.mousewheel;
	    if (newEvent.direction < 0) {
	      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
	        // Return true to animate scroll on edges
	        return true;
	      }
	    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
	      // Return true to animate scroll on edges
	      return true;
	    }
	    return false;
	  }
	  function handle(event) {
	    let e = event;
	    let disableParentSwiper = true;
	    if (!swiper.enabled) return;
	    const params = swiper.params.mousewheel;
	    if (swiper.params.cssMode) {
	      e.preventDefault();
	    }
	    let target = swiper.$el;
	    if (swiper.params.mousewheel.eventsTarget !== 'container') {
	      target = $(swiper.params.mousewheel.eventsTarget);
	    }
	    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
	    if (e.originalEvent) e = e.originalEvent; // jquery fix

	    let delta = 0;
	    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
	    const data = normalize(e);
	    if (params.forceToAxis) {
	      if (swiper.isHorizontal()) {
	        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
	      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
	    } else {
	      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
	    }
	    if (delta === 0) return true;
	    if (params.invert) delta = -delta; // Get the scroll positions

	    let positions = swiper.getTranslate() + delta * params.sensitivity;
	    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
	    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
	    //     the disableParentSwiper will be true.
	    // When loop is false:
	    //     if the scroll positions is not on edge,
	    //     then the disableParentSwiper will be true.
	    //     if the scroll on edge positions,
	    //     then the disableParentSwiper will be false.

	    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
	    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
	    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
	      // Register the new event in a variable which stores the relevant data
	      const newEvent = {
	        time: now(),
	        delta: Math.abs(delta),
	        direction: Math.sign(delta),
	        raw: event
	      }; // Keep the most recent events

	      if (recentWheelEvents.length >= 2) {
	        recentWheelEvents.shift(); // only store the last N events
	      }
	      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
	      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
	      //   If direction has changed or
	      //   if the scroll is quicker than the previous one:
	      //     Animate the slider.
	      // Else (this is the first time the wheel is moved):
	      //     Animate the slider.

	      if (prevEvent) {
	        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
	          animateSlider(newEvent);
	        }
	      } else {
	        animateSlider(newEvent);
	      } // If it's time to release the scroll:
	      //   Return now so you don't hit the preventDefault.

	      if (releaseScroll(newEvent)) {
	        return true;
	      }
	    } else {
	      // Freemode or scrollContainer:
	      // If we recently snapped after a momentum scroll, then ignore wheel events
	      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
	      // or if it's a new scroll (larger delta or inverse sign as last event before
	      // an end-of-momentum snap).
	      const newEvent = {
	        time: now(),
	        delta: Math.abs(delta),
	        direction: Math.sign(delta)
	      };
	      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
	      if (!ignoreWheelEvents) {
	        lastEventBeforeSnap = undefined;
	        if (swiper.params.loop) {
	          swiper.loopFix();
	        }
	        let position = swiper.getTranslate() + delta * params.sensitivity;
	        const wasBeginning = swiper.isBeginning;
	        const wasEnd = swiper.isEnd;
	        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
	        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
	        swiper.setTransition(0);
	        swiper.setTranslate(position);
	        swiper.updateProgress();
	        swiper.updateActiveIndex();
	        swiper.updateSlidesClasses();
	        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
	          swiper.updateSlidesClasses();
	        }
	        if (swiper.params.freeMode.sticky) {
	          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
	          // the end of a momentum scroll by storing recent (N=15?) wheel events.
	          // 1. do all N events have decreasing or same (absolute value) delta?
	          // 2. did all N events arrive in the last M (M=500?) msecs?
	          // 3. does the earliest event have an (absolute value) delta that's
	          //    at least P (P=1?) larger than the most recent event's delta?
	          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
	          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
	          // Snap immediately and ignore remaining wheel events in this scroll.
	          // See comment above for "remaining wheel events in this scroll" determination.
	          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
	          clearTimeout(timeout);
	          timeout = undefined;
	          if (recentWheelEvents.length >= 15) {
	            recentWheelEvents.shift(); // only store the last N events
	          }
	          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
	          const firstEvent = recentWheelEvents[0];
	          recentWheelEvents.push(newEvent);
	          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
	            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
	            recentWheelEvents.splice(0);
	          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
	            // We're at the end of the deceleration of a momentum scroll, so there's no need
	            // to wait for more events. Snap ASAP on the next tick.
	            // Also, because there's some remaining momentum we'll bias the snap in the
	            // direction of the ongoing scroll because it's better UX for the scroll to snap
	            // in the same direction as the scroll instead of reversing to snap.  Therefore,
	            // if it's already scrolled more than 20% in the current direction, keep going.
	            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
	            lastEventBeforeSnap = newEvent;
	            recentWheelEvents.splice(0);
	            timeout = nextTick(() => {
	              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
	            }, 0); // no delay; move on next tick
	          }
	          if (!timeout) {
	            // if we get here, then we haven't detected the end of a momentum scroll, so
	            // we'll consider a scroll "complete" when there haven't been any wheel events
	            // for 500ms.
	            timeout = nextTick(() => {
	              const snapToThreshold = 0.5;
	              lastEventBeforeSnap = newEvent;
	              recentWheelEvents.splice(0);
	              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
	            }, 500);
	          }
	        } // Emit event

	        if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay

	        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

	        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
	      }
	    }
	    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
	    return false;
	  }
	  function events(method) {
	    let target = swiper.$el;
	    if (swiper.params.mousewheel.eventsTarget !== 'container') {
	      target = $(swiper.params.mousewheel.eventsTarget);
	    }
	    target[method]('mouseenter', handleMouseEnter);
	    target[method]('mouseleave', handleMouseLeave);
	    target[method]('wheel', handle);
	  }
	  function enable() {
	    if (swiper.params.cssMode) {
	      swiper.wrapperEl.removeEventListener('wheel', handle);
	      return true;
	    }
	    if (swiper.mousewheel.enabled) return false;
	    events('on');
	    swiper.mousewheel.enabled = true;
	    return true;
	  }
	  function disable() {
	    if (swiper.params.cssMode) {
	      swiper.wrapperEl.addEventListener(event, handle);
	      return true;
	    }
	    if (!swiper.mousewheel.enabled) return false;
	    events('off');
	    swiper.mousewheel.enabled = false;
	    return true;
	  }
	  on('init', () => {
	    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
	      disable();
	    }
	    if (swiper.params.mousewheel.enabled) enable();
	  });
	  on('destroy', () => {
	    if (swiper.params.cssMode) {
	      enable();
	    }
	    if (swiper.mousewheel.enabled) disable();
	  });
	  Object.assign(swiper.mousewheel, {
	    enable,
	    disable
	  });
	}

	function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
	  const document = getDocument();
	  if (swiper.params.createElements) {
	    Object.keys(checkProps).forEach(key => {
	      if (!params[key] && params.auto === true) {
	        let element = swiper.$el.children(`.${checkProps[key]}`)[0];
	        if (!element) {
	          element = document.createElement('div');
	          element.className = checkProps[key];
	          swiper.$el.append(element);
	        }
	        params[key] = element;
	        originalParams[key] = element;
	      }
	    });
	  }
	  return params;
	}

	function Navigation({
	  swiper,
	  extendParams,
	  on,
	  emit
	}) {
	  extendParams({
	    navigation: {
	      nextEl: null,
	      prevEl: null,
	      hideOnClick: false,
	      disabledClass: 'swiper-button-disabled',
	      hiddenClass: 'swiper-button-hidden',
	      lockClass: 'swiper-button-lock',
	      navigationDisabledClass: 'swiper-navigation-disabled'
	    }
	  });
	  swiper.navigation = {
	    nextEl: null,
	    $nextEl: null,
	    prevEl: null,
	    $prevEl: null
	  };
	  function getEl(el) {
	    let $el;
	    if (el) {
	      $el = $(el);
	      if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) {
	        $el = swiper.$el.find(el);
	      }
	    }
	    return $el;
	  }
	  function toggleEl($el, disabled) {
	    const params = swiper.params.navigation;
	    if ($el && $el.length > 0) {
	      $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
	      if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
	      if (swiper.params.watchOverflow && swiper.enabled) {
	        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	      }
	    }
	  }
	  function update() {
	    // Update Navigation Buttons
	    if (swiper.params.loop) return;
	    const {
	      $nextEl,
	      $prevEl
	    } = swiper.navigation;
	    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
	    toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
	  }
	  function onPrevClick(e) {
	    e.preventDefault();
	    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
	    swiper.slidePrev();
	    emit('navigationPrev');
	  }
	  function onNextClick(e) {
	    e.preventDefault();
	    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
	    swiper.slideNext();
	    emit('navigationNext');
	  }
	  function init() {
	    const params = swiper.params.navigation;
	    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
	      nextEl: 'swiper-button-next',
	      prevEl: 'swiper-button-prev'
	    });
	    if (!(params.nextEl || params.prevEl)) return;
	    const $nextEl = getEl(params.nextEl);
	    const $prevEl = getEl(params.prevEl);
	    if ($nextEl && $nextEl.length > 0) {
	      $nextEl.on('click', onNextClick);
	    }
	    if ($prevEl && $prevEl.length > 0) {
	      $prevEl.on('click', onPrevClick);
	    }
	    Object.assign(swiper.navigation, {
	      $nextEl,
	      nextEl: $nextEl && $nextEl[0],
	      $prevEl,
	      prevEl: $prevEl && $prevEl[0]
	    });
	    if (!swiper.enabled) {
	      if ($nextEl) $nextEl.addClass(params.lockClass);
	      if ($prevEl) $prevEl.addClass(params.lockClass);
	    }
	  }
	  function destroy() {
	    const {
	      $nextEl,
	      $prevEl
	    } = swiper.navigation;
	    if ($nextEl && $nextEl.length) {
	      $nextEl.off('click', onNextClick);
	      $nextEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	    if ($prevEl && $prevEl.length) {
	      $prevEl.off('click', onPrevClick);
	      $prevEl.removeClass(swiper.params.navigation.disabledClass);
	    }
	  }
	  on('init', () => {
	    if (swiper.params.navigation.enabled === false) {
	      // eslint-disable-next-line
	      disable();
	    } else {
	      init();
	      update();
	    }
	  });
	  on('toEdge fromEdge lock unlock', () => {
	    update();
	  });
	  on('destroy', () => {
	    destroy();
	  });
	  on('enable disable', () => {
	    const {
	      $nextEl,
	      $prevEl
	    } = swiper.navigation;
	    if ($nextEl) {
	      $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
	    }
	    if ($prevEl) {
	      $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
	    }
	  });
	  on('click', (_s, e) => {
	    const {
	      $nextEl,
	      $prevEl
	    } = swiper.navigation;
	    const targetEl = e.target;
	    if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
	      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
	      let isHidden;
	      if ($nextEl) {
	        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
	      } else if ($prevEl) {
	        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
	      }
	      if (isHidden === true) {
	        emit('navigationShow');
	      } else {
	        emit('navigationHide');
	      }
	      if ($nextEl) {
	        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
	      }
	      if ($prevEl) {
	        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
	      }
	    }
	  });
	  const enable = () => {
	    swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
	    init();
	    update();
	  };
	  const disable = () => {
	    swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
	    destroy();
	  };
	  Object.assign(swiper.navigation, {
	    enable,
	    disable,
	    update,
	    init,
	    destroy
	  });
	}

	function classesToSelector(classes = '') {
	  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
	}

	function Pagination({
	  swiper,
	  extendParams,
	  on,
	  emit
	}) {
	  const pfx = 'swiper-pagination';
	  extendParams({
	    pagination: {
	      el: null,
	      bulletElement: 'span',
	      clickable: false,
	      hideOnClick: false,
	      renderBullet: null,
	      renderProgressbar: null,
	      renderFraction: null,
	      renderCustom: null,
	      progressbarOpposite: false,
	      type: 'bullets',
	      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
	      dynamicBullets: false,
	      dynamicMainBullets: 1,
	      formatFractionCurrent: number => number,
	      formatFractionTotal: number => number,
	      bulletClass: `${pfx}-bullet`,
	      bulletActiveClass: `${pfx}-bullet-active`,
	      modifierClass: `${pfx}-`,
	      currentClass: `${pfx}-current`,
	      totalClass: `${pfx}-total`,
	      hiddenClass: `${pfx}-hidden`,
	      progressbarFillClass: `${pfx}-progressbar-fill`,
	      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
	      clickableClass: `${pfx}-clickable`,
	      lockClass: `${pfx}-lock`,
	      horizontalClass: `${pfx}-horizontal`,
	      verticalClass: `${pfx}-vertical`,
	      paginationDisabledClass: `${pfx}-disabled`
	    }
	  });
	  swiper.pagination = {
	    el: null,
	    $el: null,
	    bullets: []
	  };
	  let bulletSize;
	  let dynamicBulletIndex = 0;
	  function isPaginationDisabled() {
	    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
	  }
	  function setSideBullets($bulletEl, position) {
	    const {
	      bulletActiveClass
	    } = swiper.params.pagination;
	    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
	  }
	  function update() {
	    // Render || Update Pagination bullets/items
	    const rtl = swiper.rtl;
	    const params = swiper.params.pagination;
	    if (isPaginationDisabled()) return;
	    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    const $el = swiper.pagination.$el; // Current/Total

	    let current;
	    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	    if (swiper.params.loop) {
	      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
	      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
	        current -= slidesLength - swiper.loopedSlides * 2;
	      }
	      if (current > total - 1) current -= total;
	      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
	    } else if (typeof swiper.snapIndex !== 'undefined') {
	      current = swiper.snapIndex;
	    } else {
	      current = swiper.activeIndex || 0;
	    } // Types

	    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
	      const bullets = swiper.pagination.bullets;
	      let firstIndex;
	      let lastIndex;
	      let midIndex;
	      if (params.dynamicBullets) {
	        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
	        $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);
	        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
	          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
	          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
	            dynamicBulletIndex = params.dynamicMainBullets - 1;
	          } else if (dynamicBulletIndex < 0) {
	            dynamicBulletIndex = 0;
	          }
	        }
	        firstIndex = Math.max(current - dynamicBulletIndex, 0);
	        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
	        midIndex = (lastIndex + firstIndex) / 2;
	      }
	      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`).join(' '));
	      if ($el.length > 1) {
	        bullets.each(bullet => {
	          const $bullet = $(bullet);
	          const bulletIndex = $bullet.index();
	          if (bulletIndex === current) {
	            $bullet.addClass(params.bulletActiveClass);
	          }
	          if (params.dynamicBullets) {
	            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
	              $bullet.addClass(`${params.bulletActiveClass}-main`);
	            }
	            if (bulletIndex === firstIndex) {
	              setSideBullets($bullet, 'prev');
	            }
	            if (bulletIndex === lastIndex) {
	              setSideBullets($bullet, 'next');
	            }
	          }
	        });
	      } else {
	        const $bullet = bullets.eq(current);
	        const bulletIndex = $bullet.index();
	        $bullet.addClass(params.bulletActiveClass);
	        if (params.dynamicBullets) {
	          const $firstDisplayedBullet = bullets.eq(firstIndex);
	          const $lastDisplayedBullet = bullets.eq(lastIndex);
	          for (let i = firstIndex; i <= lastIndex; i += 1) {
	            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
	          }
	          if (swiper.params.loop) {
	            if (bulletIndex >= bullets.length) {
	              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
	                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
	              }
	              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
	            } else {
	              setSideBullets($firstDisplayedBullet, 'prev');
	              setSideBullets($lastDisplayedBullet, 'next');
	            }
	          } else {
	            setSideBullets($firstDisplayedBullet, 'prev');
	            setSideBullets($lastDisplayedBullet, 'next');
	          }
	        }
	      }
	      if (params.dynamicBullets) {
	        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
	        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
	        const offsetProp = rtl ? 'right' : 'left';
	        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
	      }
	    }
	    if (params.type === 'fraction') {
	      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
	      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
	    }
	    if (params.type === 'progressbar') {
	      let progressbarDirection;
	      if (params.progressbarOpposite) {
	        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
	      } else {
	        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
	      }
	      const scale = (current + 1) / total;
	      let scaleX = 1;
	      let scaleY = 1;
	      if (progressbarDirection === 'horizontal') {
	        scaleX = scale;
	      } else {
	        scaleY = scale;
	      }
	      $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
	    }
	    if (params.type === 'custom' && params.renderCustom) {
	      $el.html(params.renderCustom(swiper, current + 1, total));
	      emit('paginationRender', $el[0]);
	    } else {
	      emit('paginationUpdate', $el[0]);
	    }
	    if (swiper.params.watchOverflow && swiper.enabled) {
	      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
	    }
	  }
	  function render() {
	    // Render Container
	    const params = swiper.params.pagination;
	    if (isPaginationDisabled()) return;
	    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
	    const $el = swiper.pagination.$el;
	    let paginationHTML = '';
	    if (params.type === 'bullets') {
	      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
	      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
	        numberOfBullets = slidesLength;
	      }
	      for (let i = 0; i < numberOfBullets; i += 1) {
	        if (params.renderBullet) {
	          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
	        } else {
	          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
	        }
	      }
	      $el.html(paginationHTML);
	      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
	    }
	    if (params.type === 'fraction') {
	      if (params.renderFraction) {
	        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
	      } else {
	        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
	      }
	      $el.html(paginationHTML);
	    }
	    if (params.type === 'progressbar') {
	      if (params.renderProgressbar) {
	        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
	      } else {
	        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
	      }
	      $el.html(paginationHTML);
	    }
	    if (params.type !== 'custom') {
	      emit('paginationRender', swiper.pagination.$el[0]);
	    }
	  }
	  function init() {
	    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
	      el: 'swiper-pagination'
	    });
	    const params = swiper.params.pagination;
	    if (!params.el) return;
	    let $el = $(params.el);
	    if ($el.length === 0) return;
	    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
	      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

	      if ($el.length > 1) {
	        $el = $el.filter(el => {
	          if ($(el).parents('.swiper')[0] !== swiper.el) return false;
	          return true;
	        });
	      }
	    }
	    if (params.type === 'bullets' && params.clickable) {
	      $el.addClass(params.clickableClass);
	    }
	    $el.addClass(params.modifierClass + params.type);
	    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
	    if (params.type === 'bullets' && params.dynamicBullets) {
	      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
	      dynamicBulletIndex = 0;
	      if (params.dynamicMainBullets < 1) {
	        params.dynamicMainBullets = 1;
	      }
	    }
	    if (params.type === 'progressbar' && params.progressbarOpposite) {
	      $el.addClass(params.progressbarOppositeClass);
	    }
	    if (params.clickable) {
	      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
	        e.preventDefault();
	        let index = $(this).index() * swiper.params.slidesPerGroup;
	        if (swiper.params.loop) index += swiper.loopedSlides;
	        swiper.slideTo(index);
	      });
	    }
	    Object.assign(swiper.pagination, {
	      $el,
	      el: $el[0]
	    });
	    if (!swiper.enabled) {
	      $el.addClass(params.lockClass);
	    }
	  }
	  function destroy() {
	    const params = swiper.params.pagination;
	    if (isPaginationDisabled()) return;
	    const $el = swiper.pagination.$el;
	    $el.removeClass(params.hiddenClass);
	    $el.removeClass(params.modifierClass + params.type);
	    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
	    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
	    if (params.clickable) {
	      $el.off('click', classesToSelector(params.bulletClass));
	    }
	  }
	  on('init', () => {
	    if (swiper.params.pagination.enabled === false) {
	      // eslint-disable-next-line
	      disable();
	    } else {
	      init();
	      render();
	      update();
	    }
	  });
	  on('activeIndexChange', () => {
	    if (swiper.params.loop) {
	      update();
	    } else if (typeof swiper.snapIndex === 'undefined') {
	      update();
	    }
	  });
	  on('snapIndexChange', () => {
	    if (!swiper.params.loop) {
	      update();
	    }
	  });
	  on('slidesLengthChange', () => {
	    if (swiper.params.loop) {
	      render();
	      update();
	    }
	  });
	  on('snapGridLengthChange', () => {
	    if (!swiper.params.loop) {
	      render();
	      update();
	    }
	  });
	  on('destroy', () => {
	    destroy();
	  });
	  on('enable disable', () => {
	    const {
	      $el
	    } = swiper.pagination;
	    if ($el) {
	      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
	    }
	  });
	  on('lock unlock', () => {
	    update();
	  });
	  on('click', (_s, e) => {
	    const targetEl = e.target;
	    const {
	      $el
	    } = swiper.pagination;
	    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
	      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
	      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
	      if (isHidden === true) {
	        emit('paginationShow');
	      } else {
	        emit('paginationHide');
	      }
	      $el.toggleClass(swiper.params.pagination.hiddenClass);
	    }
	  });
	  const enable = () => {
	    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
	    if (swiper.pagination.$el) {
	      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
	    }
	    init();
	    render();
	    update();
	  };
	  const disable = () => {
	    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
	    if (swiper.pagination.$el) {
	      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
	    }
	    destroy();
	  };
	  Object.assign(swiper.pagination, {
	    enable,
	    disable,
	    render,
	    update,
	    init,
	    destroy
	  });
	}

	/* eslint no-underscore-dangle: "off" */
	function Autoplay({
	  swiper,
	  extendParams,
	  on,
	  emit
	}) {
	  let timeout;
	  swiper.autoplay = {
	    running: false,
	    paused: false
	  };
	  extendParams({
	    autoplay: {
	      enabled: false,
	      delay: 3000,
	      waitForTransition: true,
	      disableOnInteraction: true,
	      stopOnLastSlide: false,
	      reverseDirection: false,
	      pauseOnMouseEnter: false
	    }
	  });
	  function run() {
	    if (!swiper.size) {
	      swiper.autoplay.running = false;
	      swiper.autoplay.paused = false;
	      return;
	    }
	    const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
	    let delay = swiper.params.autoplay.delay;
	    if ($activeSlideEl.attr('data-swiper-autoplay')) {
	      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
	    }
	    clearTimeout(timeout);
	    timeout = nextTick(() => {
	      let autoplayResult;
	      if (swiper.params.autoplay.reverseDirection) {
	        if (swiper.params.loop) {
	          swiper.loopFix();
	          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
	          emit('autoplay');
	        } else if (!swiper.isBeginning) {
	          autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
	          emit('autoplay');
	        } else if (!swiper.params.autoplay.stopOnLastSlide) {
	          autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
	          emit('autoplay');
	        } else {
	          stop();
	        }
	      } else if (swiper.params.loop) {
	        swiper.loopFix();
	        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
	        emit('autoplay');
	      } else if (!swiper.isEnd) {
	        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
	        emit('autoplay');
	      } else if (!swiper.params.autoplay.stopOnLastSlide) {
	        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
	        emit('autoplay');
	      } else {
	        stop();
	      }
	      if (swiper.params.cssMode && swiper.autoplay.running) run();else if (autoplayResult === false) {
	        run();
	      }
	    }, delay);
	  }
	  function start() {
	    if (typeof timeout !== 'undefined') return false;
	    if (swiper.autoplay.running) return false;
	    swiper.autoplay.running = true;
	    emit('autoplayStart');
	    run();
	    return true;
	  }
	  function stop() {
	    if (!swiper.autoplay.running) return false;
	    if (typeof timeout === 'undefined') return false;
	    if (timeout) {
	      clearTimeout(timeout);
	      timeout = undefined;
	    }
	    swiper.autoplay.running = false;
	    emit('autoplayStop');
	    return true;
	  }
	  function pause(speed) {
	    if (!swiper.autoplay.running) return;
	    if (swiper.autoplay.paused) return;
	    if (timeout) clearTimeout(timeout);
	    swiper.autoplay.paused = true;
	    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
	      swiper.autoplay.paused = false;
	      run();
	    } else {
	      ['transitionend', 'webkitTransitionEnd'].forEach(event => {
	        swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
	      });
	    }
	  }
	  function onVisibilityChange() {
	    const document = getDocument();
	    if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
	      pause();
	    }
	    if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
	      run();
	      swiper.autoplay.paused = false;
	    }
	  }
	  function onTransitionEnd(e) {
	    if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
	    if (e.target !== swiper.$wrapperEl[0]) return;
	    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
	      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
	    });
	    swiper.autoplay.paused = false;
	    if (!swiper.autoplay.running) {
	      stop();
	    } else {
	      run();
	    }
	  }
	  function onMouseEnter() {
	    if (swiper.params.autoplay.disableOnInteraction) {
	      stop();
	    } else {
	      emit('autoplayPause');
	      pause();
	    }
	    ['transitionend', 'webkitTransitionEnd'].forEach(event => {
	      swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
	    });
	  }
	  function onMouseLeave() {
	    if (swiper.params.autoplay.disableOnInteraction) {
	      return;
	    }
	    swiper.autoplay.paused = false;
	    emit('autoplayResume');
	    run();
	  }
	  function attachMouseEvents() {
	    if (swiper.params.autoplay.pauseOnMouseEnter) {
	      swiper.$el.on('mouseenter', onMouseEnter);
	      swiper.$el.on('mouseleave', onMouseLeave);
	    }
	  }
	  function detachMouseEvents() {
	    swiper.$el.off('mouseenter', onMouseEnter);
	    swiper.$el.off('mouseleave', onMouseLeave);
	  }
	  on('init', () => {
	    if (swiper.params.autoplay.enabled) {
	      start();
	      const document = getDocument();
	      document.addEventListener('visibilitychange', onVisibilityChange);
	      attachMouseEvents();
	    }
	  });
	  on('beforeTransitionStart', (_s, speed, internal) => {
	    if (swiper.autoplay.running) {
	      if (internal || !swiper.params.autoplay.disableOnInteraction) {
	        swiper.autoplay.pause(speed);
	      } else {
	        stop();
	      }
	    }
	  });
	  on('sliderFirstMove', () => {
	    if (swiper.autoplay.running) {
	      if (swiper.params.autoplay.disableOnInteraction) {
	        stop();
	      } else {
	        pause();
	      }
	    }
	  });
	  on('touchEnd', () => {
	    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
	      run();
	    }
	  });
	  on('destroy', () => {
	    detachMouseEvents();
	    if (swiper.autoplay.running) {
	      stop();
	    }
	    const document = getDocument();
	    document.removeEventListener('visibilitychange', onVisibilityChange);
	  });
	  Object.assign(swiper.autoplay, {
	    pause,
	    run,
	    start,
	    stop
	  });
	}

	function freeMode({
	  swiper,
	  extendParams,
	  emit,
	  once
	}) {
	  extendParams({
	    freeMode: {
	      enabled: false,
	      momentum: true,
	      momentumRatio: 1,
	      momentumBounce: true,
	      momentumBounceRatio: 1,
	      momentumVelocityRatio: 1,
	      sticky: false,
	      minimumVelocity: 0.02
	    }
	  });
	  function onTouchStart() {
	    const translate = swiper.getTranslate();
	    swiper.setTranslate(translate);
	    swiper.setTransition(0);
	    swiper.touchEventsData.velocities.length = 0;
	    swiper.freeMode.onTouchEnd({
	      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
	    });
	  }
	  function onTouchMove() {
	    const {
	      touchEventsData: data,
	      touches
	    } = swiper; // Velocity

	    if (data.velocities.length === 0) {
	      data.velocities.push({
	        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
	        time: data.touchStartTime
	      });
	    }
	    data.velocities.push({
	      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
	      time: now()
	    });
	  }
	  function onTouchEnd({
	    currentPos
	  }) {
	    const {
	      params,
	      $wrapperEl,
	      rtlTranslate: rtl,
	      snapGrid,
	      touchEventsData: data
	    } = swiper; // Time diff

	    const touchEndTime = now();
	    const timeDiff = touchEndTime - data.touchStartTime;
	    if (currentPos < -swiper.minTranslate()) {
	      swiper.slideTo(swiper.activeIndex);
	      return;
	    }
	    if (currentPos > -swiper.maxTranslate()) {
	      if (swiper.slides.length < snapGrid.length) {
	        swiper.slideTo(snapGrid.length - 1);
	      } else {
	        swiper.slideTo(swiper.slides.length - 1);
	      }
	      return;
	    }
	    if (params.freeMode.momentum) {
	      if (data.velocities.length > 1) {
	        const lastMoveEvent = data.velocities.pop();
	        const velocityEvent = data.velocities.pop();
	        const distance = lastMoveEvent.position - velocityEvent.position;
	        const time = lastMoveEvent.time - velocityEvent.time;
	        swiper.velocity = distance / time;
	        swiper.velocity /= 2;
	        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
	          swiper.velocity = 0;
	        } // this implies that the user stopped moving a finger then released.
	        // There would be no events with distance zero, so the last event is stale.

	        if (time > 150 || now() - lastMoveEvent.time > 300) {
	          swiper.velocity = 0;
	        }
	      } else {
	        swiper.velocity = 0;
	      }
	      swiper.velocity *= params.freeMode.momentumVelocityRatio;
	      data.velocities.length = 0;
	      let momentumDuration = 1000 * params.freeMode.momentumRatio;
	      const momentumDistance = swiper.velocity * momentumDuration;
	      let newPosition = swiper.translate + momentumDistance;
	      if (rtl) newPosition = -newPosition;
	      let doBounce = false;
	      let afterBouncePosition;
	      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
	      let needsLoopFix;
	      if (newPosition < swiper.maxTranslate()) {
	        if (params.freeMode.momentumBounce) {
	          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
	            newPosition = swiper.maxTranslate() - bounceAmount;
	          }
	          afterBouncePosition = swiper.maxTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.maxTranslate();
	        }
	        if (params.loop && params.centeredSlides) needsLoopFix = true;
	      } else if (newPosition > swiper.minTranslate()) {
	        if (params.freeMode.momentumBounce) {
	          if (newPosition - swiper.minTranslate() > bounceAmount) {
	            newPosition = swiper.minTranslate() + bounceAmount;
	          }
	          afterBouncePosition = swiper.minTranslate();
	          doBounce = true;
	          data.allowMomentumBounce = true;
	        } else {
	          newPosition = swiper.minTranslate();
	        }
	        if (params.loop && params.centeredSlides) needsLoopFix = true;
	      } else if (params.freeMode.sticky) {
	        let nextSlide;
	        for (let j = 0; j < snapGrid.length; j += 1) {
	          if (snapGrid[j] > -newPosition) {
	            nextSlide = j;
	            break;
	          }
	        }
	        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
	          newPosition = snapGrid[nextSlide];
	        } else {
	          newPosition = snapGrid[nextSlide - 1];
	        }
	        newPosition = -newPosition;
	      }
	      if (needsLoopFix) {
	        once('transitionEnd', () => {
	          swiper.loopFix();
	        });
	      } // Fix duration

	      if (swiper.velocity !== 0) {
	        if (rtl) {
	          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
	        } else {
	          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
	        }
	        if (params.freeMode.sticky) {
	          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
	          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
	          // It's easy to see this when simulating touch with mouse events. To fix this,
	          // limit single-slide swipes to the default slide duration. This also has the
	          // nice side effect of matching slide speed if the user stopped moving before
	          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
	          // For faster swipes, also apply limits (albeit higher ones).
	          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
	          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
	          if (moveDistance < currentSlideSize) {
	            momentumDuration = params.speed;
	          } else if (moveDistance < 2 * currentSlideSize) {
	            momentumDuration = params.speed * 1.5;
	          } else {
	            momentumDuration = params.speed * 2.5;
	          }
	        }
	      } else if (params.freeMode.sticky) {
	        swiper.slideToClosest();
	        return;
	      }
	      if (params.freeMode.momentumBounce && doBounce) {
	        swiper.updateProgress(afterBouncePosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	        swiper.animating = true;
	        $wrapperEl.transitionEnd(() => {
	          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
	          emit('momentumBounce');
	          swiper.setTransition(params.speed);
	          setTimeout(() => {
	            swiper.setTranslate(afterBouncePosition);
	            $wrapperEl.transitionEnd(() => {
	              if (!swiper || swiper.destroyed) return;
	              swiper.transitionEnd();
	            });
	          }, 0);
	        });
	      } else if (swiper.velocity) {
	        emit('_freeModeNoMomentumRelease');
	        swiper.updateProgress(newPosition);
	        swiper.setTransition(momentumDuration);
	        swiper.setTranslate(newPosition);
	        swiper.transitionStart(true, swiper.swipeDirection);
	        if (!swiper.animating) {
	          swiper.animating = true;
	          $wrapperEl.transitionEnd(() => {
	            if (!swiper || swiper.destroyed) return;
	            swiper.transitionEnd();
	          });
	        }
	      } else {
	        swiper.updateProgress(newPosition);
	      }
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    } else if (params.freeMode.sticky) {
	      swiper.slideToClosest();
	      return;
	    } else if (params.freeMode) {
	      emit('_freeModeNoMomentumRelease');
	    }
	    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
	      swiper.updateProgress();
	      swiper.updateActiveIndex();
	      swiper.updateSlidesClasses();
	    }
	  }
	  Object.assign(swiper, {
	    freeMode: {
	      onTouchStart,
	      onTouchMove,
	      onTouchEnd
	    }
	  });
	}

	const autoPlay = (swiper, {
	  speed
	}) => {
	  const computedDirection = document.documentElement.getAttribute('dir') === 'rtl' ? 'ltr' : 'rtl';
	  // logic is found and taken from:
	  // https://github.com/nolimits4web/swiper/blob/d34ca69bd65bf5855539081e99d2093e0518a273/src/modules/mousewheel/mousewheel.js#L274
	  let running = true;
	  let hovered = false;
	  const onPointerEnter = () => hovered = true;
	  const onPointerLeave = () => hovered = false;
	  swiper.el.addEventListener('pointerenter', onPointerEnter);
	  swiper.el.addEventListener('pointerleave', onPointerLeave);
	  const tick = () => {
	    if (running) requestAnimationFrame(tick);
	    const dir = computedDirection !== 'rtl' ? 1 : -1;
	    if (swiper.touchEventsData.isTouched || swiper.animating) return;
	    if (hovered) return;
	    swiper.setTransition(0);
	    swiper.setTranslate(-swiper.translate * dir - speed);
	    swiper.updateProgress();
	    swiper.updateActiveIndex();
	    swiper.updateSlidesClasses();
	    if (swiper.params.loop) {
	      swiper.loopFix({
	        direction: dir ? 'next' : 'prev',
	        byMousewheel: true
	      });
	    }
	  };
	  tick();
	  return {
	    stop: () => {
	      running = false;
	    },
	    start() {
	      running = true;
	      tick();
	    },
	    destroy: () => {
	      swiper.el.removeEventListener('pointerenter', onPointerEnter);
	      swiper.el.removeEventListener('pointerleave', onPointerLeave);
	    }
	  };
	};
	const makeVisibleSlidesFocusable = (slides, containerRect) => {
	  let lastVisibleSlide = null;
	  slides.forEach(slide => {
	    const rect = slide.getBoundingClientRect();
	    if (rect.left >= containerRect.left && rect.right <= containerRect.right + 20) {
	      slide.setAttribute('tabindex', '0');
	      slide.setAttribute('aria-hidden', 'false');
	      lastVisibleSlide = slide;
	    } else {
	      slide.setAttribute('tabindex', '-1');
	      slide.setAttribute('aria-hidden', 'true');
	    }
	  });
	  return lastVisibleSlide;
	};
	const manageFocus = swiper => {
	  setTimeout(() => {
	    const slides = Array.from(swiper.slides);
	    const containerRect = swiper.$el[0].getBoundingClientRect();
	    const lastVisibleSlide = makeVisibleSlidesFocusable(slides, containerRect);
	    if (swiper.activeIndex > swiper.previousIndex) slides[swiper.activeIndex].focus();else if (lastVisibleSlide && swiper.activeIndex < swiper.previousIndex) lastVisibleSlide.focus();
	  }, 500);
	};
	const classes = {
	  peek: 'is-peeking'
	};
	const selectors = {
	  activeSlide: '.swiper-slide-active',
	  nextSlide: '.swiper-slide-next'
	};
	const configurations = {
	  'ticker': {
	    options: {
	      autoplay: true
	    },
	    config: {
	      speed: 0,
	      breakpoints: {
	        320: {
	          slidesPerView: 4,
	          spaceBetween: 20
	        },
	        900: {
	          slidesPerView: 7,
	          spaceBetween: 30
	        }
	      },
	      freeMode: {
	        enabled: false,
	        sticky: false,
	        momentumRatio: 0.1,
	        momentumVelocityRatio: 0.1
	      }
	    }
	  },
	  'triple': {
	    options: {},
	    config: {
	      freeMode: {
	        enabled: false,
	        sticky: false
	      },
	      spaceBetween: 12,
	      slidesPerView: 2,
	      centeredSlides: true,
	      loop: true,
	      pagination: {
	        el: '.swiper-pagination',
	        type: 'bullets'
	      }
	    }
	  },
	  'article-list': {
	    options: {},
	    config: {
	      freeMode: {
	        enabled: false,
	        sticky: false
	      },
	      spaceBetween: 12,
	      slidesPerView: 3,
	      centeredSlides: true,
	      loop: true,
	      pagination: {
	        el: '.swiper-pagination',
	        type: 'bullets'
	      }
	    }
	  },
	  'product-hero': {
	    options: {},
	    config: {
	      freeMode: {
	        enabled: false,
	        sticky: false
	      },
	      spaceBetween: 0,
	      slidesPerView: 1,
	      centeredSlides: true,
	      loop: true,
	      pagination: {
	        el: '.swiper-pagination',
	        type: 'bullets'
	      }
	    }
	  },
	  'image-carousel': {
	    options: {
	      hasNextClick: true
	    },
	    config: {
	      freeMode: {
	        enabled: false,
	        sticky: false
	      },
	      centeredSlides: false,
	      loop: false
	    }
	  },
	  'variant-selector': {
	    options: {
	      hasNextClick: false
	    },
	    config: {
	      spaceBetween: 4,
	      breakpoints: {
	        600: {
	          slidesPerView: 'auto',
	          slidesPerGroup: 'auto'
	        },
	        1024: {
	          slidesPerView: 6,
	          slidesPerGroup: 6
	        }
	      },
	      loop: false,
	      centeredSlides: false,
	      navigation: {
	        nextEl: '.carousel__button-next',
	        prevEl: '.carousel__button-prev'
	      },
	      on: {
	        init: function (swiper) {
	          // Add flag to track initialization using type assertion
	          // eslint-disable-next-line
	          swiper.initialized = false;
	          const activeSlide = swiper.el.querySelector('.is-active');
	          if (activeSlide) {
	            const activeIndex = Array.from(swiper.slides).indexOf(activeSlide);
	            // Only slide if active item is beyond the initially visible slides
	            if (activeIndex >= 6) {
	              swiper.slideTo(activeIndex, 0);
	            }
	            // Delay making slides focusable until after initial page rendering
	            requestAnimationFrame(() => {
	              makeVisibleSlidesFocusable(Array.from(swiper.slides), swiper.$el[0].getBoundingClientRect());
	              // Mark as initialized after all initialization operations are complete
	              setTimeout(() => {
	                // eslint-disable-next-line
	                swiper.initialized = true;
	              }, 100);
	            });
	          } else {
	            // eslint-disable-next-line
	            swiper.initialized = true;
	          }
	        },
	        slideChange: swiper => {
	          // Only manage focus if not during initialization
	          // eslint-disable-next-line
	          if (swiper.initialized) {
	            manageFocus(swiper);
	          }
	        }
	      }
	    }
	  }
	};
	var componentCarousel = () => {
	  const {
	    carousel
	  } = getElementsByRef('carousel');
	  if (!carousel) {
	    return;
	  }
	  if (!carousel) return;
	  const carousels = Array.isArray(carousel) ? [...carousel] : [carousel];
	  const swipers = carousels.map(carousel => {
	    let swiper;
	    let hasPeeked = false;
	    let convention;
	    let autoPlayer;
	    let observer;
	    const initSwiper = (container, config, options) => {
	      swiper = new Swiper$1(container, config);
	      if (options.autoplay) autoPlayer = autoPlay(swiper, {
	        speed: 0.5
	      });
	      if (swiper.slides.length > 2 && !!options.hasNextClick) {
	        swiper.slides.forEach(slide => {
	          slide.addEventListener('mouseenter', handleMouseEnter);
	        });
	      }
	    };
	    const handleMouseEnter = e => {
	      if (!swiper) return;
	      const next = e.target.closest(selectors.nextSlide);
	      const active = e.target.closest(selectors.activeSlide);
	      const isFirstItem = swiper.activeIndex === 0;
	      const isLastItem = swiper.activeIndex === swiper.slides.length - 2;
	      if (next && !isLastItem) {
	        dispatchEvent(window, events$2.CHANGE_CURSOR, {
	          type: 'next',
	          contrast: true
	        });
	      } else if (active && !isFirstItem) {
	        dispatchEvent(window, events$2.CHANGE_CURSOR, {
	          type: 'prev',
	          contrast: true
	        });
	      } else {
	        dispatchEvent(window, events$2.CHANGE_CURSOR, {
	          type: 'default',
	          contrast: false
	        });
	      }
	    };
	    const handleNextClick = e => {
	      if (!swiper) return;
	      const next = e.target.closest(selectors.nextSlide);
	      const active = e.target.closest(selectors.activeSlide);
	      const firstItemClicked = swiper.clickedIndex === 0;
	      const lastItemClicked = swiper.clickedIndex === swiper.slides.length - 1;
	      if (next && !lastItemClicked) {
	        swiper.slideNext();
	      }
	      if (active && !firstItemClicked) {
	        swiper.slidePrev();
	      }
	    };
	    const handleIntersection = ([entry]) => {
	      if (!swiper) return;
	      const peekIndex = swiper.activeIndex + 2;
	      if (peekIndex > 3) return;
	      const peekItem = swiper.slides[peekIndex];
	      if (entry.isIntersecting && !hasPeeked) {
	        peekItem.classList.add(classes.peek);
	        hasPeeked = true;
	      }
	    };
	    const resetCursor = () => {
	      dispatchEvent(window, events$2.CHANGE_CURSOR, {
	        type: 'default',
	        contrast: false
	      });
	    };
	    const removeAllEventListeners = () => {
	      if (autoPlayer) autoPlayer.destroy();
	      if (carousel) {
	        carousel.removeEventListener('click', handleNextClick);
	        carousel.removeEventListener('mouseleave', resetCursor);
	      }
	      if (swiper) swiper.slides.forEach(slide => {
	        slide.removeEventListener('mouseenter', handleMouseEnter);
	      });
	      if (observer) observer.disconnect();
	    };
	    const configuration = carousel.dataset.config;
	    if (!configuration) return removeAllEventListeners;
	    const options = configurations[configuration].options;
	    const {
	      container
	    } = getRefs(carousel);
	    convention = {
	      modules: [Mousewheel, freeMode, Autoplay, Pagination, Navigation],
	      freeMode: {
	        enabled: true,
	        sticky: false
	      },
	      pagination: false,
	      slidesPerView: 'auto',
	      direction: 'horizontal',
	      watchOverflow: true,
	      loop: true,
	      centeredSlides: true,
	      mousewheel: {
	        invert: false,
	        forceToAxis: true
	      },
	      ...configurations[configuration].config
	    };
	    initSwiper(container, convention, options);
	    if (configuration === 'product-hero') {
	      if (!swiper?.slides.length) return removeAllEventListeners;
	      const lightbox = new PhotoSwipeLightbox({
	        closeSVG: close,
	        bgOpacity: 1,
	        gallery: carousel,
	        children: swiper.slides,
	        zoom: false,
	        counter: false,
	        initialZoomLevel: 'fill',
	        secondaryZoomLevel: 1,
	        maxZoomLevel: 2,
	        pswpModule: () => Promise.resolve().then(function () { return photoswipe_esm; })
	      });
	      lightbox.init();
	    }
	    if (options.hasNextClick) {
	      carousel.addEventListener('click', handleNextClick);
	      carousel.addEventListener('mouseleave', resetCursor);
	      if (!swiper || 'imagesToLoad' in swiper && Array.isArray(swiper.imagesToLoad) && swiper.imagesToLoad.length <= 2) return removeAllEventListeners;
	      observer = intersection(carousel, handleIntersection, {
	        threshold: [0.8]
	      });
	    }
	    return removeAllEventListeners;
	  });
	  return () => {
	    swipers.forEach(teardown => teardown());
	  };
	};

	var componentCarousel$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: componentCarousel
	});

	class ComponentModal extends HTMLElement {
	  previousActiveElement = null;
	  constructor() {
	    super();
	    this.elements = {
	      closeButton: null,
	      focusableElements: null
	    };
	  }
	  connectedCallback() {
	    this.render();
	    this.initializeElements();
	    this.setupEventListeners();
	    this.applyAccessibility();
	  }
	  disconnectedCallback() {
	    this.cleanup();
	  }
	  render() {
	    this.style.visibility = 'hidden';
	    this.style.opacity = '0';
	  }
	  initializeElements() {
	    this.elements.closeButton = this.querySelector('.component-modal__close');
	    this.initFocusableElements();
	  }
	  setupEventListeners() {
	    this.elements.closeButton?.addEventListener('click', this.close.bind(this));
	    this.addEventListener('click', (e => {
	      if (e.target === this) this.close();
	    }).bind(this));
	  }
	  applyAccessibility() {
	    this.addEventListener('keydown', this.handleKeyDown.bind(this));
	  }
	  handleKeyDown(e) {
	    switch (e.key) {
	      case 'Escape':
	        this.close();
	        break;
	      case 'Tab':
	        this.manageFocus(e);
	        break;
	    }
	  }
	  initFocusableElements() {
	    this.elements.focusableElements = Array.from(this.querySelectorAll(FOCUSABLE_SELECTORS));
	  }
	  manageFocus(e) {
	    const elements = this.elements.focusableElements;
	    if (!elements?.length) return;
	    const firstElement = elements[0];
	    const lastElement = elements[elements.length - 1];
	    const isTabbing = !e.shiftKey;
	    const isReverseTabbing = e.shiftKey;
	    if (isReverseTabbing && document.activeElement === firstElement) {
	      lastElement.focus();
	      e.preventDefault();
	    } else if (isTabbing && document.activeElement === lastElement) {
	      firstElement.focus();
	      e.preventDefault();
	    }
	  }
	  open() {
	    this.previousActiveElement = document.activeElement ?? null;
	    this.ariaHidden = 'false';
	    this.style.display = 'flex';
	    document.body.style.overflow = 'hidden';
	    setTimeout((() => {
	      this.style.visibility = 'visible';
	      this.style.opacity = '1';
	    }).bind(this), 70);
	    this.initFocusableElements();
	    setTimeout(() => {
	      if (this.elements.focusableElements) this.elements.focusableElements[0].focus();
	    }, 100);
	  }
	  close() {
	    this.ariaHidden = 'true';
	    this.style.visibility = 'hidden';
	    this.style.opacity = '0';
	    document.body.style.overflow = '';
	    setTimeout((() => {
	      this.style.display = 'none';
	    }).bind(this), 400);
	    this.previousActiveElement?.focus();
	  }
	  cleanup() {
	    this.elements.closeButton?.removeEventListener('click', this.close.bind(this));
	    this.removeEventListener('keydown', this.handleKeyDown.bind(this));
	  }
	  static define() {
	    if (!customElements.get('component-modal')) {
	      customElements.define('component-modal', ComponentModal);
	    }
	  }
	}
	var componentModal = () => {
	  ComponentModal.define();
	};

	var componentModal$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		ComponentModal: ComponentModal,
		default: componentModal
	});

	var InputFields;
	(function (InputFields) {
	  InputFields["FirstName"] = "firstName";
	  InputFields["LastName"] = "lastName";
	  InputFields["Address1"] = "address1";
	  InputFields["Address2"] = "address2";
	  InputFields["Zip"] = "zip";
	  InputFields["City"] = "city";
	  InputFields["Phone"] = "phone";
	  InputFields["Birthdate"] = "birthdate";
	  InputFields["email"] = "email";
	  InputFields["password"] = "password";
	  InputFields["confirmPassword"] = "confirmPassword";
	  InputFields["civility"] = "civility";
	})(InputFields || (InputFields = {}));
	const FormSelectors = {
	  Customer: {
	    BIRTHDATE: 'input[name=birthdate]',
	    PHONE: 'input[name="phone"]',
	    PHONE_COUNTRY_SELECT: 'select[name="phone_country_select"]',
	    SUBMIT_BUTTON: 'button[type="submit"]',
	    FIRST_NAME: 'input[name="firstName"]',
	    LAST_NAME: 'input[name="lastName"]',
	    EMAIL: 'input[name="email"]',
	    PASSWORD: 'input[name="password"]',
	    CIVILITY: 'select[name="civility"]',
	    Activate: {
	      Selectors: {
	        PASSWORD: 'input[name="customer[password]"]',
	        CONFIRM_PASSWORD: 'input[name="customer[password_confirmation]"]'
	      }
	    },
	    Update: {
	      ID: '#profile_form',
	      FORM: '#update_customer_form',
	      Selectors: {
	        FIRST_NAME: 'input[name="firstName"]',
	        LAST_NAME: 'input[name="lastName"]',
	        PHONE: 'input[name="phone"]'
	      },
	      Fields: {
	        FirstName: 'firstName',
	        LastName: 'lastName',
	        Phone: 'phone'
	      }
	    },
	    Address: {
	      COUNTRY_SELECT: 'select[name="address[country]"]',
	      PHONE: 'input[name="address[phone]"]',
	      FIRST_NAME: 'input[name="address[first_name]"]',
	      LAST_NAME: 'input[name="address[last_name]"]',
	      ADDRESS_1: 'input[name="address[address1]"]',
	      ADDRESS_2: 'input[name="address[address2]"]',
	      ZIP: 'input[name="address[zip]"]',
	      CITY: 'input[name="address[city]"]'
	    }
	  }
	};
	const defaultNoValidationConf = {
	  noSpecialChar: undefined,
	  nonLatinCharacters: undefined,
	  noNumber: undefined,
	  maxLength: undefined,
	  minLength: 0,
	  required: false
	};
	const inputTextDefaultValidationConf = {
	  nonLatinCharacters: true,
	  noSpecialChar: true,
	  noNumber: true,
	  maxLength: 35,
	  minLength: 0,
	  required: true
	};
	const FormValidations = {
	  [InputFields.FirstName]: {
	    ...inputTextDefaultValidationConf,
	    minLength: 2,
	    maxLength: 35
	  },
	  [InputFields.LastName]: {
	    ...inputTextDefaultValidationConf,
	    minLength: 2,
	    maxLength: 35
	  },
	  [InputFields.Address1]: {
	    ...inputTextDefaultValidationConf,
	    noNumber: false,
	    required: true
	  },
	  [InputFields.Address2]: {
	    ...inputTextDefaultValidationConf,
	    noNumber: false,
	    required: false
	  },
	  [InputFields.City]: {
	    ...inputTextDefaultValidationConf,
	    noNumber: false,
	    maxLength: undefined,
	    required: true
	  },
	  [InputFields.Zip]: {
	    ...inputTextDefaultValidationConf,
	    noNumber: false,
	    maxLength: 10,
	    required: true
	  },
	  [InputFields.Phone]: {
	    ...defaultNoValidationConf
	  },
	  [InputFields.email]: {
	    ...defaultNoValidationConf,
	    required: true
	  },
	  [InputFields.password]: {
	    ...inputTextDefaultValidationConf,
	    noNumber: false,
	    noSpecialChar: false,
	    minLength: 5
	  },
	  [InputFields.confirmPassword]: {
	    ...inputTextDefaultValidationConf,
	    noNumber: false,
	    noSpecialChar: false,
	    minLength: 5
	  },
	  [InputFields.civility]: {
	    ...defaultNoValidationConf,
	    required: true
	  },
	  [InputFields.Birthdate]: {
	    ...inputTextDefaultValidationConf,
	    noSpecialChar: true,
	    maxLength: 10,
	    maxDate: Date.now(),
	    required: false,
	    noNumber: false
	  }
	};

	var ErrorTypes;
	(function (ErrorTypes) {
	  ErrorTypes["invalidTitle"] = "invalid_title";
	  ErrorTypes["invalidName"] = "invalid_name";
	  ErrorTypes["invalidCivility"] = "invalid_civility";
	  ErrorTypes["nonLatinCharacters"] = "contains_non_latin_characters";
	  ErrorTypes["maxLengthExceeded"] = "max_length_exceeded";
	  ErrorTypes["minLength"] = "min_length";
	  ErrorTypes["containsNumbers"] = "contains_numbers";
	  ErrorTypes["containsSpecialChars"] = "contains_special_chars";
	  ErrorTypes["empty"] = "empty";
	  ErrorTypes["phoneNumberInvalid"] = "phone_number_invalid";
	  ErrorTypes["formSubmitError"] = "form_error";
	  ErrorTypes["TAKEN"] = "email_taken";
	  ErrorTypes["maxDate"] = "max_date";
	})(ErrorTypes || (ErrorTypes = {}));

	/* Copy paste from here to  enhanced customers  */
	const containsNonLatinCharactersFieldError = str => {
	  // Regex matches non-Latin characters but allows for European accented characters
	  /* eslint-disable-next-line no-control-regex */
	  const nonLatinRegex = /[^\u0000-\u017F]+/;
	  return nonLatinRegex.test(str || '');
	};
	const validateNotContainsNonLatinCharacters = str => {
	  if (containsNonLatinCharactersFieldError(str)) {
	    return {
	      isValid: false,
	      error: ErrorTypes.nonLatinCharacters
	    };
	  }
	  return {
	    isValid: true
	  };
	};
	function validateMaxLength(str, maxLength) {
	  if (str.length > maxLength) {
	    return {
	      isValid: false,
	      error: ErrorTypes.maxLengthExceeded
	    };
	  }
	  return {
	    isValid: true
	  };
	}
	function validateMinLength(str, minLength) {
	  if (str.length < minLength) {
	    return {
	      isValid: false,
	      error: ErrorTypes.minLength
	    };
	  }
	  return {
	    isValid: true
	  };
	}
	function validateNoNumbers(str) {
	  const numberRegex = /\d/;
	  if (numberRegex.test(str)) {
	    return {
	      isValid: false,
	      error: ErrorTypes.containsNumbers
	    };
	  }
	  return {
	    isValid: true
	  };
	}
	function validateNoSpecialChars(str) {
	  const specialCharsRegex = /[%_;|]/;
	  if (specialCharsRegex.test(str)) {
	    return {
	      isValid: false,
	      error: ErrorTypes.containsSpecialChars
	    };
	  }
	  return {
	    isValid: true
	  };
	}
	function validateNotEmpty(str) {
	  const withoutWhiteSpace = str.replace(/\s/g, '');
	  if (withoutWhiteSpace.length <= 0) return {
	    isValid: false,
	    error: ErrorTypes.empty
	  };
	  return {
	    isValid: true
	  };
	}
	function validateMaxDate(inputTimestamp, limitTimestamp) {
	  if (inputTimestamp > limitTimestamp) {
	    return {
	      isValid: false,
	      error: ErrorTypes.maxDate
	    };
	  }
	  return {
	    isValid: true
	  };
	}

	class InputValidation {
	  inputs = {};
	  hasSubmitOnce = false;
	  constructor({
	    formContainer,
	    inputs
	  }) {
	    this.formContainer = formContainer;
	    this.inputs = inputs;
	    this.form = this.formContainer.querySelector('form');
	    if (!this.form) throw new Error('Form not found');
	    this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
	    if (!this.submitButton) throw new Error('Submit Button not found');
	  }
	  triggerValidationEffect(input, validation) {
	    if (!validation.isValid && validation.error) {
	      this.displayErrorSpan(input, validation.error, validation.message);
	      if (this.submitButton) this.submitButton.disabled = true;
	      return false;
	    }
	    this.removeErrorSpan(input);
	    if (this.submitButton) this.submitButton.disabled = false;
	    return true;
	  }
	  displayErrorSpan(input, error, message) {
	    this.removeErrorSpan(input);
	    const errorSpan = this.form?.querySelector(`span[data-ref=${input.id}-${error}]`);
	    if (!errorSpan) return;
	    if (message) errorSpan.textContent = message;
	    input.ariaInvalid = 'true';
	    input.setAttribute('aria-describedby', `${input.id}-${error}`);
	    errorSpan.hidden = false;
	    errorSpan.style.display = 'block';
	  }
	  removeErrorSpan(input) {
	    const errorSpans = this.form?.querySelectorAll(`span[data-ref^=${input.id}]`);
	    if (!errorSpans) return;
	    input.ariaInvalid = 'false';
	    input.removeAttribute('aria-describedby');
	    errorSpans.forEach(span => {
	      span.hidden = true;
	      span.style.display = 'none';
	    });
	  }
	  checkRequiredInputs({
	    inputs
	  }) {
	    if (!inputs) return true;
	    let formHasEmptyRequiredField = false;
	    Object.values(this.inputs).forEach(input => {
	      if (!input.validationConfig.required) return;
	      const emptyCheck = validateNotEmpty(input.selector.value);
	      if (!this.triggerValidationEffect(input.selector, emptyCheck)) return false;
	      formHasEmptyRequiredField = true;
	    });
	    return formHasEmptyRequiredField;
	  }
	  validateInput(input) {
	    if (this.hasSubmitOnce) {
	      const empty = validateNotEmpty(input.selector.value);
	      if (!this.triggerValidationEffect(input.selector, empty)) {
	        return false;
	      }
	    }
	    if (input.validationConfig.maxDate) {
	      const maxDateCheck = validateMaxDate(Date.parse(input.selector.value), input.validationConfig.maxDate);
	      if (!this.triggerValidationEffect(input.selector, maxDateCheck)) return false;
	    }
	    if (input.validationConfig.noSpecialChar) {
	      const speCharCheck = validateNoSpecialChars(input.selector.value);
	      if (!this.triggerValidationEffect(input.selector, speCharCheck)) {
	        return false;
	      }
	    }
	    if (input.validationConfig.noNumber) {
	      const noNumb = validateNoNumbers(input.selector.value);
	      if (!this.triggerValidationEffect(input.selector, noNumb)) {
	        return false;
	      }
	    }
	    if (input.validationConfig.maxLength) {
	      const lengthCheck = validateMaxLength(input.selector.value, input.validationConfig.maxLength);
	      if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
	        return false;
	      }
	    }
	    if (input.validationConfig.minLength) {
	      const lengthCheck = validateMinLength(input.selector.value, input.validationConfig.minLength);
	      if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
	        return false;
	      }
	    }
	    if (input.validationConfig.nonLatinCharacters) {
	      const latinCharactersCheck = validateNotContainsNonLatinCharacters(input.selector.value);
	      if (!this.triggerValidationEffect(input.selector, latinCharactersCheck)) {
	        return false;
	      }
	    }
	    return true;
	  }
	  validateForm({
	    inputs
	  }) {
	    let isValid = true;
	    Object.values(inputs).forEach(input => {
	      if (input.selector.value.trim() !== '') {
	        if (!this.validateInput(input)) {
	          isValid = false;
	        }
	      }
	    });
	    return isValid;
	  }
	}

	const handleNewsletterEventSubscription = async formData => {
	  let customerIsSubscribedToEvent = true;
	  const errorType = ErrorTypes.formSubmitError;
	  let errorMessage;
	  const {
	    newsletterEventForm,
	    messageContainerSuccess,
	    messageContainerError,
	    messageContainerAlreadySignedUp
	  } = getElementByRef(['newsletter-event-form', 'message-container-success', 'message-container-error', 'message-container-already-signed-up']);
	  if (!newsletterEventForm || !messageContainerSuccess || !messageContainerError || !messageContainerAlreadySignedUp) {
	    customerIsSubscribedToEvent = false;
	    return {
	      customerIsSubscribedToEvent,
	      errorType,
	      errorMessage
	    };
	  }
	  const {
	    eventKey
	  } = newsletterEventForm.dataset;
	  const customerEmail = formData.get('email');
	  if (typeof customerEmail != 'string') {
	    messageContainerError.style.display = 'block';
	    customerIsSubscribedToEvent = false;
	    return {
	      customerIsSubscribedToEvent,
	      errorType,
	      errorMessage
	    };
	  } else {
	    try {
	      const response = await fetch(API_KLAVIYO.EVENT, {
	        method: 'POST',
	        headers: API_KLAVIYO.HEADERS,
	        body: JSON.stringify({
	          data: {
	            type: 'profile',
	            attributes: {
	              email: customerEmail,
	              meta: {
	                patch_properties: {
	                  append: {
	                    event: eventKey
	                  }
	                }
	              }
	            }
	          }
	        })
	      });
	      if (response.status === 202) {
	        messageContainerSuccess.style.display = 'block';
	        newsletterEventForm.querySelector('input[data-ref="event-form-email"]').value = '';
	      } else {
	        messageContainerError.style.display = 'block';
	      }
	    } catch (error) {
	      customerIsSubscribedToEvent = false;
	    }
	    return {
	      customerIsSubscribedToEvent,
	      errorType,
	      errorMessage
	    };
	  }
	};

	var handleNewsletterEvent = /*#__PURE__*/Object.freeze({
		__proto__: null,
		handleNewsletterEventSubscription: handleNewsletterEventSubscription
	});

	class NewsletterEventForm {
	  inputs = {};
	  constructor({
	    formContainerId
	  }) {
	    this.formContainer = document.getElementById(formContainerId);
	    if (!this.formContainer) throw `Unable to find form container with id: ${formContainerId}`;
	    this.form = this.formContainer.querySelector('form');
	    if (!this.form) throw `Unable to find form in the given container: ${formContainerId}`;
	    this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
	    if (!this.submitButton) throw new Error('Required elements not found');
	    this.inputs = {
	      email: {
	        selector: this.form.querySelector(FormSelectors.Customer.EMAIL),
	        validationConfig: FormValidations.email
	      }
	    };
	    this.init();
	  }
	  initInputValidation({
	    inputs
	  }) {
	    this.inputValidation = new InputValidation({
	      formContainer: this.formContainer,
	      inputs: inputs
	    });
	  }
	  handleFormValidation = () => {
	    if (!this.inputs.email?.selector) return false;
	    const isValid = this.inputValidation?.validateForm({
	      inputs: this.inputs
	    });
	    if (this.submitButton) this.submitButton.disabled = !isValid;
	    return isValid;
	  };
	  handleInputValidation = input => {
	    if (!input.selector || !input.validationConfig) return false;
	    const isValid = this.inputValidation?.validateInput(input);
	    if (this.submitButton) this.submitButton.disabled = !isValid;
	    return isValid;
	  };
	  async handleFormSubmit(event) {
	    event.preventDefault();
	    if (!this.inputValidation?.checkRequiredInputs({
	      inputs: this.inputs
	    }) || !this.handleFormValidation) return false;
	    const form = event.currentTarget;
	    const formData = new FormData(form);
	    if (this.submitButton) this.submitButton.disabled = true;
	    const newsletterEventSubscriptionHandler = await handleNewsletterEventSubscription(formData);
	    if (this.submitButton) {
	      if (!newsletterEventSubscriptionHandler.customerIsSubscribedToEvent) {
	        this.inputValidation?.triggerValidationEffect(this.submitButton, {
	          isValid: newsletterEventSubscriptionHandler.customerIsSubscribedToEvent,
	          error: newsletterEventSubscriptionHandler.errorType,
	          message: newsletterEventSubscriptionHandler.errorMessage
	        });
	      }
	      this.submitButton.disabled = !newsletterEventSubscriptionHandler.customerIsSubscribedToEvent;
	    }
	  }
	  init() {
	    this.initInputValidation({
	      inputs: this.inputs
	    });
	    this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
	    Object.values(this.inputs).forEach(input => {
	      return input.selector.addEventListener('blur', () => this.handleInputValidation(input));
	    });
	  }
	  destroy() {
	    this.form.removeEventListener('submit', this.handleFormSubmit.bind(this));
	    Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', () => this.handleInputValidation(input)));
	  }
	}
	var eventForm = async () => {
	  const newsletterEventForm = getElementsByRef('newsletter-event-form');
	  if (newsletterEventForm) {
	    try {
	      const form = new NewsletterEventForm({
	        formContainerId: 'newsletter-event-form-container'
	      });
	      return () => {
	        form.destroy();
	      };
	    } catch (error) {}
	  }
	};

	var eventForm$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: eventForm
	});

	/*!
	  * PhotoSwipe 5.4.4 - https://photoswipe.com
	  * (c) 2024 Dmytro Semenov
	  */
	/** @typedef {import('../photoswipe.js').Point} Point */

	/**
	 * @template {keyof HTMLElementTagNameMap} T
	 * @param {string} className
	 * @param {T} tagName
	 * @param {Node} [appendToEl]
	 * @returns {HTMLElementTagNameMap[T]}
	 */
	function createElement(className, tagName, appendToEl) {
	  const el = document.createElement(tagName);
	  if (className) {
	    el.className = className;
	  }
	  if (appendToEl) {
	    appendToEl.appendChild(el);
	  }
	  return el;
	}
	/**
	 * @param {Point} p1
	 * @param {Point} p2
	 * @returns {Point}
	 */

	function equalizePoints(p1, p2) {
	  p1.x = p2.x;
	  p1.y = p2.y;
	  if (p2.id !== undefined) {
	    p1.id = p2.id;
	  }
	  return p1;
	}
	/**
	 * @param {Point} p
	 */

	function roundPoint(p) {
	  p.x = Math.round(p.x);
	  p.y = Math.round(p.y);
	}
	/**
	 * Returns distance between two points.
	 *
	 * @param {Point} p1
	 * @param {Point} p2
	 * @returns {number}
	 */

	function getDistanceBetween(p1, p2) {
	  const x = Math.abs(p1.x - p2.x);
	  const y = Math.abs(p1.y - p2.y);
	  return Math.sqrt(x * x + y * y);
	}
	/**
	 * Whether X and Y positions of points are equal
	 *
	 * @param {Point} p1
	 * @param {Point} p2
	 * @returns {boolean}
	 */

	function pointsEqual(p1, p2) {
	  return p1.x === p2.x && p1.y === p2.y;
	}
	/**
	 * The float result between the min and max values.
	 *
	 * @param {number} val
	 * @param {number} min
	 * @param {number} max
	 * @returns {number}
	 */

	function clamp(val, min, max) {
	  return Math.min(Math.max(val, min), max);
	}
	/**
	 * Get transform string
	 *
	 * @param {number} x
	 * @param {number} [y]
	 * @param {number} [scale]
	 * @returns {string}
	 */

	function toTransformString(x, y, scale) {
	  let propValue = `translate3d(${x}px,${y || 0}px,0)`;
	  if (scale !== undefined) {
	    propValue += ` scale3d(${scale},${scale},1)`;
	  }
	  return propValue;
	}
	/**
	 * Apply transform:translate(x, y) scale(scale) to element
	 *
	 * @param {HTMLElement} el
	 * @param {number} x
	 * @param {number} [y]
	 * @param {number} [scale]
	 */

	function setTransform(el, x, y, scale) {
	  el.style.transform = toTransformString(x, y, scale);
	}
	const defaultCSSEasing = 'cubic-bezier(.4,0,.22,1)';
	/**
	 * Apply CSS transition to element
	 *
	 * @param {HTMLElement} el
	 * @param {string} [prop] CSS property to animate
	 * @param {number} [duration] in ms
	 * @param {string} [ease] CSS easing function
	 */

	function setTransitionStyle(el, prop, duration, ease) {
	  // inOut: 'cubic-bezier(.4, 0, .22, 1)', // for "toggle state" transitions
	  // out: 'cubic-bezier(0, 0, .22, 1)', // for "show" transitions
	  // in: 'cubic-bezier(.4, 0, 1, 1)'// for "hide" transitions
	  el.style.transition = prop ? `${prop} ${duration}ms ${ease || defaultCSSEasing}` : 'none';
	}
	/**
	 * Apply width and height CSS properties to element
	 *
	 * @param {HTMLElement} el
	 * @param {string | number} w
	 * @param {string | number} h
	 */

	function setWidthHeight(el, w, h) {
	  el.style.width = typeof w === 'number' ? `${w}px` : w;
	  el.style.height = typeof h === 'number' ? `${h}px` : h;
	}
	/**
	 * @param {HTMLElement} el
	 */

	function removeTransitionStyle(el) {
	  setTransitionStyle(el);
	}
	/**
	 * @param {HTMLImageElement} img
	 * @returns {Promise<HTMLImageElement | void>}
	 */

	function decodeImage(img) {
	  if ('decode' in img) {
	    return img.decode().catch(() => {});
	  }
	  if (img.complete) {
	    return Promise.resolve(img);
	  }
	  return new Promise((resolve, reject) => {
	    img.onload = () => resolve(img);
	    img.onerror = reject;
	  });
	}
	/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */

	/** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */

	const LOAD_STATE = {
	  IDLE: 'idle',
	  LOADING: 'loading',
	  LOADED: 'loaded',
	  ERROR: 'error'
	};
	/**
	 * Check if click or keydown event was dispatched
	 * with a special key or via mouse wheel.
	 *
	 * @param {MouseEvent | KeyboardEvent} e
	 * @returns {boolean}
	 */

	function specialKeyUsed(e) {
	  return 'button' in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
	}
	/**
	 * Parse `gallery` or `children` options.
	 *
	 * @param {import('../photoswipe.js').ElementProvider} [option]
	 * @param {string} [legacySelector]
	 * @param {HTMLElement | Document} [parent]
	 * @returns HTMLElement[]
	 */

	function getElementsFromOption(option, legacySelector, parent = document) {
	  /** @type {HTMLElement[]} */
	  let elements = [];
	  if (option instanceof Element) {
	    elements = [option];
	  } else if (option instanceof NodeList || Array.isArray(option)) {
	    elements = Array.from(option);
	  } else {
	    const selector = typeof option === 'string' ? option : legacySelector;
	    if (selector) {
	      elements = Array.from(parent.querySelectorAll(selector));
	    }
	  }
	  return elements;
	}
	/**
	 * Check if browser is Safari
	 *
	 * @returns {boolean}
	 */

	function isSafari() {
	  return !!(navigator.vendor && navigator.vendor.match(/apple/i));
	}

	// Detect passive event listener support
	let supportsPassive = false;
	/* eslint-disable */

	try {
	  /* @ts-ignore */
	  window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
	    get: () => {
	      supportsPassive = true;
	    }
	  }));
	} catch (e) {}
	/* eslint-enable */

	/**
	 * @typedef {Object} PoolItem
	 * @prop {HTMLElement | Window | Document | undefined | null} target
	 * @prop {string} type
	 * @prop {EventListenerOrEventListenerObject} listener
	 * @prop {boolean} [passive]
	 */

	class DOMEvents {
	  constructor() {
	    /**
	     * @type {PoolItem[]}
	     * @private
	     */
	    this._pool = [];
	  }
	  /**
	   * Adds event listeners
	   *
	   * @param {PoolItem['target']} target
	   * @param {PoolItem['type']} type Can be multiple, separated by space.
	   * @param {PoolItem['listener']} listener
	   * @param {PoolItem['passive']} [passive]
	   */

	  add(target, type, listener, passive) {
	    this._toggleListener(target, type, listener, passive);
	  }
	  /**
	   * Removes event listeners
	   *
	   * @param {PoolItem['target']} target
	   * @param {PoolItem['type']} type
	   * @param {PoolItem['listener']} listener
	   * @param {PoolItem['passive']} [passive]
	   */

	  remove(target, type, listener, passive) {
	    this._toggleListener(target, type, listener, passive, true);
	  }
	  /**
	   * Removes all bound events
	   */

	  removeAll() {
	    this._pool.forEach(poolItem => {
	      this._toggleListener(poolItem.target, poolItem.type, poolItem.listener, poolItem.passive, true, true);
	    });
	    this._pool = [];
	  }
	  /**
	   * Adds or removes event
	   *
	   * @private
	   * @param {PoolItem['target']} target
	   * @param {PoolItem['type']} type
	   * @param {PoolItem['listener']} listener
	   * @param {PoolItem['passive']} [passive]
	   * @param {boolean} [unbind] Whether the event should be added or removed
	   * @param {boolean} [skipPool] Whether events pool should be skipped
	   */

	  _toggleListener(target, type, listener, passive, unbind, skipPool) {
	    if (!target) {
	      return;
	    }
	    const methodName = unbind ? 'removeEventListener' : 'addEventListener';
	    const types = type.split(' ');
	    types.forEach(eType => {
	      if (eType) {
	        // Events pool is used to easily unbind all events when PhotoSwipe is closed,
	        // so developer doesn't need to do this manually
	        if (!skipPool) {
	          if (unbind) {
	            // Remove from the events pool
	            this._pool = this._pool.filter(poolItem => {
	              return poolItem.type !== eType || poolItem.listener !== listener || poolItem.target !== target;
	            });
	          } else {
	            // Add to the events pool
	            this._pool.push({
	              target,
	              type: eType,
	              listener,
	              passive
	            });
	          }
	        } // most PhotoSwipe events call preventDefault,
	        // and we do not need browser to scroll the page

	        const eventOptions = supportsPassive ? {
	          passive: passive || false
	        } : false;
	        target[methodName](eType, listener, eventOptions);
	      }
	    });
	  }
	}

	/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

	/** @typedef {import('../core/base.js').default} PhotoSwipeBase */

	/** @typedef {import('../photoswipe.js').Point} Point */

	/** @typedef {import('../slide/slide.js').SlideData} SlideData */

	/**
	 * @param {PhotoSwipeOptions} options
	 * @param {PhotoSwipeBase} pswp
	 * @returns {Point}
	 */
	function getViewportSize(options, pswp) {
	  if (options.getViewportSizeFn) {
	    const newViewportSize = options.getViewportSizeFn(options, pswp);
	    if (newViewportSize) {
	      return newViewportSize;
	    }
	  }
	  return {
	    x: document.documentElement.clientWidth,
	    // TODO: height on mobile is very incosistent due to toolbar
	    // find a way to improve this
	    //
	    // document.documentElement.clientHeight - doesn't seem to work well
	    y: window.innerHeight
	  };
	}
	/**
	 * Parses padding option.
	 * Supported formats:
	 *
	 * // Object
	 * padding: {
	 *  top: 0,
	 *  bottom: 0,
	 *  left: 0,
	 *  right: 0
	 * }
	 *
	 * // A function that returns the object
	 * paddingFn: (viewportSize, itemData, index) => {
	 *  return {
	 *    top: 0,
	 *    bottom: 0,
	 *    left: 0,
	 *    right: 0
	 *  };
	 * }
	 *
	 * // Legacy variant
	 * paddingLeft: 0,
	 * paddingRight: 0,
	 * paddingTop: 0,
	 * paddingBottom: 0,
	 *
	 * @param {'left' | 'top' | 'bottom' | 'right'} prop
	 * @param {PhotoSwipeOptions} options PhotoSwipe options
	 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
	 * @param {SlideData} itemData Data about the slide
	 * @param {number} index Slide index
	 * @returns {number}
	 */

	function parsePaddingOption(prop, options, viewportSize, itemData, index) {
	  let paddingValue = 0;
	  if (options.paddingFn) {
	    paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
	  } else if (options.padding) {
	    paddingValue = options.padding[prop];
	  } else {
	    const legacyPropName = 'padding' + prop[0].toUpperCase() + prop.slice(1); // @ts-expect-error

	    if (options[legacyPropName]) {
	      // @ts-expect-error
	      paddingValue = options[legacyPropName];
	    }
	  }
	  return Number(paddingValue) || 0;
	}
	/**
	 * @param {PhotoSwipeOptions} options
	 * @param {Point} viewportSize
	 * @param {SlideData} itemData
	 * @param {number} index
	 * @returns {Point}
	 */

	function getPanAreaSize(options, viewportSize, itemData, index) {
	  return {
	    x: viewportSize.x - parsePaddingOption('left', options, viewportSize, itemData, index) - parsePaddingOption('right', options, viewportSize, itemData, index),
	    y: viewportSize.y - parsePaddingOption('top', options, viewportSize, itemData, index) - parsePaddingOption('bottom', options, viewportSize, itemData, index)
	  };
	}

	/** @typedef {import('./slide.js').default} Slide */

	/** @typedef {Record<Axis, number>} Point */

	/** @typedef {'x' | 'y'} Axis */

	/**
	 * Calculates minimum, maximum and initial (center) bounds of a slide
	 */

	class PanBounds {
	  /**
	   * @param {Slide} slide
	   */
	  constructor(slide) {
	    this.slide = slide;
	    this.currZoomLevel = 1;
	    this.center = /** @type {Point} */
	    {
	      x: 0,
	      y: 0
	    };
	    this.max = /** @type {Point} */
	    {
	      x: 0,
	      y: 0
	    };
	    this.min = /** @type {Point} */
	    {
	      x: 0,
	      y: 0
	    };
	  }
	  /**
	   * _getItemBounds
	   *
	   * @param {number} currZoomLevel
	   */

	  update(currZoomLevel) {
	    this.currZoomLevel = currZoomLevel;
	    if (!this.slide.width) {
	      this.reset();
	    } else {
	      this._updateAxis('x');
	      this._updateAxis('y');
	      this.slide.pswp.dispatch('calcBounds', {
	        slide: this.slide
	      });
	    }
	  }
	  /**
	   * _calculateItemBoundsForAxis
	   *
	   * @param {Axis} axis
	   */

	  _updateAxis(axis) {
	    const {
	      pswp
	    } = this.slide;
	    const elSize = this.slide[axis === 'x' ? 'width' : 'height'] * this.currZoomLevel;
	    const paddingProp = axis === 'x' ? 'left' : 'top';
	    const padding = parsePaddingOption(paddingProp, pswp.options, pswp.viewportSize, this.slide.data, this.slide.index);
	    const panAreaSize = this.slide.panAreaSize[axis]; // Default position of element.
	    // By default, it is center of viewport:

	    this.center[axis] = Math.round((panAreaSize - elSize) / 2) + padding; // maximum pan position

	    this.max[axis] = elSize > panAreaSize ? Math.round(panAreaSize - elSize) + padding : this.center[axis]; // minimum pan position

	    this.min[axis] = elSize > panAreaSize ? padding : this.center[axis];
	  } // _getZeroBounds

	  reset() {
	    this.center.x = 0;
	    this.center.y = 0;
	    this.max.x = 0;
	    this.max.y = 0;
	    this.min.x = 0;
	    this.min.y = 0;
	  }
	  /**
	   * Correct pan position if it's beyond the bounds
	   *
	   * @param {Axis} axis x or y
	   * @param {number} panOffset
	   * @returns {number}
	   */

	  correctPan(axis, panOffset) {
	    // checkPanBounds
	    return clamp(panOffset, this.max[axis], this.min[axis]);
	  }
	}
	const MAX_IMAGE_WIDTH = 4000;
	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

	/** @typedef {import('../photoswipe.js').Point} Point */

	/** @typedef {import('../slide/slide.js').SlideData} SlideData */

	/** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */

	/**
	 * Calculates zoom levels for specific slide.
	 * Depends on viewport size and image size.
	 */

	class ZoomLevel {
	  /**
	   * @param {PhotoSwipeOptions} options PhotoSwipe options
	   * @param {SlideData} itemData Slide data
	   * @param {number} index Slide index
	   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
	   */
	  constructor(options, itemData, index, pswp) {
	    this.pswp = pswp;
	    this.options = options;
	    this.itemData = itemData;
	    this.index = index;
	    /** @type { Point | null } */

	    this.panAreaSize = null;
	    /** @type { Point | null } */

	    this.elementSize = null;
	    this.fit = 1;
	    this.fill = 1;
	    this.vFill = 1;
	    this.initial = 1;
	    this.secondary = 1;
	    this.max = 1;
	    this.min = 1;
	  }
	  /**
	   * Calculate initial, secondary and maximum zoom level for the specified slide.
	   *
	   * It should be called when either image or viewport size changes.
	   *
	   * @param {number} maxWidth
	   * @param {number} maxHeight
	   * @param {Point} panAreaSize
	   */

	  update(maxWidth, maxHeight, panAreaSize) {
	    /** @type {Point} */
	    const elementSize = {
	      x: maxWidth,
	      y: maxHeight
	    };
	    this.elementSize = elementSize;
	    this.panAreaSize = panAreaSize;
	    const hRatio = panAreaSize.x / elementSize.x;
	    const vRatio = panAreaSize.y / elementSize.y;
	    this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
	    this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio); // zoom.vFill defines zoom level of the image
	    // when it has 100% of viewport vertical space (height)

	    this.vFill = Math.min(1, vRatio);
	    this.initial = this._getInitial();
	    this.secondary = this._getSecondary();
	    this.max = Math.max(this.initial, this.secondary, this._getMax());
	    this.min = Math.min(this.fit, this.initial, this.secondary);
	    if (this.pswp) {
	      this.pswp.dispatch('zoomLevelsUpdate', {
	        zoomLevels: this,
	        slideData: this.itemData
	      });
	    }
	  }
	  /**
	   * Parses user-defined zoom option.
	   *
	   * @private
	   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
	   * @returns { number | undefined }
	   */

	  _parseZoomLevelOption(optionPrefix) {
	    const optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */
	    optionPrefix + 'ZoomLevel';
	    const optionValue = this.options[optionName];
	    if (!optionValue) {
	      return;
	    }
	    if (typeof optionValue === 'function') {
	      return optionValue(this);
	    }
	    if (optionValue === 'fill') {
	      return this.fill;
	    }
	    if (optionValue === 'fit') {
	      return this.fit;
	    }
	    return Number(optionValue);
	  }
	  /**
	   * Get zoom level to which image will be zoomed after double-tap gesture,
	   * or when user clicks on zoom icon,
	   * or mouse-click on image itself.
	   * If you return 1 image will be zoomed to its original size.
	   *
	   * @private
	   * @return {number}
	   */

	  _getSecondary() {
	    let currZoomLevel = this._parseZoomLevelOption('secondary');
	    if (currZoomLevel) {
	      return currZoomLevel;
	    } // 3x of "fit" state, but not larger than original

	    currZoomLevel = Math.min(1, this.fit * 3);
	    if (this.elementSize && currZoomLevel * this.elementSize.x > MAX_IMAGE_WIDTH) {
	      currZoomLevel = MAX_IMAGE_WIDTH / this.elementSize.x;
	    }
	    return currZoomLevel;
	  }
	  /**
	   * Get initial image zoom level.
	   *
	   * @private
	   * @return {number}
	   */

	  _getInitial() {
	    return this._parseZoomLevelOption('initial') || this.fit;
	  }
	  /**
	   * Maximum zoom level when user zooms
	   * via zoom/pinch gesture,
	   * via cmd/ctrl-wheel or via trackpad.
	   *
	   * @private
	   * @return {number}
	   */

	  _getMax() {
	    // max zoom level is x4 from "fit state",
	    // used for zoom gesture and ctrl/trackpad zoom
	    return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
	  }
	}

	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */
	/**
	 * Renders and allows to control a single slide
	 */

	class Slide {
	  /**
	   * @param {SlideData} data
	   * @param {number} index
	   * @param {PhotoSwipe} pswp
	   */
	  constructor(data, index, pswp) {
	    this.data = data;
	    this.index = index;
	    this.pswp = pswp;
	    this.isActive = index === pswp.currIndex;
	    this.currentResolution = 0;
	    /** @type {Point} */

	    this.panAreaSize = {
	      x: 0,
	      y: 0
	    };
	    /** @type {Point} */

	    this.pan = {
	      x: 0,
	      y: 0
	    };
	    this.isFirstSlide = this.isActive && !pswp.opener.isOpen;
	    this.zoomLevels = new ZoomLevel(pswp.options, data, index, pswp);
	    this.pswp.dispatch('gettingData', {
	      slide: this,
	      data: this.data,
	      index
	    });
	    this.content = this.pswp.contentLoader.getContentBySlide(this);
	    this.container = createElement('pswp__zoom-wrap', 'div');
	    /** @type {HTMLElement | null} */

	    this.holderElement = null;
	    this.currZoomLevel = 1;
	    /** @type {number} */

	    this.width = this.content.width;
	    /** @type {number} */

	    this.height = this.content.height;
	    this.heavyAppended = false;
	    this.bounds = new PanBounds(this);
	    this.prevDisplayedWidth = -1;
	    this.prevDisplayedHeight = -1;
	    this.pswp.dispatch('slideInit', {
	      slide: this
	    });
	  }
	  /**
	   * If this slide is active/current/visible
	   *
	   * @param {boolean} isActive
	   */

	  setIsActive(isActive) {
	    if (isActive && !this.isActive) {
	      // slide just became active
	      this.activate();
	    } else if (!isActive && this.isActive) {
	      // slide just became non-active
	      this.deactivate();
	    }
	  }
	  /**
	   * Appends slide content to DOM
	   *
	   * @param {HTMLElement} holderElement
	   */

	  append(holderElement) {
	    this.holderElement = holderElement;
	    this.container.style.transformOrigin = '0 0'; // Slide appended to DOM

	    if (!this.data) {
	      return;
	    }
	    this.calculateSize();
	    this.load();
	    this.updateContentSize();
	    this.appendHeavy();
	    this.holderElement.appendChild(this.container);
	    this.zoomAndPanToInitial();
	    this.pswp.dispatch('firstZoomPan', {
	      slide: this
	    });
	    this.applyCurrentZoomPan();
	    this.pswp.dispatch('afterSetContent', {
	      slide: this
	    });
	    if (this.isActive) {
	      this.activate();
	    }
	  }
	  load() {
	    this.content.load(false);
	    this.pswp.dispatch('slideLoad', {
	      slide: this
	    });
	  }
	  /**
	   * Append "heavy" DOM elements
	   *
	   * This may depend on a type of slide,
	   * but generally these are large images.
	   */

	  appendHeavy() {
	    const {
	      pswp
	    } = this;
	    const appendHeavyNearby = true; // todo
	    // Avoid appending heavy elements during animations

	    if (this.heavyAppended || !pswp.opener.isOpen || pswp.mainScroll.isShifted() || !this.isActive && !appendHeavyNearby) {
	      return;
	    }
	    if (this.pswp.dispatch('appendHeavy', {
	      slide: this
	    }).defaultPrevented) {
	      return;
	    }
	    this.heavyAppended = true;
	    this.content.append();
	    this.pswp.dispatch('appendHeavyContent', {
	      slide: this
	    });
	  }
	  /**
	   * Triggered when this slide is active (selected).
	   *
	   * If it's part of opening/closing transition -
	   * activate() will trigger after the transition is ended.
	   */

	  activate() {
	    this.isActive = true;
	    this.appendHeavy();
	    this.content.activate();
	    this.pswp.dispatch('slideActivate', {
	      slide: this
	    });
	  }
	  /**
	   * Triggered when this slide becomes inactive.
	   *
	   * Slide can become inactive only after it was active.
	   */

	  deactivate() {
	    this.isActive = false;
	    this.content.deactivate();
	    if (this.currZoomLevel !== this.zoomLevels.initial) {
	      // allow filtering
	      this.calculateSize();
	    } // reset zoom level

	    this.currentResolution = 0;
	    this.zoomAndPanToInitial();
	    this.applyCurrentZoomPan();
	    this.updateContentSize();
	    this.pswp.dispatch('slideDeactivate', {
	      slide: this
	    });
	  }
	  /**
	   * The slide should destroy itself, it will never be used again.
	   * (unbind all events and destroy internal components)
	   */

	  destroy() {
	    this.content.hasSlide = false;
	    this.content.remove();
	    this.container.remove();
	    this.pswp.dispatch('slideDestroy', {
	      slide: this
	    });
	  }
	  resize() {
	    if (this.currZoomLevel === this.zoomLevels.initial || !this.isActive) {
	      // Keep initial zoom level if it was before the resize,
	      // as well as when this slide is not active
	      // Reset position and scale to original state
	      this.calculateSize();
	      this.currentResolution = 0;
	      this.zoomAndPanToInitial();
	      this.applyCurrentZoomPan();
	      this.updateContentSize();
	    } else {
	      // readjust pan position if it's beyond the bounds
	      this.calculateSize();
	      this.bounds.update(this.currZoomLevel);
	      this.panTo(this.pan.x, this.pan.y);
	    }
	  }
	  /**
	   * Apply size to current slide content,
	   * based on the current resolution and scale.
	   *
	   * @param {boolean} [force] if size should be updated even if dimensions weren't changed
	   */

	  updateContentSize(force) {
	    // Use initial zoom level
	    // if resolution is not defined (user didn't zoom yet)
	    const scaleMultiplier = this.currentResolution || this.zoomLevels.initial;
	    if (!scaleMultiplier) {
	      return;
	    }
	    const width = Math.round(this.width * scaleMultiplier) || this.pswp.viewportSize.x;
	    const height = Math.round(this.height * scaleMultiplier) || this.pswp.viewportSize.y;
	    if (!this.sizeChanged(width, height) && !force) {
	      return;
	    }
	    this.content.setDisplayedSize(width, height);
	  }
	  /**
	   * @param {number} width
	   * @param {number} height
	   */

	  sizeChanged(width, height) {
	    if (width !== this.prevDisplayedWidth || height !== this.prevDisplayedHeight) {
	      this.prevDisplayedWidth = width;
	      this.prevDisplayedHeight = height;
	      return true;
	    }
	    return false;
	  }
	  /** @returns {HTMLImageElement | HTMLDivElement | null | undefined} */

	  getPlaceholderElement() {
	    var _this$content$placeho;
	    return (_this$content$placeho = this.content.placeholder) === null || _this$content$placeho === void 0 ? void 0 : _this$content$placeho.element;
	  }
	  /**
	   * Zoom current slide image to...
	   *
	   * @param {number} destZoomLevel Destination zoom level.
	   * @param {Point} [centerPoint]
	   * Transform origin center point, or false if viewport center should be used.
	   * @param {number | false} [transitionDuration] Transition duration, may be set to 0.
	   * @param {boolean} [ignoreBounds] Minimum and maximum zoom levels will be ignored.
	   */

	  zoomTo(destZoomLevel, centerPoint, transitionDuration, ignoreBounds) {
	    const {
	      pswp
	    } = this;
	    if (!this.isZoomable() || pswp.mainScroll.isShifted()) {
	      return;
	    }
	    pswp.dispatch('beforeZoomTo', {
	      destZoomLevel,
	      centerPoint,
	      transitionDuration
	    }); // stop all pan and zoom transitions

	    pswp.animations.stopAllPan(); // if (!centerPoint) {
	    //   centerPoint = pswp.getViewportCenterPoint();
	    // }

	    const prevZoomLevel = this.currZoomLevel;
	    if (!ignoreBounds) {
	      destZoomLevel = clamp(destZoomLevel, this.zoomLevels.min, this.zoomLevels.max);
	    } // if (transitionDuration === undefined) {
	    //   transitionDuration = this.pswp.options.zoomAnimationDuration;
	    // }

	    this.setZoomLevel(destZoomLevel);
	    this.pan.x = this.calculateZoomToPanOffset('x', centerPoint, prevZoomLevel);
	    this.pan.y = this.calculateZoomToPanOffset('y', centerPoint, prevZoomLevel);
	    roundPoint(this.pan);
	    const finishTransition = () => {
	      this._setResolution(destZoomLevel);
	      this.applyCurrentZoomPan();
	    };
	    if (!transitionDuration) {
	      finishTransition();
	    } else {
	      pswp.animations.startTransition({
	        isPan: true,
	        name: 'zoomTo',
	        target: this.container,
	        transform: this.getCurrentTransform(),
	        onComplete: finishTransition,
	        duration: transitionDuration,
	        easing: pswp.options.easing
	      });
	    }
	  }
	  /**
	   * @param {Point} [centerPoint]
	   */

	  toggleZoom(centerPoint) {
	    this.zoomTo(this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial, centerPoint, this.pswp.options.zoomAnimationDuration);
	  }
	  /**
	   * Updates zoom level property and recalculates new pan bounds,
	   * unlike zoomTo it does not apply transform (use applyCurrentZoomPan)
	   *
	   * @param {number} currZoomLevel
	   */

	  setZoomLevel(currZoomLevel) {
	    this.currZoomLevel = currZoomLevel;
	    this.bounds.update(this.currZoomLevel);
	  }
	  /**
	   * Get pan position after zoom at a given `point`.
	   *
	   * Always call setZoomLevel(newZoomLevel) beforehand to recalculate
	   * pan bounds according to the new zoom level.
	   *
	   * @param {'x' | 'y'} axis
	   * @param {Point} [point]
	   * point based on which zoom is performed, usually refers to the current mouse position,
	   * if false - viewport center will be used.
	   * @param {number} [prevZoomLevel] Zoom level before new zoom was applied.
	   * @returns {number}
	   */

	  calculateZoomToPanOffset(axis, point, prevZoomLevel) {
	    const totalPanDistance = this.bounds.max[axis] - this.bounds.min[axis];
	    if (totalPanDistance === 0) {
	      return this.bounds.center[axis];
	    }
	    if (!point) {
	      point = this.pswp.getViewportCenterPoint();
	    }
	    if (!prevZoomLevel) {
	      prevZoomLevel = this.zoomLevels.initial;
	    }
	    const zoomFactor = this.currZoomLevel / prevZoomLevel;
	    return this.bounds.correctPan(axis, (this.pan[axis] - point[axis]) * zoomFactor + point[axis]);
	  }
	  /**
	   * Apply pan and keep it within bounds.
	   *
	   * @param {number} panX
	   * @param {number} panY
	   */

	  panTo(panX, panY) {
	    this.pan.x = this.bounds.correctPan('x', panX);
	    this.pan.y = this.bounds.correctPan('y', panY);
	    this.applyCurrentZoomPan();
	  }
	  /**
	   * If the slide in the current state can be panned by the user
	   * @returns {boolean}
	   */

	  isPannable() {
	    return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
	  }
	  /**
	   * If the slide can be zoomed
	   * @returns {boolean}
	   */

	  isZoomable() {
	    return Boolean(this.width) && this.content.isZoomable();
	  }
	  /**
	   * Apply transform and scale based on
	   * the current pan position (this.pan) and zoom level (this.currZoomLevel)
	   */

	  applyCurrentZoomPan() {
	    this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel);
	    if (this === this.pswp.currSlide) {
	      this.pswp.dispatch('zoomPanUpdate', {
	        slide: this
	      });
	    }
	  }
	  zoomAndPanToInitial() {
	    this.currZoomLevel = this.zoomLevels.initial; // pan according to the zoom level

	    this.bounds.update(this.currZoomLevel);
	    equalizePoints(this.pan, this.bounds.center);
	    this.pswp.dispatch('initialZoomPan', {
	      slide: this
	    });
	  }
	  /**
	   * Set translate and scale based on current resolution
	   *
	   * @param {number} x
	   * @param {number} y
	   * @param {number} zoom
	   * @private
	   */

	  _applyZoomTransform(x, y, zoom) {
	    zoom /= this.currentResolution || this.zoomLevels.initial;
	    setTransform(this.container, x, y, zoom);
	  }
	  calculateSize() {
	    const {
	      pswp
	    } = this;
	    equalizePoints(this.panAreaSize, getPanAreaSize(pswp.options, pswp.viewportSize, this.data, this.index));
	    this.zoomLevels.update(this.width, this.height, this.panAreaSize);
	    pswp.dispatch('calcSlideSize', {
	      slide: this
	    });
	  }
	  /** @returns {string} */

	  getCurrentTransform() {
	    const scale = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
	    return toTransformString(this.pan.x, this.pan.y, scale);
	  }
	  /**
	   * Set resolution and re-render the image.
	   *
	   * For example, if the real image size is 2000x1500,
	   * and resolution is 0.5 - it will be rendered as 1000x750.
	   *
	   * Image with zoom level 2 and resolution 0.5 is
	   * the same as image with zoom level 1 and resolution 1.
	   *
	   * Used to optimize animations and make
	   * sure that browser renders image in the highest quality.
	   * Also used by responsive images to load the correct one.
	   *
	   * @param {number} newResolution
	   */

	  _setResolution(newResolution) {
	    if (newResolution === this.currentResolution) {
	      return;
	    }
	    this.currentResolution = newResolution;
	    this.updateContentSize();
	    this.pswp.dispatch('resolutionChanged');
	  }
	}

	/** @typedef {import('../photoswipe.js').Point} Point */

	/** @typedef {import('./gestures.js').default} Gestures */

	const PAN_END_FRICTION = 0.35;
	const VERTICAL_DRAG_FRICTION = 0.6; // 1 corresponds to the third of viewport height

	const MIN_RATIO_TO_CLOSE = 0.4; // Minimum speed required to navigate
	// to next or previous slide

	const MIN_NEXT_SLIDE_SPEED = 0.5;
	/**
	 * @param {number} initialVelocity
	 * @param {number} decelerationRate
	 * @returns {number}
	 */

	function project(initialVelocity, decelerationRate) {
	  return initialVelocity * decelerationRate / (1 - decelerationRate);
	}
	/**
	 * Handles single pointer dragging
	 */

	class DragHandler {
	  /**
	   * @param {Gestures} gestures
	   */
	  constructor(gestures) {
	    this.gestures = gestures;
	    this.pswp = gestures.pswp;
	    /** @type {Point} */

	    this.startPan = {
	      x: 0,
	      y: 0
	    };
	  }
	  start() {
	    if (this.pswp.currSlide) {
	      equalizePoints(this.startPan, this.pswp.currSlide.pan);
	    }
	    this.pswp.animations.stopAll();
	  }
	  change() {
	    const {
	      p1,
	      prevP1,
	      dragAxis
	    } = this.gestures;
	    const {
	      currSlide
	    } = this.pswp;
	    if (dragAxis === 'y' && this.pswp.options.closeOnVerticalDrag && currSlide && currSlide.currZoomLevel <= currSlide.zoomLevels.fit && !this.gestures.isMultitouch) {
	      // Handle vertical drag to close
	      const panY = currSlide.pan.y + (p1.y - prevP1.y);
	      if (!this.pswp.dispatch('verticalDrag', {
	        panY
	      }).defaultPrevented) {
	        this._setPanWithFriction('y', panY, VERTICAL_DRAG_FRICTION);
	        const bgOpacity = 1 - Math.abs(this._getVerticalDragRatio(currSlide.pan.y));
	        this.pswp.applyBgOpacity(bgOpacity);
	        currSlide.applyCurrentZoomPan();
	      }
	    } else {
	      const mainScrollChanged = this._panOrMoveMainScroll('x');
	      if (!mainScrollChanged) {
	        this._panOrMoveMainScroll('y');
	        if (currSlide) {
	          roundPoint(currSlide.pan);
	          currSlide.applyCurrentZoomPan();
	        }
	      }
	    }
	  }
	  end() {
	    const {
	      velocity
	    } = this.gestures;
	    const {
	      mainScroll,
	      currSlide
	    } = this.pswp;
	    let indexDiff = 0;
	    this.pswp.animations.stopAll(); // Handle main scroll if it's shifted

	    if (mainScroll.isShifted()) {
	      // Position of the main scroll relative to the viewport
	      const mainScrollShiftDiff = mainScroll.x - mainScroll.getCurrSlideX(); // Ratio between 0 and 1:
	      // 0 - slide is not visible at all,
	      // 0.5 - half of the slide is visible
	      // 1 - slide is fully visible

	      const currentSlideVisibilityRatio = mainScrollShiftDiff / this.pswp.viewportSize.x; // Go next slide.
	      //
	      // - if velocity and its direction is matched,
	      //   and we see at least tiny part of the next slide
	      //
	      // - or if we see less than 50% of the current slide
	      //   and velocity is close to 0
	      //

	      if (velocity.x < -MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio < 0 || velocity.x < 0.1 && currentSlideVisibilityRatio < -0.5) {
	        // Go to next slide
	        indexDiff = 1;
	        velocity.x = Math.min(velocity.x, 0);
	      } else if (velocity.x > MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio > 0 || velocity.x > -0.1 && currentSlideVisibilityRatio > 0.5) {
	        // Go to prev slide
	        indexDiff = -1;
	        velocity.x = Math.max(velocity.x, 0);
	      }
	      mainScroll.moveIndexBy(indexDiff, true, velocity.x);
	    } // Restore zoom level

	    if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.max || this.gestures.isMultitouch) {
	      this.gestures.zoomLevels.correctZoomPan(true);
	    } else {
	      // we run two animations instead of one,
	      // as each axis has own pan boundaries and thus different spring function
	      // (correctZoomPan does not have this functionality,
	      //  it animates all properties with single timing function)
	      this._finishPanGestureForAxis('x');
	      this._finishPanGestureForAxis('y');
	    }
	  }
	  /**
	   * @private
	   * @param {'x' | 'y'} axis
	   */

	  _finishPanGestureForAxis(axis) {
	    const {
	      velocity
	    } = this.gestures;
	    const {
	      currSlide
	    } = this.pswp;
	    if (!currSlide) {
	      return;
	    }
	    const {
	      pan,
	      bounds
	    } = currSlide;
	    const panPos = pan[axis];
	    const restoreBgOpacity = this.pswp.bgOpacity < 1 && axis === 'y'; // 0.995 means - scroll view loses 0.5% of its velocity per millisecond
	    // Increasing this number will reduce travel distance

	    const decelerationRate = 0.995; // 0.99
	    // Pan position if there is no bounds

	    const projectedPosition = panPos + project(velocity[axis], decelerationRate);
	    if (restoreBgOpacity) {
	      const vDragRatio = this._getVerticalDragRatio(panPos);
	      const projectedVDragRatio = this._getVerticalDragRatio(projectedPosition); // If we are above and moving upwards,
	      // or if we are below and moving downwards

	      if (vDragRatio < 0 && projectedVDragRatio < -MIN_RATIO_TO_CLOSE || vDragRatio > 0 && projectedVDragRatio > MIN_RATIO_TO_CLOSE) {
	        this.pswp.close();
	        return;
	      }
	    } // Pan position with corrected bounds

	    const correctedPanPosition = bounds.correctPan(axis, projectedPosition); // Exit if pan position should not be changed
	    // or if speed it too low

	    if (panPos === correctedPanPosition) {
	      return;
	    } // Overshoot if the final position is out of pan bounds

	    const dampingRatio = correctedPanPosition === projectedPosition ? 1 : 0.82;
	    const initialBgOpacity = this.pswp.bgOpacity;
	    const totalPanDist = correctedPanPosition - panPos;
	    this.pswp.animations.startSpring({
	      name: 'panGesture' + axis,
	      isPan: true,
	      start: panPos,
	      end: correctedPanPosition,
	      velocity: velocity[axis],
	      dampingRatio,
	      onUpdate: pos => {
	        // Animate opacity of background relative to Y pan position of an image
	        if (restoreBgOpacity && this.pswp.bgOpacity < 1) {
	          // 0 - start of animation, 1 - end of animation
	          const animationProgressRatio = 1 - (correctedPanPosition - pos) / totalPanDist; // We clamp opacity to keep it between 0 and 1.
	          // As progress ratio can be larger than 1 due to overshoot,
	          // and we do not want to bounce opacity.

	          this.pswp.applyBgOpacity(clamp(initialBgOpacity + (1 - initialBgOpacity) * animationProgressRatio, 0, 1));
	        }
	        pan[axis] = Math.floor(pos);
	        currSlide.applyCurrentZoomPan();
	      }
	    });
	  }
	  /**
	   * Update position of the main scroll,
	   * or/and update pan position of the current slide.
	   *
	   * Should return true if it changes (or can change) main scroll.
	   *
	   * @private
	   * @param {'x' | 'y'} axis
	   * @returns {boolean}
	   */

	  _panOrMoveMainScroll(axis) {
	    const {
	      p1,
	      dragAxis,
	      prevP1,
	      isMultitouch
	    } = this.gestures;
	    const {
	      currSlide,
	      mainScroll
	    } = this.pswp;
	    const delta = p1[axis] - prevP1[axis];
	    const newMainScrollX = mainScroll.x + delta;
	    if (!delta || !currSlide) {
	      return false;
	    } // Always move main scroll if image can not be panned

	    if (axis === 'x' && !currSlide.isPannable() && !isMultitouch) {
	      mainScroll.moveTo(newMainScrollX, true);
	      return true; // changed main scroll
	    }
	    const {
	      bounds
	    } = currSlide;
	    const newPan = currSlide.pan[axis] + delta;
	    if (this.pswp.options.allowPanToNext && dragAxis === 'x' && axis === 'x' && !isMultitouch) {
	      const currSlideMainScrollX = mainScroll.getCurrSlideX(); // Position of the main scroll relative to the viewport

	      const mainScrollShiftDiff = mainScroll.x - currSlideMainScrollX;
	      const isLeftToRight = delta > 0;
	      const isRightToLeft = !isLeftToRight;
	      if (newPan > bounds.min[axis] && isLeftToRight) {
	        // Panning from left to right, beyond the left edge
	        // Wether the image was at minimum pan position (or less)
	        // when this drag gesture started.
	        // Minimum pan position refers to the left edge of the image.
	        const wasAtMinPanPosition = bounds.min[axis] <= this.startPan[axis];
	        if (wasAtMinPanPosition) {
	          mainScroll.moveTo(newMainScrollX, true);
	          return true;
	        } else {
	          this._setPanWithFriction(axis, newPan); //currSlide.pan[axis] = newPan;
	        }
	      } else if (newPan < bounds.max[axis] && isRightToLeft) {
	        // Paning from right to left, beyond the right edge
	        // Maximum pan position refers to the right edge of the image.
	        const wasAtMaxPanPosition = this.startPan[axis] <= bounds.max[axis];
	        if (wasAtMaxPanPosition) {
	          mainScroll.moveTo(newMainScrollX, true);
	          return true;
	        } else {
	          this._setPanWithFriction(axis, newPan); //currSlide.pan[axis] = newPan;
	        }
	      } else {
	        // If main scroll is shifted
	        if (mainScrollShiftDiff !== 0) {
	          // If main scroll is shifted right
	          if (mainScrollShiftDiff > 0
	          /*&& isRightToLeft*/) {
	            mainScroll.moveTo(Math.max(newMainScrollX, currSlideMainScrollX), true);
	            return true;
	          } else if (mainScrollShiftDiff < 0
	          /*&& isLeftToRight*/) {
	            // Main scroll is shifted left (Position is less than 0 comparing to the viewport 0)
	            mainScroll.moveTo(Math.min(newMainScrollX, currSlideMainScrollX), true);
	            return true;
	          }
	        } else {
	          // We are within pan bounds, so just pan
	          this._setPanWithFriction(axis, newPan);
	        }
	      }
	    } else {
	      if (axis === 'y') {
	        // Do not pan vertically if main scroll is shifted o
	        if (!mainScroll.isShifted() && bounds.min.y !== bounds.max.y) {
	          this._setPanWithFriction(axis, newPan);
	        }
	      } else {
	        this._setPanWithFriction(axis, newPan);
	      }
	    }
	    return false;
	  } // If we move above - the ratio is negative
	  // If we move below the ratio is positive

	  /**
	   * Relation between pan Y position and third of viewport height.
	   *
	   * When we are at initial position (center bounds) - the ratio is 0,
	   * if position is shifted upwards - the ratio is negative,
	   * if position is shifted downwards - the ratio is positive.
	   *
	   * @private
	   * @param {number} panY The current pan Y position.
	   * @returns {number}
	   */

	  _getVerticalDragRatio(panY) {
	    var _this$pswp$currSlide$, _this$pswp$currSlide;
	    return (panY - ((_this$pswp$currSlide$ = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.bounds.center.y) !== null && _this$pswp$currSlide$ !== void 0 ? _this$pswp$currSlide$ : 0)) / (this.pswp.viewportSize.y / 3);
	  }
	  /**
	   * Set pan position of the current slide.
	   * Apply friction if the position is beyond the pan bounds,
	   * or if custom friction is defined.
	   *
	   * @private
	   * @param {'x' | 'y'} axis
	   * @param {number} potentialPan
	   * @param {number} [customFriction] (0.1 - 1)
	   */

	  _setPanWithFriction(axis, potentialPan, customFriction) {
	    const {
	      currSlide
	    } = this.pswp;
	    if (!currSlide) {
	      return;
	    }
	    const {
	      pan,
	      bounds
	    } = currSlide;
	    const correctedPan = bounds.correctPan(axis, potentialPan); // If we are out of pan bounds

	    if (correctedPan !== potentialPan || customFriction) {
	      const delta = Math.round(potentialPan - pan[axis]);
	      pan[axis] += delta * (customFriction || PAN_END_FRICTION);
	    } else {
	      pan[axis] = potentialPan;
	    }
	  }
	}

	/** @typedef {import('../photoswipe.js').Point} Point */

	/** @typedef {import('./gestures.js').default} Gestures */

	const UPPER_ZOOM_FRICTION = 0.05;
	const LOWER_ZOOM_FRICTION = 0.15;
	/**
	 * Get center point between two points
	 *
	 * @param {Point} p
	 * @param {Point} p1
	 * @param {Point} p2
	 * @returns {Point}
	 */

	function getZoomPointsCenter(p, p1, p2) {
	  p.x = (p1.x + p2.x) / 2;
	  p.y = (p1.y + p2.y) / 2;
	  return p;
	}
	class ZoomHandler {
	  /**
	   * @param {Gestures} gestures
	   */
	  constructor(gestures) {
	    this.gestures = gestures;
	    /**
	     * @private
	     * @type {Point}
	     */

	    this._startPan = {
	      x: 0,
	      y: 0
	    };
	    /**
	     * @private
	     * @type {Point}
	     */

	    this._startZoomPoint = {
	      x: 0,
	      y: 0
	    };
	    /**
	     * @private
	     * @type {Point}
	     */

	    this._zoomPoint = {
	      x: 0,
	      y: 0
	    };
	    /** @private */

	    this._wasOverFitZoomLevel = false;
	    /** @private */

	    this._startZoomLevel = 1;
	  }
	  start() {
	    const {
	      currSlide
	    } = this.gestures.pswp;
	    if (currSlide) {
	      this._startZoomLevel = currSlide.currZoomLevel;
	      equalizePoints(this._startPan, currSlide.pan);
	    }
	    this.gestures.pswp.animations.stopAllPan();
	    this._wasOverFitZoomLevel = false;
	  }
	  change() {
	    const {
	      p1,
	      startP1,
	      p2,
	      startP2,
	      pswp
	    } = this.gestures;
	    const {
	      currSlide
	    } = pswp;
	    if (!currSlide) {
	      return;
	    }
	    const minZoomLevel = currSlide.zoomLevels.min;
	    const maxZoomLevel = currSlide.zoomLevels.max;
	    if (!currSlide.isZoomable() || pswp.mainScroll.isShifted()) {
	      return;
	    }
	    getZoomPointsCenter(this._startZoomPoint, startP1, startP2);
	    getZoomPointsCenter(this._zoomPoint, p1, p2);
	    let currZoomLevel = 1 / getDistanceBetween(startP1, startP2) * getDistanceBetween(p1, p2) * this._startZoomLevel; // slightly over the zoom.fit

	    if (currZoomLevel > currSlide.zoomLevels.initial + currSlide.zoomLevels.initial / 15) {
	      this._wasOverFitZoomLevel = true;
	    }
	    if (currZoomLevel < minZoomLevel) {
	      if (pswp.options.pinchToClose && !this._wasOverFitZoomLevel && this._startZoomLevel <= currSlide.zoomLevels.initial) {
	        // fade out background if zooming out
	        const bgOpacity = 1 - (minZoomLevel - currZoomLevel) / (minZoomLevel / 1.2);
	        if (!pswp.dispatch('pinchClose', {
	          bgOpacity
	        }).defaultPrevented) {
	          pswp.applyBgOpacity(bgOpacity);
	        }
	      } else {
	        // Apply the friction if zoom level is below the min
	        currZoomLevel = minZoomLevel - (minZoomLevel - currZoomLevel) * LOWER_ZOOM_FRICTION;
	      }
	    } else if (currZoomLevel > maxZoomLevel) {
	      // Apply the friction if zoom level is above the max
	      currZoomLevel = maxZoomLevel + (currZoomLevel - maxZoomLevel) * UPPER_ZOOM_FRICTION;
	    }
	    currSlide.pan.x = this._calculatePanForZoomLevel('x', currZoomLevel);
	    currSlide.pan.y = this._calculatePanForZoomLevel('y', currZoomLevel);
	    currSlide.setZoomLevel(currZoomLevel);
	    currSlide.applyCurrentZoomPan();
	  }
	  end() {
	    const {
	      pswp
	    } = this.gestures;
	    const {
	      currSlide
	    } = pswp;
	    if ((!currSlide || currSlide.currZoomLevel < currSlide.zoomLevels.initial) && !this._wasOverFitZoomLevel && pswp.options.pinchToClose) {
	      pswp.close();
	    } else {
	      this.correctZoomPan();
	    }
	  }
	  /**
	   * @private
	   * @param {'x' | 'y'} axis
	   * @param {number} currZoomLevel
	   * @returns {number}
	   */

	  _calculatePanForZoomLevel(axis, currZoomLevel) {
	    const zoomFactor = currZoomLevel / this._startZoomLevel;
	    return this._zoomPoint[axis] - (this._startZoomPoint[axis] - this._startPan[axis]) * zoomFactor;
	  }
	  /**
	   * Correct currZoomLevel and pan if they are
	   * beyond minimum or maximum values.
	   * With animation.
	   *
	   * @param {boolean} [ignoreGesture]
	   * Wether gesture coordinates should be ignored when calculating destination pan position.
	   */

	  correctZoomPan(ignoreGesture) {
	    const {
	      pswp
	    } = this.gestures;
	    const {
	      currSlide
	    } = pswp;
	    if (!(currSlide !== null && currSlide !== void 0 && currSlide.isZoomable())) {
	      return;
	    }
	    if (this._zoomPoint.x === 0) {
	      ignoreGesture = true;
	    }
	    const prevZoomLevel = currSlide.currZoomLevel;
	    /** @type {number} */

	    let destinationZoomLevel;
	    let currZoomLevelNeedsChange = true;
	    if (prevZoomLevel < currSlide.zoomLevels.initial) {
	      destinationZoomLevel = currSlide.zoomLevels.initial; // zoom to min
	    } else if (prevZoomLevel > currSlide.zoomLevels.max) {
	      destinationZoomLevel = currSlide.zoomLevels.max; // zoom to max
	    } else {
	      currZoomLevelNeedsChange = false;
	      destinationZoomLevel = prevZoomLevel;
	    }
	    const initialBgOpacity = pswp.bgOpacity;
	    const restoreBgOpacity = pswp.bgOpacity < 1;
	    const initialPan = equalizePoints({
	      x: 0,
	      y: 0
	    }, currSlide.pan);
	    let destinationPan = equalizePoints({
	      x: 0,
	      y: 0
	    }, initialPan);
	    if (ignoreGesture) {
	      this._zoomPoint.x = 0;
	      this._zoomPoint.y = 0;
	      this._startZoomPoint.x = 0;
	      this._startZoomPoint.y = 0;
	      this._startZoomLevel = prevZoomLevel;
	      equalizePoints(this._startPan, initialPan);
	    }
	    if (currZoomLevelNeedsChange) {
	      destinationPan = {
	        x: this._calculatePanForZoomLevel('x', destinationZoomLevel),
	        y: this._calculatePanForZoomLevel('y', destinationZoomLevel)
	      };
	    } // set zoom level, so pan bounds are updated according to it

	    currSlide.setZoomLevel(destinationZoomLevel);
	    destinationPan = {
	      x: currSlide.bounds.correctPan('x', destinationPan.x),
	      y: currSlide.bounds.correctPan('y', destinationPan.y)
	    }; // return zoom level and its bounds to initial

	    currSlide.setZoomLevel(prevZoomLevel);
	    const panNeedsChange = !pointsEqual(destinationPan, initialPan);
	    if (!panNeedsChange && !currZoomLevelNeedsChange && !restoreBgOpacity) {
	      // update resolution after gesture
	      currSlide._setResolution(destinationZoomLevel);
	      currSlide.applyCurrentZoomPan(); // nothing to animate

	      return;
	    }
	    pswp.animations.stopAllPan();
	    pswp.animations.startSpring({
	      isPan: true,
	      start: 0,
	      end: 1000,
	      velocity: 0,
	      dampingRatio: 1,
	      naturalFrequency: 40,
	      onUpdate: now => {
	        now /= 1000; // 0 - start, 1 - end

	        if (panNeedsChange || currZoomLevelNeedsChange) {
	          if (panNeedsChange) {
	            currSlide.pan.x = initialPan.x + (destinationPan.x - initialPan.x) * now;
	            currSlide.pan.y = initialPan.y + (destinationPan.y - initialPan.y) * now;
	          }
	          if (currZoomLevelNeedsChange) {
	            const newZoomLevel = prevZoomLevel + (destinationZoomLevel - prevZoomLevel) * now;
	            currSlide.setZoomLevel(newZoomLevel);
	          }
	          currSlide.applyCurrentZoomPan();
	        } // Restore background opacity

	        if (restoreBgOpacity && pswp.bgOpacity < 1) {
	          // We clamp opacity to keep it between 0 and 1.
	          // As progress ratio can be larger than 1 due to overshoot,
	          // and we do not want to bounce opacity.
	          pswp.applyBgOpacity(clamp(initialBgOpacity + (1 - initialBgOpacity) * now, 0, 1));
	        }
	      },
	      onComplete: () => {
	        // update resolution after transition ends
	        currSlide._setResolution(destinationZoomLevel);
	        currSlide.applyCurrentZoomPan();
	      }
	    });
	  }
	}

	/**
	 * @template {string} T
	 * @template {string} P
	 * @typedef {import('../types.js').AddPostfix<T, P>} AddPostfix<T, P>
	 */

	/** @typedef {import('./gestures.js').default} Gestures */

	/** @typedef {import('../photoswipe.js').Point} Point */

	/** @typedef {'imageClick' | 'bgClick' | 'tap' | 'doubleTap'} Actions */

	/**
	 * Whether the tap was performed on the main slide
	 * (rather than controls or caption).
	 *
	 * @param {PointerEvent} event
	 * @returns {boolean}
	 */
	function didTapOnMainContent(event) {
	  return !! /** @type {HTMLElement} */
	  event.target.closest('.pswp__container');
	}
	/**
	 * Tap, double-tap handler.
	 */

	class TapHandler {
	  /**
	   * @param {Gestures} gestures
	   */
	  constructor(gestures) {
	    this.gestures = gestures;
	  }
	  /**
	   * @param {Point} point
	   * @param {PointerEvent} originalEvent
	   */

	  click(point, originalEvent) {
	    const targetClassList = /** @type {HTMLElement} */
	    originalEvent.target.classList;
	    const isImageClick = targetClassList.contains('pswp__img');
	    const isBackgroundClick = targetClassList.contains('pswp__item') || targetClassList.contains('pswp__zoom-wrap');
	    if (isImageClick) {
	      this._doClickOrTapAction('imageClick', point, originalEvent);
	    } else if (isBackgroundClick) {
	      this._doClickOrTapAction('bgClick', point, originalEvent);
	    }
	  }
	  /**
	   * @param {Point} point
	   * @param {PointerEvent} originalEvent
	   */

	  tap(point, originalEvent) {
	    if (didTapOnMainContent(originalEvent)) {
	      this._doClickOrTapAction('tap', point, originalEvent);
	    }
	  }
	  /**
	   * @param {Point} point
	   * @param {PointerEvent} originalEvent
	   */

	  doubleTap(point, originalEvent) {
	    if (didTapOnMainContent(originalEvent)) {
	      this._doClickOrTapAction('doubleTap', point, originalEvent);
	    }
	  }
	  /**
	   * @private
	   * @param {Actions} actionName
	   * @param {Point} point
	   * @param {PointerEvent} originalEvent
	   */

	  _doClickOrTapAction(actionName, point, originalEvent) {
	    var _this$gestures$pswp$e;
	    const {
	      pswp
	    } = this.gestures;
	    const {
	      currSlide
	    } = pswp;
	    const actionFullName = /** @type {AddPostfix<Actions, 'Action'>} */
	    actionName + 'Action';
	    const optionValue = pswp.options[actionFullName];
	    if (pswp.dispatch(actionFullName, {
	      point,
	      originalEvent
	    }).defaultPrevented) {
	      return;
	    }
	    if (typeof optionValue === 'function') {
	      optionValue.call(pswp, point, originalEvent);
	      return;
	    }
	    switch (optionValue) {
	      case 'close':
	      case 'next':
	        pswp[optionValue]();
	        break;
	      case 'zoom':
	        currSlide === null || currSlide === void 0 || currSlide.toggleZoom(point);
	        break;
	      case 'zoom-or-close':
	        // by default click zooms current image,
	        // if it can not be zoomed - gallery will be closed
	        if (currSlide !== null && currSlide !== void 0 && currSlide.isZoomable() && currSlide.zoomLevels.secondary !== currSlide.zoomLevels.initial) {
	          currSlide.toggleZoom(point);
	        } else if (pswp.options.clickToCloseNonZoomable) {
	          pswp.close();
	        }
	        break;
	      case 'toggle-controls':
	        (_this$gestures$pswp$e = this.gestures.pswp.element) === null || _this$gestures$pswp$e === void 0 || _this$gestures$pswp$e.classList.toggle('pswp--ui-visible'); // if (_controlsVisible) {
	        //   _ui.hideControls();
	        // } else {
	        //   _ui.showControls();
	        // }

	        break;
	    }
	  }
	}

	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	/** @typedef {import('../photoswipe.js').Point} Point */
	// How far should user should drag
	// until we can determine that the gesture is swipe and its direction

	const AXIS_SWIPE_HYSTERISIS = 10; //const PAN_END_FRICTION = 0.35;

	const DOUBLE_TAP_DELAY = 300; // ms

	const MIN_TAP_DISTANCE = 25; // px

	/**
	 * Gestures class bind touch, pointer or mouse events
	 * and emits drag to drag-handler and zoom events zoom-handler.
	 *
	 * Drag and zoom events are emited in requestAnimationFrame,
	 * and only when one of pointers was actually changed.
	 */

	class Gestures {
	  /**
	   * @param {PhotoSwipe} pswp
	   */
	  constructor(pswp) {
	    this.pswp = pswp;
	    /** @type {'x' | 'y' | null} */

	    this.dragAxis = null; // point objects are defined once and reused
	    // PhotoSwipe keeps track only of two pointers, others are ignored

	    /** @type {Point} */

	    this.p1 = {
	      x: 0,
	      y: 0
	    }; // the first pressed pointer

	    /** @type {Point} */

	    this.p2 = {
	      x: 0,
	      y: 0
	    }; // the second pressed pointer

	    /** @type {Point} */

	    this.prevP1 = {
	      x: 0,
	      y: 0
	    };
	    /** @type {Point} */

	    this.prevP2 = {
	      x: 0,
	      y: 0
	    };
	    /** @type {Point} */

	    this.startP1 = {
	      x: 0,
	      y: 0
	    };
	    /** @type {Point} */

	    this.startP2 = {
	      x: 0,
	      y: 0
	    };
	    /** @type {Point} */

	    this.velocity = {
	      x: 0,
	      y: 0
	    };
	    /** @type {Point}
	     * @private
	     */

	    this._lastStartP1 = {
	      x: 0,
	      y: 0
	    };
	    /** @type {Point}
	     * @private
	     */

	    this._intervalP1 = {
	      x: 0,
	      y: 0
	    };
	    /** @private */

	    this._numActivePoints = 0;
	    /** @type {Point[]}
	     * @private
	     */

	    this._ongoingPointers = [];
	    /** @private */

	    this._touchEventEnabled = 'ontouchstart' in window;
	    /** @private */

	    this._pointerEventEnabled = !!window.PointerEvent;
	    this.supportsTouch = this._touchEventEnabled || this._pointerEventEnabled && navigator.maxTouchPoints > 1;
	    /** @private */

	    this._numActivePoints = 0;
	    /** @private */

	    this._intervalTime = 0;
	    /** @private */

	    this._velocityCalculated = false;
	    this.isMultitouch = false;
	    this.isDragging = false;
	    this.isZooming = false;
	    /** @type {number | null} */

	    this.raf = null;
	    /** @type {NodeJS.Timeout | null}
	     * @private
	     */

	    this._tapTimer = null;
	    if (!this.supportsTouch) {
	      // disable pan to next slide for non-touch devices
	      pswp.options.allowPanToNext = false;
	    }
	    this.drag = new DragHandler(this);
	    this.zoomLevels = new ZoomHandler(this);
	    this.tapHandler = new TapHandler(this);
	    pswp.on('bindEvents', () => {
	      pswp.events.add(pswp.scrollWrap, 'click', /** @type EventListener */
	      this._onClick.bind(this));
	      if (this._pointerEventEnabled) {
	        this._bindEvents('pointer', 'down', 'up', 'cancel');
	      } else if (this._touchEventEnabled) {
	        this._bindEvents('touch', 'start', 'end', 'cancel'); // In previous versions we also bound mouse event here,
	        // in case device supports both touch and mouse events,
	        // but newer versions of browsers now support PointerEvent.
	        // on iOS10 if you bind touchmove/end after touchstart,
	        // and you don't preventDefault touchstart (which PhotoSwipe does),
	        // preventDefault will have no effect on touchmove and touchend.
	        // Unless you bind it previously.

	        if (pswp.scrollWrap) {
	          pswp.scrollWrap.ontouchmove = () => {};
	          pswp.scrollWrap.ontouchend = () => {};
	        }
	      } else {
	        this._bindEvents('mouse', 'down', 'up');
	      }
	    });
	  }
	  /**
	   * @private
	   * @param {'mouse' | 'touch' | 'pointer'} pref
	   * @param {'down' | 'start'} down
	   * @param {'up' | 'end'} up
	   * @param {'cancel'} [cancel]
	   */

	  _bindEvents(pref, down, up, cancel) {
	    const {
	      pswp
	    } = this;
	    const {
	      events
	    } = pswp;
	    const cancelEvent = cancel ? pref + cancel : '';
	    events.add(pswp.scrollWrap, pref + down, /** @type EventListener */
	    this.onPointerDown.bind(this));
	    events.add(window, pref + 'move', /** @type EventListener */
	    this.onPointerMove.bind(this));
	    events.add(window, pref + up, /** @type EventListener */
	    this.onPointerUp.bind(this));
	    if (cancelEvent) {
	      events.add(pswp.scrollWrap, cancelEvent, /** @type EventListener */
	      this.onPointerUp.bind(this));
	    }
	  }
	  /**
	   * @param {PointerEvent} e
	   */

	  onPointerDown(e) {
	    // We do not call preventDefault for touch events
	    // to allow browser to show native dialog on longpress
	    // (the one that allows to save image or open it in new tab).
	    //
	    // Desktop Safari allows to drag images when preventDefault isn't called on mousedown,
	    // even though preventDefault IS called on mousemove. That's why we preventDefault mousedown.
	    const isMousePointer = e.type === 'mousedown' || e.pointerType === 'mouse'; // Allow dragging only via left mouse button.
	    // http://www.quirksmode.org/js/events_properties.html
	    // https://developer.mozilla.org/en-US/docs/Web/API/event.button

	    if (isMousePointer && e.button > 0) {
	      return;
	    }
	    const {
	      pswp
	    } = this; // if PhotoSwipe is opening or closing

	    if (!pswp.opener.isOpen) {
	      e.preventDefault();
	      return;
	    }
	    if (pswp.dispatch('pointerDown', {
	      originalEvent: e
	    }).defaultPrevented) {
	      return;
	    }
	    if (isMousePointer) {
	      pswp.mouseDetected(); // preventDefault mouse event to prevent
	      // browser image drag feature

	      this._preventPointerEventBehaviour(e, 'down');
	    }
	    pswp.animations.stopAll();
	    this._updatePoints(e, 'down');
	    if (this._numActivePoints === 1) {
	      this.dragAxis = null; // we need to store initial point to determine the main axis,
	      // drag is activated only after the axis is determined

	      equalizePoints(this.startP1, this.p1);
	    }
	    if (this._numActivePoints > 1) {
	      // Tap or double tap should not trigger if more than one pointer
	      this._clearTapTimer();
	      this.isMultitouch = true;
	    } else {
	      this.isMultitouch = false;
	    }
	  }
	  /**
	   * @param {PointerEvent} e
	   */

	  onPointerMove(e) {
	    this._preventPointerEventBehaviour(e, 'move');
	    if (!this._numActivePoints) {
	      return;
	    }
	    this._updatePoints(e, 'move');
	    if (this.pswp.dispatch('pointerMove', {
	      originalEvent: e
	    }).defaultPrevented) {
	      return;
	    }
	    if (this._numActivePoints === 1 && !this.isDragging) {
	      if (!this.dragAxis) {
	        this._calculateDragDirection();
	      } // Drag axis was detected, emit drag.start

	      if (this.dragAxis && !this.isDragging) {
	        if (this.isZooming) {
	          this.isZooming = false;
	          this.zoomLevels.end();
	        }
	        this.isDragging = true;
	        this._clearTapTimer(); // Tap can not trigger after drag
	        // Adjust starting point

	        this._updateStartPoints();
	        this._intervalTime = Date.now(); //this._startTime = this._intervalTime;

	        this._velocityCalculated = false;
	        equalizePoints(this._intervalP1, this.p1);
	        this.velocity.x = 0;
	        this.velocity.y = 0;
	        this.drag.start();
	        this._rafStopLoop();
	        this._rafRenderLoop();
	      }
	    } else if (this._numActivePoints > 1 && !this.isZooming) {
	      this._finishDrag();
	      this.isZooming = true; // Adjust starting points

	      this._updateStartPoints();
	      this.zoomLevels.start();
	      this._rafStopLoop();
	      this._rafRenderLoop();
	    }
	  }
	  /**
	   * @private
	   */

	  _finishDrag() {
	    if (this.isDragging) {
	      this.isDragging = false; // Try to calculate velocity,
	      // if it wasn't calculated yet in drag.change

	      if (!this._velocityCalculated) {
	        this._updateVelocity(true);
	      }
	      this.drag.end();
	      this.dragAxis = null;
	    }
	  }
	  /**
	   * @param {PointerEvent} e
	   */

	  onPointerUp(e) {
	    if (!this._numActivePoints) {
	      return;
	    }
	    this._updatePoints(e, 'up');
	    if (this.pswp.dispatch('pointerUp', {
	      originalEvent: e
	    }).defaultPrevented) {
	      return;
	    }
	    if (this._numActivePoints === 0) {
	      this._rafStopLoop();
	      if (this.isDragging) {
	        this._finishDrag();
	      } else if (!this.isZooming && !this.isMultitouch) {
	        //this.zoomLevels.correctZoomPan();
	        this._finishTap(e);
	      }
	    }
	    if (this._numActivePoints < 2 && this.isZooming) {
	      this.isZooming = false;
	      this.zoomLevels.end();
	      if (this._numActivePoints === 1) {
	        // Since we have 1 point left, we need to reinitiate drag
	        this.dragAxis = null;
	        this._updateStartPoints();
	      }
	    }
	  }
	  /**
	   * @private
	   */

	  _rafRenderLoop() {
	    if (this.isDragging || this.isZooming) {
	      this._updateVelocity();
	      if (this.isDragging) {
	        // make sure that pointer moved since the last update
	        if (!pointsEqual(this.p1, this.prevP1)) {
	          this.drag.change();
	        }
	      } else /* if (this.isZooming) */
	        {
	          if (!pointsEqual(this.p1, this.prevP1) || !pointsEqual(this.p2, this.prevP2)) {
	            this.zoomLevels.change();
	          }
	        }
	      this._updatePrevPoints();
	      this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this));
	    }
	  }
	  /**
	   * Update velocity at 50ms interval
	   *
	   * @private
	   * @param {boolean} [force]
	   */

	  _updateVelocity(force) {
	    const time = Date.now();
	    const duration = time - this._intervalTime;
	    if (duration < 50 && !force) {
	      return;
	    }
	    this.velocity.x = this._getVelocity('x', duration);
	    this.velocity.y = this._getVelocity('y', duration);
	    this._intervalTime = time;
	    equalizePoints(this._intervalP1, this.p1);
	    this._velocityCalculated = true;
	  }
	  /**
	   * @private
	   * @param {PointerEvent} e
	   */

	  _finishTap(e) {
	    const {
	      mainScroll
	    } = this.pswp; // Do not trigger tap events if main scroll is shifted

	    if (mainScroll.isShifted()) {
	      // restore main scroll position
	      // (usually happens if stopped in the middle of animation)
	      mainScroll.moveIndexBy(0, true);
	      return;
	    } // Do not trigger tap for touchcancel or pointercancel

	    if (e.type.indexOf('cancel') > 0) {
	      return;
	    } // Trigger click instead of tap for mouse events

	    if (e.type === 'mouseup' || e.pointerType === 'mouse') {
	      this.tapHandler.click(this.startP1, e);
	      return;
	    } // Disable delay if there is no doubleTapAction

	    const tapDelay = this.pswp.options.doubleTapAction ? DOUBLE_TAP_DELAY : 0; // If tapTimer is defined - we tapped recently,
	    // check if the current tap is close to the previous one,
	    // if yes - trigger double tap

	    if (this._tapTimer) {
	      this._clearTapTimer(); // Check if two taps were more or less on the same place

	      if (getDistanceBetween(this._lastStartP1, this.startP1) < MIN_TAP_DISTANCE) {
	        this.tapHandler.doubleTap(this.startP1, e);
	      }
	    } else {
	      equalizePoints(this._lastStartP1, this.startP1);
	      this._tapTimer = setTimeout(() => {
	        this.tapHandler.tap(this.startP1, e);
	        this._clearTapTimer();
	      }, tapDelay);
	    }
	  }
	  /**
	   * @private
	   */

	  _clearTapTimer() {
	    if (this._tapTimer) {
	      clearTimeout(this._tapTimer);
	      this._tapTimer = null;
	    }
	  }
	  /**
	   * Get velocity for axis
	   *
	   * @private
	   * @param {'x' | 'y'} axis
	   * @param {number} duration
	   * @returns {number}
	   */

	  _getVelocity(axis, duration) {
	    // displacement is like distance, but can be negative.
	    const displacement = this.p1[axis] - this._intervalP1[axis];
	    if (Math.abs(displacement) > 1 && duration > 5) {
	      return displacement / duration;
	    }
	    return 0;
	  }
	  /**
	   * @private
	   */

	  _rafStopLoop() {
	    if (this.raf) {
	      cancelAnimationFrame(this.raf);
	      this.raf = null;
	    }
	  }
	  /**
	   * @private
	   * @param {PointerEvent} e
	   * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
	   */

	  _preventPointerEventBehaviour(e, pointerType) {
	    const preventPointerEvent = this.pswp.applyFilters('preventPointerEvent', true, e, pointerType);
	    if (preventPointerEvent) {
	      e.preventDefault();
	    }
	  }
	  /**
	   * Parses and normalizes points from the touch, mouse or pointer event.
	   * Updates p1 and p2.
	   *
	   * @private
	   * @param {PointerEvent | TouchEvent} e
	   * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
	   */

	  _updatePoints(e, pointerType) {
	    if (this._pointerEventEnabled) {
	      const pointerEvent = /** @type {PointerEvent} */
	      e; // Try to find the current pointer in ongoing pointers by its ID

	      const pointerIndex = this._ongoingPointers.findIndex(ongoingPointer => {
	        return ongoingPointer.id === pointerEvent.pointerId;
	      });
	      if (pointerType === 'up' && pointerIndex > -1) {
	        // release the pointer - remove it from ongoing
	        this._ongoingPointers.splice(pointerIndex, 1);
	      } else if (pointerType === 'down' && pointerIndex === -1) {
	        // add new pointer
	        this._ongoingPointers.push(this._convertEventPosToPoint(pointerEvent, {
	          x: 0,
	          y: 0
	        }));
	      } else if (pointerIndex > -1) {
	        // update existing pointer
	        this._convertEventPosToPoint(pointerEvent, this._ongoingPointers[pointerIndex]);
	      }
	      this._numActivePoints = this._ongoingPointers.length; // update points that PhotoSwipe uses
	      // to calculate position and scale

	      if (this._numActivePoints > 0) {
	        equalizePoints(this.p1, this._ongoingPointers[0]);
	      }
	      if (this._numActivePoints > 1) {
	        equalizePoints(this.p2, this._ongoingPointers[1]);
	      }
	    } else {
	      const touchEvent = /** @type {TouchEvent} */
	      e;
	      this._numActivePoints = 0;
	      if (touchEvent.type.indexOf('touch') > -1) {
	        // Touch Event
	        // https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
	        if (touchEvent.touches && touchEvent.touches.length > 0) {
	          this._convertEventPosToPoint(touchEvent.touches[0], this.p1);
	          this._numActivePoints++;
	          if (touchEvent.touches.length > 1) {
	            this._convertEventPosToPoint(touchEvent.touches[1], this.p2);
	            this._numActivePoints++;
	          }
	        }
	      } else {
	        // Mouse Event
	        this._convertEventPosToPoint(/** @type {PointerEvent} */
	        e, this.p1);
	        if (pointerType === 'up') {
	          // clear all points on mouseup
	          this._numActivePoints = 0;
	        } else {
	          this._numActivePoints++;
	        }
	      }
	    }
	  }
	  /** update points that were used during previous rAF tick
	   * @private
	   */

	  _updatePrevPoints() {
	    equalizePoints(this.prevP1, this.p1);
	    equalizePoints(this.prevP2, this.p2);
	  }
	  /** update points at the start of gesture
	   * @private
	   */

	  _updateStartPoints() {
	    equalizePoints(this.startP1, this.p1);
	    equalizePoints(this.startP2, this.p2);
	    this._updatePrevPoints();
	  }
	  /** @private */

	  _calculateDragDirection() {
	    if (this.pswp.mainScroll.isShifted()) {
	      // if main scroll position is shifted – direction is always horizontal
	      this.dragAxis = 'x';
	    } else {
	      // calculate delta of the last touchmove tick
	      const diff = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
	      if (diff !== 0) {
	        // check if pointer was shifted horizontally or vertically
	        const axisToCheck = diff > 0 ? 'x' : 'y';
	        if (Math.abs(this.p1[axisToCheck] - this.startP1[axisToCheck]) >= AXIS_SWIPE_HYSTERISIS) {
	          this.dragAxis = axisToCheck;
	        }
	      }
	    }
	  }
	  /**
	   * Converts touch, pointer or mouse event
	   * to PhotoSwipe point.
	   *
	   * @private
	   * @param {Touch | PointerEvent} e
	   * @param {Point} p
	   * @returns {Point}
	   */

	  _convertEventPosToPoint(e, p) {
	    p.x = e.pageX - this.pswp.offset.x;
	    p.y = e.pageY - this.pswp.offset.y;
	    if ('pointerId' in e) {
	      p.id = e.pointerId;
	    } else if (e.identifier !== undefined) {
	      p.id = e.identifier;
	    }
	    return p;
	  }
	  /**
	   * @private
	   * @param {PointerEvent} e
	   */

	  _onClick(e) {
	    // Do not allow click event to pass through after drag
	    if (this.pswp.mainScroll.isShifted()) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  }
	}

	/** @typedef {import('./photoswipe.js').default} PhotoSwipe */

	/** @typedef {import('./slide/slide.js').default} Slide */

	/** @typedef {{ el: HTMLDivElement; slide?: Slide }} ItemHolder */

	const MAIN_SCROLL_END_FRICTION = 0.35; // const MIN_SWIPE_TRANSITION_DURATION = 250;
	// const MAX_SWIPE_TRABSITION_DURATION = 500;
	// const DEFAULT_SWIPE_TRANSITION_DURATION = 333;

	/**
	 * Handles movement of the main scrolling container
	 * (for example, it repositions when user swipes left or right).
	 *
	 * Also stores its state.
	 */

	class MainScroll {
	  /**
	   * @param {PhotoSwipe} pswp
	   */
	  constructor(pswp) {
	    this.pswp = pswp;
	    this.x = 0;
	    this.slideWidth = 0;
	    /** @private */

	    this._currPositionIndex = 0;
	    /** @private */

	    this._prevPositionIndex = 0;
	    /** @private */

	    this._containerShiftIndex = -1;
	    /** @type {ItemHolder[]} */

	    this.itemHolders = [];
	  }
	  /**
	   * Position the scroller and slide containers
	   * according to viewport size.
	   *
	   * @param {boolean} [resizeSlides] Whether slides content should resized
	   */

	  resize(resizeSlides) {
	    const {
	      pswp
	    } = this;
	    const newSlideWidth = Math.round(pswp.viewportSize.x + pswp.viewportSize.x * pswp.options.spacing); // Mobile browsers might trigger a resize event during a gesture.
	    // (due to toolbar appearing or hiding).
	    // Avoid re-adjusting main scroll position if width wasn't changed

	    const slideWidthChanged = newSlideWidth !== this.slideWidth;
	    if (slideWidthChanged) {
	      this.slideWidth = newSlideWidth;
	      this.moveTo(this.getCurrSlideX());
	    }
	    this.itemHolders.forEach((itemHolder, index) => {
	      if (slideWidthChanged) {
	        setTransform(itemHolder.el, (index + this._containerShiftIndex) * this.slideWidth);
	      }
	      if (resizeSlides && itemHolder.slide) {
	        itemHolder.slide.resize();
	      }
	    });
	  }
	  /**
	   * Reset X position of the main scroller to zero
	   */

	  resetPosition() {
	    // Position on the main scroller (offset)
	    // it is independent from slide index
	    this._currPositionIndex = 0;
	    this._prevPositionIndex = 0; // This will force recalculation of size on next resize()

	    this.slideWidth = 0; // _containerShiftIndex*viewportSize will give you amount of transform of the current slide

	    this._containerShiftIndex = -1;
	  }
	  /**
	   * Create and append array of three items
	   * that hold data about slides in DOM
	   */

	  appendHolders() {
	    this.itemHolders = []; // append our three slide holders -
	    // previous, current, and next

	    for (let i = 0; i < 3; i++) {
	      const el = createElement('pswp__item', 'div', this.pswp.container);
	      el.setAttribute('role', 'group');
	      el.setAttribute('aria-roledescription', 'slide');
	      el.setAttribute('aria-hidden', 'true'); // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)

	      el.style.display = i === 1 ? 'block' : 'none';
	      this.itemHolders.push({
	        el //index: -1
	      });
	    }
	  }
	  /**
	   * Whether the main scroll can be horizontally swiped to the next or previous slide.
	   * @returns {boolean}
	   */

	  canBeSwiped() {
	    return this.pswp.getNumItems() > 1;
	  }
	  /**
	   * Move main scroll by X amount of slides.
	   * For example:
	   *   `-1` will move to the previous slide,
	   *    `0` will reset the scroll position of the current slide,
	   *    `3` will move three slides forward
	   *
	   * If loop option is enabled - index will be automatically looped too,
	   * (for example `-1` will move to the last slide of the gallery).
	   *
	   * @param {number} diff
	   * @param {boolean} [animate]
	   * @param {number} [velocityX]
	   * @returns {boolean} whether index was changed or not
	   */

	  moveIndexBy(diff, animate, velocityX) {
	    const {
	      pswp
	    } = this;
	    let newIndex = pswp.potentialIndex + diff;
	    const numSlides = pswp.getNumItems();
	    if (pswp.canLoop()) {
	      newIndex = pswp.getLoopedIndex(newIndex);
	      const distance = (diff + numSlides) % numSlides;
	      if (distance <= numSlides / 2) {
	        // go forward
	        diff = distance;
	      } else {
	        // go backwards
	        diff = distance - numSlides;
	      }
	    } else {
	      if (newIndex < 0) {
	        newIndex = 0;
	      } else if (newIndex >= numSlides) {
	        newIndex = numSlides - 1;
	      }
	      diff = newIndex - pswp.potentialIndex;
	    }
	    pswp.potentialIndex = newIndex;
	    this._currPositionIndex -= diff;
	    pswp.animations.stopMainScroll();
	    const destinationX = this.getCurrSlideX();
	    if (!animate) {
	      this.moveTo(destinationX);
	      this.updateCurrItem();
	    } else {
	      pswp.animations.startSpring({
	        isMainScroll: true,
	        start: this.x,
	        end: destinationX,
	        velocity: velocityX || 0,
	        naturalFrequency: 30,
	        dampingRatio: 1,
	        //0.7,
	        onUpdate: x => {
	          this.moveTo(x);
	        },
	        onComplete: () => {
	          this.updateCurrItem();
	          pswp.appendHeavy();
	        }
	      });
	      let currDiff = pswp.potentialIndex - pswp.currIndex;
	      if (pswp.canLoop()) {
	        const currDistance = (currDiff + numSlides) % numSlides;
	        if (currDistance <= numSlides / 2) {
	          // go forward
	          currDiff = currDistance;
	        } else {
	          // go backwards
	          currDiff = currDistance - numSlides;
	        }
	      } // Force-append new slides during transition
	      // if difference between slides is more than 1

	      if (Math.abs(currDiff) > 1) {
	        this.updateCurrItem();
	      }
	    }
	    return Boolean(diff);
	  }
	  /**
	   * X position of the main scroll for the current slide
	   * (ignores position during dragging)
	   * @returns {number}
	   */

	  getCurrSlideX() {
	    return this.slideWidth * this._currPositionIndex;
	  }
	  /**
	   * Whether scroll position is shifted.
	   * For example, it will return true if the scroll is being dragged or animated.
	   * @returns {boolean}
	   */

	  isShifted() {
	    return this.x !== this.getCurrSlideX();
	  }
	  /**
	   * Update slides X positions and set their content
	   */

	  updateCurrItem() {
	    var _this$itemHolders$;
	    const {
	      pswp
	    } = this;
	    const positionDifference = this._prevPositionIndex - this._currPositionIndex;
	    if (!positionDifference) {
	      return;
	    }
	    this._prevPositionIndex = this._currPositionIndex;
	    pswp.currIndex = pswp.potentialIndex;
	    let diffAbs = Math.abs(positionDifference);
	    /** @type {ItemHolder | undefined} */

	    let tempHolder;
	    if (diffAbs >= 3) {
	      this._containerShiftIndex += positionDifference + (positionDifference > 0 ? -3 : 3);
	      diffAbs = 3; // If slides are changed by 3 screens or more - clean up previous slides

	      this.itemHolders.forEach(itemHolder => {
	        var _itemHolder$slide;
	        (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.destroy();
	        itemHolder.slide = undefined;
	      });
	    }
	    for (let i = 0; i < diffAbs; i++) {
	      if (positionDifference > 0) {
	        tempHolder = this.itemHolders.shift();
	        if (tempHolder) {
	          this.itemHolders[2] = tempHolder; // move first to last

	          this._containerShiftIndex++;
	          setTransform(tempHolder.el, (this._containerShiftIndex + 2) * this.slideWidth);
	          pswp.setContent(tempHolder, pswp.currIndex - diffAbs + i + 2);
	        }
	      } else {
	        tempHolder = this.itemHolders.pop();
	        if (tempHolder) {
	          this.itemHolders.unshift(tempHolder); // move last to first

	          this._containerShiftIndex--;
	          setTransform(tempHolder.el, this._containerShiftIndex * this.slideWidth);
	          pswp.setContent(tempHolder, pswp.currIndex + diffAbs - i - 2);
	        }
	      }
	    } // Reset transfrom every 50ish navigations in one direction.
	    //
	    // Otherwise transform will keep growing indefinitely,
	    // which might cause issues as browsers have a maximum transform limit.
	    // I wasn't able to reach it, but just to be safe.
	    // This should not cause noticable lag.

	    if (Math.abs(this._containerShiftIndex) > 50 && !this.isShifted()) {
	      this.resetPosition();
	      this.resize();
	    } // Pan transition might be running (and consntantly updating pan position)

	    pswp.animations.stopAllPan();
	    this.itemHolders.forEach((itemHolder, i) => {
	      if (itemHolder.slide) {
	        // Slide in the 2nd holder is always active
	        itemHolder.slide.setIsActive(i === 1);
	      }
	    });
	    pswp.currSlide = (_this$itemHolders$ = this.itemHolders[1]) === null || _this$itemHolders$ === void 0 ? void 0 : _this$itemHolders$.slide;
	    pswp.contentLoader.updateLazy(positionDifference);
	    if (pswp.currSlide) {
	      pswp.currSlide.applyCurrentZoomPan();
	    }
	    pswp.dispatch('change');
	  }
	  /**
	   * Move the X position of the main scroll container
	   *
	   * @param {number} x
	   * @param {boolean} [dragging]
	   */

	  moveTo(x, dragging) {
	    if (!this.pswp.canLoop() && dragging) {
	      // Apply friction
	      let newSlideIndexOffset = (this.slideWidth * this._currPositionIndex - x) / this.slideWidth;
	      newSlideIndexOffset += this.pswp.currIndex;
	      const delta = Math.round(x - this.x);
	      if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= this.pswp.getNumItems() - 1 && delta < 0) {
	        x = this.x + delta * MAIN_SCROLL_END_FRICTION;
	      }
	    }
	    this.x = x;
	    if (this.pswp.container) {
	      setTransform(this.pswp.container, x);
	    }
	    this.pswp.dispatch('moveMainScroll', {
	      x,
	      dragging: dragging !== null && dragging !== void 0 ? dragging : false
	    });
	  }
	}

	/** @typedef {import('./photoswipe.js').default} PhotoSwipe */

	/**
	 * @template T
	 * @typedef {import('./types.js').Methods<T>} Methods<T>
	 */

	const KeyboardKeyCodesMap = {
	  Escape: 27,
	  z: 90,
	  ArrowLeft: 37,
	  ArrowUp: 38,
	  ArrowRight: 39,
	  ArrowDown: 40,
	  Tab: 9
	};
	/**
	 * @template {keyof KeyboardKeyCodesMap} T
	 * @param {T} key
	 * @param {boolean} isKeySupported
	 * @returns {T | number | undefined}
	 */

	const getKeyboardEventKey = (key, isKeySupported) => {
	  return isKeySupported ? key : KeyboardKeyCodesMap[key];
	};
	/**
	 * - Manages keyboard shortcuts.
	 * - Helps trap focus within photoswipe.
	 */

	class Keyboard {
	  /**
	   * @param {PhotoSwipe} pswp
	   */
	  constructor(pswp) {
	    this.pswp = pswp;
	    /** @private */

	    this._wasFocused = false;
	    pswp.on('bindEvents', () => {
	      if (pswp.options.trapFocus) {
	        // Dialog was likely opened by keyboard if initial point is not defined
	        if (!pswp.options.initialPointerPos) {
	          // focus causes layout,
	          // which causes lag during the animation,
	          // that's why we delay it until the opener transition ends
	          this._focusRoot();
	        }
	        pswp.events.add(document, 'focusin', /** @type EventListener */
	        this._onFocusIn.bind(this));
	      }
	      pswp.events.add(document, 'keydown', /** @type EventListener */
	      this._onKeyDown.bind(this));
	    });
	    const lastActiveElement = /** @type {HTMLElement} */
	    document.activeElement;
	    pswp.on('destroy', () => {
	      if (pswp.options.returnFocus && lastActiveElement && this._wasFocused) {
	        lastActiveElement.focus();
	      }
	    });
	  }
	  /** @private */

	  _focusRoot() {
	    if (!this._wasFocused && this.pswp.element) {
	      this.pswp.element.focus();
	      this._wasFocused = true;
	    }
	  }
	  /**
	   * @private
	   * @param {KeyboardEvent} e
	   */

	  _onKeyDown(e) {
	    const {
	      pswp
	    } = this;
	    if (pswp.dispatch('keydown', {
	      originalEvent: e
	    }).defaultPrevented) {
	      return;
	    }
	    if (specialKeyUsed(e)) {
	      // don't do anything if special key pressed
	      // to prevent from overriding default browser actions
	      // for example, in Chrome on Mac cmd+arrow-left returns to previous page
	      return;
	    }
	    /** @type {Methods<PhotoSwipe> | undefined} */

	    let keydownAction;
	    /** @type {'x' | 'y' | undefined} */

	    let axis;
	    let isForward = false;
	    const isKeySupported = 'key' in e;
	    switch (isKeySupported ? e.key : e.keyCode) {
	      case getKeyboardEventKey('Escape', isKeySupported):
	        if (pswp.options.escKey) {
	          keydownAction = 'close';
	        }
	        break;
	      case getKeyboardEventKey('z', isKeySupported):
	        keydownAction = 'toggleZoom';
	        break;
	      case getKeyboardEventKey('ArrowLeft', isKeySupported):
	        axis = 'x';
	        break;
	      case getKeyboardEventKey('ArrowUp', isKeySupported):
	        axis = 'y';
	        break;
	      case getKeyboardEventKey('ArrowRight', isKeySupported):
	        axis = 'x';
	        isForward = true;
	        break;
	      case getKeyboardEventKey('ArrowDown', isKeySupported):
	        isForward = true;
	        axis = 'y';
	        break;
	      case getKeyboardEventKey('Tab', isKeySupported):
	        this._focusRoot();
	        break;
	    } // if left/right/top/bottom key

	    if (axis) {
	      // prevent page scroll
	      e.preventDefault();
	      const {
	        currSlide
	      } = pswp;
	      if (pswp.options.arrowKeys && axis === 'x' && pswp.getNumItems() > 1) {
	        keydownAction = isForward ? 'next' : 'prev';
	      } else if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.fit) {
	        // up/down arrow keys pan the image vertically
	        // left/right arrow keys pan horizontally.
	        // Unless there is only one image,
	        // or arrowKeys option is disabled
	        currSlide.pan[axis] += isForward ? -80 : 80;
	        currSlide.panTo(currSlide.pan.x, currSlide.pan.y);
	      }
	    }
	    if (keydownAction) {
	      e.preventDefault(); // @ts-ignore

	      pswp[keydownAction]();
	    }
	  }
	  /**
	   * Trap focus inside photoswipe
	   *
	   * @private
	   * @param {FocusEvent} e
	   */

	  _onFocusIn(e) {
	    const {
	      template
	    } = this.pswp;
	    if (template && document !== e.target && template !== e.target && !template.contains(/** @type {Node} */
	    e.target)) {
	      // focus root element
	      template.focus();
	    }
	  }
	}
	const DEFAULT_EASING = 'cubic-bezier(.4,0,.22,1)';
	/** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps */

	/** @typedef {Object} DefaultCssAnimationProps
	 *
	 * @prop {HTMLElement} target
	 * @prop {number} [duration]
	 * @prop {string} [easing]
	 * @prop {string} [transform]
	 * @prop {string} [opacity]
	 * */

	/** @typedef {SharedAnimationProps & DefaultCssAnimationProps} CssAnimationProps */

	/**
	 * Runs CSS transition.
	 */

	class CSSAnimation {
	  /**
	   * onComplete can be unpredictable, be careful about current state
	   *
	   * @param {CssAnimationProps} props
	   */
	  constructor(props) {
	    var _props$prop;
	    this.props = props;
	    const {
	      target,
	      onComplete,
	      transform,
	      onFinish = () => {},
	      duration = 333,
	      easing = DEFAULT_EASING
	    } = props;
	    this.onFinish = onFinish; // support only transform and opacity

	    const prop = transform ? 'transform' : 'opacity';
	    const propValue = (_props$prop = props[prop]) !== null && _props$prop !== void 0 ? _props$prop : '';
	    /** @private */

	    this._target = target;
	    /** @private */

	    this._onComplete = onComplete;
	    /** @private */

	    this._finished = false;
	    /** @private */

	    this._onTransitionEnd = this._onTransitionEnd.bind(this); // Using timeout hack to make sure that animation
	    // starts even if the animated property was changed recently,
	    // otherwise transitionend might not fire or transition won't start.
	    // https://drafts.csswg.org/css-transitions/#starting
	    //
	    // ¯\_(ツ)_/¯

	    /** @private */

	    this._helperTimeout = setTimeout(() => {
	      setTransitionStyle(target, prop, duration, easing);
	      this._helperTimeout = setTimeout(() => {
	        target.addEventListener('transitionend', this._onTransitionEnd, false);
	        target.addEventListener('transitioncancel', this._onTransitionEnd, false); // Safari occasionally does not emit transitionend event
	        // if element property was modified during the transition,
	        // which may be caused by resize or third party component,
	        // using timeout as a safety fallback

	        this._helperTimeout = setTimeout(() => {
	          this._finalizeAnimation();
	        }, duration + 500);
	        target.style[prop] = propValue;
	      }, 30); // Do not reduce this number
	    }, 0);
	  }
	  /**
	   * @private
	   * @param {TransitionEvent} e
	   */

	  _onTransitionEnd(e) {
	    if (e.target === this._target) {
	      this._finalizeAnimation();
	    }
	  }
	  /**
	   * @private
	   */

	  _finalizeAnimation() {
	    if (!this._finished) {
	      this._finished = true;
	      this.onFinish();
	      if (this._onComplete) {
	        this._onComplete();
	      }
	    }
	  } // Destroy is called automatically onFinish

	  destroy() {
	    if (this._helperTimeout) {
	      clearTimeout(this._helperTimeout);
	    }
	    removeTransitionStyle(this._target);
	    this._target.removeEventListener('transitionend', this._onTransitionEnd, false);
	    this._target.removeEventListener('transitioncancel', this._onTransitionEnd, false);
	    if (!this._finished) {
	      this._finalizeAnimation();
	    }
	  }
	}
	const DEFAULT_NATURAL_FREQUENCY = 12;
	const DEFAULT_DAMPING_RATIO = 0.75;
	/**
	 * Spring easing helper
	 */

	class SpringEaser {
	  /**
	   * @param {number} initialVelocity Initial velocity, px per ms.
	   *
	   * @param {number} [dampingRatio]
	   * Determines how bouncy animation will be.
	   * From 0 to 1, 0 - always overshoot, 1 - do not overshoot.
	   * "overshoot" refers to part of animation that
	   * goes beyond the final value.
	   *
	   * @param {number} [naturalFrequency]
	   * Determines how fast animation will slow down.
	   * The higher value - the stiffer the transition will be,
	   * and the faster it will slow down.
	   * Recommended value from 10 to 50
	   */
	  constructor(initialVelocity, dampingRatio, naturalFrequency) {
	    this.velocity = initialVelocity * 1000; // convert to "pixels per second"
	    // https://en.wikipedia.org/wiki/Damping_ratio

	    this._dampingRatio = dampingRatio || DEFAULT_DAMPING_RATIO; // https://en.wikipedia.org/wiki/Natural_frequency

	    this._naturalFrequency = naturalFrequency || DEFAULT_NATURAL_FREQUENCY;
	    this._dampedFrequency = this._naturalFrequency;
	    if (this._dampingRatio < 1) {
	      this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio);
	    }
	  }
	  /**
	   * @param {number} deltaPosition Difference between current and end position of the animation
	   * @param {number} deltaTime Frame duration in milliseconds
	   *
	   * @returns {number} Displacement, relative to the end position.
	   */

	  easeFrame(deltaPosition, deltaTime) {
	    // Inspired by Apple Webkit and Android spring function implementation
	    // https://en.wikipedia.org/wiki/Oscillation
	    // https://en.wikipedia.org/wiki/Damping_ratio
	    // we ignore mass (assume that it's 1kg)
	    let displacement = 0;
	    let coeff;
	    deltaTime /= 1000;
	    const naturalDumpingPow = Math.E ** (-this._dampingRatio * this._naturalFrequency * deltaTime);
	    if (this._dampingRatio === 1) {
	      coeff = this.velocity + this._naturalFrequency * deltaPosition;
	      displacement = (deltaPosition + coeff * deltaTime) * naturalDumpingPow;
	      this.velocity = displacement * -this._naturalFrequency + coeff * naturalDumpingPow;
	    } else if (this._dampingRatio < 1) {
	      coeff = 1 / this._dampedFrequency * (this._dampingRatio * this._naturalFrequency * deltaPosition + this.velocity);
	      const dumpedFCos = Math.cos(this._dampedFrequency * deltaTime);
	      const dumpedFSin = Math.sin(this._dampedFrequency * deltaTime);
	      displacement = naturalDumpingPow * (deltaPosition * dumpedFCos + coeff * dumpedFSin);
	      this.velocity = displacement * -this._naturalFrequency * this._dampingRatio + naturalDumpingPow * (-this._dampedFrequency * deltaPosition * dumpedFSin + this._dampedFrequency * coeff * dumpedFCos);
	    } // Overdamped (>1) damping ratio is not supported

	    return displacement;
	  }
	}

	/** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps */

	/**
	 * @typedef {Object} DefaultSpringAnimationProps
	 *
	 * @prop {number} start
	 * @prop {number} end
	 * @prop {number} velocity
	 * @prop {number} [dampingRatio]
	 * @prop {number} [naturalFrequency]
	 * @prop {(end: number) => void} onUpdate
	 */

	/** @typedef {SharedAnimationProps & DefaultSpringAnimationProps} SpringAnimationProps */

	class SpringAnimation {
	  /**
	   * @param {SpringAnimationProps} props
	   */
	  constructor(props) {
	    this.props = props;
	    this._raf = 0;
	    const {
	      start,
	      end,
	      velocity,
	      onUpdate,
	      onComplete,
	      onFinish = () => {},
	      dampingRatio,
	      naturalFrequency
	    } = props;
	    this.onFinish = onFinish;
	    const easer = new SpringEaser(velocity, dampingRatio, naturalFrequency);
	    let prevTime = Date.now();
	    let deltaPosition = start - end;
	    const animationLoop = () => {
	      if (this._raf) {
	        deltaPosition = easer.easeFrame(deltaPosition, Date.now() - prevTime); // Stop the animation if velocity is low and position is close to end

	        if (Math.abs(deltaPosition) < 1 && Math.abs(easer.velocity) < 50) {
	          // Finalize the animation
	          onUpdate(end);
	          if (onComplete) {
	            onComplete();
	          }
	          this.onFinish();
	        } else {
	          prevTime = Date.now();
	          onUpdate(deltaPosition + end);
	          this._raf = requestAnimationFrame(animationLoop);
	        }
	      }
	    };
	    this._raf = requestAnimationFrame(animationLoop);
	  } // Destroy is called automatically onFinish

	  destroy() {
	    if (this._raf >= 0) {
	      cancelAnimationFrame(this._raf);
	    }
	    this._raf = 0;
	  }
	}

	/** @typedef {import('./css-animation.js').CssAnimationProps} CssAnimationProps */

	/** @typedef {import('./spring-animation.js').SpringAnimationProps} SpringAnimationProps */

	/** @typedef {Object} SharedAnimationProps
	 * @prop {string} [name]
	 * @prop {boolean} [isPan]
	 * @prop {boolean} [isMainScroll]
	 * @prop {VoidFunction} [onComplete]
	 * @prop {VoidFunction} [onFinish]
	 */

	/** @typedef {SpringAnimation | CSSAnimation} Animation */

	/** @typedef {SpringAnimationProps | CssAnimationProps} AnimationProps */

	/**
	 * Manages animations
	 */

	class Animations {
	  constructor() {
	    /** @type {Animation[]} */
	    this.activeAnimations = [];
	  }
	  /**
	   * @param {SpringAnimationProps} props
	   */

	  startSpring(props) {
	    this._start(props, true);
	  }
	  /**
	   * @param {CssAnimationProps} props
	   */

	  startTransition(props) {
	    this._start(props);
	  }
	  /**
	   * @private
	   * @param {AnimationProps} props
	   * @param {boolean} [isSpring]
	   * @returns {Animation}
	   */

	  _start(props, isSpring) {
	    const animation = isSpring ? new SpringAnimation(/** @type SpringAnimationProps */
	    props) : new CSSAnimation(/** @type CssAnimationProps */
	    props);
	    this.activeAnimations.push(animation);
	    animation.onFinish = () => this.stop(animation);
	    return animation;
	  }
	  /**
	   * @param {Animation} animation
	   */

	  stop(animation) {
	    animation.destroy();
	    const index = this.activeAnimations.indexOf(animation);
	    if (index > -1) {
	      this.activeAnimations.splice(index, 1);
	    }
	  }
	  stopAll() {
	    // _stopAllAnimations
	    this.activeAnimations.forEach(animation => {
	      animation.destroy();
	    });
	    this.activeAnimations = [];
	  }
	  /**
	   * Stop all pan or zoom transitions
	   */

	  stopAllPan() {
	    this.activeAnimations = this.activeAnimations.filter(animation => {
	      if (animation.props.isPan) {
	        animation.destroy();
	        return false;
	      }
	      return true;
	    });
	  }
	  stopMainScroll() {
	    this.activeAnimations = this.activeAnimations.filter(animation => {
	      if (animation.props.isMainScroll) {
	        animation.destroy();
	        return false;
	      }
	      return true;
	    });
	  }
	  /**
	   * Returns true if main scroll transition is running
	   */
	  // isMainScrollRunning() {
	  //   return this.activeAnimations.some((animation) => {
	  //     return animation.props.isMainScroll;
	  //   });
	  // }

	  /**
	   * Returns true if any pan or zoom transition is running
	   */

	  isPanRunning() {
	    return this.activeAnimations.some(animation => {
	      return animation.props.isPan;
	    });
	  }
	}

	/** @typedef {import('./photoswipe.js').default} PhotoSwipe */

	/**
	 * Handles scroll wheel.
	 * Can pan and zoom current slide image.
	 */
	class ScrollWheel {
	  /**
	   * @param {PhotoSwipe} pswp
	   */
	  constructor(pswp) {
	    this.pswp = pswp;
	    pswp.events.add(pswp.element, 'wheel', /** @type EventListener */
	    this._onWheel.bind(this));
	  }
	  /**
	   * @private
	   * @param {WheelEvent} e
	   */

	  _onWheel(e) {
	    e.preventDefault();
	    const {
	      currSlide
	    } = this.pswp;
	    let {
	      deltaX,
	      deltaY
	    } = e;
	    if (!currSlide) {
	      return;
	    }
	    if (this.pswp.dispatch('wheel', {
	      originalEvent: e
	    }).defaultPrevented) {
	      return;
	    }
	    if (e.ctrlKey || this.pswp.options.wheelToZoom) {
	      // zoom
	      if (currSlide.isZoomable()) {
	        let zoomFactor = -deltaY;
	        if (e.deltaMode === 1
	        /* DOM_DELTA_LINE */) {
	          zoomFactor *= 0.05;
	        } else {
	          zoomFactor *= e.deltaMode ? 1 : 0.002;
	        }
	        zoomFactor = 2 ** zoomFactor;
	        const destZoomLevel = currSlide.currZoomLevel * zoomFactor;
	        currSlide.zoomTo(destZoomLevel, {
	          x: e.clientX,
	          y: e.clientY
	        });
	      }
	    } else {
	      // pan
	      if (currSlide.isPannable()) {
	        if (e.deltaMode === 1
	        /* DOM_DELTA_LINE */) {
	          // 18 - average line height
	          deltaX *= 18;
	          deltaY *= 18;
	        }
	        currSlide.panTo(currSlide.pan.x - deltaX, currSlide.pan.y - deltaY);
	      }
	    }
	  }
	}

	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	/**
	 * @template T
	 * @typedef {import('../types.js').Methods<T>} Methods<T>
	 */

	/**
	 * @typedef {Object} UIElementMarkupProps
	 * @prop {boolean} [isCustomSVG]
	 * @prop {string} inner
	 * @prop {string} [outlineID]
	 * @prop {number | string} [size]
	 */

	/**
	 * @typedef {Object} UIElementData
	 * @prop {DefaultUIElements | string} [name]
	 * @prop {string} [className]
	 * @prop {UIElementMarkup} [html]
	 * @prop {boolean} [isButton]
	 * @prop {keyof HTMLElementTagNameMap} [tagName]
	 * @prop {string} [title]
	 * @prop {string} [ariaLabel]
	 * @prop {(element: HTMLElement, pswp: PhotoSwipe) => void} [onInit]
	 * @prop {Methods<PhotoSwipe> | ((e: MouseEvent, element: HTMLElement, pswp: PhotoSwipe) => void)} [onClick]
	 * @prop {'bar' | 'wrapper' | 'root'} [appendTo]
	 * @prop {number} [order]
	 */

	/** @typedef {'arrowPrev' | 'arrowNext' | 'close' | 'zoom' | 'counter'} DefaultUIElements */

	/** @typedef {string | UIElementMarkupProps} UIElementMarkup */

	/**
	 * @param {UIElementMarkup} [htmlData]
	 * @returns {string}
	 */

	function addElementHTML(htmlData) {
	  if (typeof htmlData === 'string') {
	    // Allow developers to provide full svg,
	    // For example:
	    // <svg viewBox="0 0 32 32" width="32" height="32" aria-hidden="true" class="pswp__icn">
	    //   <path d="..." />
	    //   <circle ... />
	    // </svg>
	    // Can also be any HTML string.
	    return htmlData;
	  }
	  if (!htmlData || !htmlData.isCustomSVG) {
	    return '';
	  }
	  const svgData = htmlData;
	  let out = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">'; // replace all %d with size

	  out = out.split('%d').join(/** @type {string} */
	  svgData.size || 32); // Icons may contain outline/shadow,
	  // to make it we "clone" base icon shape and add border to it.
	  // Icon itself and border are styled via CSS.
	  //
	  // Property shadowID defines ID of element that should be cloned.

	  if (svgData.outlineID) {
	    out += '<use class="pswp__icn-shadow" xlink:href="#' + svgData.outlineID + '"/>';
	  }
	  out += svgData.inner;
	  out += '</svg>';
	  return out;
	}
	class UIElement {
	  /**
	   * @param {PhotoSwipe} pswp
	   * @param {UIElementData} data
	   */
	  constructor(pswp, data) {
	    var _container;
	    const name = data.name || data.className;
	    let elementHTML = data.html; // @ts-expect-error lookup only by `data.name` maybe?

	    if (pswp.options[name] === false) {
	      // exit if element is disabled from options
	      return;
	    } // Allow to override SVG icons from options
	    // @ts-expect-error lookup only by `data.name` maybe?

	    if (typeof pswp.options[name + 'SVG'] === 'string') {
	      // arrowPrevSVG
	      // arrowNextSVG
	      // closeSVG
	      // zoomSVG
	      // @ts-expect-error lookup only by `data.name` maybe?
	      elementHTML = pswp.options[name + 'SVG'];
	    }
	    pswp.dispatch('uiElementCreate', {
	      data
	    });
	    let className = '';
	    if (data.isButton) {
	      className += 'pswp__button ';
	      className += data.className || `pswp__button--${data.name}`;
	    } else {
	      className += data.className || `pswp__${data.name}`;
	    }
	    let tagName = data.isButton ? data.tagName || 'button' : data.tagName || 'div';
	    tagName = /** @type {keyof HTMLElementTagNameMap} */
	    tagName.toLowerCase();
	    /** @type {HTMLElement} */

	    const element = createElement(className, tagName);
	    if (data.isButton) {
	      if (tagName === 'button') {
	        /** @type {HTMLButtonElement} */
	        element.type = 'button';
	      }
	      let {
	        title
	      } = data;
	      const {
	        ariaLabel
	      } = data; // @ts-expect-error lookup only by `data.name` maybe?

	      if (typeof pswp.options[name + 'Title'] === 'string') {
	        // @ts-expect-error lookup only by `data.name` maybe?
	        title = pswp.options[name + 'Title'];
	      }
	      if (title) {
	        element.title = title;
	      }
	      const ariaText = ariaLabel || title;
	      if (ariaText) {
	        element.setAttribute('aria-label', ariaText);
	      }
	    }
	    element.innerHTML = addElementHTML(elementHTML);
	    if (data.onInit) {
	      data.onInit(element, pswp);
	    }
	    if (data.onClick) {
	      element.onclick = e => {
	        if (typeof data.onClick === 'string') {
	          // @ts-ignore
	          pswp[data.onClick]();
	        } else if (typeof data.onClick === 'function') {
	          data.onClick(e, element, pswp);
	        }
	      };
	    } // Top bar is default position

	    const appendTo = data.appendTo || 'bar';
	    /** @type {HTMLElement | undefined} root element by default */

	    let container = pswp.element;
	    if (appendTo === 'bar') {
	      if (!pswp.topBar) {
	        pswp.topBar = createElement('pswp__top-bar pswp__hide-on-close', 'div', pswp.scrollWrap);
	      }
	      container = pswp.topBar;
	    } else {
	      // element outside of top bar gets a secondary class
	      // that makes element fade out on close
	      element.classList.add('pswp__hide-on-close');
	      if (appendTo === 'wrapper') {
	        container = pswp.scrollWrap;
	      }
	    }
	    (_container = container) === null || _container === void 0 || _container.appendChild(pswp.applyFilters('uiElement', element, data));
	  }
	}

	/*
	  Backward and forward arrow buttons
	 */

	/** @typedef {import('./ui-element.js').UIElementData} UIElementData */

	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	/**
	 *
	 * @param {HTMLElement} element
	 * @param {PhotoSwipe} pswp
	 * @param {boolean} [isNextButton]
	 */
	function initArrowButton(element, pswp, isNextButton) {
	  element.classList.add('pswp__button--arrow'); // TODO: this should point to a unique id for this instance

	  element.setAttribute('aria-controls', 'pswp__items');
	  pswp.on('change', () => {
	    if (!pswp.options.loop) {
	      if (isNextButton) {
	        /** @type {HTMLButtonElement} */
	        element.disabled = !(pswp.currIndex < pswp.getNumItems() - 1);
	      } else {
	        /** @type {HTMLButtonElement} */
	        element.disabled = !(pswp.currIndex > 0);
	      }
	    }
	  });
	}
	/** @type {UIElementData} */

	const arrowPrev = {
	  name: 'arrowPrev',
	  className: 'pswp__button--arrow--prev',
	  title: 'Previous',
	  order: 10,
	  isButton: true,
	  appendTo: 'wrapper',
	  html: {
	    isCustomSVG: true,
	    size: 60,
	    inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
	    outlineID: 'pswp__icn-arrow'
	  },
	  onClick: 'prev',
	  onInit: initArrowButton
	};
	/** @type {UIElementData} */

	const arrowNext = {
	  name: 'arrowNext',
	  className: 'pswp__button--arrow--next',
	  title: 'Next',
	  order: 11,
	  isButton: true,
	  appendTo: 'wrapper',
	  html: {
	    isCustomSVG: true,
	    size: 60,
	    inner: '<use xlink:href="#pswp__icn-arrow"/>',
	    outlineID: 'pswp__icn-arrow'
	  },
	  onClick: 'next',
	  onInit: (el, pswp) => {
	    initArrowButton(el, pswp, true);
	  }
	};

	/** @type {import('./ui-element.js').UIElementData} UIElementData */
	const closeButton = {
	  name: 'close',
	  title: 'Close',
	  order: 20,
	  isButton: true,
	  html: {
	    isCustomSVG: true,
	    inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
	    outlineID: 'pswp__icn-close'
	  },
	  onClick: 'close'
	};

	/** @type {import('./ui-element.js').UIElementData} UIElementData */
	const zoomButton = {
	  name: 'zoom',
	  title: 'Zoom',
	  order: 10,
	  isButton: true,
	  html: {
	    isCustomSVG: true,
	    // eslint-disable-next-line max-len
	    inner: '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/>' + '<path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/>' + '<path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
	    outlineID: 'pswp__icn-zoom'
	  },
	  onClick: 'toggleZoom'
	};

	/** @type {import('./ui-element.js').UIElementData} UIElementData */
	const loadingIndicator = {
	  name: 'preloader',
	  appendTo: 'bar',
	  order: 7,
	  html: {
	    isCustomSVG: true,
	    // eslint-disable-next-line max-len
	    inner: '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
	    outlineID: 'pswp__icn-loading'
	  },
	  onInit: (indicatorElement, pswp) => {
	    /** @type {boolean | undefined} */
	    let isVisible;
	    /** @type {NodeJS.Timeout | null} */

	    let delayTimeout = null;
	    /**
	     * @param {string} className
	     * @param {boolean} add
	     */

	    const toggleIndicatorClass = (className, add) => {
	      indicatorElement.classList.toggle('pswp__preloader--' + className, add);
	    };
	    /**
	     * @param {boolean} visible
	     */

	    const setIndicatorVisibility = visible => {
	      if (isVisible !== visible) {
	        isVisible = visible;
	        toggleIndicatorClass('active', visible);
	      }
	    };
	    const updatePreloaderVisibility = () => {
	      var _pswp$currSlide;
	      if (!((_pswp$currSlide = pswp.currSlide) !== null && _pswp$currSlide !== void 0 && _pswp$currSlide.content.isLoading())) {
	        setIndicatorVisibility(false);
	        if (delayTimeout) {
	          clearTimeout(delayTimeout);
	          delayTimeout = null;
	        }
	        return;
	      }
	      if (!delayTimeout) {
	        // display loading indicator with delay
	        delayTimeout = setTimeout(() => {
	          var _pswp$currSlide2;
	          setIndicatorVisibility(Boolean((_pswp$currSlide2 = pswp.currSlide) === null || _pswp$currSlide2 === void 0 ? void 0 : _pswp$currSlide2.content.isLoading()));
	          delayTimeout = null;
	        }, pswp.options.preloaderDelay);
	      }
	    };
	    pswp.on('change', updatePreloaderVisibility);
	    pswp.on('loadComplete', e => {
	      if (pswp.currSlide === e.slide) {
	        updatePreloaderVisibility();
	      }
	    }); // expose the method

	    if (pswp.ui) {
	      pswp.ui.updatePreloaderVisibility = updatePreloaderVisibility;
	    }
	  }
	};

	/** @type {import('./ui-element.js').UIElementData} UIElementData */
	const counterIndicator = {
	  name: 'counter',
	  order: 5,
	  onInit: (counterElement, pswp) => {
	    pswp.on('change', () => {
	      counterElement.innerText = pswp.currIndex + 1 + pswp.options.indexIndicatorSep + pswp.getNumItems();
	    });
	  }
	};

	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	/** @typedef {import('./ui-element.js').UIElementData} UIElementData */

	/**
	 * Set special class on element when image is zoomed.
	 *
	 * By default, it is used to adjust
	 * zoom icon and zoom cursor via CSS.
	 *
	 * @param {HTMLElement} el
	 * @param {boolean} isZoomedIn
	 */

	function setZoomedIn(el, isZoomedIn) {
	  el.classList.toggle('pswp--zoomed-in', isZoomedIn);
	}
	class UI {
	  /**
	   * @param {PhotoSwipe} pswp
	   */
	  constructor(pswp) {
	    this.pswp = pswp;
	    this.isRegistered = false;
	    /** @type {UIElementData[]} */

	    this.uiElementsData = [];
	    /** @type {(UIElement | UIElementData)[]} */

	    this.items = [];
	    /** @type {() => void} */

	    this.updatePreloaderVisibility = () => {};
	    /**
	     * @private
	     * @type {number | undefined}
	     */

	    this._lastUpdatedZoomLevel = undefined;
	  }
	  init() {
	    const {
	      pswp
	    } = this;
	    this.isRegistered = false;
	    this.uiElementsData = [closeButton, arrowPrev, arrowNext, zoomButton, loadingIndicator, counterIndicator];
	    pswp.dispatch('uiRegister'); // sort by order

	    this.uiElementsData.sort((a, b) => {
	      // default order is 0
	      return (a.order || 0) - (b.order || 0);
	    });
	    this.items = [];
	    this.isRegistered = true;
	    this.uiElementsData.forEach(uiElementData => {
	      this.registerElement(uiElementData);
	    });
	    pswp.on('change', () => {
	      var _pswp$element;
	      (_pswp$element = pswp.element) === null || _pswp$element === void 0 || _pswp$element.classList.toggle('pswp--one-slide', pswp.getNumItems() === 1);
	    });
	    pswp.on('zoomPanUpdate', () => this._onZoomPanUpdate());
	  }
	  /**
	   * @param {UIElementData} elementData
	   */

	  registerElement(elementData) {
	    if (this.isRegistered) {
	      this.items.push(new UIElement(this.pswp, elementData));
	    } else {
	      this.uiElementsData.push(elementData);
	    }
	  }
	  /**
	   * Fired each time zoom or pan position is changed.
	   * Update classes that control visibility of zoom button and cursor icon.
	   *
	   * @private
	   */

	  _onZoomPanUpdate() {
	    const {
	      template,
	      currSlide,
	      options
	    } = this.pswp;
	    if (this.pswp.opener.isClosing || !template || !currSlide) {
	      return;
	    }
	    let {
	      currZoomLevel
	    } = currSlide; // if not open yet - check against initial zoom level

	    if (!this.pswp.opener.isOpen) {
	      currZoomLevel = currSlide.zoomLevels.initial;
	    }
	    if (currZoomLevel === this._lastUpdatedZoomLevel) {
	      return;
	    }
	    this._lastUpdatedZoomLevel = currZoomLevel;
	    const currZoomLevelDiff = currSlide.zoomLevels.initial - currSlide.zoomLevels.secondary; // Initial and secondary zoom levels are almost equal

	    if (Math.abs(currZoomLevelDiff) < 0.01 || !currSlide.isZoomable()) {
	      // disable zoom
	      setZoomedIn(template, false);
	      template.classList.remove('pswp--zoom-allowed');
	      return;
	    }
	    template.classList.add('pswp--zoom-allowed');
	    const potentialZoomLevel = currZoomLevel === currSlide.zoomLevels.initial ? currSlide.zoomLevels.secondary : currSlide.zoomLevels.initial;
	    setZoomedIn(template, potentialZoomLevel <= currZoomLevel);
	    if (options.imageClickAction === 'zoom' || options.imageClickAction === 'zoom-or-close') {
	      template.classList.add('pswp--click-to-zoom');
	    }
	  }
	}

	/** @typedef {import('./slide.js').SlideData} SlideData */

	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	/** @typedef {{ x: number; y: number; w: number; innerRect?: { w: number; h: number; x: number; y: number } }} Bounds */

	/**
	 * @param {HTMLElement} el
	 * @returns Bounds
	 */
	function getBoundsByElement(el) {
	  const thumbAreaRect = el.getBoundingClientRect();
	  return {
	    x: thumbAreaRect.left,
	    y: thumbAreaRect.top,
	    w: thumbAreaRect.width
	  };
	}
	/**
	 * @param {HTMLElement} el
	 * @param {number} imageWidth
	 * @param {number} imageHeight
	 * @returns Bounds
	 */

	function getCroppedBoundsByElement(el, imageWidth, imageHeight) {
	  const thumbAreaRect = el.getBoundingClientRect(); // fill image into the area
	  // (do they same as object-fit:cover does to retrieve coordinates)

	  const hRatio = thumbAreaRect.width / imageWidth;
	  const vRatio = thumbAreaRect.height / imageHeight;
	  const fillZoomLevel = hRatio > vRatio ? hRatio : vRatio;
	  const offsetX = (thumbAreaRect.width - imageWidth * fillZoomLevel) / 2;
	  const offsetY = (thumbAreaRect.height - imageHeight * fillZoomLevel) / 2;
	  /**
	   * Coordinates of the image,
	   * as if it was not cropped,
	   * height is calculated automatically
	   *
	   * @type {Bounds}
	   */

	  const bounds = {
	    x: thumbAreaRect.left + offsetX,
	    y: thumbAreaRect.top + offsetY,
	    w: imageWidth * fillZoomLevel
	  }; // Coordinates of inner crop area
	  // relative to the image

	  bounds.innerRect = {
	    w: thumbAreaRect.width,
	    h: thumbAreaRect.height,
	    x: offsetX,
	    y: offsetY
	  };
	  return bounds;
	}
	/**
	 * Get dimensions of thumbnail image
	 * (click on which opens photoswipe or closes photoswipe to)
	 *
	 * @param {number} index
	 * @param {SlideData} itemData
	 * @param {PhotoSwipe} instance PhotoSwipe instance
	 * @returns {Bounds | undefined}
	 */

	function getThumbBounds(index, itemData, instance) {
	  // legacy event, before filters were introduced
	  const event = instance.dispatch('thumbBounds', {
	    index,
	    itemData,
	    instance
	  }); // @ts-expect-error

	  if (event.thumbBounds) {
	    // @ts-expect-error
	    return event.thumbBounds;
	  }
	  const {
	    element
	  } = itemData;
	  /** @type {Bounds | undefined} */

	  let thumbBounds;
	  /** @type {HTMLElement | null | undefined} */

	  let thumbnail;
	  if (element && instance.options.thumbSelector !== false) {
	    const thumbSelector = instance.options.thumbSelector || 'img';
	    thumbnail = element.matches(thumbSelector) ? element : /** @type {HTMLElement | null} */
	    element.querySelector(thumbSelector);
	  }
	  thumbnail = instance.applyFilters('thumbEl', thumbnail, itemData, index);
	  if (thumbnail) {
	    if (!itemData.thumbCropped) {
	      thumbBounds = getBoundsByElement(thumbnail);
	    } else {
	      thumbBounds = getCroppedBoundsByElement(thumbnail, itemData.width || itemData.w || 0, itemData.height || itemData.h || 0);
	    }
	  }
	  return instance.applyFilters('thumbBounds', thumbBounds, itemData, index);
	}

	/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */

	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

	/** @typedef {import('../photoswipe.js').DataSource} DataSource */

	/** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */

	/** @typedef {import('../slide/content.js').default} ContentDefault */

	/** @typedef {import('../slide/slide.js').default} Slide */

	/** @typedef {import('../slide/slide.js').SlideData} SlideData */

	/** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */

	/** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */

	/**
	 * Allow adding an arbitrary props to the Content
	 * https://photoswipe.com/custom-content/#using-webp-image-format
	 * @typedef {ContentDefault & Record<string, any>} Content
	 */

	/** @typedef {{ x?: number; y?: number }} Point */

	/**
	 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
	 *
	 *
	 * https://photoswipe.com/adding-ui-elements/
	 *
	 * @prop {undefined} uiRegister
	 * @prop {{ data: UIElementData }} uiElementCreate
	 *
	 *
	 * https://photoswipe.com/events/#initialization-events
	 *
	 * @prop {undefined} beforeOpen
	 * @prop {undefined} firstUpdate
	 * @prop {undefined} initialLayout
	 * @prop {undefined} change
	 * @prop {undefined} afterInit
	 * @prop {undefined} bindEvents
	 *
	 *
	 * https://photoswipe.com/events/#opening-or-closing-transition-events
	 *
	 * @prop {undefined} openingAnimationStart
	 * @prop {undefined} openingAnimationEnd
	 * @prop {undefined} closingAnimationStart
	 * @prop {undefined} closingAnimationEnd
	 *
	 *
	 * https://photoswipe.com/events/#closing-events
	 *
	 * @prop {undefined} close
	 * @prop {undefined} destroy
	 *
	 *
	 * https://photoswipe.com/events/#pointer-and-gesture-events
	 *
	 * @prop {{ originalEvent: PointerEvent }} pointerDown
	 * @prop {{ originalEvent: PointerEvent }} pointerMove
	 * @prop {{ originalEvent: PointerEvent }} pointerUp
	 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
	 * @prop {{ panY: number }} verticalDrag can be default prevented
	 *
	 *
	 * https://photoswipe.com/events/#slide-content-events
	 *
	 * @prop {{ content: Content }} contentInit
	 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
	 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
	 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
	 * @prop {{ content: Content; slide: Slide }} loadError
	 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
	 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
	 * @prop {{ content: Content }} contentLazyLoad can be default prevented
	 * @prop {{ content: Content }} contentAppend can be default prevented
	 * @prop {{ content: Content }} contentActivate can be default prevented
	 * @prop {{ content: Content }} contentDeactivate can be default prevented
	 * @prop {{ content: Content }} contentRemove can be default prevented
	 * @prop {{ content: Content }} contentDestroy can be default prevented
	 *
	 *
	 * undocumented
	 *
	 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
	 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
	 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
	 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
	 *
	 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
	 * @prop {{ x: number; dragging: boolean }} moveMainScroll
	 * @prop {{ slide: Slide }} firstZoomPan
	 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
	 * @prop {undefined} beforeResize
	 * @prop {undefined} resize
	 * @prop {undefined} viewportSize
	 * @prop {undefined} updateScrollOffset
	 * @prop {{ slide: Slide }} slideInit
	 * @prop {{ slide: Slide }} afterSetContent
	 * @prop {{ slide: Slide }} slideLoad
	 * @prop {{ slide: Slide }} appendHeavy can be default prevented
	 * @prop {{ slide: Slide }} appendHeavyContent
	 * @prop {{ slide: Slide }} slideActivate
	 * @prop {{ slide: Slide }} slideDeactivate
	 * @prop {{ slide: Slide }} slideDestroy
	 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
	 * @prop {{ slide: Slide }} zoomPanUpdate
	 * @prop {{ slide: Slide }} initialZoomPan
	 * @prop {{ slide: Slide }} calcSlideSize
	 * @prop {undefined} resolutionChanged
	 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
	 * @prop {{ content: Content }} contentAppendImage can be default prevented
	 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
	 * @prop {undefined} lazyLoad
	 * @prop {{ slide: Slide }} calcBounds
	 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
	 *
	 *
	 * legacy
	 *
	 * @prop {undefined} init
	 * @prop {undefined} initialZoomIn
	 * @prop {undefined} initialZoomOut
	 * @prop {undefined} initialZoomInEnd
	 * @prop {undefined} initialZoomOutEnd
	 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
	 * @prop {{ itemData: SlideData; index: number }} itemData
	 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
	 */

	/**
	 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
	 *
	 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
	 * Modify the total amount of slides. Example on Data sources page.
	 * https://photoswipe.com/filters/#numitems
	 *
	 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
	 * Modify slide item data. Example on Data sources page.
	 * https://photoswipe.com/filters/#itemdata
	 *
	 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
	 * Modify item data when it's parsed from DOM element. Example on Data sources page.
	 * https://photoswipe.com/filters/#domitemdata
	 *
	 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
	 * Modify clicked gallery item index.
	 * https://photoswipe.com/filters/#clickedindex
	 *
	 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
	 * Modify placeholder image source.
	 * https://photoswipe.com/filters/#placeholdersrc
	 *
	 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
	 * Modify if the content is currently loading.
	 * https://photoswipe.com/filters/#iscontentloading
	 *
	 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
	 * Modify if the content can be zoomed.
	 * https://photoswipe.com/filters/#iscontentzoomable
	 *
	 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
	 * Modify if the placeholder should be used for the content.
	 * https://photoswipe.com/filters/#usecontentplaceholder
	 *
	 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
	 * Modify if the placeholder should be kept after the content is loaded.
	 * https://photoswipe.com/filters/#iskeepingplaceholder
	 *
	 *
	 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
	 * Modify an element when the content has error state (for example, if image cannot be loaded).
	 * https://photoswipe.com/filters/#contenterrorelement
	 *
	 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
	 * Modify a UI element that's being created.
	 * https://photoswipe.com/filters/#uielement
	 *
	 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
	 * Modify the thumbnail element from which opening zoom animation starts or ends.
	 * https://photoswipe.com/filters/#thumbel
	 *
	 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
	 * Modify the thumbnail bounds from which opening zoom animation starts or ends.
	 * https://photoswipe.com/filters/#thumbbounds
	 *
	 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
	 *
	 * @prop {(preventPointerEvent: boolean, event: PointerEvent, pointerType: string) => boolean} preventPointerEvent
	 *
	 */

	/**
	 * @template {keyof PhotoSwipeFiltersMap} T
	 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
	 */

	/**
	 * @template {keyof PhotoSwipeEventsMap} T
	 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
	 */

	/**
	 * @template {keyof PhotoSwipeEventsMap} T
	 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
	 */

	/**
	 * Base PhotoSwipe event object
	 *
	 * @template {keyof PhotoSwipeEventsMap} T
	 */
	class PhotoSwipeEvent {
	  /**
	   * @param {T} type
	   * @param {PhotoSwipeEventsMap[T]} [details]
	   */
	  constructor(type, details) {
	    this.type = type;
	    this.defaultPrevented = false;
	    if (details) {
	      Object.assign(this, details);
	    }
	  }
	  preventDefault() {
	    this.defaultPrevented = true;
	  }
	}
	/**
	 * PhotoSwipe base class that can listen and dispatch for events.
	 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
	 */

	class Eventable {
	  constructor() {
	    /**
	     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
	     */
	    this._listeners = {};
	    /**
	     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
	     */

	    this._filters = {};
	    /** @type {PhotoSwipe | undefined} */

	    this.pswp = undefined;
	    /** @type {PhotoSwipeOptions | undefined} */

	    this.options = undefined;
	  }
	  /**
	   * @template {keyof PhotoSwipeFiltersMap} T
	   * @param {T} name
	   * @param {PhotoSwipeFiltersMap[T]} fn
	   * @param {number} priority
	   */

	  addFilter(name, fn, priority = 100) {
	    var _this$_filters$name, _this$_filters$name2, _this$pswp;
	    if (!this._filters[name]) {
	      this._filters[name] = [];
	    }
	    (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
	      fn,
	      priority
	    });
	    (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort((f1, f2) => f1.priority - f2.priority);
	    (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
	  }
	  /**
	   * @template {keyof PhotoSwipeFiltersMap} T
	   * @param {T} name
	   * @param {PhotoSwipeFiltersMap[T]} fn
	   */

	  removeFilter(name, fn) {
	    if (this._filters[name]) {
	      // @ts-expect-error
	      this._filters[name] = this._filters[name].filter(filter => filter.fn !== fn);
	    }
	    if (this.pswp) {
	      this.pswp.removeFilter(name, fn);
	    }
	  }
	  /**
	   * @template {keyof PhotoSwipeFiltersMap} T
	   * @param {T} name
	   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
	   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
	   */

	  applyFilters(name, ...args) {
	    var _this$_filters$name3;
	    (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach(filter => {
	      // @ts-expect-error
	      args[0] = filter.fn.apply(this, args);
	    });
	    return args[0];
	  }
	  /**
	   * @template {keyof PhotoSwipeEventsMap} T
	   * @param {T} name
	   * @param {EventCallback<T>} fn
	   */

	  on(name, fn) {
	    var _this$_listeners$name, _this$pswp2;
	    if (!this._listeners[name]) {
	      this._listeners[name] = [];
	    }
	    (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn); // When binding events to lightbox,
	    // also bind events to PhotoSwipe Core,
	    // if it's open.

	    (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
	  }
	  /**
	   * @template {keyof PhotoSwipeEventsMap} T
	   * @param {T} name
	   * @param {EventCallback<T>} fn
	   */

	  off(name, fn) {
	    var _this$pswp3;
	    if (this._listeners[name]) {
	      // @ts-expect-error
	      this._listeners[name] = this._listeners[name].filter(listener => fn !== listener);
	    }
	    (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
	  }
	  /**
	   * @template {keyof PhotoSwipeEventsMap} T
	   * @param {T} name
	   * @param {PhotoSwipeEventsMap[T]} [details]
	   * @returns {AugmentedEvent<T>}
	   */

	  dispatch(name, details) {
	    var _this$_listeners$name2;
	    if (this.pswp) {
	      return this.pswp.dispatch(name, details);
	    }
	    const event = /** @type {AugmentedEvent<T>} */
	    new PhotoSwipeEvent(name, details);
	    (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach(listener => {
	      listener.call(this, event);
	    });
	    return event;
	  }
	}
	class Placeholder {
	  /**
	   * @param {string | false} imageSrc
	   * @param {HTMLElement} container
	   */
	  constructor(imageSrc, container) {
	    // Create placeholder
	    // (stretched thumbnail or simple div behind the main image)

	    /** @type {HTMLImageElement | HTMLDivElement | null} */
	    this.element = createElement('pswp__img pswp__img--placeholder', imageSrc ? 'img' : 'div', container);
	    if (imageSrc) {
	      const imgEl = /** @type {HTMLImageElement} */
	      this.element;
	      imgEl.decoding = 'async';
	      imgEl.alt = '';
	      imgEl.src = imageSrc;
	      imgEl.setAttribute('role', 'presentation');
	    }
	    this.element.setAttribute('aria-hidden', 'true');
	  }
	  /**
	   * @param {number} width
	   * @param {number} height
	   */

	  setDisplayedSize(width, height) {
	    if (!this.element) {
	      return;
	    }
	    if (this.element.tagName === 'IMG') {
	      // Use transform scale() to modify img placeholder size
	      // (instead of changing width/height directly).
	      // This helps with performance, specifically in iOS15 Safari.
	      setWidthHeight(this.element, 250, 'auto');
	      this.element.style.transformOrigin = '0 0';
	      this.element.style.transform = toTransformString(0, 0, width / 250);
	    } else {
	      setWidthHeight(this.element, width, height);
	    }
	  }
	  destroy() {
	    var _this$element;
	    if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) {
	      this.element.remove();
	    }
	    this.element = null;
	  }
	}

	/** @typedef {import('./slide.js').default} Slide */

	/** @typedef {import('./slide.js').SlideData} SlideData */

	/** @typedef {import('../core/base.js').default} PhotoSwipeBase */

	/** @typedef {import('../util/util.js').LoadState} LoadState */

	class Content {
	  /**
	   * @param {SlideData} itemData Slide data
	   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
	   * @param {number} index
	   */
	  constructor(itemData, instance, index) {
	    this.instance = instance;
	    this.data = itemData;
	    this.index = index;
	    /** @type {HTMLImageElement | HTMLDivElement | undefined} */

	    this.element = undefined;
	    /** @type {Placeholder | undefined} */

	    this.placeholder = undefined;
	    /** @type {Slide | undefined} */

	    this.slide = undefined;
	    this.displayedImageWidth = 0;
	    this.displayedImageHeight = 0;
	    this.width = Number(this.data.w) || Number(this.data.width) || 0;
	    this.height = Number(this.data.h) || Number(this.data.height) || 0;
	    this.isAttached = false;
	    this.hasSlide = false;
	    this.isDecoding = false;
	    /** @type {LoadState} */

	    this.state = LOAD_STATE.IDLE;
	    if (this.data.type) {
	      this.type = this.data.type;
	    } else if (this.data.src) {
	      this.type = 'image';
	    } else {
	      this.type = 'html';
	    }
	    this.instance.dispatch('contentInit', {
	      content: this
	    });
	  }
	  removePlaceholder() {
	    if (this.placeholder && !this.keepPlaceholder()) {
	      // With delay, as image might be loaded, but not rendered
	      setTimeout(() => {
	        if (this.placeholder) {
	          this.placeholder.destroy();
	          this.placeholder = undefined;
	        }
	      }, 1000);
	    }
	  }
	  /**
	   * Preload content
	   *
	   * @param {boolean} isLazy
	   * @param {boolean} [reload]
	   */

	  load(isLazy, reload) {
	    if (this.slide && this.usePlaceholder()) {
	      if (!this.placeholder) {
	        const placeholderSrc = this.instance.applyFilters('placeholderSrc',
	        // use  image-based placeholder only for the first slide,
	        // as rendering (even small stretched thumbnail) is an expensive operation
	        this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
	        this.placeholder = new Placeholder(placeholderSrc, this.slide.container);
	      } else {
	        const placeholderEl = this.placeholder.element; // Add placeholder to DOM if it was already created

	        if (placeholderEl && !placeholderEl.parentElement) {
	          this.slide.container.prepend(placeholderEl);
	        }
	      }
	    }
	    if (this.element && !reload) {
	      return;
	    }
	    if (this.instance.dispatch('contentLoad', {
	      content: this,
	      isLazy
	    }).defaultPrevented) {
	      return;
	    }
	    if (this.isImageContent()) {
	      this.element = createElement('pswp__img', 'img'); // Start loading only after width is defined, as sizes might depend on it.
	      // Due to Safari feature, we must define sizes before srcset.

	      if (this.displayedImageWidth) {
	        this.loadImage(isLazy);
	      }
	    } else {
	      this.element = createElement('pswp__content', 'div');
	      this.element.innerHTML = this.data.html || '';
	    }
	    if (reload && this.slide) {
	      this.slide.updateContentSize(true);
	    }
	  }
	  /**
	   * Preload image
	   *
	   * @param {boolean} isLazy
	   */

	  loadImage(isLazy) {
	    var _this$data$src, _this$data$alt;
	    if (!this.isImageContent() || !this.element || this.instance.dispatch('contentLoadImage', {
	      content: this,
	      isLazy
	    }).defaultPrevented) {
	      return;
	    }
	    const imageElement = /** @type HTMLImageElement */
	    this.element;
	    this.updateSrcsetSizes();
	    if (this.data.srcset) {
	      imageElement.srcset = this.data.srcset;
	    }
	    imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : '';
	    imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : '';
	    this.state = LOAD_STATE.LOADING;
	    if (imageElement.complete) {
	      this.onLoaded();
	    } else {
	      imageElement.onload = () => {
	        this.onLoaded();
	      };
	      imageElement.onerror = () => {
	        this.onError();
	      };
	    }
	  }
	  /**
	   * Assign slide to content
	   *
	   * @param {Slide} slide
	   */

	  setSlide(slide) {
	    this.slide = slide;
	    this.hasSlide = true;
	    this.instance = slide.pswp; // todo: do we need to unset slide?
	  }
	  /**
	   * Content load success handler
	   */

	  onLoaded() {
	    this.state = LOAD_STATE.LOADED;
	    if (this.slide && this.element) {
	      this.instance.dispatch('loadComplete', {
	        slide: this.slide,
	        content: this
	      }); // if content is reloaded

	      if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
	        this.append();
	        this.slide.updateContentSize(true);
	      }
	      if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
	        this.removePlaceholder();
	      }
	    }
	  }
	  /**
	   * Content load error handler
	   */

	  onError() {
	    this.state = LOAD_STATE.ERROR;
	    if (this.slide) {
	      this.displayError();
	      this.instance.dispatch('loadComplete', {
	        slide: this.slide,
	        isError: true,
	        content: this
	      });
	      this.instance.dispatch('loadError', {
	        slide: this.slide,
	        content: this
	      });
	    }
	  }
	  /**
	   * @returns {Boolean} If the content is currently loading
	   */

	  isLoading() {
	    return this.instance.applyFilters('isContentLoading', this.state === LOAD_STATE.LOADING, this);
	  }
	  /**
	   * @returns {Boolean} If the content is in error state
	   */

	  isError() {
	    return this.state === LOAD_STATE.ERROR;
	  }
	  /**
	   * @returns {boolean} If the content is image
	   */

	  isImageContent() {
	    return this.type === 'image';
	  }
	  /**
	   * Update content size
	   *
	   * @param {Number} width
	   * @param {Number} height
	   */

	  setDisplayedSize(width, height) {
	    if (!this.element) {
	      return;
	    }
	    if (this.placeholder) {
	      this.placeholder.setDisplayedSize(width, height);
	    }
	    if (this.instance.dispatch('contentResize', {
	      content: this,
	      width,
	      height
	    }).defaultPrevented) {
	      return;
	    }
	    setWidthHeight(this.element, width, height);
	    if (this.isImageContent() && !this.isError()) {
	      const isInitialSizeUpdate = !this.displayedImageWidth && width;
	      this.displayedImageWidth = width;
	      this.displayedImageHeight = height;
	      if (isInitialSizeUpdate) {
	        this.loadImage(false);
	      } else {
	        this.updateSrcsetSizes();
	      }
	      if (this.slide) {
	        this.instance.dispatch('imageSizeChange', {
	          slide: this.slide,
	          width,
	          height,
	          content: this
	        });
	      }
	    }
	  }
	  /**
	   * @returns {boolean} If the content can be zoomed
	   */

	  isZoomable() {
	    return this.instance.applyFilters('isContentZoomable', this.isImageContent() && this.state !== LOAD_STATE.ERROR, this);
	  }
	  /**
	   * Update image srcset sizes attribute based on width and height
	   */

	  updateSrcsetSizes() {
	    // Handle srcset sizes attribute.
	    //
	    // Never lower quality, if it was increased previously.
	    // Chrome does this automatically, Firefox and Safari do not,
	    // so we store largest used size in dataset.
	    if (!this.isImageContent() || !this.element || !this.data.srcset) {
	      return;
	    }
	    const image = /** @type HTMLImageElement */
	    this.element;
	    const sizesWidth = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
	    if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
	      image.sizes = sizesWidth + 'px';
	      image.dataset.largestUsedSize = String(sizesWidth);
	    }
	  }
	  /**
	   * @returns {boolean} If content should use a placeholder (from msrc by default)
	   */

	  usePlaceholder() {
	    return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
	  }
	  /**
	   * Preload content with lazy-loading param
	   */

	  lazyLoad() {
	    if (this.instance.dispatch('contentLazyLoad', {
	      content: this
	    }).defaultPrevented) {
	      return;
	    }
	    this.load(true);
	  }
	  /**
	   * @returns {boolean} If placeholder should be kept after content is loaded
	   */

	  keepPlaceholder() {
	    return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
	  }
	  /**
	   * Destroy the content
	   */

	  destroy() {
	    this.hasSlide = false;
	    this.slide = undefined;
	    if (this.instance.dispatch('contentDestroy', {
	      content: this
	    }).defaultPrevented) {
	      return;
	    }
	    this.remove();
	    if (this.placeholder) {
	      this.placeholder.destroy();
	      this.placeholder = undefined;
	    }
	    if (this.isImageContent() && this.element) {
	      this.element.onload = null;
	      this.element.onerror = null;
	      this.element = undefined;
	    }
	  }
	  /**
	   * Display error message
	   */

	  displayError() {
	    if (this.slide) {
	      var _this$instance$option, _this$instance$option2;
	      let errorMsgEl = createElement('pswp__error-msg', 'div');
	      errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : '';
	      errorMsgEl = /** @type {HTMLDivElement} */
	      this.instance.applyFilters('contentErrorElement', errorMsgEl, this);
	      this.element = createElement('pswp__content pswp__error-msg-container', 'div');
	      this.element.appendChild(errorMsgEl);
	      this.slide.container.innerText = '';
	      this.slide.container.appendChild(this.element);
	      this.slide.updateContentSize(true);
	      this.removePlaceholder();
	    }
	  }
	  /**
	   * Append the content
	   */

	  append() {
	    if (this.isAttached || !this.element) {
	      return;
	    }
	    this.isAttached = true;
	    if (this.state === LOAD_STATE.ERROR) {
	      this.displayError();
	      return;
	    }
	    if (this.instance.dispatch('contentAppend', {
	      content: this
	    }).defaultPrevented) {
	      return;
	    }
	    const supportsDecode = 'decode' in this.element;
	    if (this.isImageContent()) {
	      // Use decode() on nearby slides
	      //
	      // Nearby slide images are in DOM and not hidden via display:none.
	      // However, they are placed offscreen (to the left and right side).
	      //
	      // Some browsers do not composite the image until it's actually visible,
	      // using decode() helps.
	      //
	      // You might ask "why dont you just decode() and then append all images",
	      // that's because I want to show image before it's fully loaded,
	      // as browser can render parts of image while it is loading.
	      // We do not do this in Safari due to partial loading bug.
	      if (supportsDecode && this.slide && (!this.slide.isActive || isSafari())) {
	        this.isDecoding = true; // purposefully using finally instead of then,
	        // as if srcset sizes changes dynamically - it may cause decode error

	        /** @type {HTMLImageElement} */

	        this.element.decode().catch(() => {}).finally(() => {
	          this.isDecoding = false;
	          this.appendImage();
	        });
	      } else {
	        this.appendImage();
	      }
	    } else if (this.slide && !this.element.parentNode) {
	      this.slide.container.appendChild(this.element);
	    }
	  }
	  /**
	   * Activate the slide,
	   * active slide is generally the current one,
	   * meaning the user can see it.
	   */

	  activate() {
	    if (this.instance.dispatch('contentActivate', {
	      content: this
	    }).defaultPrevented || !this.slide) {
	      return;
	    }
	    if (this.isImageContent() && this.isDecoding && !isSafari()) {
	      // add image to slide when it becomes active,
	      // even if it's not finished decoding
	      this.appendImage();
	    } else if (this.isError()) {
	      this.load(false, true); // try to reload
	    }
	    if (this.slide.holderElement) {
	      this.slide.holderElement.setAttribute('aria-hidden', 'false');
	    }
	  }
	  /**
	   * Deactivate the content
	   */

	  deactivate() {
	    this.instance.dispatch('contentDeactivate', {
	      content: this
	    });
	    if (this.slide && this.slide.holderElement) {
	      this.slide.holderElement.setAttribute('aria-hidden', 'true');
	    }
	  }
	  /**
	   * Remove the content from DOM
	   */

	  remove() {
	    this.isAttached = false;
	    if (this.instance.dispatch('contentRemove', {
	      content: this
	    }).defaultPrevented) {
	      return;
	    }
	    if (this.element && this.element.parentNode) {
	      this.element.remove();
	    }
	    if (this.placeholder && this.placeholder.element) {
	      this.placeholder.element.remove();
	    }
	  }
	  /**
	   * Append the image content to slide container
	   */

	  appendImage() {
	    if (!this.isAttached) {
	      return;
	    }
	    if (this.instance.dispatch('contentAppendImage', {
	      content: this
	    }).defaultPrevented) {
	      return;
	    } // ensure that element exists and is not already appended

	    if (this.slide && this.element && !this.element.parentNode) {
	      this.slide.container.appendChild(this.element);
	    }
	    if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
	      this.removePlaceholder();
	    }
	  }
	}

	/** @typedef {import('./content.js').default} Content */

	/** @typedef {import('./slide.js').default} Slide */

	/** @typedef {import('./slide.js').SlideData} SlideData */

	/** @typedef {import('../core/base.js').default} PhotoSwipeBase */

	/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

	const MIN_SLIDES_TO_CACHE = 5;
	/**
	 * Lazy-load an image
	 * This function is used both by Lightbox and PhotoSwipe core,
	 * thus it can be called before dialog is opened.
	 *
	 * @param {SlideData} itemData Data about the slide
	 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
	 * @param {number} index
	 * @returns {Content} Image that is being decoded or false.
	 */

	function lazyLoadData(itemData, instance, index) {
	  const content = instance.createContentFromData(itemData, index);
	  /** @type {ZoomLevel | undefined} */

	  let zoomLevel;
	  const {
	    options
	  } = instance; // We need to know dimensions of the image to preload it,
	  // as it might use srcset, and we need to define sizes

	  if (options) {
	    zoomLevel = new ZoomLevel(options, itemData, -1);
	    let viewportSize;
	    if (instance.pswp) {
	      viewportSize = instance.pswp.viewportSize;
	    } else {
	      viewportSize = getViewportSize(options, instance);
	    }
	    const panAreaSize = getPanAreaSize(options, viewportSize, itemData, index);
	    zoomLevel.update(content.width, content.height, panAreaSize);
	  }
	  content.lazyLoad();
	  if (zoomLevel) {
	    content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
	  }
	  return content;
	}
	/**
	 * Lazy-loads specific slide.
	 * This function is used both by Lightbox and PhotoSwipe core,
	 * thus it can be called before dialog is opened.
	 *
	 * By default, it loads image based on viewport size and initial zoom level.
	 *
	 * @param {number} index Slide index
	 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
	 * @returns {Content | undefined}
	 */

	function lazyLoadSlide(index, instance) {
	  const itemData = instance.getItemData(index);
	  if (instance.dispatch('lazyLoadSlide', {
	    index,
	    itemData
	  }).defaultPrevented) {
	    return;
	  }
	  return lazyLoadData(itemData, instance, index);
	}
	class ContentLoader {
	  /**
	   * @param {PhotoSwipe} pswp
	   */
	  constructor(pswp) {
	    this.pswp = pswp; // Total amount of cached images

	    this.limit = Math.max(pswp.options.preload[0] + pswp.options.preload[1] + 1, MIN_SLIDES_TO_CACHE);
	    /** @type {Content[]} */

	    this._cachedItems = [];
	  }
	  /**
	   * Lazy load nearby slides based on `preload` option.
	   *
	   * @param {number} [diff] Difference between slide indexes that was changed recently, or 0.
	   */

	  updateLazy(diff) {
	    const {
	      pswp
	    } = this;
	    if (pswp.dispatch('lazyLoad').defaultPrevented) {
	      return;
	    }
	    const {
	      preload
	    } = pswp.options;
	    const isForward = diff === undefined ? true : diff >= 0;
	    let i; // preload[1] - num items to preload in forward direction

	    for (i = 0; i <= preload[1]; i++) {
	      this.loadSlideByIndex(pswp.currIndex + (isForward ? i : -i));
	    } // preload[0] - num items to preload in backward direction

	    for (i = 1; i <= preload[0]; i++) {
	      this.loadSlideByIndex(pswp.currIndex + (isForward ? -i : i));
	    }
	  }
	  /**
	   * @param {number} initialIndex
	   */

	  loadSlideByIndex(initialIndex) {
	    const index = this.pswp.getLoopedIndex(initialIndex); // try to get cached content

	    let content = this.getContentByIndex(index);
	    if (!content) {
	      // no cached content, so try to load from scratch:
	      content = lazyLoadSlide(index, this.pswp); // if content can be loaded, add it to cache:

	      if (content) {
	        this.addToCache(content);
	      }
	    }
	  }
	  /**
	   * @param {Slide} slide
	   * @returns {Content}
	   */

	  getContentBySlide(slide) {
	    let content = this.getContentByIndex(slide.index);
	    if (!content) {
	      // create content if not found in cache
	      content = this.pswp.createContentFromData(slide.data, slide.index);
	      this.addToCache(content);
	    } // assign slide to content

	    content.setSlide(slide);
	    return content;
	  }
	  /**
	   * @param {Content} content
	   */

	  addToCache(content) {
	    // move to the end of array
	    this.removeByIndex(content.index);
	    this._cachedItems.push(content);
	    if (this._cachedItems.length > this.limit) {
	      // Destroy the first content that's not attached
	      const indexToRemove = this._cachedItems.findIndex(item => {
	        return !item.isAttached && !item.hasSlide;
	      });
	      if (indexToRemove !== -1) {
	        const removedItem = this._cachedItems.splice(indexToRemove, 1)[0];
	        removedItem.destroy();
	      }
	    }
	  }
	  /**
	   * Removes an image from cache, does not destroy() it, just removes.
	   *
	   * @param {number} index
	   */

	  removeByIndex(index) {
	    const indexToRemove = this._cachedItems.findIndex(item => item.index === index);
	    if (indexToRemove !== -1) {
	      this._cachedItems.splice(indexToRemove, 1);
	    }
	  }
	  /**
	   * @param {number} index
	   * @returns {Content | undefined}
	   */

	  getContentByIndex(index) {
	    return this._cachedItems.find(content => content.index === index);
	  }
	  destroy() {
	    this._cachedItems.forEach(content => content.destroy());
	    this._cachedItems = [];
	  }
	}

	/** @typedef {import("../photoswipe.js").default} PhotoSwipe */

	/** @typedef {import("../slide/slide.js").SlideData} SlideData */

	/**
	 * PhotoSwipe base class that can retrieve data about every slide.
	 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
	 */

	class PhotoSwipeBase extends Eventable {
	  /**
	   * Get total number of slides
	   *
	   * @returns {number}
	   */
	  getNumItems() {
	    var _this$options;
	    let numItems = 0;
	    const dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
	    if (dataSource && 'length' in dataSource) {
	      // may be an array or just object with length property
	      numItems = dataSource.length;
	    } else if (dataSource && 'gallery' in dataSource) {
	      // query DOM elements
	      if (!dataSource.items) {
	        dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
	      }
	      if (dataSource.items) {
	        numItems = dataSource.items.length;
	      }
	    } // legacy event, before filters were introduced

	    const event = this.dispatch('numItems', {
	      dataSource,
	      numItems
	    });
	    return this.applyFilters('numItems', event.numItems, dataSource);
	  }
	  /**
	   * @param {SlideData} slideData
	   * @param {number} index
	   * @returns {Content}
	   */

	  createContentFromData(slideData, index) {
	    return new Content(slideData, this, index);
	  }
	  /**
	   * Get item data by index.
	   *
	   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
	   * For example, it may contain properties like
	   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
	   *
	   * @param {number} index
	   * @returns {SlideData}
	   */

	  getItemData(index) {
	    var _this$options2;
	    const dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
	    /** @type {SlideData | HTMLElement} */

	    let dataSourceItem = {};
	    if (Array.isArray(dataSource)) {
	      // Datasource is an array of elements
	      dataSourceItem = dataSource[index];
	    } else if (dataSource && 'gallery' in dataSource) {
	      // dataSource has gallery property,
	      // thus it was created by Lightbox, based on
	      // gallery and children options
	      // query DOM elements
	      if (!dataSource.items) {
	        dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
	      }
	      dataSourceItem = dataSource.items[index];
	    }
	    let itemData = dataSourceItem;
	    if (itemData instanceof Element) {
	      itemData = this._domElementToItemData(itemData);
	    } // Dispatching the itemData event,
	    // it's a legacy verion before filters were introduced

	    const event = this.dispatch('itemData', {
	      itemData: itemData || {},
	      index
	    });
	    return this.applyFilters('itemData', event.itemData, index);
	  }
	  /**
	   * Get array of gallery DOM elements,
	   * based on childSelector and gallery element.
	   *
	   * @param {HTMLElement} galleryElement
	   * @returns {HTMLElement[]}
	   */

	  _getGalleryDOMElements(galleryElement) {
	    var _this$options3, _this$options4;
	    if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) {
	      return getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
	    }
	    return [galleryElement];
	  }
	  /**
	   * Converts DOM element to item data object.
	   *
	   * @param {HTMLElement} element DOM element
	   * @returns {SlideData}
	   */

	  _domElementToItemData(element) {
	    /** @type {SlideData} */
	    const itemData = {
	      element
	    };
	    const linkEl = /** @type {HTMLAnchorElement} */
	    element.tagName === 'A' ? element : element.querySelector('a');
	    if (linkEl) {
	      // src comes from data-pswp-src attribute,
	      // if it's empty link href is used
	      itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
	      if (linkEl.dataset.pswpSrcset) {
	        itemData.srcset = linkEl.dataset.pswpSrcset;
	      }
	      itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
	      itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0; // support legacy w & h properties

	      itemData.w = itemData.width;
	      itemData.h = itemData.height;
	      if (linkEl.dataset.pswpType) {
	        itemData.type = linkEl.dataset.pswpType;
	      }
	      const thumbnailEl = element.querySelector('img');
	      if (thumbnailEl) {
	        var _thumbnailEl$getAttri;

	        // msrc is URL to placeholder image that's displayed before large image is loaded
	        // by default it's displayed only for the first slide
	        itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
	        itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute('alt')) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : '';
	      }
	      if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) {
	        itemData.thumbCropped = true;
	      }
	    }
	    return this.applyFilters('domItemData', itemData, element, linkEl);
	  }
	  /**
	   * Lazy-load by slide data
	   *
	   * @param {SlideData} itemData Data about the slide
	   * @param {number} index
	   * @returns {Content} Image that is being decoded or false.
	   */

	  lazyLoadData(itemData, index) {
	    return lazyLoadData(itemData, this, index);
	  }
	}

	/** @typedef {import('./photoswipe.js').default} PhotoSwipe */

	/** @typedef {import('./slide/get-thumb-bounds.js').Bounds} Bounds */

	/** @typedef {import('./util/animations.js').AnimationProps} AnimationProps */
	// some browsers do not paint
	// elements which opacity is set to 0,
	// since we need to pre-render elements for the animation -
	// we set it to the minimum amount

	const MIN_OPACITY = 0.003;
	/**
	 * Manages opening and closing transitions of the PhotoSwipe.
	 *
	 * It can perform zoom, fade or no transition.
	 */

	class Opener {
	  /**
	   * @param {PhotoSwipe} pswp
	   */
	  constructor(pswp) {
	    this.pswp = pswp;
	    this.isClosed = true;
	    this.isOpen = false;
	    this.isClosing = false;
	    this.isOpening = false;
	    /**
	     * @private
	     * @type {number | false | undefined}
	     */

	    this._duration = undefined;
	    /** @private */

	    this._useAnimation = false;
	    /** @private */

	    this._croppedZoom = false;
	    /** @private */

	    this._animateRootOpacity = false;
	    /** @private */

	    this._animateBgOpacity = false;
	    /**
	     * @private
	     * @type { HTMLDivElement | HTMLImageElement | null | undefined }
	     */

	    this._placeholder = undefined;
	    /**
	     * @private
	     * @type { HTMLDivElement | undefined }
	     */

	    this._opacityElement = undefined;
	    /**
	     * @private
	     * @type { HTMLDivElement | undefined }
	     */

	    this._cropContainer1 = undefined;
	    /**
	     * @private
	     * @type { HTMLElement | null | undefined }
	     */

	    this._cropContainer2 = undefined;
	    /**
	     * @private
	     * @type {Bounds | undefined}
	     */

	    this._thumbBounds = undefined;
	    this._prepareOpen = this._prepareOpen.bind(this); // Override initial zoom and pan position

	    pswp.on('firstZoomPan', this._prepareOpen);
	  }
	  open() {
	    this._prepareOpen();
	    this._start();
	  }
	  close() {
	    if (this.isClosed || this.isClosing || this.isOpening) {
	      // if we close during opening animation
	      // for now do nothing,
	      // browsers aren't good at changing the direction of the CSS transition
	      return;
	    }
	    const slide = this.pswp.currSlide;
	    this.isOpen = false;
	    this.isOpening = false;
	    this.isClosing = true;
	    this._duration = this.pswp.options.hideAnimationDuration;
	    if (slide && slide.currZoomLevel * slide.width >= this.pswp.options.maxWidthToAnimate) {
	      this._duration = 0;
	    }
	    this._applyStartProps();
	    setTimeout(() => {
	      this._start();
	    }, this._croppedZoom ? 30 : 0);
	  }
	  /** @private */

	  _prepareOpen() {
	    this.pswp.off('firstZoomPan', this._prepareOpen);
	    if (!this.isOpening) {
	      const slide = this.pswp.currSlide;
	      this.isOpening = true;
	      this.isClosing = false;
	      this._duration = this.pswp.options.showAnimationDuration;
	      if (slide && slide.zoomLevels.initial * slide.width >= this.pswp.options.maxWidthToAnimate) {
	        this._duration = 0;
	      }
	      this._applyStartProps();
	    }
	  }
	  /** @private */

	  _applyStartProps() {
	    const {
	      pswp
	    } = this;
	    const slide = this.pswp.currSlide;
	    const {
	      options
	    } = pswp;
	    if (options.showHideAnimationType === 'fade') {
	      options.showHideOpacity = true;
	      this._thumbBounds = undefined;
	    } else if (options.showHideAnimationType === 'none') {
	      options.showHideOpacity = false;
	      this._duration = 0;
	      this._thumbBounds = undefined;
	    } else if (this.isOpening && pswp._initialThumbBounds) {
	      // Use initial bounds if defined
	      this._thumbBounds = pswp._initialThumbBounds;
	    } else {
	      this._thumbBounds = this.pswp.getThumbBounds();
	    }
	    this._placeholder = slide === null || slide === void 0 ? void 0 : slide.getPlaceholderElement();
	    pswp.animations.stopAll(); // Discard animations when duration is less than 50ms

	    this._useAnimation = Boolean(this._duration && this._duration > 50);
	    this._animateZoom = Boolean(this._thumbBounds) && (slide === null || slide === void 0 ? void 0 : slide.content.usePlaceholder()) && (!this.isClosing || !pswp.mainScroll.isShifted());
	    if (!this._animateZoom) {
	      this._animateRootOpacity = true;
	      if (this.isOpening && slide) {
	        slide.zoomAndPanToInitial();
	        slide.applyCurrentZoomPan();
	      }
	    } else {
	      var _options$showHideOpac;
	      this._animateRootOpacity = (_options$showHideOpac = options.showHideOpacity) !== null && _options$showHideOpac !== void 0 ? _options$showHideOpac : false;
	    }
	    this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > MIN_OPACITY;
	    this._opacityElement = this._animateRootOpacity ? pswp.element : pswp.bg;
	    if (!this._useAnimation) {
	      this._duration = 0;
	      this._animateZoom = false;
	      this._animateBgOpacity = false;
	      this._animateRootOpacity = true;
	      if (this.isOpening) {
	        if (pswp.element) {
	          pswp.element.style.opacity = String(MIN_OPACITY);
	        }
	        pswp.applyBgOpacity(1);
	      }
	      return;
	    }
	    if (this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect) {
	      var _this$pswp$currSlide;

	      // Properties are used when animation from cropped thumbnail
	      this._croppedZoom = true;
	      this._cropContainer1 = this.pswp.container;
	      this._cropContainer2 = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.holderElement;
	      if (pswp.container) {
	        pswp.container.style.overflow = 'hidden';
	        pswp.container.style.width = pswp.viewportSize.x + 'px';
	      }
	    } else {
	      this._croppedZoom = false;
	    }
	    if (this.isOpening) {
	      // Apply styles before opening transition
	      if (this._animateRootOpacity) {
	        if (pswp.element) {
	          pswp.element.style.opacity = String(MIN_OPACITY);
	        }
	        pswp.applyBgOpacity(1);
	      } else {
	        if (this._animateBgOpacity && pswp.bg) {
	          pswp.bg.style.opacity = String(MIN_OPACITY);
	        }
	        if (pswp.element) {
	          pswp.element.style.opacity = '1';
	        }
	      }
	      if (this._animateZoom) {
	        this._setClosedStateZoomPan();
	        if (this._placeholder) {
	          // tell browser that we plan to animate the placeholder
	          this._placeholder.style.willChange = 'transform'; // hide placeholder to allow hiding of
	          // elements that overlap it (such as icons over the thumbnail)

	          this._placeholder.style.opacity = String(MIN_OPACITY);
	        }
	      }
	    } else if (this.isClosing) {
	      // hide nearby slides to make sure that
	      // they are not painted during the transition
	      if (pswp.mainScroll.itemHolders[0]) {
	        pswp.mainScroll.itemHolders[0].el.style.display = 'none';
	      }
	      if (pswp.mainScroll.itemHolders[2]) {
	        pswp.mainScroll.itemHolders[2].el.style.display = 'none';
	      }
	      if (this._croppedZoom) {
	        if (pswp.mainScroll.x !== 0) {
	          // shift the main scroller to zero position
	          pswp.mainScroll.resetPosition();
	          pswp.mainScroll.resize();
	        }
	      }
	    }
	  }
	  /** @private */

	  _start() {
	    if (this.isOpening && this._useAnimation && this._placeholder && this._placeholder.tagName === 'IMG') {
	      // To ensure smooth animation
	      // we wait till the current slide image placeholder is decoded,
	      // but no longer than 250ms,
	      // and no shorter than 50ms
	      // (just using requestanimationframe is not enough in Firefox,
	      // for some reason)
	      new Promise(resolve => {
	        let decoded = false;
	        let isDelaying = true;
	        decodeImage(/** @type {HTMLImageElement} */
	        this._placeholder).finally(() => {
	          decoded = true;
	          if (!isDelaying) {
	            resolve(true);
	          }
	        });
	        setTimeout(() => {
	          isDelaying = false;
	          if (decoded) {
	            resolve(true);
	          }
	        }, 50);
	        setTimeout(resolve, 250);
	      }).finally(() => this._initiate());
	    } else {
	      this._initiate();
	    }
	  }
	  /** @private */

	  _initiate() {
	    var _this$pswp$element, _this$pswp$element2;
	    (_this$pswp$element = this.pswp.element) === null || _this$pswp$element === void 0 || _this$pswp$element.style.setProperty('--pswp-transition-duration', this._duration + 'ms');
	    this.pswp.dispatch(this.isOpening ? 'openingAnimationStart' : 'closingAnimationStart'); // legacy event

	    this.pswp.dispatch(/** @type {'initialZoomIn' | 'initialZoomOut'} */
	    'initialZoom' + (this.isOpening ? 'In' : 'Out'));
	    (_this$pswp$element2 = this.pswp.element) === null || _this$pswp$element2 === void 0 || _this$pswp$element2.classList.toggle('pswp--ui-visible', this.isOpening);
	    if (this.isOpening) {
	      if (this._placeholder) {
	        // unhide the placeholder
	        this._placeholder.style.opacity = '1';
	      }
	      this._animateToOpenState();
	    } else if (this.isClosing) {
	      this._animateToClosedState();
	    }
	    if (!this._useAnimation) {
	      this._onAnimationComplete();
	    }
	  }
	  /** @private */

	  _onAnimationComplete() {
	    const {
	      pswp
	    } = this;
	    this.isOpen = this.isOpening;
	    this.isClosed = this.isClosing;
	    this.isOpening = false;
	    this.isClosing = false;
	    pswp.dispatch(this.isOpen ? 'openingAnimationEnd' : 'closingAnimationEnd'); // legacy event

	    pswp.dispatch(/** @type {'initialZoomInEnd' | 'initialZoomOutEnd'} */
	    'initialZoom' + (this.isOpen ? 'InEnd' : 'OutEnd'));
	    if (this.isClosed) {
	      pswp.destroy();
	    } else if (this.isOpen) {
	      var _pswp$currSlide;
	      if (this._animateZoom && pswp.container) {
	        pswp.container.style.overflow = 'visible';
	        pswp.container.style.width = '100%';
	      }
	      (_pswp$currSlide = pswp.currSlide) === null || _pswp$currSlide === void 0 || _pswp$currSlide.applyCurrentZoomPan();
	    }
	  }
	  /** @private */

	  _animateToOpenState() {
	    const {
	      pswp
	    } = this;
	    if (this._animateZoom) {
	      if (this._croppedZoom && this._cropContainer1 && this._cropContainer2) {
	        this._animateTo(this._cropContainer1, 'transform', 'translate3d(0,0,0)');
	        this._animateTo(this._cropContainer2, 'transform', 'none');
	      }
	      if (pswp.currSlide) {
	        pswp.currSlide.zoomAndPanToInitial();
	        this._animateTo(pswp.currSlide.container, 'transform', pswp.currSlide.getCurrentTransform());
	      }
	    }
	    if (this._animateBgOpacity && pswp.bg) {
	      this._animateTo(pswp.bg, 'opacity', String(pswp.options.bgOpacity));
	    }
	    if (this._animateRootOpacity && pswp.element) {
	      this._animateTo(pswp.element, 'opacity', '1');
	    }
	  }
	  /** @private */

	  _animateToClosedState() {
	    const {
	      pswp
	    } = this;
	    if (this._animateZoom) {
	      this._setClosedStateZoomPan(true);
	    } // do not animate opacity if it's already at 0

	    if (this._animateBgOpacity && pswp.bgOpacity > 0.01 && pswp.bg) {
	      this._animateTo(pswp.bg, 'opacity', '0');
	    }
	    if (this._animateRootOpacity && pswp.element) {
	      this._animateTo(pswp.element, 'opacity', '0');
	    }
	  }
	  /**
	   * @private
	   * @param {boolean} [animate]
	   */

	  _setClosedStateZoomPan(animate) {
	    if (!this._thumbBounds) return;
	    const {
	      pswp
	    } = this;
	    const {
	      innerRect
	    } = this._thumbBounds;
	    const {
	      currSlide,
	      viewportSize
	    } = pswp;
	    if (this._croppedZoom && innerRect && this._cropContainer1 && this._cropContainer2) {
	      const containerOnePanX = -viewportSize.x + (this._thumbBounds.x - innerRect.x) + innerRect.w;
	      const containerOnePanY = -viewportSize.y + (this._thumbBounds.y - innerRect.y) + innerRect.h;
	      const containerTwoPanX = viewportSize.x - innerRect.w;
	      const containerTwoPanY = viewportSize.y - innerRect.h;
	      if (animate) {
	        this._animateTo(this._cropContainer1, 'transform', toTransformString(containerOnePanX, containerOnePanY));
	        this._animateTo(this._cropContainer2, 'transform', toTransformString(containerTwoPanX, containerTwoPanY));
	      } else {
	        setTransform(this._cropContainer1, containerOnePanX, containerOnePanY);
	        setTransform(this._cropContainer2, containerTwoPanX, containerTwoPanY);
	      }
	    }
	    if (currSlide) {
	      equalizePoints(currSlide.pan, innerRect || this._thumbBounds);
	      currSlide.currZoomLevel = this._thumbBounds.w / currSlide.width;
	      if (animate) {
	        this._animateTo(currSlide.container, 'transform', currSlide.getCurrentTransform());
	      } else {
	        currSlide.applyCurrentZoomPan();
	      }
	    }
	  }
	  /**
	   * @private
	   * @param {HTMLElement} target
	   * @param {'transform' | 'opacity'} prop
	   * @param {string} propValue
	   */

	  _animateTo(target, prop, propValue) {
	    if (!this._duration) {
	      target.style[prop] = propValue;
	      return;
	    }
	    const {
	      animations
	    } = this.pswp;
	    /** @type {AnimationProps} */

	    const animProps = {
	      duration: this._duration,
	      easing: this.pswp.options.easing,
	      onComplete: () => {
	        if (!animations.activeAnimations.length) {
	          this._onAnimationComplete();
	        }
	      },
	      target
	    };
	    animProps[prop] = propValue;
	    animations.startTransition(animProps);
	  }
	}

	/**
	 * @template T
	 * @typedef {import('./types.js').Type<T>} Type<T>
	 */

	/** @typedef {import('./slide/slide.js').SlideData} SlideData */

	/** @typedef {import('./slide/zoom-level.js').ZoomLevelOption} ZoomLevelOption */

	/** @typedef {import('./ui/ui-element.js').UIElementData} UIElementData */

	/** @typedef {import('./main-scroll.js').ItemHolder} ItemHolder */

	/** @typedef {import('./core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */

	/** @typedef {import('./core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */

	/** @typedef {import('./slide/get-thumb-bounds').Bounds} Bounds */

	/**
	 * @template {keyof PhotoSwipeEventsMap} T
	 * @typedef {import('./core/eventable.js').EventCallback<T>} EventCallback<T>
	 */

	/**
	 * @template {keyof PhotoSwipeEventsMap} T
	 * @typedef {import('./core/eventable.js').AugmentedEvent<T>} AugmentedEvent<T>
	 */

	/** @typedef {{ x: number; y: number; id?: string | number }} Point */

	/** @typedef {{ top: number; bottom: number; left: number; right: number }} Padding */

	/** @typedef {SlideData[]} DataSourceArray */

	/** @typedef {{ gallery: HTMLElement; items?: HTMLElement[] }} DataSourceObject */

	/** @typedef {DataSourceArray | DataSourceObject} DataSource */

	/** @typedef {(point: Point, originalEvent: PointerEvent) => void} ActionFn */

	/** @typedef {'close' | 'next' | 'zoom' | 'zoom-or-close' | 'toggle-controls'} ActionType */

	/** @typedef {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} PhotoSwipeModule */

	/** @typedef {PhotoSwipeModule | Promise<PhotoSwipeModule> | (() => Promise<PhotoSwipeModule>)} PhotoSwipeModuleOption */

	/**
	 * @typedef {string | NodeListOf<HTMLElement> | HTMLElement[] | HTMLElement} ElementProvider
	 */

	/** @typedef {Partial<PreparedPhotoSwipeOptions>} PhotoSwipeOptions https://photoswipe.com/options/ */

	/**
	 * @typedef {Object} PreparedPhotoSwipeOptions
	 *
	 * @prop {DataSource} [dataSource]
	 * Pass an array of any items via dataSource option. Its length will determine amount of slides
	 * (which may be modified further from numItems event).
	 *
	 * Each item should contain data that you need to generate slide
	 * (for image slide it would be src (image URL), width (image width), height, srcset, alt).
	 *
	 * If these properties are not present in your initial array, you may "pre-parse" each item from itemData filter.
	 *
	 * @prop {number} bgOpacity
	 * Background backdrop opacity, always define it via this option and not via CSS rgba color.
	 *
	 * @prop {number} spacing
	 * Spacing between slides. Defined as ratio relative to the viewport width (0.1 = 10% of viewport).
	 *
	 * @prop {boolean} allowPanToNext
	 * Allow swipe navigation to the next slide when the current slide is zoomed. Does not apply to mouse events.
	 *
	 * @prop {boolean} loop
	 * If set to true you'll be able to swipe from the last to the first image.
	 * Option is always false when there are less than 3 slides.
	 *
	 * @prop {boolean} [wheelToZoom]
	 * By default PhotoSwipe zooms image with ctrl-wheel, if you enable this option - image will zoom just via wheel.
	 *
	 * @prop {boolean} pinchToClose
	 * Pinch touch gesture to close the gallery.
	 *
	 * @prop {boolean} closeOnVerticalDrag
	 * Vertical drag gesture to close the PhotoSwipe.
	 *
	 * @prop {Padding} [padding]
	 * Slide area padding (in pixels).
	 *
	 * @prop {(viewportSize: Point, itemData: SlideData, index: number) => Padding} [paddingFn]
	 * The option is checked frequently, so make sure it's performant. Overrides padding option if defined. For example:
	 *
	 * @prop {number | false} hideAnimationDuration
	 * Transition duration in milliseconds, can be 0.
	 *
	 * @prop {number | false} showAnimationDuration
	 * Transition duration in milliseconds, can be 0.
	 *
	 * @prop {number | false} zoomAnimationDuration
	 * Transition duration in milliseconds, can be 0.
	 *
	 * @prop {string} easing
	 * String, 'cubic-bezier(.4,0,.22,1)'. CSS easing function for open/close/zoom transitions.
	 *
	 * @prop {boolean} escKey
	 * Esc key to close.
	 *
	 * @prop {boolean} arrowKeys
	 * Left/right arrow keys for navigation.
	 *
	 * @prop {boolean} trapFocus
	 * Trap focus within PhotoSwipe element while it's open.
	 *
	 * @prop {boolean} returnFocus
	 * Restore focus the last active element after PhotoSwipe is closed.
	 *
	 * @prop {boolean} clickToCloseNonZoomable
	 * If image is not zoomable (for example, smaller than viewport) it can be closed by clicking on it.
	 *
	 * @prop {ActionType | ActionFn | false} imageClickAction
	 * Refer to click and tap actions page.
	 *
	 * @prop {ActionType | ActionFn | false} bgClickAction
	 * Refer to click and tap actions page.
	 *
	 * @prop {ActionType | ActionFn | false} tapAction
	 * Refer to click and tap actions page.
	 *
	 * @prop {ActionType | ActionFn | false} doubleTapAction
	 * Refer to click and tap actions page.
	 *
	 * @prop {number} preloaderDelay
	 * Delay before the loading indicator will be displayed,
	 * if image is loaded during it - the indicator will not be displayed at all. Can be zero.
	 *
	 * @prop {string} indexIndicatorSep
	 * Used for slide count indicator ("1 of 10 ").
	 *
	 * @prop {(options: PhotoSwipeOptions, pswp: PhotoSwipeBase) => Point} [getViewportSizeFn]
	 * A function that should return slide viewport width and height, in format {x: 100, y: 100}.
	 *
	 * @prop {string} errorMsg
	 * Message to display when the image wasn't able to load. If you need to display HTML - use contentErrorElement filter.
	 *
	 * @prop {[number, number]} preload
	 * Lazy loading of nearby slides based on direction of movement. Should be an array with two integers,
	 * first one - number of items to preload before the current image, second one - after the current image.
	 * Two nearby images are always loaded.
	 *
	 * @prop {string} [mainClass]
	 * Class that will be added to the root element of PhotoSwipe, may contain multiple separated by space.
	 * Example on Styling page.
	 *
	 * @prop {HTMLElement} [appendToEl]
	 * Element to which PhotoSwipe dialog will be appended when it opens.
	 *
	 * @prop {number} maxWidthToAnimate
	 * Maximum width of image to animate, if initial rendered image width
	 * is larger than this value - the opening/closing transition will be automatically disabled.
	 *
	 * @prop {string} [closeTitle]
	 * Translating
	 *
	 * @prop {string} [zoomTitle]
	 * Translating
	 *
	 * @prop {string} [arrowPrevTitle]
	 * Translating
	 *
	 * @prop {string} [arrowNextTitle]
	 * Translating
	 *
	 * @prop {'zoom' | 'fade' | 'none'} [showHideAnimationType]
	 * To adjust opening or closing transition type use lightbox option `showHideAnimationType` (`String`).
	 * It supports three values - `zoom` (default), `fade` (default if there is no thumbnail) and `none`.
	 *
	 * Animations are automatically disabled if user `(prefers-reduced-motion: reduce)`.
	 *
	 * @prop {number} index
	 * Defines start slide index.
	 *
	 * @prop {(e: MouseEvent) => number} [getClickedIndexFn]
	 *
	 * @prop {boolean} [arrowPrev]
	 * @prop {boolean} [arrowNext]
	 * @prop {boolean} [zoom]
	 * @prop {boolean} [close]
	 * @prop {boolean} [counter]
	 *
	 * @prop {string} [arrowPrevSVG]
	 * @prop {string} [arrowNextSVG]
	 * @prop {string} [zoomSVG]
	 * @prop {string} [closeSVG]
	 * @prop {string} [counterSVG]
	 *
	 * @prop {string} [arrowPrevTitle]
	 * @prop {string} [arrowNextTitle]
	 * @prop {string} [zoomTitle]
	 * @prop {string} [closeTitle]
	 * @prop {string} [counterTitle]
	 *
	 * @prop {ZoomLevelOption} [initialZoomLevel]
	 * @prop {ZoomLevelOption} [secondaryZoomLevel]
	 * @prop {ZoomLevelOption} [maxZoomLevel]
	 *
	 * @prop {boolean} [mouseMovePan]
	 * @prop {Point | null} [initialPointerPos]
	 * @prop {boolean} [showHideOpacity]
	 *
	 * @prop {PhotoSwipeModuleOption} [pswpModule]
	 * @prop {() => Promise<any>} [openPromise]
	 * @prop {boolean} [preloadFirstSlide]
	 * @prop {ElementProvider} [gallery]
	 * @prop {string} [gallerySelector]
	 * @prop {ElementProvider} [children]
	 * @prop {string} [childSelector]
	 * @prop {string | false} [thumbSelector]
	 */

	/** @type {PreparedPhotoSwipeOptions} */

	const defaultOptions = {
	  allowPanToNext: true,
	  spacing: 0.1,
	  loop: true,
	  pinchToClose: true,
	  closeOnVerticalDrag: true,
	  hideAnimationDuration: 333,
	  showAnimationDuration: 333,
	  zoomAnimationDuration: 333,
	  escKey: true,
	  arrowKeys: true,
	  trapFocus: true,
	  returnFocus: true,
	  maxWidthToAnimate: 4000,
	  clickToCloseNonZoomable: true,
	  imageClickAction: 'zoom-or-close',
	  bgClickAction: 'close',
	  tapAction: 'toggle-controls',
	  doubleTapAction: 'zoom',
	  indexIndicatorSep: ' / ',
	  preloaderDelay: 2000,
	  bgOpacity: 0.8,
	  index: 0,
	  errorMsg: 'The image cannot be loaded',
	  preload: [1, 2],
	  easing: 'cubic-bezier(.4,0,.22,1)'
	};
	/**
	 * PhotoSwipe Core
	 */

	class PhotoSwipe extends PhotoSwipeBase {
	  /**
	   * @param {PhotoSwipeOptions} [options]
	   */
	  constructor(options) {
	    super();
	    this.options = this._prepareOptions(options || {});
	    /**
	     * offset of viewport relative to document
	     *
	     * @type {Point}
	     */

	    this.offset = {
	      x: 0,
	      y: 0
	    };
	    /**
	     * @type {Point}
	     * @private
	     */

	    this._prevViewportSize = {
	      x: 0,
	      y: 0
	    };
	    /**
	     * Size of scrollable PhotoSwipe viewport
	     *
	     * @type {Point}
	     */

	    this.viewportSize = {
	      x: 0,
	      y: 0
	    };
	    /**
	     * background (backdrop) opacity
	     */

	    this.bgOpacity = 1;
	    this.currIndex = 0;
	    this.potentialIndex = 0;
	    this.isOpen = false;
	    this.isDestroying = false;
	    this.hasMouse = false;
	    /**
	     * @private
	     * @type {SlideData}
	     */

	    this._initialItemData = {};
	    /** @type {Bounds | undefined} */

	    this._initialThumbBounds = undefined;
	    /** @type {HTMLDivElement | undefined} */

	    this.topBar = undefined;
	    /** @type {HTMLDivElement | undefined} */

	    this.element = undefined;
	    /** @type {HTMLDivElement | undefined} */

	    this.template = undefined;
	    /** @type {HTMLDivElement | undefined} */

	    this.container = undefined;
	    /** @type {HTMLElement | undefined} */

	    this.scrollWrap = undefined;
	    /** @type {Slide | undefined} */

	    this.currSlide = undefined;
	    this.events = new DOMEvents();
	    this.animations = new Animations();
	    this.mainScroll = new MainScroll(this);
	    this.gestures = new Gestures(this);
	    this.opener = new Opener(this);
	    this.keyboard = new Keyboard(this);
	    this.contentLoader = new ContentLoader(this);
	  }
	  /** @returns {boolean} */

	  init() {
	    if (this.isOpen || this.isDestroying) {
	      return false;
	    }
	    this.isOpen = true;
	    this.dispatch('init'); // legacy

	    this.dispatch('beforeOpen');
	    this._createMainStructure(); // add classes to the root element of PhotoSwipe

	    let rootClasses = 'pswp--open';
	    if (this.gestures.supportsTouch) {
	      rootClasses += ' pswp--touch';
	    }
	    if (this.options.mainClass) {
	      rootClasses += ' ' + this.options.mainClass;
	    }
	    if (this.element) {
	      this.element.className += ' ' + rootClasses;
	    }
	    this.currIndex = this.options.index || 0;
	    this.potentialIndex = this.currIndex;
	    this.dispatch('firstUpdate'); // starting index can be modified here
	    // initialize scroll wheel handler to block the scroll

	    this.scrollWheel = new ScrollWheel(this); // sanitize index

	    if (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems()) {
	      this.currIndex = 0;
	    }
	    if (!this.gestures.supportsTouch) {
	      // enable mouse features if no touch support detected
	      this.mouseDetected();
	    } // causes forced synchronous layout

	    this.updateSize();
	    this.offset.y = window.pageYOffset;
	    this._initialItemData = this.getItemData(this.currIndex);
	    this.dispatch('gettingData', {
	      index: this.currIndex,
	      data: this._initialItemData,
	      slide: undefined
	    }); // *Layout* - calculate size and position of elements here

	    this._initialThumbBounds = this.getThumbBounds();
	    this.dispatch('initialLayout');
	    this.on('openingAnimationEnd', () => {
	      const {
	        itemHolders
	      } = this.mainScroll; // Add content to the previous and next slide

	      if (itemHolders[0]) {
	        itemHolders[0].el.style.display = 'block';
	        this.setContent(itemHolders[0], this.currIndex - 1);
	      }
	      if (itemHolders[2]) {
	        itemHolders[2].el.style.display = 'block';
	        this.setContent(itemHolders[2], this.currIndex + 1);
	      }
	      this.appendHeavy();
	      this.contentLoader.updateLazy();
	      this.events.add(window, 'resize', this._handlePageResize.bind(this));
	      this.events.add(window, 'scroll', this._updatePageScrollOffset.bind(this));
	      this.dispatch('bindEvents');
	    }); // set content for center slide (first time)

	    if (this.mainScroll.itemHolders[1]) {
	      this.setContent(this.mainScroll.itemHolders[1], this.currIndex);
	    }
	    this.dispatch('change');
	    this.opener.open();
	    this.dispatch('afterInit');
	    return true;
	  }
	  /**
	   * Get looped slide index
	   * (for example, -1 will return the last slide)
	   *
	   * @param {number} index
	   * @returns {number}
	   */

	  getLoopedIndex(index) {
	    const numSlides = this.getNumItems();
	    if (this.options.loop) {
	      if (index > numSlides - 1) {
	        index -= numSlides;
	      }
	      if (index < 0) {
	        index += numSlides;
	      }
	    }
	    return clamp(index, 0, numSlides - 1);
	  }
	  appendHeavy() {
	    this.mainScroll.itemHolders.forEach(itemHolder => {
	      var _itemHolder$slide;
	      (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.appendHeavy();
	    });
	  }
	  /**
	   * Change the slide
	   * @param {number} index New index
	   */

	  goTo(index) {
	    this.mainScroll.moveIndexBy(this.getLoopedIndex(index) - this.potentialIndex);
	  }
	  /**
	   * Go to the next slide.
	   */

	  next() {
	    this.goTo(this.potentialIndex + 1);
	  }
	  /**
	   * Go to the previous slide.
	   */

	  prev() {
	    this.goTo(this.potentialIndex - 1);
	  }
	  /**
	   * @see slide/slide.js zoomTo
	   *
	   * @param {Parameters<Slide['zoomTo']>} args
	   */

	  zoomTo(...args) {
	    var _this$currSlide;
	    (_this$currSlide = this.currSlide) === null || _this$currSlide === void 0 || _this$currSlide.zoomTo(...args);
	  }
	  /**
	   * @see slide/slide.js toggleZoom
	   */

	  toggleZoom() {
	    var _this$currSlide2;
	    (_this$currSlide2 = this.currSlide) === null || _this$currSlide2 === void 0 || _this$currSlide2.toggleZoom();
	  }
	  /**
	   * Close the gallery.
	   * After closing transition ends - destroy it
	   */

	  close() {
	    if (!this.opener.isOpen || this.isDestroying) {
	      return;
	    }
	    this.isDestroying = true;
	    this.dispatch('close');
	    this.events.removeAll();
	    this.opener.close();
	  }
	  /**
	   * Destroys the gallery:
	   * - instantly closes the gallery
	   * - unbinds events,
	   * - cleans intervals and timeouts
	   * - removes elements from DOM
	   */

	  destroy() {
	    var _this$element;
	    if (!this.isDestroying) {
	      this.options.showHideAnimationType = 'none';
	      this.close();
	      return;
	    }
	    this.dispatch('destroy');
	    this._listeners = {};
	    if (this.scrollWrap) {
	      this.scrollWrap.ontouchmove = null;
	      this.scrollWrap.ontouchend = null;
	    }
	    (_this$element = this.element) === null || _this$element === void 0 || _this$element.remove();
	    this.mainScroll.itemHolders.forEach(itemHolder => {
	      var _itemHolder$slide2;
	      (_itemHolder$slide2 = itemHolder.slide) === null || _itemHolder$slide2 === void 0 || _itemHolder$slide2.destroy();
	    });
	    this.contentLoader.destroy();
	    this.events.removeAll();
	  }
	  /**
	   * Refresh/reload content of a slide by its index
	   *
	   * @param {number} slideIndex
	   */

	  refreshSlideContent(slideIndex) {
	    this.contentLoader.removeByIndex(slideIndex);
	    this.mainScroll.itemHolders.forEach((itemHolder, i) => {
	      var _this$currSlide$index, _this$currSlide3;
	      let potentialHolderIndex = ((_this$currSlide$index = (_this$currSlide3 = this.currSlide) === null || _this$currSlide3 === void 0 ? void 0 : _this$currSlide3.index) !== null && _this$currSlide$index !== void 0 ? _this$currSlide$index : 0) - 1 + i;
	      if (this.canLoop()) {
	        potentialHolderIndex = this.getLoopedIndex(potentialHolderIndex);
	      }
	      if (potentialHolderIndex === slideIndex) {
	        // set the new slide content
	        this.setContent(itemHolder, slideIndex, true); // activate the new slide if it's current

	        if (i === 1) {
	          var _itemHolder$slide3;
	          this.currSlide = itemHolder.slide;
	          (_itemHolder$slide3 = itemHolder.slide) === null || _itemHolder$slide3 === void 0 || _itemHolder$slide3.setIsActive(true);
	        }
	      }
	    });
	    this.dispatch('change');
	  }
	  /**
	   * Set slide content
	   *
	   * @param {ItemHolder} holder mainScroll.itemHolders array item
	   * @param {number} index Slide index
	   * @param {boolean} [force] If content should be set even if index wasn't changed
	   */

	  setContent(holder, index, force) {
	    if (this.canLoop()) {
	      index = this.getLoopedIndex(index);
	    }
	    if (holder.slide) {
	      if (holder.slide.index === index && !force) {
	        // exit if holder already contains this slide
	        // this could be common when just three slides are used
	        return;
	      } // destroy previous slide

	      holder.slide.destroy();
	      holder.slide = undefined;
	    } // exit if no loop and index is out of bounds

	    if (!this.canLoop() && (index < 0 || index >= this.getNumItems())) {
	      return;
	    }
	    const itemData = this.getItemData(index);
	    holder.slide = new Slide(itemData, index, this); // set current slide

	    if (index === this.currIndex) {
	      this.currSlide = holder.slide;
	    }
	    holder.slide.append(holder.el);
	  }
	  /** @returns {Point} */

	  getViewportCenterPoint() {
	    return {
	      x: this.viewportSize.x / 2,
	      y: this.viewportSize.y / 2
	    };
	  }
	  /**
	   * Update size of all elements.
	   * Executed on init and on page resize.
	   *
	   * @param {boolean} [force] Update size even if size of viewport was not changed.
	   */

	  updateSize(force) {
	    // let item;
	    // let itemIndex;
	    if (this.isDestroying) {
	      // exit if PhotoSwipe is closed or closing
	      // (to avoid errors, as resize event might be delayed)
	      return;
	    } //const newWidth = this.scrollWrap.clientWidth;
	    //const newHeight = this.scrollWrap.clientHeight;

	    const newViewportSize = getViewportSize(this.options, this);
	    if (!force && pointsEqual(newViewportSize, this._prevViewportSize)) {
	      // Exit if dimensions were not changed
	      return;
	    } //this._prevViewportSize.x = newWidth;
	    //this._prevViewportSize.y = newHeight;

	    equalizePoints(this._prevViewportSize, newViewportSize);
	    this.dispatch('beforeResize');
	    equalizePoints(this.viewportSize, this._prevViewportSize);
	    this._updatePageScrollOffset();
	    this.dispatch('viewportSize'); // Resize slides only after opener animation is finished
	    // and don't re-calculate size on inital size update

	    this.mainScroll.resize(this.opener.isOpen);
	    if (!this.hasMouse && window.matchMedia('(any-hover: hover)').matches) {
	      this.mouseDetected();
	    }
	    this.dispatch('resize');
	  }
	  /**
	   * @param {number} opacity
	   */

	  applyBgOpacity(opacity) {
	    this.bgOpacity = Math.max(opacity, 0);
	    if (this.bg) {
	      this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity);
	    }
	  }
	  /**
	   * Whether mouse is detected
	   */

	  mouseDetected() {
	    if (!this.hasMouse) {
	      var _this$element2;
	      this.hasMouse = true;
	      (_this$element2 = this.element) === null || _this$element2 === void 0 || _this$element2.classList.add('pswp--has_mouse');
	    }
	  }
	  /**
	   * Page resize event handler
	   *
	   * @private
	   */

	  _handlePageResize() {
	    this.updateSize(); // In iOS webview, if element size depends on document size,
	    // it'll be measured incorrectly in resize event
	    //
	    // https://bugs.webkit.org/show_bug.cgi?id=170595
	    // https://hackernoon.com/onresize-event-broken-in-mobile-safari-d8469027bf4d

	    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
	      setTimeout(() => {
	        this.updateSize();
	      }, 500);
	    }
	  }
	  /**
	   * Page scroll offset is used
	   * to get correct coordinates
	   * relative to PhotoSwipe viewport.
	   *
	   * @private
	   */

	  _updatePageScrollOffset() {
	    this.setScrollOffset(0, window.pageYOffset);
	  }
	  /**
	   * @param {number} x
	   * @param {number} y
	   */

	  setScrollOffset(x, y) {
	    this.offset.x = x;
	    this.offset.y = y;
	    this.dispatch('updateScrollOffset');
	  }
	  /**
	   * Create main HTML structure of PhotoSwipe,
	   * and add it to DOM
	   *
	   * @private
	   */

	  _createMainStructure() {
	    // root DOM element of PhotoSwipe (.pswp)
	    this.element = createElement('pswp', 'div');
	    this.element.setAttribute('tabindex', '-1');
	    this.element.setAttribute('role', 'dialog'); // template is legacy prop

	    this.template = this.element; // Background is added as a separate element,
	    // as animating opacity is faster than animating rgba()

	    this.bg = createElement('pswp__bg', 'div', this.element);
	    this.scrollWrap = createElement('pswp__scroll-wrap', 'section', this.element);
	    this.container = createElement('pswp__container', 'div', this.scrollWrap); // aria pattern: carousel

	    this.scrollWrap.setAttribute('aria-roledescription', 'carousel');
	    this.container.setAttribute('aria-live', 'off');
	    this.container.setAttribute('id', 'pswp__items');
	    this.mainScroll.appendHolders();
	    this.ui = new UI(this);
	    this.ui.init(); // append to DOM

	    (this.options.appendToEl || document.body).appendChild(this.element);
	  }
	  /**
	   * Get position and dimensions of small thumbnail
	   *   {x:,y:,w:}
	   *
	   * Height is optional (calculated based on the large image)
	   *
	   * @returns {Bounds | undefined}
	   */

	  getThumbBounds() {
	    return getThumbBounds(this.currIndex, this.currSlide ? this.currSlide.data : this._initialItemData, this);
	  }
	  /**
	   * If the PhotoSwipe can have continuous loop
	   * @returns Boolean
	   */

	  canLoop() {
	    return this.options.loop && this.getNumItems() > 2;
	  }
	  /**
	   * @private
	   * @param {PhotoSwipeOptions} options
	   * @returns {PreparedPhotoSwipeOptions}
	   */

	  _prepareOptions(options) {
	    if (window.matchMedia('(prefers-reduced-motion), (update: slow)').matches) {
	      options.showHideAnimationType = 'none';
	      options.zoomAnimationDuration = 0;
	    }
	    /** @type {PreparedPhotoSwipeOptions} */

	    return {
	      ...defaultOptions,
	      ...options
	    };
	  }
	}

	var photoswipe_esm = /*#__PURE__*/Object.freeze({
		__proto__: null,
		default: PhotoSwipe
	});

})();
